window.JSIntakeRegistry = {
  "meta": {
    "name": "JapanSolved™ Native Intake Registry Bank",
    "version": "native-intake-registry-bank-v6-global-intake-ux-law-final02",
    "generated": "2026-07-03 12:15:50 UTC",
    "purpose": "Central bank of page-specific Native Intake intelligence scraped from broken page-body-embedded NIF pages, reconstructed from Tally planning documents for missing Tally pages, and projected for Compact NIF annex wing pages.",
    "migration_rule": "Extract page-specific NIF intelligence before converting the page body to the Liquid-template-call slot marker.",
    "slot_marker": "<!-- JAPANSOLVED_NATIVE_INTAKE_SLOT -->",
    "source_zip": "Landing Pages - Broken Pipeline.zip",
    "records_extracted_from_page_body_embedded_nif": 34,
    "records_using_v1_4_baseline_due_to_tally_shell": 2,
    "pipeline_baseline": "Original NIF Backend Reconciliation v1.4; v1.3 proved Shopify email delivery.",
    "tally_reconstructed_records": 2,
    "compact_nif_projected_records": 11,
    "total_records": 49,
    "sources_added_v2": [
      "Missing Tally Intake Intelligence.docx",
      "Compact NIF wing - landing pages.docx"
    ],
    "important_caveat_v2": "Ginza and Celebrity records are reconstructed from supplied Tally build specs. Compact ANNEX records are projected question-intelligence records for planning/reference and should be reviewed before live publication.",
    "page31_celebrity_status": "FULL_Q1_Q62_DOCX_RECORD_BAKED",
    "page31_celebrity_handle": "japan-celebrity-concierge-private-access",
    "records": 49,
    "important_caveat_v3": "Page 31 celebrity/private-access record now exposes canonical client_name/contact_email fields for Native Intake email validation, preserves source Tally QIDs, and uses readable option values so review/email output does not show machine slugs.",
    "important_caveat_v4": "Page31 values are display-label-safe; legacy snake_case values are removed from option objects and supported by the template display bridge only.",
    "important_caveat_v5": "Final pass for the two Tally-only reconstructed records: Ginza and Celebrity now use canonical client_name/contact_email contracts, step-blocking email validation metadata, human-readable option values with legacy slug display bridges, and source-docx-aligned Q/field aliases.",
    "important_caveat_v6": "Global intake UX law is now enforced by the Native Intake controller: step-gated validation, readable review display with no raw snake_case values, universal supporting references/upload-link fields, polished final confirmation review card, clear/start-again control, and secure CAPTCHA notice before final submission.",
    "ginza_status": "FINAL_DOCX_NATIVE_BRIDGE_WITH_CONTACT_EMAIL_CANONICALIZATION",
    "celebrity_status": "FINAL_Q1_Q62_WITH_PAYMENT_GATE_ROUTE_LINKS_V1_9_12",
    "celebrity_descriptor_status_v1_9_23": "HEADER_DESCRIPTION_PARAGRAPH_FORMATTING_MATCH_LOCK",
    "private_sourcing_request_review_alias_status_v1_9_24": "ADDED_ALTERNATE_PAGE_HANDLES_FOR_JAPAN_PRIVATE_SOURCING_REQUEST_REVIEW"
  },
  "universal_final_confirmations": [
    "I confirm that this intake is connected to the appropriate paid review, deposit, retainer, invoice, or JapanSolved™-approved payment path for the service I am requesting.",
    "If I have not completed payment yet, I understand JapanSolved™ may route me to the correct product/payment path before reviewing or acting on this intake.",
    "I understand this intake does not guarantee acceptance, approval, availability, seller cooperation, access, sourcing success, reservation success, export/import clearance, customs clearance, carrier acceptance, repair outcome, recovery outcome, safety outcome, ticket or reservation outcome, or final third-party pricing.",
    "I confirm the information I submitted is accurate to the best of my knowledge and that I am authorized to share it.",
    "I understand JapanSolved™ may request additional clarification, documents, photos, links, payment, authorization, route correction, lawful-handling review, feasibility review, or a separate quote before the case can proceed."
  ],
  "records": [
    {
      "page_title": "Japan Arts & Antiques Authentication & Provenance Intelligence Desk™",
      "page_handle": "japan-art-antiques-authentication-provenance",
      "page_url": "https://japansolved.com/pages/japan-art-antiques-authentication-provenance",
      "subject_label": "Arts & Antiques Authentication & Provenance Intake",
      "intake_title": "Arts & Antiques Authentication & Provenance Case File Intake",
      "service_label": "Japan art, antiques, appraisal, provenance, condition, specialist pathway, export-risk, custody, and acquisition-support review",
      "descriptor_line1": "Payment first. Case file second. Object photos, seller links, documentation, certificates, inscriptions, condition notes, price context, export risk, and the decision question stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the object review payment first",
      "payment_block_copy": "Choose the baseline object review, specialist case deposit, collector retainer, proxy-shopping review, approved invoice, access deposit, custom quote, or private payment path that matches this art and antiques authentication or provenance request.",
      "payment_block_fineprint": "Use the same payment email at intake so the art and antiques authentication file can be matched to the paid path.",
      "not_paid_error": "This art and antiques authentication/provenance intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Art & Antique Appraisal Review™ — $395",
          "value": "/products/japan-art-antique-appraisal-review"
        },
        {
          "label": "Japan Art & Antique Specialist Case Deposit™ — from $750",
          "value": "/products/japan-art-antique-specialist-case-deposit"
        },
        {
          "label": "Japan Private Collector Desk Retainer™ — from $1,500/month",
          "value": "/products/japan-private-collector-desk-retainer"
        },
        {
          "label": "Japan High-Value Proxy Shopping Review™",
          "value": "/products/japan-high-value-proxy-shopping-review"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the object review file for a paid review, specialist case deposit, approved invoice, collector retainer, proxy-shopping path, custom quote, or JapanSolved™-approved private payment route.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this object review?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for Japan Art & Antique Appraisal Review™",
                  "value": "yes_art_antique_appraisal_review_paid"
                },
                {
                  "label": "Yes, I completed payment for Japan Art & Antique Specialist Case Deposit™",
                  "value": "yes_specialist_case_deposit_paid"
                },
                {
                  "label": "Yes, I am on an approved invoice, access deposit, collector retainer, custom quote, or private payment path",
                  "value": "yes_approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_submit"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Art & Antique Appraisal Review™ — /products/japan-art-antique-appraisal-review",
                  "value": "/products/japan-art-antique-appraisal-review"
                },
                {
                  "label": "Japan Art & Antique Specialist Case Deposit™ — /products/japan-art-antique-specialist-case-deposit",
                  "value": "/products/japan-art-antique-specialist-case-deposit"
                },
                {
                  "label": "Japan Private Collector Desk Retainer™ — /products/japan-private-collector-desk-retainer",
                  "value": "/products/japan-private-collector-desk-retainer"
                },
                {
                  "label": "Japan High-Value Proxy Shopping Review™ — /products/japan-high-value-proxy-shopping-review",
                  "value": "/products/japan-high-value-proxy-shopping-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, deposit, retainer, invoice, proxy-shopping route, or approved private payment path."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the collector / buyer / owner",
                  "value": "collector_buyer_owner"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Gallery / dealer / designer / advisor",
                  "value": "gallery_dealer_designer_advisor"
                },
                {
                  "label": "Estate, family, or institutional representative",
                  "value": "estate_family_institutional_representative"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client, object owner, or buying office now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "object_profile",
          "title": "Object, seller, and documentation profile",
          "fields": [
            {
              "id": "object_description",
              "label": "What object, listing, document set, collection item, or category needs authentication/provenance review?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "object_category",
              "label": "Which category best describes the object?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Textile, kimono, obi, boro, sashiko, or wearable/archive material",
                  "value": "textile_kimono_obi_boro_sashiko"
                },
                {
                  "label": "Print, paper, wall art, calligraphy, painting, or framed work",
                  "value": "print_paper_wall_art_calligraphy_painting"
                },
                {
                  "label": "Lacquer, cloisonné, Meiji craft, ceramics, tea object, tetsubin, or boxed craft",
                  "value": "lacquer_cloisonne_meiji_craft_ceramics_tea_tetsubin"
                },
                {
                  "label": "Armor, fittings, samurai display object, sword-adjacent object, or martial-cultural item",
                  "value": "armor_fittings_samurai_sword_adjacent"
                },
                {
                  "label": "Buddhist, ritual, temple-adjacent, devotional, folk, doll, mask, netsuke, or okimono object",
                  "value": "buddhist_ritual_folk_netsuke_okimono"
                },
                {
                  "label": "Tansu, byobu, ranma, furniture, interior statement piece, or large-format object",
                  "value": "tansu_byobu_ranma_furniture_large_format"
                },
                {
                  "label": "Multiple objects or uncertain category",
                  "value": "multiple_or_uncertain_category"
                }
              ]
            },
            {
              "id": "seller_and_source",
              "label": "Seller/source context: shop, dealer, auction, marketplace, gallery, estate, private seller, listing URL, location, and price",
              "type": "textarea",
              "required": false
            },
            {
              "id": "documents_and_marks",
              "label": "Known documents, boxes, certificates, inscriptions, signatures, labels, seals, prior ownership notes, or Japanese-language materials",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "proof_condition_risk",
          "title": "Proof, attribution, condition, and red-flag review",
          "fields": [
            {
              "id": "decision_question",
              "label": "What are you trying to decide: buy, pause, authenticate, request more proof, negotiate, insure, export, sell, or walk away?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "proof_questions",
              "label": "What proof, provenance, authorship, age, maker, school, period, certificate, inscription, or seller claim needs review?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "condition_concerns",
              "label": "Visible or suspected condition concerns",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Stains, fading, odor, textile weakness, or fiber damage",
                  "value": "stains_fading_odor_textile_weakness"
                },
                {
                  "label": "Foxing, trimming, backing, fading, edition/reprint concern, or paper damage",
                  "value": "foxing_trimming_backing_reprint_paper_damage"
                },
                {
                  "label": "Cracks, chips, missing parts, repair, restoration, repainting, over-polish, or unstable material",
                  "value": "cracks_chips_missing_parts_repair_restoration"
                },
                {
                  "label": "Rust, mineral buildup, lining concern, safety/use issue, or tea-object condition issue",
                  "value": "rust_mineral_lining_safety_or_use_issue"
                },
                {
                  "label": "Mixed-period assembly, replacement parts, loose fittings, display/custody risk",
                  "value": "mixed_period_replacement_parts_display_custody_risk"
                },
                {
                  "label": "Photos are incomplete, unclear, cropped, filtered, or too weak for confidence",
                  "value": "photos_incomplete_or_unclear"
                },
                {
                  "label": "No obvious condition concern yet",
                  "value": "no_obvious_condition_concern"
                }
              ]
            },
            {
              "id": "market_or_value_context",
              "label": "Price, comparable sales, insurance/resale goal, family/estate context, collection strategy, or value sensitivity",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "export_custody_route",
          "title": "Export, custody, acquisition, and escalation route",
          "fields": [
            {
              "id": "current_stage",
              "label": "Where is the object opportunity right now?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Before purchase / listing under review",
                  "value": "before_purchase_listing_under_review"
                },
                {
                  "label": "Auction or seller deadline approaching",
                  "value": "auction_or_seller_deadline_approaching"
                },
                {
                  "label": "Already purchased and needs review/routing",
                  "value": "already_purchased_needs_review_routing"
                },
                {
                  "label": "Estate, inheritance, insurance, resale, or documentation question",
                  "value": "estate_inheritance_insurance_resale_documentation"
                },
                {
                  "label": "Category exploration before sourcing",
                  "value": "category_exploration_before_sourcing"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "likely_next_route",
              "label": "Which next route may be needed after baseline review?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Specialist appraisal, expert review, or expanded provenance research",
                  "value": "specialist_appraisal_expert_review_provenance"
                },
                {
                  "label": "Seller questions, proof request, negotiation, or pre-acquisition support",
                  "value": "seller_questions_proof_request_negotiation"
                },
                {
                  "label": "Private buyer execution or proxy QA for a found listing",
                  "value": "private_buyer_execution_or_proxy_qa"
                },
                {
                  "label": "Export, cultural property, customs, packing, storage, cargo, or insurance route",
                  "value": "export_cultural_property_customs_packing_cargo_insurance"
                },
                {
                  "label": "Collector watch desk, retainer, or repeat acquisition support",
                  "value": "collector_watch_retainer_repeat_acquisition"
                },
                {
                  "label": "No next route yet. I need the first decision framework.",
                  "value": "need_first_decision_framework"
                }
              ]
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination country/city, Japan-side object location, seller region, storage/custody context, or handoff route",
              "type": "textarea",
              "required": false
            },
            {
              "id": "approval_boundaries",
              "label": "Actions JapanSolved™ must not take without explicit written approval",
              "type": "textarea",
              "required": false,
              "helper": "Examples: seller contact, bid approval, purchase approval, proof request, deposit, pickup, packing, storage, freight route, specialist fee, declared value, or retainer escalation."
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "urgency",
              "label": "How urgent is this object review?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Immediate / purchase deadline within 24 hours",
                  "value": "urgent_within_24_hours"
                },
                {
                  "label": "Within 72 hours",
                  "value": "urgent_within_72_hours"
                },
                {
                  "label": "This week",
                  "value": "this_week"
                },
                {
                  "label": "Before purchase decision, timing still flexible",
                  "value": "pre_purchase_flexible"
                },
                {
                  "label": "Category exploration or documentation review, flexible timing",
                  "value": "category_or_documentation_flexible"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_timing",
              "label": "Target timing, auction close, seller deadline, appointment date, shipping window, or decision deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Purchase price, quoted value, budget range, insurance/resale value, or specialist support budget",
              "type": "text",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, custody concerns, resale constraints, institutional/advisor requirements, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, photos, videos, seller pages, auction records, certificates, box photos, inscriptions, screenshots, market examples, or documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, compared, translated, authenticated, sourced, negotiated, quoted, purchased, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "tone": "Please confirm the operating boundaries before reviewing and sending the art and antiques authentication/provenance case file.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid path boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand this intake is tied to the appropriate paid review, specialist case deposit, collector retainer, invoice, or JapanSolved™-approved private payment route."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users must be routed to the correct product/payment path before intake submission can be reviewed or authentication/provenance work can begin."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, authenticity, valuation, market value, investment return, seller cooperation, item availability, purchase approval, export approval, customs clearance, carrier acceptance, specialist opinion, resale performance, or final outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate and I am authorized to submit it."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "001",
      "record_id": "JSII_BANK_JAPAN_ART_ANTIQUES_AUTHENTICATION_PROVENANCE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Arts & Antiques Authentication & Provenance Intelligence Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Private Deputy Shopping Proxy & Quality Assurance Desk™",
      "page_handle": "japan-proxy-shopping-quality-assurance",
      "page_url": "https://japansolved.com/pages/japan-proxy-shopping-quality-assurance",
      "intake_title": "Japan Private Deputy Shopping Proxy & Quality Assurance™ Intake",
      "service_label": "Japan found-listing proxy shopping, seller question, purchase-risk, and quality-assurance support",
      "subject_label": "Private Deputy Shopping Proxy & Quality Assurance",
      "descriptor_line1": "A guided, paginated case-file intake for Japan Private Deputy Shopping Proxy & Quality Assurance Desk™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan High-Value Proxy Shopping Review™",
          "value": "/products/japan-high-value-proxy-shopping-review",
          "render_as_link": true
        },
        {
          "label": "Japan Proxy Purchase Case Deposit™",
          "value": "/products/japan-proxy-purchase-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan High-Value Proxy Shopping Review™",
                  "value": "/products/japan-high-value-proxy-shopping-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Proxy Shopping & Quality Assurance request profile",
          "fields": [
            {
              "id": "proxy_goal",
              "label": "What found item, listing, seller, shop, auction, or platform do you want JapanSolved™ to review?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "item_listing_details",
              "label": "Item details, URL, screenshots, seller name, price, photos, size/version/condition notes, and availability concerns",
              "type": "textarea",
              "required": false
            },
            {
              "id": "qa_questions",
              "label": "Questions you need answered before purchase: condition, completeness, seller terms, domestic delivery, return limits, or platform friction",
              "type": "textarea",
              "required": false
            },
            {
              "id": "purchase_handoff_concerns",
              "label": "Payment, receiving, inspection photos, storage, packing, cargo, export, authenticity, or handoff concerns",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, service route, or local execution location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, service notes, route notes, product pages, or documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, shop, service center, carrier, facility, customs party, or logistics provider?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, service-center acceptance, compliance approval, export/import clearance, pickup, shipment, recovery, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "002",
      "record_id": "JSII_BANK_JAPAN_PROXY_SHOPPING_QUALITY_ASSURANCE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Private Deputy Shopping Proxy & Quality Assurance Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Private Buyer Proxy & Execution Desk™",
      "page_handle": "japan-private-buyer-proxy-execution-desk",
      "page_url": "https://japansolved.com/pages/japan-private-buyer-proxy-execution-desk",
      "intake_title": "Japan Private Buyer Proxy & Execution™ Intake",
      "service_label": "Japan-side private buyer execution, seller communication, purchase, custody, and handoff support",
      "subject_label": "Private Buyer Proxy & Execution",
      "descriptor_line1": "A guided, paginated case-file intake for Japan Private Buyer Proxy & Execution Desk™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Private Buyer Execution Review™",
          "value": "/products/japan-private-buyer-execution-review",
          "render_as_link": true
        },
        {
          "label": "Japan Private Buyer Execution Case Deposit™",
          "value": "/products/japan-private-buyer-execution-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Private Buyer Execution Review™",
                  "value": "/products/japan-private-buyer-execution-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Private Buyer Proxy & Execution request profile",
          "fields": [
            {
              "id": "buyer_goal",
              "label": "What item, seller, shop, dealer, appointment, or Japan-side action do you need handled?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "item_seller_details",
              "label": "Item details, seller/shop name, listing URL, price, location, photos, condition notes, and current availability",
              "type": "textarea",
              "required": false
            },
            {
              "id": "execution_needs",
              "label": "Needed action: seller contact, reservation, purchase execution, pickup, receiving, inspection photos, service routing, custody, or handoff",
              "type": "textarea",
              "required": false
            },
            {
              "id": "handoff_risks",
              "label": "Payment limits, urgency, fragile handling, storage, packing, cargo, export, authentication, warranty, or compliance concerns",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, service route, or local execution location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, service notes, route notes, product pages, or documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, shop, service center, carrier, facility, customs party, or logistics provider?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, service-center acceptance, compliance approval, export/import clearance, pickup, shipment, recovery, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "003",
      "record_id": "JSII_BANK_JAPAN_PRIVATE_BUYER_PROXY_EXECUTION_DESK",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Private Buyer Proxy & Execution Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Private Sourcing & Collector Acquisition Desk™",
      "page_handle": "japan-private-sourcing-collector-acquisition-desk",
      "alternate_page_handles": [
        "japan-private-sourcing-request-review",
        "private-sourcing-request-review",
        "japan-private-sourcing-review"
      ],
      "page_url": "https://japansolved.com/pages/japan-private-sourcing-collector-acquisition-desk",
      "intake_title": "Japan Private Sourcing & Collector Acquisition Intake™",
      "service_label": "Japan private sourcing, collector acquisition, target definition, seller-channel logic, category fit, budget, and acquisition-route review",
      "subject_label": "Private Sourcing & Collector Acquisition",
      "descriptor_line1": "A guided, paginated case-file intake for private sourcing and collector acquisition review.",
      "descriptor_line2": "Payment first. Case file second. Route, scope, timing, privacy, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review path that matches this request. Private invoice, deposit, quote, or retainer cases should use the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Private Sourcing Request Review™",
          "value": "/products/japan-private-sourcing-request-review",
          "render_as_link": true
        },
        {
          "label": "Japan Private Sourcing Case Deposit™",
          "value": "/products/japan-private-sourcing-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, deposit, quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Private Sourcing Request Review™",
                  "value": "/products/japan-private-sourcing-request-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Private sourcing and acquisition request profile",
          "fields": [
            {
              "id": "sourcing_target",
              "label": "What do you want JapanSolved™ to source, compare, locate, or route for acquisition?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "target_examples",
              "label": "Examples, reference links/photos, preferred condition, quantity, dimensions, brands/makers/categories, style direction, and must-have details",
              "type": "textarea",
              "required": false
            },
            {
              "id": "source_logic",
              "label": "Known source channels, sellers, fairs, shops, auction routes, private-dealer context, or places already checked",
              "type": "textarea",
              "required": false
            },
            {
              "id": "acquisition_decision",
              "label": "What should happen next: define target, search, compare, negotiate, authenticate, buy, QA, cargo, or build an ongoing mandate?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, spending ceiling, retainer context, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, city, route, handoff, appointment, movement, support location, delivery address, or service context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, safety concerns, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, image references, messages, route notes, product pages, public listings, documents, or prior correspondence",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, booked, checked, reported, sourced, purchased, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, access, assignment, availability, coordination, purchase, meeting, location result, family outcome, recovery, approval, export/import clearance, service completion, or any specific outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "004",
      "record_id": "JSII_BANK_JAPAN_PRIVATE_SOURCING_COLLECTOR_ACQUISITION_DESK",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Private Sourcing & Collector Acquisition Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Large Format Cargo Shipping & Execution Desk™",
      "page_handle": "japan-large-cargo-shipping-logistics",
      "page_url": "https://japansolved.com/pages/japan-large-cargo-shipping-logistics",
      "intake_title": "Japan Large Format Cargo Shipping & Execution™ Intake",
      "service_label": "Japan large-format cargo feasibility, pickup, packing, storage, freight, and export-handoff support",
      "subject_label": "Large Format Cargo Shipping & Execution",
      "descriptor_line1": "A guided, paginated case-file intake for Japan Large Format Cargo Shipping & Execution Desk™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Large Cargo Logistics Review™",
          "value": "/products/japan-large-cargo-logistics-review",
          "render_as_link": true
        },
        {
          "label": "Japan Cargo Execution Case Deposit™",
          "value": "/products/japan-cargo-execution-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Large Cargo Logistics Review™",
                  "value": "/products/japan-large-cargo-logistics-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Large Cargo Shipping & Execution request profile",
          "fields": [
            {
              "id": "cargo_goal",
              "label": "What object, cargo, seller handoff, pickup, packing, or freight route do you need JapanSolved™ to review?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "object_details",
              "label": "Object details: category, dimensions, weight, fragility, value, materials, condition, photos, current packing status, and location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "movement_route",
              "label": "Pickup location, seller capacity, destination country/city, timing, storage, vendor, freight, customs, or insurance context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "cargo_risks",
              "label": "Known risks: stairs/access, crating, fragile surfaces, cultural-object concerns, oversize freight, documentation, or destination-side handling",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, service route, or local execution location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, service notes, route notes, product pages, or documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, shop, service center, carrier, facility, customs party, or logistics provider?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, service-center acceptance, compliance approval, export/import clearance, pickup, shipment, recovery, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "005",
      "record_id": "JSII_BANK_JAPAN_LARGE_CARGO_SHIPPING_LOGISTICS",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Large Format Cargo Shipping & Execution Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Cultural Asset & Luxury Collectibles Investment Intelligence Desk™",
      "page_handle": "japan-cultural-asset-luxury-collectibles-intelligence",
      "page_url": "https://japansolved.com/pages/japan-cultural-asset-luxury-collectibles-intelligence",
      "subject_label": "Cultural Asset & Luxury Collectibles Intelligence Intake",
      "intake_title": "Cultural Asset & Luxury Collectibles Intelligence™ Case File Intake",
      "service_label": "Japan cultural asset, luxury collectible, acquisition thesis, market context, category intelligence, proof-sensitivity, and pursuit-routing review",
      "descriptor_line1": "Payment first. Case file second. Object links, category interest, seller context, budget, proof sensitivity, movement risk, and the decision question stay attached to the paid intelligence review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the intelligence review payment first",
      "payment_block_copy": "Choose the object interest triage, collector purchase intelligence brief, acquisition strategy desk, approved invoice, access deposit, custom quote, or private payment path that matches this cultural asset or luxury collectibles request.",
      "payment_block_fineprint": "Use the same payment email at intake so the cultural asset intelligence file can be matched to the paid path.",
      "not_paid_error": "This cultural asset and luxury collectibles intelligence intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Object Interest Triage™ — $295",
          "value": "/products/japan-cultural-asset-object-interest-triage"
        },
        {
          "label": "Collector Purchase Intelligence Brief™ — from $750",
          "value": "/products/japan-collector-purchase-intelligence-brief"
        },
        {
          "label": "Cultural Asset Acquisition Strategy Desk™ — from $1,500",
          "value": "/products/japan-cultural-asset-acquisition-strategy-desk"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the intelligence support file for a paid review, approved invoice, acquisition strategy desk, access deposit, retainer, custom quote, or JapanSolved™-approved private payment path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this intelligence request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for Object Interest Triage™",
                  "value": "yes_object_interest_triage_paid"
                },
                {
                  "label": "Yes, I completed payment for Collector Purchase Intelligence Brief™",
                  "value": "yes_collector_purchase_intelligence_brief_paid"
                },
                {
                  "label": "Yes, I am on an approved invoice, access deposit, strategy desk, retainer, or private payment path",
                  "value": "yes_approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_submit"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Object Interest Triage™ — /products/japan-cultural-asset-object-interest-triage",
                  "value": "/products/japan-cultural-asset-object-interest-triage"
                },
                {
                  "label": "Collector Purchase Intelligence Brief™ — /products/japan-collector-purchase-intelligence-brief",
                  "value": "/products/japan-collector-purchase-intelligence-brief"
                },
                {
                  "label": "Cultural Asset Acquisition Strategy Desk™ — /products/japan-cultural-asset-acquisition-strategy-desk",
                  "value": "/products/japan-cultural-asset-acquisition-strategy-desk"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, brief, strategy desk, access deposit, invoice, retainer, or approved private payment route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the collector / buyer / owner",
                  "value": "collector_buyer_owner"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Gallery / dealer / designer / advisor",
                  "value": "gallery_dealer_designer_advisor"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client or buying office now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "asset_interest_profile",
          "title": "Object, category, or acquisition thesis profile",
          "fields": [
            {
              "id": "asset_interest",
              "label": "What object, category, collection direction, luxury collectible, or acquisition idea do you want reviewed?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "asset_category",
              "label": "Which category best describes the interest?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Art, antiques, folk craft, Buddhist object, tea object, lacquer, textile, print, armor, furniture, tansu, or cultural object",
                  "value": "art_antique_folk_craft_religious_tea_lacquer_textile_print_armor_furniture"
                },
                {
                  "label": "Luxury collectible, fashion archive, watch, designer object, limited item, or Japan-only release",
                  "value": "luxury_collectible_fashion_archive_watch_designer_limited_release"
                },
                {
                  "label": "Gallery, auction, dealer, private seller, online listing, or marketplace object",
                  "value": "gallery_auction_dealer_private_seller_online_listing"
                },
                {
                  "label": "Category direction with no specific object yet",
                  "value": "category_direction_no_specific_object"
                },
                {
                  "label": "Multi-object or collection-building plan",
                  "value": "multi_object_collection_building"
                },
                {
                  "label": "Not sure how to classify it",
                  "value": "not_sure_how_to_classify"
                }
              ]
            },
            {
              "id": "object_category_details",
              "label": "Object/category details: links, photos, seller materials, age/artist/maker claims, price, condition, market examples, and intended use",
              "type": "textarea",
              "required": false
            },
            {
              "id": "current_stage",
              "label": "Where is the opportunity right now?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am exploring a category before sourcing",
                  "value": "exploring_category_before_sourcing"
                },
                {
                  "label": "I found a specific object/listing and need decision intelligence",
                  "value": "specific_object_or_listing_decision_intelligence"
                },
                {
                  "label": "I am comparing multiple objects or categories",
                  "value": "comparing_multiple_objects_or_categories"
                },
                {
                  "label": "I am close to purchase and need route classification",
                  "value": "close_to_purchase_route_classification"
                },
                {
                  "label": "I already purchased and need next-step routing",
                  "value": "already_purchased_need_next_step_routing"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "decision_and_risk_logic",
          "title": "Decision question, proof sensitivity, and risk logic",
          "fields": [
            {
              "id": "decision_question",
              "label": "What are you trying to decide: pursue, pause, authenticate, source, compare, negotiate, route to cargo, or walk away?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "proof_sensitivity",
              "label": "What proof, provenance, authorship, condition, certificate, category, or seller claims may affect the decision?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "investment_context",
              "label": "Budget, resale horizon, collection strategy, family-office/advisor context, insurance/storage concerns, and risk tolerance",
              "type": "textarea",
              "required": false
            },
            {
              "id": "visible_risk_flags",
              "label": "Visible risk flags or concerns",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Rarity language or seller story may be weak",
                  "value": "rarity_language_or_seller_story_may_be_weak"
                },
                {
                  "label": "Authenticity, maker, period, provenance, or certificate uncertainty",
                  "value": "authenticity_maker_period_provenance_certificate_uncertainty"
                },
                {
                  "label": "Condition, restoration, damage, missing parts, or incomplete photos",
                  "value": "condition_restoration_damage_missing_parts_incomplete_photos"
                },
                {
                  "label": "Price seems high, unclear, or difficult to compare",
                  "value": "price_high_unclear_or_difficult_to_compare"
                },
                {
                  "label": "Export, cultural-property, regulated-category, or ethical-source concern",
                  "value": "export_cultural_property_regulated_or_ethics_concern"
                },
                {
                  "label": "Cargo, storage, packing, insurance, customs, or destination movement risk",
                  "value": "cargo_storage_packing_insurance_customs_destination_risk"
                },
                {
                  "label": "No obvious risk yet",
                  "value": "no_obvious_risk_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "routing_and_next_path",
          "title": "Possible next desk or escalation route",
          "fields": [
            {
              "id": "likely_next_route",
              "label": "Which next route do you think may be needed after intelligence review?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Authentication / provenance / proof review",
                  "value": "authentication_provenance_proof_review"
                },
                {
                  "label": "Private sourcing or collector acquisition search",
                  "value": "private_sourcing_collector_acquisition_search"
                },
                {
                  "label": "Private buyer execution or proxy QA for a found listing",
                  "value": "private_buyer_execution_or_proxy_qa"
                },
                {
                  "label": "Guided shopping, gallery route, or in-person discovery",
                  "value": "guided_shopping_gallery_route_in_person_discovery"
                },
                {
                  "label": "Compliance, export, cargo, packing, storage, or freight review",
                  "value": "compliance_export_cargo_packing_storage_freight"
                },
                {
                  "label": "Strategy desk, advisory retainer, or repeated collection support",
                  "value": "strategy_desk_advisory_retainer_repeated_support"
                },
                {
                  "label": "No next route yet. I need the first decision framework.",
                  "value": "need_first_decision_framework"
                }
              ]
            },
            {
              "id": "approval_boundaries",
              "label": "Approvals JapanSolved™ must not give without your explicit written consent",
              "type": "textarea",
              "required": false,
              "helper": "Examples: purchase approval, bid approval, seller contact, proof request, negotiation, deposit, pickup, storage, packing, freight route, declared value, specialist fee, or retainer escalation."
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "urgency",
              "label": "How urgent is this intelligence request?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Immediate / purchase deadline within 24 hours",
                  "value": "urgent_within_24_hours"
                },
                {
                  "label": "Within 72 hours",
                  "value": "urgent_within_72_hours"
                },
                {
                  "label": "This week",
                  "value": "this_week"
                },
                {
                  "label": "Before purchase decision, timing still flexible",
                  "value": "pre_purchase_flexible"
                },
                {
                  "label": "Category exploration, flexible timing",
                  "value": "category_exploration_flexible"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_timing",
              "label": "Target timing, seller deadline, auction close, appointment date, purchase window, or decision deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, purchase ceiling, item value range, vendor quote received, or advisory budget",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination country/city, Japan-side location, seller region, gallery/auction route, storage route, or handoff context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, custody concerns, language issues, resale constraints, institution/advisor requirements, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, photos, videos, seller pages, auction records, certificates, screenshots, market examples, route notes, or documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, compared, authenticated, sourced, negotiated, quoted, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "tone": "Please confirm the operating boundaries before reviewing and sending the cultural asset intelligence case file.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid path boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand this intake is tied to the appropriate paid review, intelligence brief, strategy desk, retainer, invoice, or JapanSolved™-approved private payment route."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users must be routed to the correct product/payment path before intake submission can be reviewed or acquisition intelligence work can begin."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, authenticity, valuation, investment return, seller cooperation, item availability, sourcing success, purchase approval, export approval, customs clearance, carrier acceptance, market liquidity, resale performance, or final outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate and I am authorized to submit it."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "006",
      "record_id": "JSII_BANK_JAPAN_CULTURAL_ASSET_LUXURY_COLLECTIBLES_INTELLIGENCE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Cultural Asset & Luxury Collectibles Investment Intelligence Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Watch Servicing & Warranty Proxy Desk™",
      "page_handle": "japan-watch-servicing-warranty-proxy",
      "page_url": "https://japansolved.com/pages/japan-watch-servicing-warranty-proxy",
      "intake_title": "Japan Watch Servicing & Warranty Proxy™ Intake",
      "service_label": "Japan watch servicing, warranty, boutique, custody, repair communication, and return-route support",
      "subject_label": "Watch Servicing & Warranty Proxy",
      "descriptor_line1": "A guided, paginated case-file intake for Japan Watch Servicing & Warranty Proxy Desk™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Watch Servicing Proxy Review™",
          "value": "/products/japan-watch-servicing-proxy-review",
          "render_as_link": true
        },
        {
          "label": "Japan Watch Service Case Deposit™",
          "value": "/products/japan-watch-service-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Watch Servicing Proxy Review™",
                  "value": "/products/japan-watch-servicing-proxy-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Watch Servicing & Warranty request profile",
          "fields": [
            {
              "id": "watch_goal",
              "label": "What watch service, warranty, boutique, repair, custody, or return-route issue do you need JapanSolved™ to review?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "watch_details",
              "label": "Watch details: brand, model, serial-sensitive notes, purchase country, warranty status, documents, service history, and current location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "service_path",
              "label": "Service path context: boutique, authorized service center, seller, repair desk, warranty claim, estimate, refusal, or required approval",
              "type": "textarea",
              "required": false
            },
            {
              "id": "custody_return_risks",
              "label": "Custody, insured movement, storage, pickup, domestic delivery, international return, customs, originality, or parts-replacement concerns",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, service route, or local execution location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, service notes, route notes, product pages, or documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, shop, service center, carrier, facility, customs party, or logistics provider?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, service-center acceptance, compliance approval, export/import clearance, pickup, shipment, recovery, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "007",
      "record_id": "JSII_BANK_JAPAN_WATCH_SERVICING_WARRANTY_PROXY",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Watch Servicing & Warranty Proxy Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Sword Compliance & Export Intelligence Desk™",
      "page_handle": "japan-sword-export-compliance",
      "alternate_page_handles": [
        "japanese-sword-export-documentation-compliance",
        "japan-sword-export-documentation-compliance",
        "japanese-sword-export-compliance"
      ],
      "page_url": "https://japansolved.com/pages/japan-sword-export-compliance",
      "intake_title": "Japan Sword Compliance & Export Intelligence Intake™",
      "service_label": "Japan sword, fittings, martial-cultural object, compliance, documentation, export, and destination-risk support",
      "subject_label": "Sword Compliance & Export Intelligence",
      "descriptor_line1": "A guided, paginated case-file intake for Japan Sword Compliance & Export Intelligence Desk™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Sword Export Compliance Review™",
          "value": "/products/japan-sword-export-compliance-review",
          "render_as_link": true
        },
        {
          "label": "Japan Sword Compliance Case Deposit™",
          "value": "/products/japan-sword-compliance-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Sword Export Compliance Review™",
                  "value": "/products/japan-sword-export-compliance-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Sword Compliance & Export request profile",
          "fields": [
            {
              "id": "sword_goal",
              "label": "What sword, fitting, armor-related object, seller claim, documentation, or export path do you need JapanSolved™ to review?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "object_documents",
              "label": "Object details: photos, dimensions, registration card, appraisal papers, inscriptions, seller materials, purchase status, and location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "destination_compliance",
              "label": "Destination country, intended movement route, carrier/customs concerns, ownership context, and deadline",
              "type": "textarea",
              "required": false
            },
            {
              "id": "risk_questions",
              "label": "Questions about cultural property risk, registration mismatch, attribution, specialist review, legal consultation, cargo, or whether to pause",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, service route, or local execution location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, service notes, route notes, product pages, or documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, shop, service center, carrier, facility, customs party, or logistics provider?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, service-center acceptance, compliance approval, export/import clearance, pickup, shipment, recovery, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "008",
      "record_id": "JSII_BANK_JAPAN_SWORD_EXPORT_COMPLIANCE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Sword Compliance & Export Intelligence Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Bonsai Export & Compliance Desk™",
      "page_handle": "japan-bonsai-export-compliance",
      "page_url": "https://japansolved.com/pages/japan-bonsai-export-compliance",
      "subject_label": "Bonsai Export Compliance Intake",
      "intake_title": "Bonsai Export & Living Cargo™ Case File Intake",
      "descriptor_line1": "Payment first. Case file second. Tree profile, nursery route, destination rules, timing, documents, and living-cargo risk stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the paid review, case deposit, living-cargo retainer, or approved private path that matches this bonsai export request.",
      "payment_block_fineprint": "Use the same payment email at intake so the tree file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full bonsai export case file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Bonsai Export Compliance Review™",
          "value": "/products/japan-bonsai-export-compliance-review"
        },
        {
          "label": "Japan Bonsai Export Case Deposit™",
          "value": "/products/japan-bonsai-export-case-deposit"
        },
        {
          "label": "Japan Living Cargo Coordination Retainer™",
          "value": "/products/japan-living-cargo-coordination-retainer"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the case file for a paid bonsai export review, approved invoice, living-cargo deposit, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_public_review_paid"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_private_approved_path_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Bonsai Export Compliance Review™",
                  "value": "/products/japan-bonsai-export-compliance-review"
                },
                {
                  "label": "Japan Bonsai Export Case Deposit™",
                  "value": "/products/japan-bonsai-export-case-deposit"
                },
                {
                  "label": "Japan Living Cargo Coordination Retainer™",
                  "value": "/products/japan-living-cargo-coordination-retainer"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "If JapanSolved™ told you to submit before a public checkout exists, enter the approved instruction or invoice reference."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client and requester identity",
          "tone": "Tell us who the bonsai export file belongs to and who has authority to make decisions about the tree, nursery, destination, and paid scope.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "country_timezone",
              "label": "Country / timezone",
              "type": "text",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "client_case_profile",
              "label": "Requester / buyer profile",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Private collector / private buyer",
                  "value": "private_collector_buyer"
                },
                {
                  "label": "Garden / landscape project / estate project",
                  "value": "garden_landscape_estate"
                },
                {
                  "label": "Nursery / commercial buyer / trade-side request",
                  "value": "nursery_commercial_trade"
                },
                {
                  "label": "Designer / hotel / hospitality project",
                  "value": "designer_hotel_project"
                },
                {
                  "label": "Family office / assistant / representative",
                  "value": "family_office_representative"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "requester_authority",
              "label": "Are you authorized to submit details and make paid-scope decisions for this file?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Yes, I am the decision-maker",
                  "value": "decision_maker"
                },
                {
                  "label": "Yes, I am authorized by the decision-maker",
                  "value": "authorized_representative"
                },
                {
                  "label": "I need JapanSolved™ to understand the decision chain",
                  "value": "decision_chain_unclear"
                }
              ]
            }
          ]
        },
        {
          "id": "tree_and_route_profile",
          "title": "Tree, nursery, and destination profile",
          "tone": "Bonsai export begins with the actual tree and its route. A beautiful tree is not automatically an exportable tree.",
          "fields": [
            {
              "id": "bonsai_goal",
              "label": "What bonsai, nursery tree, pot, or horticultural item are you considering?",
              "type": "textarea",
              "required": true,
              "helper": "Include species if known, quantity, nursery/source, listing or seller, whether it is already selected, and what you want JapanSolved™ to decide."
            },
            {
              "id": "purchase_status",
              "label": "Purchase / reservation status",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Not purchased yet. I want feasibility before commitment.",
                  "value": "not_purchased_feasibility_first"
                },
                {
                  "label": "Reserved or under discussion with seller / nursery",
                  "value": "reserved_under_discussion"
                },
                {
                  "label": "Already purchased or deposit paid",
                  "value": "already_purchased_or_deposit_paid"
                },
                {
                  "label": "I need JapanSolved™ to help find candidates first",
                  "value": "needs_sourcing_first"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure_purchase_status"
                }
              ]
            },
            {
              "id": "destination_country",
              "label": "Destination country / import side",
              "type": "text",
              "required": true,
              "helper": "Import rules depend heavily on destination country, species, soil/root state, permits, and inspection path."
            },
            {
              "id": "species_quantity",
              "label": "Species, quantity, age/size, pot/root status, and value range",
              "type": "textarea",
              "required": false
            },
            {
              "id": "nursery_seller_details",
              "label": "Nursery, seller, source, location in Japan, or listing details",
              "type": "textarea",
              "required": false
            },
            {
              "id": "photos_documents_links",
              "label": "Links, photos, documents, seller messages, or reference material",
              "type": "textarea",
              "required": false,
              "helper": "Paste URLs or describe the images/documents you can provide after intake."
            }
          ]
        },
        {
          "id": "living_cargo_compliance",
          "title": "Living-cargo compliance and handling concerns",
          "tone": "Flag the checkpoints that may control whether the case remains a review, becomes a deposit, or needs specialist routing.",
          "fields": [
            {
              "id": "bonsai_route_themes",
              "label": "Which bonsai/export support layers may matter?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Species and destination eligibility review",
                  "value": "species_destination_eligibility"
                },
                {
                  "label": "Plant quarantine or phytosanitary document path",
                  "value": "quarantine_phytosanitary"
                },
                {
                  "label": "CITES, restricted species, or protected-material concern",
                  "value": "cites_restricted_species"
                },
                {
                  "label": "Soil, root, bare-root, pest, treatment, or inspection risk",
                  "value": "soil_root_pest_treatment"
                },
                {
                  "label": "Nursery communication or seller export-readiness questions",
                  "value": "nursery_communication_export_readiness"
                },
                {
                  "label": "Pickup, temporary custody, specialist packing, or domestic handoff",
                  "value": "custody_packing_handoff"
                },
                {
                  "label": "Freight, broker, customs, or destination-side import readiness",
                  "value": "freight_broker_customs_import"
                },
                {
                  "label": "High-value pot, stand, ceramic object, or non-living-cargo route",
                  "value": "pot_stand_non_living_object"
                },
                {
                  "label": "Sourcing or private buyer support before export review",
                  "value": "sourcing_private_buyer_first"
                }
              ]
            },
            {
              "id": "compliance_concerns",
              "label": "Known quarantine, import, soil/root, document, packing, custody, or survival concerns",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a nursery, seller, exporter, broker, carrier, or destination authority?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "privacy_boundary",
              "label": "Privacy, value, sensitivity, or visibility level",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Normal private client handling",
                  "value": "normal_private"
                },
                {
                  "label": "High discretion / high-value collector file",
                  "value": "high_discretion_high_value"
                },
                {
                  "label": "Commercial / trade-side confidentiality",
                  "value": "commercial_trade_confidentiality"
                },
                {
                  "label": "Very sensitive. Explain below.",
                  "value": "very_sensitive"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false,
              "helper": "Examples: high-value object, surprise gift, public client, nursery confidentiality, urgent release deadline, medical/accessibility context, or unusual risk."
            }
          ]
        },
        {
          "id": "timing_budget_scope",
          "title": "Timing, budget, and desired next step",
          "tone": "Timing, spending ceiling, and destination rules decide whether the file is a review, deposit, retainer, or specialist escalation.",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "textarea",
              "required": true,
              "helper": "Include purchase deadline, nursery release date, Japan pickup timing, export/import window, travel dates, inspection dates, or decision deadline."
            },
            {
              "id": "urgency",
              "label": "Timing urgency",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "One month or more before target date",
                  "value": "one_month_plus"
                },
                {
                  "label": "About one to three weeks before target date",
                  "value": "one_to_three_weeks"
                },
                {
                  "label": "About one week before target date",
                  "value": "one_week"
                },
                {
                  "label": "Within 72 hours / rush review may be needed",
                  "value": "within_72"
                },
                {
                  "label": "Tree already purchased / custody or release issue is active",
                  "value": "already_purchased_custody_active"
                }
              ]
            },
            {
              "id": "budget_range",
              "label": "Approximate budget range in USD",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "$295 baseline review only",
                  "value": "295_review"
                },
                {
                  "label": "$650–$1,500 expanded review or seller/document questions",
                  "value": "650_1500"
                },
                {
                  "label": "$1,500–$3,500 custody, quarantine, packing, or coordination path",
                  "value": "1500_3500"
                },
                {
                  "label": "$3,500–$10,000+ acquisition, multi-tree, or private coordination",
                  "value": "3500_10000_plus"
                },
                {
                  "label": "$10,000+ collector, commercial, or multi-desk program",
                  "value": "10000_plus"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_budget"
                }
              ]
            },
            {
              "id": "desired_next_step",
              "label": "What do you want after this review?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Feasibility classification and next paid step",
                  "value": "feasibility_classification"
                },
                {
                  "label": "Seller / nursery questions and export-readiness clarification",
                  "value": "seller_nursery_questions"
                },
                {
                  "label": "Quarantine, document, or destination-readiness pathway",
                  "value": "quarantine_document_pathway"
                },
                {
                  "label": "Pickup, custody, packing, freight, or living-cargo coordination quote",
                  "value": "living_cargo_coordination_quote"
                },
                {
                  "label": "Sourcing / private buyer / acquisition route recommendation",
                  "value": "sourcing_private_buyer_route"
                },
                {
                  "label": "Not sure. I need JapanSolved™ to recommend the route.",
                  "value": "not_sure_recommendation"
                }
              ]
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, or storage location details",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, language issues, people involved, or practical constraints",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid intake boundary",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users may be routed to the correct product, payment path, or review before the case file is processed."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, purchase, access, compliance approval, export clearance, import clearance, plant survival, carrier acceptance, timing, or outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate, authorized, and safe for JapanSolved™ to review for this paid request."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "009",
      "record_id": "JSII_BANK_JAPAN_BONSAI_EXPORT_COMPLIANCE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Bonsai Export & Compliance Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan JDM Inspection, Export & Registration Desk™",
      "page_handle": "japan-jdm-export-inspection",
      "page_url": "https://japansolved.com/pages/japan-jdm-export-inspection",
      "intake_title": "Japan JDM Inspection, Export & Registration™ Intake",
      "service_label": "Japan JDM vehicle inspection, export, and registration-route support",
      "subject_label": "JDM Inspection, Export & Registration",
      "descriptor_line1": "A guided, paginated case-file intake for Japan JDM Inspection, Export & Registration Desk™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, and private-payment boundaries protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan JDM Export Inspection Review™",
          "value": "/products/japan-jdm-export-inspection-review",
          "render_as_link": true
        },
        {
          "label": "Japan JDM Export Case Deposit™",
          "value": "/products/japan-jdm-export-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan JDM Export Inspection Review™ — /products/japan-jdm-export-inspection-review",
                  "value": "/products/japan-jdm-export-inspection-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "JDM Inspection, Export & Registration request profile",
          "fields": [
            {
              "id": "vehicle_goal",
              "label": "What vehicle, auction listing, dealer car, or export-registration path are you evaluating?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "vehicle_details",
              "label": "Vehicle details: make, model, year, trim, chassis code, mileage, modifications, auction grade, or visible condition",
              "type": "textarea",
              "required": false
            },
            {
              "id": "seller_listing",
              "label": "Seller, auction, dealer, listing, photos, inspection sheet, or available documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "export_registration_concerns",
              "label": "Export, deregistration, shipping, destination eligibility, customs, title, or registration concerns",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, or route location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, accessibility needs, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, route notes, or product pages",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, provider, shop, facility, venue, operator, or logistics party?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, access, recovery, compliance approval, export/import clearance, reservation success, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "010",
      "record_id": "JSII_BANK_JAPAN_JDM_EXPORT_INSPECTION",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan JDM Inspection, Export & Registration Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Lost Item Recovery & Return Coordination Desk™",
      "page_handle": "japan-lost-item-recovery-return-coordination",
      "page_url": "https://japansolved.com/pages/japan-lost-item-recovery-return-coordination",
      "intake_title": "Lost Item Recovery & Return Coordination™ Case File Intake",
      "service_label": "Japan lost item recovery route, inquiry, proxy pickup, and return coordination support",
      "subject_label": "Lost Item Recovery & Return Coordination Intake",
      "descriptor_line1": "Payment first. Case file second. Lost item details, location trail, ownership proof, custodian clues, release limits, and return-shipping concerns stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the recovery review payment first",
      "payment_block_copy": "Choose the paid recovery path that matches this lost-item case. If JapanSolved™ gave you a private invoice, urgent deposit, access deposit, agency retainer, custom quote, or approved service route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the lost-item file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full recovery file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Lost Item Recovery Review™ — $150",
          "value": "/products/japan-lost-item-recovery-review",
          "render_as_link": true
        },
        {
          "label": "Lost Item Recovery Case Deposit™ — from $950",
          "value": "/products/japan-lost-item-urgent-recovery-deposit",
          "render_as_link": true
        },
        {
          "label": "Travel Agency Lost Item Support Retainer™ — from $500/month",
          "value": "/products/japan-travel-agency-lost-item-support-retainer",
          "render_as_link": true
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and recovery route match",
          "tone": "This intake creates the support file for a paid lost-item review, urgent deposit, agency retainer, approved invoice, or JapanSolved™-approved private path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this lost-item request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the Lost Item Recovery Review™",
                  "value": "yes_public_review_paid"
                },
                {
                  "label": "Yes, I paid an urgent deposit, agency retainer, invoice, or approved private path",
                  "value": "yes_private_approved_path_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me"
                },
                {
                  "label": "Not yet, I need the correct payment route first",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "helper": "Choose the closest path. If you have not paid yet, use the lost item recovery review unless JapanSolved™ gave you a private path.",
              "options": [
                {
                  "label": "Japan Lost Item Recovery Review™ — /products/japan-lost-item-recovery-review",
                  "value": "/products/japan-lost-item-recovery-review"
                },
                {
                  "label": "Lost Item Recovery Case Deposit™ — /products/japan-lost-item-urgent-recovery-deposit",
                  "value": "/products/japan-lost-item-urgent-recovery-deposit"
                },
                {
                  "label": "Travel Agency Lost Item Support Retainer™ — /products/japan-travel-agency-lost-item-support-retainer",
                  "value": "/products/japan-travel-agency-lost-item-support-retainer"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the same email connected to the paid review, urgent deposit, invoice, retainer, or approved private route.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "Include the order number, invoice number, receipt ID, urgent deposit reference, retainer note, or private payment reference if available.",
              "placeholder": "Example: #1234, invoice number, or pending"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "tone": "Japan-side recovery routing depends on exact owner details, authority, location, and a reliable contact channel.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client / owner name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for recovery follow-up",
              "type": "email",
              "required": true,
              "placeholder": "name@example.com"
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text"
            },
            {
              "id": "current_location",
              "label": "Where are you now?",
              "type": "text",
              "required": true,
              "helper": "City/country is enough. Tell us if you are still in Japan or already overseas."
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the item owner",
                  "value": "owner"
                },
                {
                  "label": "I am helping the owner as family / friend / travel companion",
                  "value": "family_friend_travel_companion"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / agency / concierge partner",
                  "value": "travel_advisor_agency_concierge"
                },
                {
                  "label": "Company representative / corporate travel team",
                  "value": "company_representative_corporate_team"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "owner_authority",
              "label": "Are you authorized to request recovery, pickup, or return coordination for this item?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Yes, I am the owner",
                  "value": "owner"
                },
                {
                  "label": "Yes, the owner authorized me",
                  "value": "authorized_by_owner"
                },
                {
                  "label": "I am requesting initial routing only",
                  "value": "initial_routing_only"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "lost_item_profile",
          "title": "Lost item and ownership evidence",
          "tone": "The more specific the item description, the stronger the recovery route. Generic descriptions are hard to match.",
          "fields": [
            {
              "id": "item_description",
              "label": "What item was lost, forgotten, or left behind?",
              "type": "textarea",
              "required": true,
              "helper": "Include item type, brand, color, size, model, contents, photos, serial number, stickers, scratches, initials, tags, or sentimental details."
            },
            {
              "id": "item_category",
              "label": "Primary lost item category",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Wallet / pouch / bag / suitcase",
                  "value": "wallet_pouch_bag_suitcase"
                },
                {
                  "label": "Passport / ID / travel document",
                  "value": "passport_id_travel_document"
                },
                {
                  "label": "Phone / laptop / tablet / camera / device",
                  "value": "device_camera_laptop"
                },
                {
                  "label": "Jewelry / watch / luxury item / high-value object",
                  "value": "jewelry_watch_luxury_high_value"
                },
                {
                  "label": "Clothing / textile / personal accessory",
                  "value": "clothing_textile_accessory"
                },
                {
                  "label": "Toy / plush / sentimental object / memory item",
                  "value": "sentimental_object"
                },
                {
                  "label": "Documents / notebook / business material",
                  "value": "documents_notebook_business_material"
                },
                {
                  "label": "Other / not sure",
                  "value": "other_not_sure"
                }
              ]
            },
            {
              "id": "ownership_evidence",
              "label": "What proof of ownership or matching evidence do you have?",
              "type": "textarea",
              "helper": "Examples: photos, receipt, booking record, serial number, item contents, device ID, luggage tag, name label, purchase record, or prior messages."
            },
            {
              "id": "sensitive_contents",
              "label": "Does the item contain passports, IDs, cards, keys, company data, medical items, devices, private photos, or other sensitive contents?",
              "type": "textarea"
            }
          ]
        },
        {
          "id": "location_trail",
          "title": "Location trail and likely custodian",
          "tone": "Recovery depends on the precise movement trail: where, when, and which operator or facility may control the item now.",
          "fields": [
            {
              "id": "last_known_route",
              "label": "Last-known location, date, time, route, and movement trail",
              "type": "textarea",
              "required": true,
              "helper": "Include station names, train lines, taxi route, hotel, airport, aircraft, shop, restaurant, venue, locker, tour, city, dates, and approximate times."
            },
            {
              "id": "likely_custodian",
              "label": "Where do you think the item may be held now?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Railway / station / Shinkansen / train operator",
                  "value": "railway_station_train_operator"
                },
                {
                  "label": "Taxi / ride route / unknown vehicle",
                  "value": "taxi_ride_route"
                },
                {
                  "label": "Hotel / ryokan / accommodation",
                  "value": "hotel_accommodation"
                },
                {
                  "label": "Airport / airline / aircraft / terminal",
                  "value": "airport_airline_terminal"
                },
                {
                  "label": "Restaurant / shop / museum / venue / facility",
                  "value": "restaurant_shop_venue_facility"
                },
                {
                  "label": "Police / lost-property center",
                  "value": "police_lost_property_center"
                },
                {
                  "label": "Already confirmed found, release/return needed",
                  "value": "confirmed_found_release_return_needed"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "contact_attempts",
              "label": "Who has already been contacted and what did they say?",
              "type": "textarea",
              "helper": "Include emails, phone calls, case numbers, facility replies, police numbers, hotel messages, or operator instructions."
            },
            {
              "id": "case_numbers",
              "label": "Lost-property report number, police reference, airline case number, hotel ticket, or operator reference",
              "type": "textarea"
            }
          ]
        },
        {
          "id": "urgency_and_return_path",
          "title": "Urgency, release, pickup, and return path",
          "tone": "Being found is not always the final step. Release rules, identity checks, proxy pickup, packing, courier acceptance, and customs may decide the next move.",
          "fields": [
            {
              "id": "urgency",
              "label": "How urgent is this case?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Critical: passport, wallet, cards, device, medicine, company material, or same-week deadline",
                  "value": "critical_same_week"
                },
                {
                  "label": "Urgent: item may transfer, expire, or be disposed soon",
                  "value": "urgent_transfer_deadline"
                },
                {
                  "label": "Standard: still worth pursuing but not emergency-level",
                  "value": "standard"
                },
                {
                  "label": "Confirmed found: release, pickup, or return coordination needed",
                  "value": "confirmed_found"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "still_in_japan",
              "label": "Are you or a trusted person still in Japan?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Yes, I am still in Japan",
                  "value": "owner_still_in_japan"
                },
                {
                  "label": "Yes, a trusted person is still in Japan",
                  "value": "trusted_person_in_japan"
                },
                {
                  "label": "No, I already left Japan",
                  "value": "already_left_japan"
                },
                {
                  "label": "Not sure / mixed group",
                  "value": "not_sure_mixed"
                }
              ]
            },
            {
              "id": "desired_support",
              "label": "What support do you likely need?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Recovery route review only",
                  "value": "route_review_only"
                },
                {
                  "label": "Japanese inquiry support",
                  "value": "japanese_inquiry_support"
                },
                {
                  "label": "Urgent facility/operator follow-up",
                  "value": "urgent_follow_up"
                },
                {
                  "label": "Police/lost-property center routing support",
                  "value": "police_lost_property_routing"
                },
                {
                  "label": "Confirmed-found release/document explanation",
                  "value": "release_document_explanation"
                },
                {
                  "label": "Proxy pickup coordination",
                  "value": "proxy_pickup_coordination"
                },
                {
                  "label": "Packing / domestic handoff / international return shipping",
                  "value": "packing_handoff_return_shipping"
                },
                {
                  "label": "High-value custody / careful handling route",
                  "value": "high_value_custody"
                }
              ]
            },
            {
              "id": "return_destination",
              "label": "Return destination, handoff preference, or shipping destination",
              "type": "textarea",
              "helper": "Country/city is enough for first routing. Do not include full street address unless JapanSolved™ asks later."
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, privacy needs, legal boundaries, accessibility needs, language issues, or people involved",
              "type": "textarea"
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "tone": "Photos, receipts, routes, maps, screenshots, booking records, and prior messages can prevent expensive wrong turns.",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, maps, screenshots, booking records, product pages, or upload notes",
              "type": "textarea",
              "helper": "Paste links or describe what you will send after intake."
            },
            {
              "id": "documents_available",
              "label": "What documents, screenshots, receipts, IDs, or photos are available if JapanSolved™ asks?",
              "type": "textarea"
            },
            {
              "id": "prior_attempts",
              "label": "What have you already tried?",
              "type": "textarea",
              "helper": "Examples: contacted hotel, station, airline, taxi company, police, airport, restaurant, shop, travel agency, or courier."
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "helper": "Examples: passport/card/device risk, company data, family situation, child’s sentimental item, privacy issue, theft concern, or urgent travel/document timing."
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final confirmation",
          "tone": "Confirm the file is accurate, authorized, and tied to the correct paid or approved route before review.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "I understand this intake is tied to the appropriate paid recovery review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "text": "Confirmed"
            },
            {
              "id": "confirm_unpaid_route",
              "label": "I understand unpaid users must use the correct payment route before full intake review, active recovery work, pickup, or return coordination can begin.",
              "type": "checkbox",
              "required": true,
              "text": "Confirmed"
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, recovery, release, pickup, shipping, insurance, customs clearance, facility cooperation, police action, carrier acceptance, or outcome.",
              "type": "checkbox",
              "required": true,
              "text": "Confirmed"
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit this lost-item recovery request.",
              "type": "checkbox",
              "required": true,
              "text": "Confirmed"
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by safety, privacy, legal, institutional, third-party, documentation, timing, and cooperation constraints, and that JapanSolved™ may require additional clarification, authorization, payment, route correction, or quote before proceeding."
            }
          ]
        }
      ],
      "page_sequence": "011",
      "record_id": "JSII_BANK_JAPAN_LOST_ITEM_RECOVERY_RETURN_COORDINATION",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Lost Item Recovery & Return Coordination Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Missing Person Welfare & Search Coordination Desk™",
      "page_handle": "japan-missing-person-welfare-search-coordination",
      "page_url": "https://japansolved.com/pages/japan-missing-person-welfare-search-coordination",
      "subject_label": "Missing Person Welfare & Search Coordination Intake",
      "intake_title": "Missing Person Welfare & Search Coordination Case File Intake",
      "service_label": "Japan missing-person welfare coordination, family-support routing, authority-first search context, lawful next-step review, and privacy-protected case organization",
      "descriptor_line1": "Payment first. Case file second. Requester standing, relationship authority, last-known timeline, Japan route, urgency signals, prior authority contact, privacy boundaries, and supporting evidence stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path. If there is immediate danger, contact emergency authorities first.",
      "payment_block_title": "Complete the welfare coordination review payment first",
      "payment_block_copy": "Choose the missing-person welfare coordination review, urgent case deposit, family support retainer, approved invoice, access deposit, custom quote, or JapanSolved™-approved private service path that matches this welfare/search request.",
      "payment_block_fineprint": "Use the same payment email at intake so the welfare/search case file can be matched to the paid path.",
      "not_paid_error": "This missing-person welfare and search coordination intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. If there is immediate danger, contact police, ambulance/fire, embassy, consulate, or the relevant emergency authority first.",
      "product_routes": [
        {
          "label": "Japan Missing Person Welfare Coordination Review™ — $1,250",
          "value": "/products/japan-missing-person-welfare-coordination-review"
        },
        {
          "label": "Japan Missing Person Welfare Coordination Case Deposit™ — from $950",
          "value": "/products/japan-missing-person-welfare-coordination-case-deposit"
        },
        {
          "label": "Japan Missing Person Family Support Retainer™ — from $2,500",
          "value": "/products/japan-missing-person-family-support-retainer"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the welfare/search support file for a paid review, approved invoice, case deposit, access deposit, retainer, custom quote, or JapanSolved™-approved private payment path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this welfare/search request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the Missing Person Welfare Coordination Review",
                  "value": "yes_missing_person_welfare_review_paid"
                },
                {
                  "label": "Yes, I completed a welfare/search case deposit",
                  "value": "yes_welfare_search_case_deposit_paid"
                },
                {
                  "label": "Yes, I am on an approved invoice, access deposit, retainer, or private payment path",
                  "value": "yes_approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_submit"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Missing Person Welfare Coordination Review™ — /products/japan-missing-person-welfare-coordination-review",
                  "value": "/products/japan-missing-person-welfare-coordination-review"
                },
                {
                  "label": "Japan Missing Person Welfare Coordination Case Deposit™ — /products/japan-missing-person-welfare-coordination-case-deposit",
                  "value": "/products/japan-missing-person-welfare-coordination-case-deposit"
                },
                {
                  "label": "Japan Missing Person Family Support Retainer™ — /products/japan-missing-person-family-support-retainer",
                  "value": "/products/japan-missing-person-family-support-retainer"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, deposit, invoice, retainer, or approved private payment route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "requester_identity",
          "title": "Requester identity, authority, and lawful basis",
          "tone": "Missing-person and welfare files must begin with who is asking, why the concern is legitimate, and what authority or relationship supports the request.",
          "fields": [
            {
              "id": "client_name",
              "label": "Requester / client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Parent, spouse, adult child, sibling, or close family member",
                  "value": "close_family_member"
                },
                {
                  "label": "Legal guardian, attorney, trustee, or authorized representative",
                  "value": "legal_guardian_attorney_authorized_representative"
                },
                {
                  "label": "School, employer, tour operator, travel advisor, or organization with duty-of-care responsibility",
                  "value": "institution_or_duty_of_care_organization"
                },
                {
                  "label": "Embassy, consular, police, hospital, or official-channel support contact",
                  "value": "official_channel_support_contact"
                },
                {
                  "label": "Friend, old contact, or reconnection requester",
                  "value": "friend_old_contact_reconnection_requester"
                },
                {
                  "label": "Other requester with a welfare concern",
                  "value": "other_welfare_concern_requester"
                }
              ]
            },
            {
              "id": "relationship_authority",
              "label": "Describe your relationship, authority, duty-of-care role, or lawful basis for requesting help",
              "type": "textarea",
              "required": true
            },
            {
              "id": "requester_location",
              "label": "Where is the requester now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "missing_person_profile",
          "title": "Missing person / welfare concern profile",
          "fields": [
            {
              "id": "person_identity",
              "label": "Person’s name, known aliases, age, nationality, language, photo availability, and identifying details",
              "type": "textarea",
              "required": true
            },
            {
              "id": "person_context",
              "label": "Why are you concerned about this person now?",
              "type": "textarea",
              "required": true,
              "helper": "Explain the silence, missed check-in, distress signal, itinerary gap, institutional concern, family concern, or lawful reconnection purpose."
            },
            {
              "id": "case_lane",
              "label": "Which case lane best describes this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Missing tourist or traveler",
                  "value": "missing_tourist_or_traveler"
                },
                {
                  "label": "Mountain, ski, rural, trail, coastal, wilderness, or weather-exposure concern",
                  "value": "terrain_wilderness_weather_exposure_concern"
                },
                {
                  "label": "Student, worker, long-stay foreign resident, or institutional-duty case",
                  "value": "student_worker_long_stay_institutional_case"
                },
                {
                  "label": "Elder, dementia, medical, disability, vulnerable-person, or medication concern",
                  "value": "elder_medical_vulnerable_person_concern"
                },
                {
                  "label": "Minor / child / youth welfare concern",
                  "value": "minor_child_youth_welfare_concern"
                },
                {
                  "label": "Long-lost relative, old friend, family-history, or consent-aware reconnection case",
                  "value": "consent_aware_reconnection_case"
                },
                {
                  "label": "Corporate, school, tour operator, delegation, retreat, or VIP duty-of-care incident",
                  "value": "organizational_duty_of_care_incident"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "timeline_location",
          "title": "Timeline, last-known location, and Japan route",
          "fields": [
            {
              "id": "last_known_status",
              "label": "Last known location, date/time, contact status, hotel/school/workplace, route, phone status, travel plan, and who last saw/heard from them",
              "type": "textarea",
              "required": true
            },
            {
              "id": "japan_route_details",
              "label": "Japan locations, itinerary, transportation, flight/train/bus details, hotel/hostel/rental, tour provider, school, employer, landlord, or local contacts",
              "type": "textarea",
              "required": false
            },
            {
              "id": "evidence_summary",
              "label": "Evidence already available",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Screenshots of messages or calls",
                  "value": "screenshots_messages_calls"
                },
                {
                  "label": "Travel itinerary, booking, flight, train, hotel, or route records",
                  "value": "travel_itinerary_booking_records"
                },
                {
                  "label": "Passport, visa, residence card, student, employee, or institutional details",
                  "value": "identity_visa_institutional_details"
                },
                {
                  "label": "Photos or identifying details suitable for official channels",
                  "value": "photos_identifying_details"
                },
                {
                  "label": "Police report, embassy/consulate contact, hospital contact, school/employer contact, or case number",
                  "value": "official_or_institutional_case_reference"
                },
                {
                  "label": "No organized evidence yet",
                  "value": "no_organized_evidence_yet"
                }
              ]
            },
            {
              "id": "authority_steps",
              "label": "Authorities, hospitals, hotels, transport providers, consulates, schools, employers, family members, or local contacts already reached",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "risk_and_authority",
          "title": "Urgency, safety signals, and authority-first routing",
          "tone": "If there is immediate danger, this private intake should not delay police, ambulance/fire, embassy, consulate, school, employer, hospital, or rescue-channel action.",
          "fields": [
            {
              "id": "urgency",
              "label": "How urgent is this welfare/search concern?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Immediate life-safety concern / emergency authorities should be involved now",
                  "value": "immediate_life_safety_authorities_now"
                },
                {
                  "label": "Recent disappearance or silence within 24 hours",
                  "value": "recent_disappearance_within_24_hours"
                },
                {
                  "label": "Within 72 hours / high concern",
                  "value": "within_72_hours_high_concern"
                },
                {
                  "label": "This week / unresolved concern",
                  "value": "this_week_unresolved_concern"
                },
                {
                  "label": "Longer-running welfare or reconnection matter",
                  "value": "longer_running_welfare_or_reconnection"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "risk_level",
              "label": "Immediate safety, medical, self-harm, coercion, minor, elder, dementia, crime, detention, hospitalization, mountain, disaster, or life-safety concern",
              "type": "textarea",
              "required": false
            },
            {
              "id": "official_channels",
              "label": "Which official or institutional channels are already involved or should be involved first?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Police / emergency services",
                  "value": "police_emergency_services"
                },
                {
                  "label": "Fire / ambulance / hospital / medical route",
                  "value": "fire_ambulance_hospital_medical_route"
                },
                {
                  "label": "Embassy or consulate",
                  "value": "embassy_or_consulate"
                },
                {
                  "label": "School / employer / tour operator / hotel / landlord / institution",
                  "value": "institutional_route"
                },
                {
                  "label": "Attorney / court / legal representative",
                  "value": "attorney_court_legal_representative"
                },
                {
                  "label": "Licensed investigator or specialist vendor",
                  "value": "licensed_investigator_specialist_vendor"
                },
                {
                  "label": "No official channel yet",
                  "value": "no_official_channel_yet"
                }
              ]
            },
            {
              "id": "emergency_note_acknowledgement",
              "label": "Emergency note",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ is not an emergency service, law-enforcement agency, rescue unit, hospital, embassy, consulate, court, lawyer, or private investigator, and urgent danger should be routed to proper authorities first."
            }
          ]
        },
        {
          "id": "privacy_consent_boundaries",
          "title": "Privacy, consent, and refusal boundaries",
          "tone": "This desk protects welfare without becoming private tracking, doxxing, stalking, coercive locating, or unwanted contact.",
          "fields": [
            {
              "id": "privacy_boundaries",
              "label": "Consent, lawful basis, privacy limits, no-contact boundaries, safety separation, domestic violence risk, harassment risk, or information JapanSolved™ must not disclose or pursue",
              "type": "textarea",
              "required": false
            },
            {
              "id": "decline_risk_check",
              "label": "Are any of these risk boundaries present?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Romantic pursuit, jealousy, or unwanted relationship contact may be involved",
                  "value": "romantic_pursuit_unwanted_contact_risk"
                },
                {
                  "label": "Debt pressure, revenge, coercion, family conflict, custody conflict, or legal dispute may be involved",
                  "value": "coercion_family_legal_dispute_risk"
                },
                {
                  "label": "The person may be hiding from harm, harassment, abuse, pressure, or unsafe contact",
                  "value": "person_may_be_hiding_from_harm"
                },
                {
                  "label": "Requester wants private address, workplace, phone number, exact location, or public exposure",
                  "value": "private_location_or_exposure_requested"
                },
                {
                  "label": "None of these apply to my request",
                  "value": "none_apply"
                }
              ]
            },
            {
              "id": "safe_endpoint",
              "label": "What responsible endpoint would be acceptable if private location cannot be disclosed?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Welfare confirmation through proper channel",
                  "value": "welfare_confirmation_proper_channel"
                },
                {
                  "label": "Message relay / consent-aware contact attempt",
                  "value": "message_relay_consent_aware_contact"
                },
                {
                  "label": "Police / embassy / attorney / institution routing",
                  "value": "authority_or_institution_routing"
                },
                {
                  "label": "Licensed investigator routing if lawful and appropriate",
                  "value": "licensed_investigator_routing_if_appropriate"
                },
                {
                  "label": "Decline or pause if privacy/safety rules prevent further action",
                  "value": "decline_or_pause_if_privacy_prevents_action"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and coordination constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing, emergency deadline, family update need, official-channel deadline, travel window, or institutional reporting timeline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, case deposit, retainer context, investigator budget, attorney budget, travel budget, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Japan city/region, last-known location, family location, embassy/consular jurisdiction, police prefecture, or coordination handoff context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, legal boundaries, privacy needs, safety concerns, language issues, documents needed, people involved, or vendor restrictions",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, documents, screenshots, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, message history, route notes, hotel/school/work records, travel documents, official references, photos, public posts, or case documents",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, checked, reported, booked, ruled out, or escalated?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "tone": "Please confirm the operating boundaries before reviewing and sending the welfare/search case file.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid path boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand this intake is tied to the appropriate paid review, welfare/search case deposit, family support retainer, invoice, or JapanSolved™-approved private payment route."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users must be routed to the correct product/payment path before intake submission can be reviewed or coordination can begin."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, person found, contact, disclosure, return, welfare confirmation, family outcome, investigator result, police action, embassy response, hospital disclosure, institution cooperation, safety confirmation, or any specific outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate, I am authorized to submit it, and this request is not for stalking, harassment, doxxing, romantic pursuit, revenge, coercive contact, or bypassing lawful authorities."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by safety, privacy, legal, institutional, third-party, documentation, timing, and cooperation constraints, and that JapanSolved™ may require additional clarification, authorization, payment, route correction, or quote before proceeding."
            }
          ]
        }
      ],
      "page_sequence": "012",
      "record_id": "JSII_BANK_JAPAN_MISSING_PERSON_WELFARE_SEARCH_COORDINATION",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Missing Person Welfare & Search Coordination Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan JDM Parts, Wheels & Tuning Acquisition Desk™",
      "page_handle": "japan-jdm-parts-wheels-tuning-acquisition",
      "page_url": "https://japansolved.com/pages/japan-jdm-parts-wheels-tuning-acquisition",
      "intake_title": "Japan JDM Parts, Wheels & Tuning Acquisition™ Intake",
      "service_label": "Japan JDM parts, wheels, tuning, seller outreach, and freight-route support",
      "subject_label": "JDM Parts, Wheels & Tuning Acquisition",
      "descriptor_line1": "A guided, paginated case-file intake for Japan JDM Parts, Wheels & Tuning Acquisition Desk™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, and private-payment boundaries protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan JDM Parts Acquisition Review™",
          "value": "/products/japan-jdm-parts-acquisition-review",
          "render_as_link": true
        },
        {
          "label": "Japan JDM Parts Acquisition Case Deposit™",
          "value": "/products/japan-jdm-parts-acquisition-case-deposit",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan JDM Parts Acquisition Review™ — /products/japan-jdm-parts-acquisition-review",
                  "value": "/products/japan-jdm-parts-acquisition-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "JDM Parts, Wheels & Tuning Acquisition request profile",
          "fields": [
            {
              "id": "parts_goal",
              "label": "What part, wheel set, tuning component, seller, or rare-parts hunt do you want JapanSolved™ to review?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "vehicle_fitment",
              "label": "Vehicle fitment details: make, model, year, chassis code, trim, market, engine, transmission, wheel specs, or part number",
              "type": "textarea",
              "required": false
            },
            {
              "id": "seller_or_listing",
              "label": "Seller, listing, auction, shop, marketplace, photos, messages, or current source route",
              "type": "textarea",
              "required": false
            },
            {
              "id": "condition_freight_concerns",
              "label": "Condition, authenticity, missing parts, compatibility, packing, oversized freight, customs, or destination concerns",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, or route location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, accessibility needs, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, route notes, or product pages",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, provider, shop, facility, venue, operator, or logistics party?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, access, recovery, compliance approval, export/import clearance, reservation success, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "013",
      "record_id": "JSII_BANK_JAPAN_JDM_PARTS_WHEELS_TUNING_ACQUISITION",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan JDM Parts, Wheels & Tuning Acquisition Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Jewelry Shopping Proxy & Personal Shopper Desk™",
      "page_handle": "japan-jewelry-shopping-proxy-personal-shopper",
      "page_url": "https://japansolved.com/pages/japan-jewelry-shopping-proxy-personal-shopper",
      "subject_label": "Jewelry Shopping Intake",
      "intake_title": "Jewelry Shopping Proxy & Personal Shopper Case File Intake",
      "descriptor_line1": "Payment first. Case file second. Item details, seller path, material claims, sizing, timing, budget, and handoff concerns stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the paid jewelry review, case deposit, personal shopper attendance, purchase coordination, or approved private path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the jewelry file can be matched to the paid path.",
      "not_paid_error": "This jewelry intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Jewelry Shopping Review™",
          "value": "/products/japan-jewelry-shopping-review"
        },
        {
          "label": "Japan Jewelry Shopping Case Deposit™",
          "value": "/products/japan-jewelry-shopping-case-deposit"
        },
        {
          "label": "Japan Jewelry Personal Shopper Attendance™",
          "value": "/products/japan-jewelry-personal-shopper-attendance"
        },
        {
          "label": "Japan Jewelry Purchase Coordination™",
          "value": "/products/japan-jewelry-purchase-coordination"
        },
        {
          "label": "Private Concierge Shopping Retainer™",
          "value": "/products/japan-private-concierge-shopping-retainer"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the jewelry support file for a paid review, approved invoice, access deposit, case deposit, retainer, or JapanSolved™-approved private payment path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this jewelry request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public jewelry review",
                  "value": "yes_public_jewelry_review_paid"
                },
                {
                  "label": "Yes, I paid a jewelry case deposit, attendance fee, coordination fee, invoice, or retainer",
                  "value": "yes_case_deposit_invoice_or_retainer_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet, I need the correct payment route first",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "helper": "Choose the closest paid path. If JapanSolved™ gave you a private invoice, access deposit, or custom quote, choose the approved private payment path.",
              "options": [
                {
                  "label": "Japan Jewelry Shopping Review™ — /products/japan-jewelry-shopping-review",
                  "value": "/products/japan-jewelry-shopping-review"
                },
                {
                  "label": "Japan Jewelry Shopping Case Deposit™ — /products/japan-jewelry-shopping-case-deposit",
                  "value": "/products/japan-jewelry-shopping-case-deposit"
                },
                {
                  "label": "Japan Jewelry Personal Shopper Attendance™ — /products/japan-jewelry-personal-shopper-attendance",
                  "value": "/products/japan-jewelry-personal-shopper-attendance"
                },
                {
                  "label": "Japan Jewelry Purchase Coordination™ — /products/japan-jewelry-purchase-coordination",
                  "value": "/products/japan-jewelry-purchase-coordination"
                },
                {
                  "label": "Private Concierge Shopping Retainer™ — /products/japan-private-concierge-shopping-retainer",
                  "value": "/products/japan-private-concierge-shopping-retainer"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, case deposit, invoice, retainer, or approved private route.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference.",
              "placeholder": "Example: #1234, invoice number, or receipt ID"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and decision authority",
          "tone": "Jewelry cases may involve gifts, couples, families, assistants, stylists, or remote buyers, so decision authority and follow-up channels need to be clear.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true,
              "placeholder": "name@example.com"
            },
            {
              "id": "country_timezone",
              "label": "Client country / time zone",
              "type": "text",
              "required": true,
              "helper": "City/country and time zone are enough."
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "traveler_profile",
              "label": "Which buyer profile best describes this request?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Private buyer or gift buyer",
                  "value": "private_buyer_or_gift_buyer"
                },
                {
                  "label": "Couple / engagement / wedding / anniversary purchase",
                  "value": "couple_milestone_purchase"
                },
                {
                  "label": "Collector / estate or archive jewelry buyer",
                  "value": "collector_estate_archive_jewelry_buyer"
                },
                {
                  "label": "Stylist / fashion buyer / professional shopper",
                  "value": "stylist_fashion_buyer_professional_shopper"
                },
                {
                  "label": "Family office / assistant / authorized representative",
                  "value": "family_office_assistant_authorized_representative"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "requester_authority",
              "label": "Are you authorized to submit purchase and contact details for this jewelry request?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Yes, I am the buyer/client",
                  "value": "buyer_client"
                },
                {
                  "label": "Yes, I am submitting for the buyer with authorization",
                  "value": "authorized_representative"
                },
                {
                  "label": "I need JapanSolved™ to clarify authority before action",
                  "value": "authority_needs_clarification"
                }
              ]
            }
          ]
        },
        {
          "id": "jewelry_profile",
          "title": "Jewelry item and seller profile",
          "tone": "A small piece can carry dense risk: material claims, stones, sizing, treatment, paperwork, seller trust, purchase timing, and handoff all matter.",
          "fields": [
            {
              "id": "jewelry_goal",
              "label": "What jewelry, gemstone, pearl, watch-adjacent item, seller path, or shopping route do you want JapanSolved™ to review?",
              "type": "textarea",
              "required": true,
              "helper": "Mention item type, brand or maker, metal, stone, pearl, size, recipient, budget, seller, and whether this is in-person shopping or remote purchase support."
            },
            {
              "id": "desired_deliverable",
              "label": "Which jewelry support route fits best?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Jewelry shopping review / first-pass triage",
                  "value": "jewelry_shopping_review_first_pass_triage"
                },
                {
                  "label": "Estate or archive jewelry acquisition review",
                  "value": "estate_archive_jewelry_acquisition_review"
                },
                {
                  "label": "Gemstone or pearl seller-question prep",
                  "value": "gemstone_pearl_seller_question_prep"
                },
                {
                  "label": "Personal shopper attendance in Japan",
                  "value": "personal_shopper_attendance_in_japan"
                },
                {
                  "label": "Remote jewelry purchase coordination",
                  "value": "remote_jewelry_purchase_coordination"
                },
                {
                  "label": "Milestone gift / engagement / family jewelry route",
                  "value": "milestone_gift_family_jewelry_route"
                },
                {
                  "label": "Private jewelry acquisition program",
                  "value": "private_jewelry_acquisition_program"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "seller_or_listing",
              "label": "Known seller, boutique, counter, listing, shop page, photos, or reference links",
              "type": "textarea",
              "required": false,
              "helper": "Paste links or describe the seller/store. Use “none yet” if discovery or route planning is needed."
            },
            {
              "id": "item_details",
              "label": "Known item details, paperwork, sizing, condition, and purchase context",
              "type": "textarea",
              "required": false,
              "helper": "Include metal purity, stone/pearl claims, certificates, receipt/card/box status, ring size, repair/resizing notes, price, tax-free needs, and current seller explanation."
            }
          ]
        },
        {
          "id": "risk_and_support_layers",
          "title": "Risk, proof, and support layers",
          "tone": "Select the areas JapanSolved™ should pay attention to first. This helps separate ordinary shopping from specialist, proxy, or secure handoff routing.",
          "fields": [
            {
              "id": "experience_themes",
              "label": "Which support layers are relevant?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Metal, hallmark, karat, plating, or material-claim questions",
                  "value": "metal_hallmark_karat_material_claims"
                },
                {
                  "label": "Gemstone, pearl, treatment, certificate, or appraisal questions",
                  "value": "gemstone_pearl_treatment_certificate_appraisal"
                },
                {
                  "label": "Estate, antique, archive, signed, or maker-mark jewelry",
                  "value": "estate_antique_archive_signed_maker_mark"
                },
                {
                  "label": "Ring size, resizing, repair, setting, prong, clasp, or wear concerns",
                  "value": "sizing_repair_setting_wear_concerns"
                },
                {
                  "label": "Seller/listing review, store communication, or question prep",
                  "value": "seller_listing_store_question_prep"
                },
                {
                  "label": "In-person personal shopper attendance or interpretation",
                  "value": "in_person_personal_shopper_attendance"
                },
                {
                  "label": "Remote purchase, pickup, custody, or private buyer execution",
                  "value": "remote_purchase_pickup_custody_execution"
                },
                {
                  "label": "Gift, engagement, wedding, anniversary, or family milestone route",
                  "value": "gift_engagement_wedding_family_milestone"
                },
                {
                  "label": "Shipping, insurance, customs, secure handoff, or hotel delivery",
                  "value": "shipping_insurance_customs_secure_handoff"
                },
                {
                  "label": "Specialist appraisal, gemological review, or related-desk escalation",
                  "value": "specialist_appraisal_gemological_escalation"
                }
              ]
            },
            {
              "id": "risk_concerns",
              "label": "Authentication, grading, metal/stone/pearl, sizing, repairs, tax-free purchase, export, insurance, or handoff concerns",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted the seller, boutique, brand, jeweler, appraiser, shipper, or logistics party?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "privacy_boundary",
              "label": "How discreet should this jewelry request be?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Standard private client handling",
                  "value": "standard_private_client_handling"
                },
                {
                  "label": "High discretion: gift, proposal, family, or sensitive budget context",
                  "value": "high_discretion_gift_proposal_family_budget"
                },
                {
                  "label": "Very sensitive: public figure, staff-handled, security, or high-value context",
                  "value": "very_sensitive_public_figure_staff_security_high_value"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_budget_scope",
          "title": "Timing, budget, and handoff constraints",
          "tone": "Jewelry work changes quickly when the piece is time-sensitive, high-value, appointment-dependent, remote, documentation-sensitive, or already close to purchase.",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "textarea",
              "required": true,
              "helper": "Include travel dates, appointment date, purchase deadline, proposal/gift date, export/import timing, or decision deadline."
            },
            {
              "id": "urgency",
              "label": "How urgent is this jewelry request?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "One month or more",
                  "value": "one_month_or_more"
                },
                {
                  "label": "One to three weeks",
                  "value": "one_to_three_weeks"
                },
                {
                  "label": "Within one week",
                  "value": "within_one_week"
                },
                {
                  "label": "Within 72 hours / already in Japan",
                  "value": "within_72_hours_or_already_in_japan"
                },
                {
                  "label": "Item is live, held, at risk of selling, or purchase window is active",
                  "value": "live_item_or_active_purchase_window"
                }
              ]
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Under $1,000",
                  "value": "under_1000_usd"
                },
                {
                  "label": "$1,000–$3,000",
                  "value": "1000_3000_usd"
                },
                {
                  "label": "$3,000–$10,000",
                  "value": "3000_10000_usd"
                },
                {
                  "label": "$10,000–$25,000",
                  "value": "10000_25000_usd"
                },
                {
                  "label": "$25,000+",
                  "value": "25000_plus_usd"
                },
                {
                  "label": "Confidential / to discuss privately",
                  "value": "confidential_to_discuss_privately"
                }
              ]
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, pickup, hotel handoff, shipment, appointment, or custody location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, sizing needs, privacy needs, accessibility needs, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, photos, paperwork, and supporting context",
          "tone": "Screenshots, seller messages, certificates, photos, receipts, and sizing details can prevent expensive wrong turns.",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, images, seller messages, certificates, paperwork, item pages, or reference photos",
              "type": "textarea",
              "required": false,
              "helper": "Paste links or describe what you will send after intake."
            },
            {
              "id": "documents_available",
              "label": "What documents or accessories are currently available?",
              "type": "textarea",
              "required": false,
              "helper": "Examples: certificate, appraisal, receipt, brand card, box, pouch, tag, lab report, seller note, warranty, resizing record."
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false,
              "helper": "Examples: surprise gift, proposal timing, family privacy, high-value context, staff coordination, security concern, or unusual risk."
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final confirmation",
          "tone": "Confirm the jewelry file is accurate, authorized, and tied to the correct paid or approved route before the review screen.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid path boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand this intake is tied to the appropriate paid jewelry review, deposit, retainer, invoice, or approved private payment route."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid routing boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users must use the correct jewelry payment route before full intake review or execution can begin."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, purchase, authenticity, appraisal value, seller cooperation, item availability, tax-free eligibility, export/import clearance, delivery timing, or outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate, authorized, and safe for JapanSolved™ to review for this paid jewelry request."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "014",
      "record_id": "JSII_BANK_JAPAN_JEWELRY_SHOPPING_PROXY_PERSONAL_SHOPPER",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Jewelry Shopping Proxy & Personal Shopper Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "record_id": "japan-ginza-luxury-brand-personal-shopping",
      "page_sequence": "015",
      "page_title": "Japan Ginza Luxury Brand Personal Shopping Desk™",
      "page_handle": "japan-ginza-luxury-brand-personal-shopping",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-ginza-luxury-brand-personal-shopping",
      "page_type": "native_intake_registry_record",
      "service_family": "Luxury Shopping / Ginza / Concierge",
      "template_system": "registry_bank_record",
      "question_intelligence_status": "FINAL_GINZA_DOCX_NATIVE_BRIDGE_WITH_CANONICAL_EMAIL_VALIDATION",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Ginza Luxury Shopping Intake",
      "intake_title": "Japan Ginza Luxury Brand Personal Shopping Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Ginza luxury shopping route planning, boutique inquiry support, interpretation, guided personal shopping attendance, concierge shopping support, and post-purchase handoff routing",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Ginza Luxury Shopping Session Review™ — $295 path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-ginza-luxury-shopping-session-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Ginza Luxury Shopping Session Review™ — $295",
          "url": "/products/japan-ginza-luxury-shopping-session-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": {
        "legacy_note": "routing_reference_only_until_payment_is_matched",
        "if_payment_status_is_unpaid": "show_payment_required_block_only_then_unpaid_submission_screen",
        "do_not_open_detailed_intake_for_unpaid": true,
        "formal_review_requires_payment": true
      },
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Ginza Luxury Shopping Session Review™ — $295",
                  "value": "I purchased / completed payment for Japan Ginza Luxury Shopping Session Review™ — $295",
                  "legacy_value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "legacy_value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "JapanSolved™ instructed me to submit this intake before payment",
                  "legacy_value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "I have not paid yet",
                  "legacy_value": "not_paid"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Ginza Luxury Shopping Session Review™ — $295",
                  "value": "/products/japan-ginza-luxury-shopping-session-review",
                  "legacy_value": "/products/japan-ginza-luxury-shopping-session-review",
                  "display_value": "Japan Ginza Luxury Shopping Session Review™ — $295",
                  "target_url": "/products/japan-ginza-luxury-shopping-session-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "Approved invoice / case deposit / retainer / private quote",
                  "legacy_value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "JapanSolved™ instructed me to submit before payment",
                  "legacy_value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "Not paid yet / routing reference only",
                  "legacy_value": "not_paid_routing_reference_only"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "contact_email",
              "label": "Email used at checkout / best contact email",
              "type": "email",
              "required": true,
              "step_blocking": true,
              "validation": {
                "kind": "email",
                "required": true,
                "step_blocking": true,
                "review_blocking": true,
                "submit_blocking": true,
                "message": "Please enter a valid best contact email before continuing. Use one @ symbol and a real domain, such as name@example.com."
              },
              "autocomplete": "email",
              "inputmode": "email",
              "placeholder": "name@example.com",
              "canonical_role": "contact_email",
              "native_required_key": "contact_email",
              "legacy_ids": [
                "Field 3",
                "Q3",
                "best_contact_email",
                "checkout_email",
                "email",
                "email_used_at_checkout"
              ]
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note",
              "step_blocking": true
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Full name of the client or lead contact",
              "type": "text",
              "required": true,
              "step_blocking": true,
              "canonical_role": "client_name",
              "native_required_key": "client_name",
              "legacy_ids": [
                "Field 4",
                "Q4",
                "full_name_client_or_lead_contact",
                "lead_contact_name"
              ],
              "autocomplete": "name"
            },
            {
              "id": "alternate_contact_email",
              "label": "Alternate contact email, if different from checkout email",
              "type": "email",
              "required": false,
              "step_blocking": true,
              "validation": {
                "kind": "email",
                "required": false,
                "step_blocking": true,
                "review_blocking": true,
                "submit_blocking": false,
                "message": "If you enter an alternate email, use one @ symbol and a real domain, such as name@example.com."
              },
              "autocomplete": "email",
              "inputmode": "email",
              "placeholder": "name@example.com",
              "canonical_role": "alternate_contact_email",
              "legacy_ids": [
                "alternate_email"
              ]
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "Myself / principal client",
                  "legacy_value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "Partner or family member",
                  "legacy_value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "Assistant / manager / representative",
                  "legacy_value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "Travel planner / concierge",
                  "legacy_value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "Family office / executive team",
                  "legacy_value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "Other",
                  "legacy_value": "other"
                }
              ],
              "step_blocking": true
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "travel_status_ginza_timing",
          "title": "Travel status and Ginza timing",
          "tone": "This desk is mainly for clients physically in Japan or planning a Japan shopping visit.",
          "fields": [
            {
              "id": "japan_travel_status",
              "label": "What is your current Japan travel status?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I am already in Japan",
                  "value": "I am already in Japan",
                  "legacy_value": "i_am_already_in_japan"
                },
                {
                  "label": "I will arrive in Japan soon",
                  "value": "I will arrive in Japan soon",
                  "legacy_value": "i_will_arrive_in_japan_soon"
                },
                {
                  "label": "I am planning a future Japan trip",
                  "value": "I am planning a future Japan trip",
                  "legacy_value": "i_am_planning_a_future_japan_trip"
                },
                {
                  "label": "I am submitting for someone who will be in Japan",
                  "value": "I am submitting for someone who will be in Japan",
                  "legacy_value": "i_am_submitting_for_someone_who_will_be_in_japan"
                },
                {
                  "label": "I am not sure yet",
                  "value": "I am not sure yet",
                  "legacy_value": "i_am_not_sure_yet"
                },
                {
                  "label": "I may need remote follow-up after leaving Japan",
                  "value": "I may need remote follow-up after leaving Japan",
                  "legacy_value": "i_may_need_remote_follow_up_after_leaving_japan"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "planned_arrival_date",
              "label": "Planned arrival date in Japan",
              "type": "date",
              "required": false
            },
            {
              "id": "preferred_ginza_date",
              "label": "Preferred Ginza shopping date",
              "type": "date",
              "required": true,
              "step_blocking": true
            },
            {
              "id": "shopping_date_urgency",
              "label": "How soon is the shopping date?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 48 hours",
                  "value": "Within 48 hours",
                  "legacy_value": "within_48_hours"
                },
                {
                  "label": "Within 3–7 days",
                  "value": "Within 3–7 days",
                  "legacy_value": "within_3_7_days"
                },
                {
                  "label": "Within 1–2 weeks",
                  "value": "Within 1–2 weeks",
                  "legacy_value": "within_1_2_weeks"
                },
                {
                  "label": "More than 2 weeks away",
                  "value": "More than 2 weeks away",
                  "legacy_value": "more_than_2_weeks_away"
                },
                {
                  "label": "Date is flexible",
                  "value": "Date is flexible",
                  "legacy_value": "date_is_flexible"
                },
                {
                  "label": "I do not know yet",
                  "value": "I do not know yet",
                  "legacy_value": "i_do_not_know_yet"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "hotel_or_start_area",
              "label": "Hotel area or starting area in Tokyo",
              "type": "text",
              "required": false,
              "placeholder": "Example: Ginza, Marunouchi, Roppongi, Shinjuku, Tokyo Station area"
            },
            {
              "id": "shopping_time_window",
              "label": "Preferred shopping time window",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Morning",
                  "value": "Morning",
                  "legacy_value": "morning"
                },
                {
                  "label": "Afternoon",
                  "value": "Afternoon",
                  "legacy_value": "afternoon"
                },
                {
                  "label": "Evening",
                  "value": "Evening",
                  "legacy_value": "evening"
                },
                {
                  "label": "Full day",
                  "value": "Full day",
                  "legacy_value": "full_day"
                },
                {
                  "label": "Flexible",
                  "value": "Flexible",
                  "legacy_value": "flexible"
                },
                {
                  "label": "Not sure yet",
                  "value": "Not sure yet",
                  "legacy_value": "not_sure_yet"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "party_size",
              "label": "Number of people who may join the shopping session",
              "type": "text",
              "required": true,
              "step_blocking": true
            },
            {
              "id": "movement_privacy_timing_concerns",
              "label": "Any movement, comfort, privacy, or timing concerns?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Limited walking tolerance",
                  "value": "Limited walking tolerance",
                  "legacy_value": "limited_walking_tolerance"
                },
                {
                  "label": "Wheelchair or stroller considerations",
                  "value": "Wheelchair or stroller considerations",
                  "legacy_value": "wheelchair_or_stroller_considerations"
                },
                {
                  "label": "Elderly family member joining",
                  "value": "Elderly family member joining",
                  "legacy_value": "elderly_family_member_joining"
                },
                {
                  "label": "Child or family waiting needs",
                  "value": "Child or family waiting needs",
                  "legacy_value": "child_or_family_waiting_needs"
                },
                {
                  "label": "VIP / executive privacy concerns",
                  "value": "VIP / executive privacy concerns",
                  "legacy_value": "vip_executive_privacy_concerns"
                },
                {
                  "label": "Limited shopping time",
                  "value": "Limited shopping time",
                  "legacy_value": "limited_shopping_time"
                },
                {
                  "label": "Need transport coordination",
                  "value": "Need transport coordination",
                  "legacy_value": "need_transport_coordination"
                },
                {
                  "label": "Need hotel pickup or hotel handoff",
                  "value": "Need hotel pickup or hotel handoff",
                  "legacy_value": "need_hotel_pickup_or_hotel_handoff"
                },
                {
                  "label": "Need low-visibility / discreet support",
                  "value": "Need low-visibility / discreet support",
                  "legacy_value": "need_low_visibility_discreet_support"
                },
                {
                  "label": "None of the above",
                  "value": "None of the above",
                  "legacy_value": "none_of_the_above"
                },
                {
                  "label": "Other",
                  "value": "Other",
                  "legacy_value": "other"
                }
              ]
            },
            {
              "id": "travel_privacy_family_constraints",
              "label": "Please explain any travel, privacy, family, or timing constraints we should know.",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "shopping_objective",
          "title": "Shopping objective",
          "tone": "A good route depends on brands, item type, budget, timing, and whether someone needs to stand beside the client.",
          "fields": [
            {
              "id": "support_requested",
              "label": "What kind of support are you requesting?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Ginza route planning only",
                  "value": "Ginza route planning only",
                  "legacy_value": "ginza_route_planning_only"
                },
                {
                  "label": "Boutique availability / appointment feasibility pre-check",
                  "value": "Boutique availability / appointment feasibility pre-check",
                  "legacy_value": "boutique_availability_appointment_feasibility_pre_check"
                },
                {
                  "label": "In-person interpreter attendance",
                  "value": "In-person interpreter attendance",
                  "legacy_value": "in_person_interpreter_attendance"
                },
                {
                  "label": "Store-side communication support",
                  "value": "Store-side communication support",
                  "legacy_value": "store_side_communication_support"
                },
                {
                  "label": "Product clarification and comparison support",
                  "value": "Product clarification and comparison support",
                  "legacy_value": "product_clarification_and_comparison_support"
                },
                {
                  "label": "Luxury gift or milestone shopping support",
                  "value": "Luxury gift or milestone shopping support",
                  "legacy_value": "luxury_gift_or_milestone_shopping_support"
                },
                {
                  "label": "Family / executive / private client shopping support",
                  "value": "Family / executive / private client shopping support",
                  "legacy_value": "family_executive_private_client_shopping_support"
                },
                {
                  "label": "Multi-stop concierge shopping day",
                  "value": "Multi-stop concierge shopping day",
                  "legacy_value": "multi_stop_concierge_shopping_day"
                },
                {
                  "label": "Payment / tax-free / pickup clarification",
                  "value": "Payment / tax-free / pickup clarification",
                  "legacy_value": "payment_tax_free_pickup_clarification"
                },
                {
                  "label": "Hotel delivery or handoff planning",
                  "value": "Hotel delivery or handoff planning",
                  "legacy_value": "hotel_delivery_or_handoff_planning"
                },
                {
                  "label": "Post-purchase shipping or logistics routing",
                  "value": "Post-purchase shipping or logistics routing",
                  "legacy_value": "post_purchase_shipping_or_logistics_routing"
                },
                {
                  "label": "Remote follow-up after leaving Japan",
                  "value": "Remote follow-up after leaving Japan",
                  "legacy_value": "remote_follow_up_after_leaving_japan"
                },
                {
                  "label": "I am not sure yet",
                  "value": "I am not sure yet",
                  "legacy_value": "i_am_not_sure_yet"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "item_categories",
              "label": "What type of item are you shopping for?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Bags / leather goods",
                  "value": "Bags / leather goods",
                  "legacy_value": "bags_leather_goods"
                },
                {
                  "label": "Jewelry",
                  "value": "Jewelry",
                  "legacy_value": "jewelry"
                },
                {
                  "label": "Watches-adjacent accessories",
                  "value": "Watches-adjacent accessories",
                  "legacy_value": "watches_adjacent_accessories"
                },
                {
                  "label": "Fashion / ready-to-wear",
                  "value": "Fashion / ready-to-wear",
                  "legacy_value": "fashion_ready_to_wear"
                },
                {
                  "label": "Shoes",
                  "value": "Shoes",
                  "legacy_value": "shoes"
                },
                {
                  "label": "Fragrance / beauty",
                  "value": "Fragrance / beauty",
                  "legacy_value": "fragrance_beauty"
                },
                {
                  "label": "Home, lifestyle, or decorative luxury objects",
                  "value": "Home, lifestyle, or decorative luxury objects",
                  "legacy_value": "home_lifestyle_or_decorative_luxury_objects"
                },
                {
                  "label": "Gift item",
                  "value": "Gift item",
                  "legacy_value": "gift_item"
                },
                {
                  "label": "Limited / seasonal item",
                  "value": "Limited / seasonal item",
                  "legacy_value": "limited_seasonal_item"
                },
                {
                  "label": "Archive, discontinued, vintage, or pre-owned luxury",
                  "value": "Archive, discontinued, vintage, or pre-owned luxury",
                  "legacy_value": "archive_discontinued_vintage_or_pre_owned_luxury"
                },
                {
                  "label": "Multiple categories",
                  "value": "Multiple categories",
                  "legacy_value": "multiple_categories"
                },
                {
                  "label": "I am not sure yet",
                  "value": "I am not sure yet",
                  "legacy_value": "i_am_not_sure_yet"
                },
                {
                  "label": "Other",
                  "value": "Other",
                  "legacy_value": "other"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "desired_brands_boutiques",
              "label": "Desired brands, boutiques, departments, or store names",
              "type": "textarea",
              "required": true,
              "placeholder": "Please list the brands, stores, counters, or department stores you want to visit.",
              "rows": 5,
              "step_blocking": true
            },
            {
              "id": "desired_item_details",
              "label": "Desired item details",
              "type": "textarea",
              "required": true,
              "placeholder": "Please describe item names, colors, sizes, models, materials, references, recipient needs, or gift purpose.",
              "rows": 5,
              "step_blocking": true
            },
            {
              "id": "shopping_budget_usd",
              "label": "Approximate shopping budget in USD",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Under $1,000",
                  "value": "Under $1,000",
                  "legacy_value": "under_1_000"
                },
                {
                  "label": "$1,000–$2,500",
                  "value": "$1,000–$2,500",
                  "legacy_value": "1_000_2_500"
                },
                {
                  "label": "$2,500–$5,000",
                  "value": "$2,500–$5,000",
                  "legacy_value": "2_500_5_000"
                },
                {
                  "label": "$5,000–$10,000",
                  "value": "$5,000–$10,000",
                  "legacy_value": "5_000_10_000"
                },
                {
                  "label": "$10,000–$25,000",
                  "value": "$10,000–$25,000",
                  "legacy_value": "10_000_25_000"
                },
                {
                  "label": "$25,000–$50,000",
                  "value": "$25,000–$50,000",
                  "legacy_value": "25_000_50_000"
                },
                {
                  "label": "$50,000+",
                  "value": "$50,000+",
                  "legacy_value": "50_000"
                },
                {
                  "label": "Budget is flexible",
                  "value": "Budget is flexible",
                  "legacy_value": "budget_is_flexible"
                },
                {
                  "label": "I prefer not to say yet",
                  "value": "I prefer not to say yet",
                  "legacy_value": "i_prefer_not_to_say_yet"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "purchase_time_sensitive",
              "label": "Is this purchase time-sensitive?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, specific travel date",
                  "value": "Yes, specific travel date",
                  "legacy_value": "yes_specific_travel_date"
                },
                {
                  "label": "Yes, gift/event/wedding/anniversary/milestone",
                  "value": "Yes, gift/event/wedding/anniversary/milestone",
                  "legacy_value": "yes_gift_event_wedding_anniversary_milestone"
                },
                {
                  "label": "Somewhat",
                  "value": "Somewhat",
                  "legacy_value": "somewhat"
                },
                {
                  "label": "No, timing is flexible",
                  "value": "No, timing is flexible",
                  "legacy_value": "no_timing_is_flexible"
                },
                {
                  "label": "I am not sure",
                  "value": "I am not sure",
                  "legacy_value": "i_am_not_sure"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "shopping_success_definition",
              "label": "What would make this shopping day successful?",
              "type": "textarea",
              "required": true,
              "rows": 5,
              "step_blocking": true
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "route_appointments_store_contact",
          "title": "Route, appointments, and store contact",
          "tone": "Ginza luxury shopping can involve boutique timing, department store routing, staff communication, appointment expectations, inventory uncertainty, and tax-free logistics.",
          "fields": [
            {
              "id": "already_contacted_store",
              "label": "Have you already contacted any boutique, store, department, or concierge desk?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes",
                  "value": "Yes",
                  "legacy_value": "yes"
                },
                {
                  "label": "No",
                  "value": "No",
                  "legacy_value": "no"
                },
                {
                  "label": "Someone else contacted them for me",
                  "value": "Someone else contacted them for me",
                  "legacy_value": "someone_else_contacted_them_for_me"
                },
                {
                  "label": "I tried but did not receive a clear answer",
                  "value": "I tried but did not receive a clear answer",
                  "legacy_value": "i_tried_but_did_not_receive_a_clear_answer"
                },
                {
                  "label": "I am not sure",
                  "value": "I am not sure",
                  "legacy_value": "i_am_not_sure"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "store_contact_history",
              "label": "If yes, what was discussed or confirmed?",
              "type": "textarea",
              "required": false,
              "placeholder": "Include appointment times, staff replies, item availability notes, store names, or communication history.",
              "rows": 5
            },
            {
              "id": "boutique_appointment_status",
              "label": "Do you already have a boutique appointment?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed",
                  "value": "Yes, confirmed",
                  "legacy_value": "yes_confirmed"
                },
                {
                  "label": "Requested but not confirmed",
                  "value": "Requested but not confirmed",
                  "legacy_value": "requested_but_not_confirmed"
                },
                {
                  "label": "No",
                  "value": "No",
                  "legacy_value": "no"
                },
                {
                  "label": "I want JapanSolved™ to advise whether an appointment makes sense",
                  "value": "I want JapanSolved™ to advise whether an appointment makes sense",
                  "legacy_value": "i_want_japansolved_to_advise_whether_an_appointment_makes_sense"
                },
                {
                  "label": "Not sure",
                  "value": "Not sure",
                  "legacy_value": "not_sure"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "route_concerns",
              "label": "Which route concerns apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Too many boutiques or stores in one day",
                  "value": "Too many boutiques or stores in one day",
                  "legacy_value": "too_many_boutiques_or_stores_in_one_day"
                },
                {
                  "label": "Need help choosing store order",
                  "value": "Need help choosing store order",
                  "legacy_value": "need_help_choosing_store_order"
                },
                {
                  "label": "Need department store floor guidance",
                  "value": "Need department store floor guidance",
                  "legacy_value": "need_department_store_floor_guidance"
                },
                {
                  "label": "Need tax-free desk guidance",
                  "value": "Need tax-free desk guidance",
                  "legacy_value": "need_tax_free_desk_guidance"
                },
                {
                  "label": "Need payment method clarification",
                  "value": "Need payment method clarification",
                  "legacy_value": "need_payment_method_clarification"
                },
                {
                  "label": "Need pickup timing clarification",
                  "value": "Need pickup timing clarification",
                  "legacy_value": "need_pickup_timing_clarification"
                },
                {
                  "label": "Need hotel delivery or domestic delivery clarification",
                  "value": "Need hotel delivery or domestic delivery clarification",
                  "legacy_value": "need_hotel_delivery_or_domestic_delivery_clarification"
                },
                {
                  "label": "Need transport between stops",
                  "value": "Need transport between stops",
                  "legacy_value": "need_transport_between_stops"
                },
                {
                  "label": "Need lunch / waiting / family timing built around shopping",
                  "value": "Need lunch / waiting / family timing built around shopping",
                  "legacy_value": "need_lunch_waiting_family_timing_built_around_shopping"
                },
                {
                  "label": "Need privacy-aware movement",
                  "value": "Need privacy-aware movement",
                  "legacy_value": "need_privacy_aware_movement"
                },
                {
                  "label": "None of the above",
                  "value": "None of the above",
                  "legacy_value": "none_of_the_above"
                },
                {
                  "label": "Other",
                  "value": "Other",
                  "legacy_value": "other"
                }
              ]
            },
            {
              "id": "fixed_day_plans",
              "label": "List any fixed appointments, reservations, meals, meetings, or travel plans on the shopping day.",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "reference_links_upload_notes",
              "label": "Screenshots, wish lists, boutique replies, product photos, itinerary notes, reference images, or product URLs",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste public links or describe the files. If uploads are needed, JapanSolved™ may request them by follow-up.",
              "rows": 5
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "support_level_and_related_routes",
          "title": "Desired JapanSolved™ support level",
          "tone": "The first review determines whether the request stays a route review, becomes guided shopping attendance, escalates to concierge support, or routes to another desk.",
          "fields": [
            {
              "id": "desired_support_level",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline shopping session review only",
                  "value": "Baseline shopping session review only",
                  "legacy_value": "baseline_shopping_session_review_only"
                },
                {
                  "label": "Route and availability pre-check",
                  "value": "Route and availability pre-check",
                  "legacy_value": "route_and_availability_pre_check"
                },
                {
                  "label": "In-person interpreter attendance",
                  "value": "In-person interpreter attendance",
                  "legacy_value": "in_person_interpreter_attendance"
                },
                {
                  "label": "Half-day guided shopping support",
                  "value": "Half-day guided shopping support",
                  "legacy_value": "half_day_guided_shopping_support"
                },
                {
                  "label": "Full-day guided shopping support",
                  "value": "Full-day guided shopping support",
                  "legacy_value": "full_day_guided_shopping_support"
                },
                {
                  "label": "Multi-stop concierge shopping day",
                  "value": "Multi-stop concierge shopping day",
                  "legacy_value": "multi_stop_concierge_shopping_day"
                },
                {
                  "label": "Multi-day private shopping program",
                  "value": "Multi-day private shopping program",
                  "legacy_value": "multi_day_private_shopping_program"
                },
                {
                  "label": "Post-purchase handoff / logistics support",
                  "value": "Post-purchase handoff / logistics support",
                  "legacy_value": "post_purchase_handoff_logistics_support"
                },
                {
                  "label": "I am not sure and want JapanSolved™ to classify the file",
                  "value": "I am not sure and want JapanSolved™ to classify the file",
                  "legacy_value": "i_am_not_sure_and_want_japansolved_to_classify_the_file"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "shopping_day_help",
              "label": "What would you want JapanSolved™ to help with during the shopping day?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Explain store etiquette and expected flow",
                  "value": "Explain store etiquette and expected flow",
                  "legacy_value": "explain_store_etiquette_and_expected_flow"
                },
                {
                  "label": "Communicate with staff in Japanese",
                  "value": "Communicate with staff in Japanese",
                  "legacy_value": "communicate_with_staff_in_japanese"
                },
                {
                  "label": "Clarify item availability",
                  "value": "Clarify item availability",
                  "legacy_value": "clarify_item_availability"
                },
                {
                  "label": "Clarify product differences",
                  "value": "Clarify product differences",
                  "legacy_value": "clarify_product_differences"
                },
                {
                  "label": "Help compare options",
                  "value": "Help compare options",
                  "legacy_value": "help_compare_options"
                },
                {
                  "label": "Help communicate gift preferences",
                  "value": "Help communicate gift preferences",
                  "legacy_value": "help_communicate_gift_preferences"
                },
                {
                  "label": "Clarify payment process",
                  "value": "Clarify payment process",
                  "legacy_value": "clarify_payment_process"
                },
                {
                  "label": "Clarify tax-free handling",
                  "value": "Clarify tax-free handling",
                  "legacy_value": "clarify_tax_free_handling"
                },
                {
                  "label": "Clarify pickup or delivery timing",
                  "value": "Clarify pickup or delivery timing",
                  "legacy_value": "clarify_pickup_or_delivery_timing"
                },
                {
                  "label": "Help manage route timing",
                  "value": "Help manage route timing",
                  "legacy_value": "help_manage_route_timing"
                },
                {
                  "label": "Help manage family, entourage, or VIP movement",
                  "value": "Help manage family, entourage, or VIP movement",
                  "legacy_value": "help_manage_family_entourage_or_vip_movement"
                },
                {
                  "label": "Help coordinate hotel handoff",
                  "value": "Help coordinate hotel handoff",
                  "legacy_value": "help_coordinate_hotel_handoff"
                },
                {
                  "label": "Help route shipping or cargo needs",
                  "value": "Help route shipping or cargo needs",
                  "legacy_value": "help_route_shipping_or_cargo_needs"
                },
                {
                  "label": "Help decide whether another JapanSolved™ desk is more appropriate",
                  "value": "Help decide whether another JapanSolved™ desk is more appropriate",
                  "legacy_value": "help_decide_whether_another_japansolved_desk_is_more_appropriate"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Jewelry or gemstones",
                  "value": "Jewelry or gemstones",
                  "legacy_value": "jewelry_or_gemstones"
                },
                {
                  "label": "Archive / vintage / pre-owned luxury",
                  "value": "Archive / vintage / pre-owned luxury",
                  "legacy_value": "archive_vintage_pre_owned_luxury"
                },
                {
                  "label": "Watch servicing or warranty support",
                  "value": "Watch servicing or warranty support",
                  "legacy_value": "watch_servicing_or_warranty_support"
                },
                {
                  "label": "Remote buyer follow-up after I leave Japan",
                  "value": "Remote buyer follow-up after I leave Japan",
                  "legacy_value": "remote_buyer_follow_up_after_i_leave_japan"
                },
                {
                  "label": "Proxy purchase or seller-side risk review",
                  "value": "Proxy purchase or seller-side risk review",
                  "legacy_value": "proxy_purchase_or_seller_side_risk_review"
                },
                {
                  "label": "Large-format cargo, shipping, or customs-sensitive movement",
                  "value": "Large-format cargo, shipping, or customs-sensitive movement",
                  "legacy_value": "large_format_cargo_shipping_or_customs_sensitive_movement"
                },
                {
                  "label": "Local representation or hotel handoff",
                  "value": "Local representation or hotel handoff",
                  "legacy_value": "local_representation_or_hotel_handoff"
                },
                {
                  "label": "None of these",
                  "value": "None of these",
                  "legacy_value": "none_of_these"
                },
                {
                  "label": "I am not sure",
                  "value": "I am not sure",
                  "legacy_value": "i_am_not_sure"
                }
              ]
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "purchase_flow_handoff",
          "title": "Purchase flow and handoff",
          "tone": "Store rules, payment acceptance, tax-free eligibility, delivery timing, stock, returns, and brand decisions remain controlled by the boutique or seller.",
          "fields": [
            {
              "id": "store_payment_party",
              "label": "Who will pay the boutique or store for the item?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I will pay directly in store",
                  "value": "I will pay directly in store",
                  "legacy_value": "i_will_pay_directly_in_store"
                },
                {
                  "label": "My spouse / family member will pay directly in store",
                  "value": "My spouse / family member will pay directly in store",
                  "legacy_value": "my_spouse_family_member_will_pay_directly_in_store"
                },
                {
                  "label": "My executive / private client will pay directly in store",
                  "value": "My executive / private client will pay directly in store",
                  "legacy_value": "my_executive_private_client_will_pay_directly_in_store"
                },
                {
                  "label": "I may need JapanSolved™ to advise on payment flow",
                  "value": "I may need JapanSolved™ to advise on payment flow",
                  "legacy_value": "i_may_need_japansolved_to_advise_on_payment_flow"
                },
                {
                  "label": "I may need JapanSolved™ to purchase later as a private buyer / proxy",
                  "value": "I may need JapanSolved™ to purchase later as a private buyer / proxy",
                  "legacy_value": "i_may_need_japansolved_to_purchase_later_as_a_private_buyer_proxy"
                },
                {
                  "label": "Not sure yet",
                  "value": "Not sure yet",
                  "legacy_value": "not_sure_yet"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "payment_purchase_questions",
              "label": "Which payment or purchase questions do you have?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Tax-free purchase process",
                  "value": "Tax-free purchase process",
                  "legacy_value": "tax_free_purchase_process"
                },
                {
                  "label": "Credit card acceptance",
                  "value": "Credit card acceptance",
                  "legacy_value": "credit_card_acceptance"
                },
                {
                  "label": "Identity / passport requirements",
                  "value": "Identity / passport requirements",
                  "legacy_value": "identity_passport_requirements"
                },
                {
                  "label": "Pickup timing",
                  "value": "Pickup timing",
                  "legacy_value": "pickup_timing"
                },
                {
                  "label": "Delivery to hotel",
                  "value": "Delivery to hotel",
                  "legacy_value": "delivery_to_hotel"
                },
                {
                  "label": "Domestic delivery in Japan",
                  "value": "Domestic delivery in Japan",
                  "legacy_value": "domestic_delivery_in_japan"
                },
                {
                  "label": "International shipping possibility",
                  "value": "International shipping possibility",
                  "legacy_value": "international_shipping_possibility"
                },
                {
                  "label": "Return / exchange policy",
                  "value": "Return / exchange policy",
                  "legacy_value": "return_exchange_policy"
                },
                {
                  "label": "Gift wrapping",
                  "value": "Gift wrapping",
                  "legacy_value": "gift_wrapping"
                },
                {
                  "label": "Receipt / documentation",
                  "value": "Receipt / documentation",
                  "legacy_value": "receipt_documentation"
                },
                {
                  "label": "Insurance or protected packing",
                  "value": "Insurance or protected packing",
                  "legacy_value": "insurance_or_protected_packing"
                },
                {
                  "label": "Not sure yet",
                  "value": "Not sure yet",
                  "legacy_value": "not_sure_yet"
                },
                {
                  "label": "None",
                  "value": "None",
                  "legacy_value": "none"
                }
              ]
            },
            {
              "id": "japansolved_custody_expectation",
              "label": "Do you expect JapanSolved™ to take custody of any purchased item?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "No, I will keep the item",
                  "value": "No, I will keep the item",
                  "legacy_value": "no_i_will_keep_the_item"
                },
                {
                  "label": "Maybe, only for hotel handoff",
                  "value": "Maybe, only for hotel handoff",
                  "legacy_value": "maybe_only_for_hotel_handoff"
                },
                {
                  "label": "Maybe, only for domestic delivery coordination",
                  "value": "Maybe, only for domestic delivery coordination",
                  "legacy_value": "maybe_only_for_domestic_delivery_coordination"
                },
                {
                  "label": "Maybe, only for shipping / logistics escalation",
                  "value": "Maybe, only for shipping / logistics escalation",
                  "legacy_value": "maybe_only_for_shipping_logistics_escalation"
                },
                {
                  "label": "Yes, but I understand this requires separate approval and quote",
                  "value": "Yes, but I understand this requires separate approval and quote",
                  "legacy_value": "yes_but_i_understand_this_requires_separate_approval_and_quote"
                },
                {
                  "label": "Not sure yet",
                  "value": "Not sure yet",
                  "legacy_value": "not_sure_yet"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "post_purchase_needs",
              "label": "Describe any post-purchase handoff, hotel delivery, storage, shipping, packing, or follow-up needs.",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "final_shopping_brief",
          "title": "Final shopping brief",
          "tone": "Explain the request in plain language so the route can be classified.",
          "fields": [
            {
              "id": "final_shopping_summary",
              "label": "Please summarize your Ginza luxury shopping request.",
              "type": "textarea",
              "required": true,
              "placeholder": "Include who is shopping, when, where, what you want to buy, budget, support needed, and what would make the day successful.",
              "rows": 5,
              "step_blocking": true
            },
            {
              "id": "preferred_contact_method",
              "label": "Preferred contact method",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Email",
                  "value": "Email",
                  "legacy_value": "email"
                },
                {
                  "label": "WhatsApp",
                  "value": "WhatsApp",
                  "legacy_value": "whatsapp"
                },
                {
                  "label": "LINE",
                  "value": "LINE",
                  "legacy_value": "line"
                },
                {
                  "label": "Phone call",
                  "value": "Phone call",
                  "legacy_value": "phone_call"
                },
                {
                  "label": "I prefer email first",
                  "value": "I prefer email first",
                  "legacy_value": "i_prefer_email_first"
                }
              ],
              "step_blocking": true
            },
            {
              "id": "messaging_contact",
              "label": "WhatsApp, LINE, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Emergency / within 24 hours",
                  "value": "Emergency / within 24 hours",
                  "legacy_value": "emergency_within_24_hours"
                },
                {
                  "label": "Very urgent / within 48 hours",
                  "value": "Very urgent / within 48 hours",
                  "legacy_value": "very_urgent_within_48_hours"
                },
                {
                  "label": "Time-sensitive / within 3–7 days",
                  "value": "Time-sensitive / within 3–7 days",
                  "legacy_value": "time_sensitive_within_3_7_days"
                },
                {
                  "label": "Normal",
                  "value": "Normal",
                  "legacy_value": "normal"
                },
                {
                  "label": "Flexible",
                  "value": "Flexible",
                  "legacy_value": "flexible"
                }
              ],
              "step_blocking": true
            }
          ],
          "validate_before_next": true
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "step_blocking": true
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "step_blocking": true
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee item availability, boutique access, appointment approval, purchase approval, special pricing, allocation, tax-free eligibility, return, delivery timing, or brand decision.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee item availability, boutique access, appointment approval, purchase approval, special pricing, allocation, tax-free eligibility, return, delivery timing, or brand decision.",
              "step_blocking": true
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "step_blocking": true
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "step_blocking": true
            }
          ],
          "validate_before_next": true
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee item availability, boutique access, appointment approval, purchase approval, special pricing, allocation, tax-free eligibility, return, delivery timing, or brand decision.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "If payment path is not paid, show payment-required logic and treat as routing reference only.",
        "If urgent timing is within 48 hours or 3–7 days, flag as urgent and expect case deposit or narrowed route.",
        "If jewelry, archive luxury, proxy/private buyer, or logistics flags are selected, route to the appropriate related desk.",
        "Original Tally included file upload; Native Intake v2 records it as reference-link/upload-note field until file handling exists."
      ],
      "email_subject": "New Ginza Luxury Shopping Intake — {client_name} — {preferred_ginza_date}",
      "hidden_fields": {
        "page_handle": "japan-ginza-luxury-brand-personal-shopping",
        "desk_name": "Japan Ginza Luxury Brand Personal Shopping Desk™",
        "intake_type": "japan_ginza_luxury_brand_personal_shopping",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_GINZA_LUXURY_BRAND_PERSONAL_SHOPPING",
        "LUXURY_SHOPPING___GINZA___CONCIERGE",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "tally_doc_reconstruction_full_native_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5,
        "final_bridge_pass": "GINZA_CHECKOUT_EMAIL_TO_CONTACT_EMAIL_CANONICAL_VALIDATION_FINAL01"
      },
      "legacy_display_map": {
        "paid_primary_review": "I purchased / completed payment for Japan Ginza Luxury Shopping Session Review™ — $295",
        "approved_private_path": "I am on an approved invoice, case deposit, retainer, or private payment path",
        "japansolved_instructed": "JapanSolved™ instructed me to submit this intake before payment",
        "not_paid": "I have not paid yet",
        "/products/japan-ginza-luxury-shopping-session-review": "Japan Ginza Luxury Shopping Session Review™ — $295",
        "approved_private_payment_path": "Approved invoice / case deposit / retainer / private quote",
        "japansolved_instructed_prepayment_exception": "JapanSolved™ instructed me to submit before payment",
        "not_paid_routing_reference_only": "Not paid yet / routing reference only",
        "myself_principal_client": "Myself / principal client",
        "partner_or_family_member": "Partner or family member",
        "assistant_manager_representative": "Assistant / manager / representative",
        "travel_planner_concierge": "Travel planner / concierge",
        "family_office_executive_team": "Family office / executive team",
        "other": "Other",
        "i_am_already_in_japan": "I am already in Japan",
        "i_will_arrive_in_japan_soon": "I will arrive in Japan soon",
        "i_am_planning_a_future_japan_trip": "I am planning a future Japan trip",
        "i_am_submitting_for_someone_who_will_be_in_japan": "I am submitting for someone who will be in Japan",
        "i_am_not_sure_yet": "I am not sure yet",
        "i_may_need_remote_follow_up_after_leaving_japan": "I may need remote follow-up after leaving Japan",
        "within_48_hours": "Within 48 hours",
        "within_3_7_days": "Within 3–7 days",
        "within_1_2_weeks": "Within 1–2 weeks",
        "more_than_2_weeks_away": "More than 2 weeks away",
        "date_is_flexible": "Date is flexible",
        "i_do_not_know_yet": "I do not know yet",
        "morning": "Morning",
        "afternoon": "Afternoon",
        "evening": "Evening",
        "full_day": "Full day",
        "flexible": "Flexible",
        "not_sure_yet": "Not sure yet",
        "limited_walking_tolerance": "Limited walking tolerance",
        "wheelchair_or_stroller_considerations": "Wheelchair or stroller considerations",
        "elderly_family_member_joining": "Elderly family member joining",
        "child_or_family_waiting_needs": "Child or family waiting needs",
        "vip_executive_privacy_concerns": "VIP / executive privacy concerns",
        "limited_shopping_time": "Limited shopping time",
        "need_transport_coordination": "Need transport coordination",
        "need_hotel_pickup_or_hotel_handoff": "Need hotel pickup or hotel handoff",
        "need_low_visibility_discreet_support": "Need low-visibility / discreet support",
        "none_of_the_above": "None of the above",
        "ginza_route_planning_only": "Ginza route planning only",
        "boutique_availability_appointment_feasibility_pre_check": "Boutique availability / appointment feasibility pre-check",
        "in_person_interpreter_attendance": "In-person interpreter attendance",
        "store_side_communication_support": "Store-side communication support",
        "product_clarification_and_comparison_support": "Product clarification and comparison support",
        "luxury_gift_or_milestone_shopping_support": "Luxury gift or milestone shopping support",
        "family_executive_private_client_shopping_support": "Family / executive / private client shopping support",
        "multi_stop_concierge_shopping_day": "Multi-stop concierge shopping day",
        "payment_tax_free_pickup_clarification": "Payment / tax-free / pickup clarification",
        "hotel_delivery_or_handoff_planning": "Hotel delivery or handoff planning",
        "post_purchase_shipping_or_logistics_routing": "Post-purchase shipping or logistics routing",
        "remote_follow_up_after_leaving_japan": "Remote follow-up after leaving Japan",
        "bags_leather_goods": "Bags / leather goods",
        "jewelry": "Jewelry",
        "watches_adjacent_accessories": "Watches-adjacent accessories",
        "fashion_ready_to_wear": "Fashion / ready-to-wear",
        "shoes": "Shoes",
        "fragrance_beauty": "Fragrance / beauty",
        "home_lifestyle_or_decorative_luxury_objects": "Home, lifestyle, or decorative luxury objects",
        "gift_item": "Gift item",
        "limited_seasonal_item": "Limited / seasonal item",
        "archive_discontinued_vintage_or_pre_owned_luxury": "Archive, discontinued, vintage, or pre-owned luxury",
        "multiple_categories": "Multiple categories",
        "under_1_000": "Under $1,000",
        "1_000_2_500": "$1,000–$2,500",
        "2_500_5_000": "$2,500–$5,000",
        "5_000_10_000": "$5,000–$10,000",
        "10_000_25_000": "$10,000–$25,000",
        "25_000_50_000": "$25,000–$50,000",
        "50_000": "$50,000+",
        "budget_is_flexible": "Budget is flexible",
        "i_prefer_not_to_say_yet": "I prefer not to say yet",
        "yes_specific_travel_date": "Yes, specific travel date",
        "yes_gift_event_wedding_anniversary_milestone": "Yes, gift/event/wedding/anniversary/milestone",
        "somewhat": "Somewhat",
        "no_timing_is_flexible": "No, timing is flexible",
        "i_am_not_sure": "I am not sure",
        "yes": "Yes",
        "no": "No",
        "someone_else_contacted_them_for_me": "Someone else contacted them for me",
        "i_tried_but_did_not_receive_a_clear_answer": "I tried but did not receive a clear answer",
        "yes_confirmed": "Yes, confirmed",
        "requested_but_not_confirmed": "Requested but not confirmed",
        "i_want_japansolved_to_advise_whether_an_appointment_makes_sense": "I want JapanSolved™ to advise whether an appointment makes sense",
        "not_sure": "Not sure",
        "too_many_boutiques_or_stores_in_one_day": "Too many boutiques or stores in one day",
        "need_help_choosing_store_order": "Need help choosing store order",
        "need_department_store_floor_guidance": "Need department store floor guidance",
        "need_tax_free_desk_guidance": "Need tax-free desk guidance",
        "need_payment_method_clarification": "Need payment method clarification",
        "need_pickup_timing_clarification": "Need pickup timing clarification",
        "need_hotel_delivery_or_domestic_delivery_clarification": "Need hotel delivery or domestic delivery clarification",
        "need_transport_between_stops": "Need transport between stops",
        "need_lunch_waiting_family_timing_built_around_shopping": "Need lunch / waiting / family timing built around shopping",
        "need_privacy_aware_movement": "Need privacy-aware movement",
        "baseline_shopping_session_review_only": "Baseline shopping session review only",
        "route_and_availability_pre_check": "Route and availability pre-check",
        "half_day_guided_shopping_support": "Half-day guided shopping support",
        "full_day_guided_shopping_support": "Full-day guided shopping support",
        "multi_day_private_shopping_program": "Multi-day private shopping program",
        "post_purchase_handoff_logistics_support": "Post-purchase handoff / logistics support",
        "i_am_not_sure_and_want_japansolved_to_classify_the_file": "I am not sure and want JapanSolved™ to classify the file",
        "explain_store_etiquette_and_expected_flow": "Explain store etiquette and expected flow",
        "communicate_with_staff_in_japanese": "Communicate with staff in Japanese",
        "clarify_item_availability": "Clarify item availability",
        "clarify_product_differences": "Clarify product differences",
        "help_compare_options": "Help compare options",
        "help_communicate_gift_preferences": "Help communicate gift preferences",
        "clarify_payment_process": "Clarify payment process",
        "clarify_tax_free_handling": "Clarify tax-free handling",
        "clarify_pickup_or_delivery_timing": "Clarify pickup or delivery timing",
        "help_manage_route_timing": "Help manage route timing",
        "help_manage_family_entourage_or_vip_movement": "Help manage family, entourage, or VIP movement",
        "help_coordinate_hotel_handoff": "Help coordinate hotel handoff",
        "help_route_shipping_or_cargo_needs": "Help route shipping or cargo needs",
        "help_decide_whether_another_japansolved_desk_is_more_appropriate": "Help decide whether another JapanSolved™ desk is more appropriate",
        "jewelry_or_gemstones": "Jewelry or gemstones",
        "archive_vintage_pre_owned_luxury": "Archive / vintage / pre-owned luxury",
        "watch_servicing_or_warranty_support": "Watch servicing or warranty support",
        "remote_buyer_follow_up_after_i_leave_japan": "Remote buyer follow-up after I leave Japan",
        "proxy_purchase_or_seller_side_risk_review": "Proxy purchase or seller-side risk review",
        "large_format_cargo_shipping_or_customs_sensitive_movement": "Large-format cargo, shipping, or customs-sensitive movement",
        "local_representation_or_hotel_handoff": "Local representation or hotel handoff",
        "none_of_these": "None of these",
        "i_will_pay_directly_in_store": "I will pay directly in store",
        "my_spouse_family_member_will_pay_directly_in_store": "My spouse / family member will pay directly in store",
        "my_executive_private_client_will_pay_directly_in_store": "My executive / private client will pay directly in store",
        "i_may_need_japansolved_to_advise_on_payment_flow": "I may need JapanSolved™ to advise on payment flow",
        "i_may_need_japansolved_to_purchase_later_as_a_private_buyer_proxy": "I may need JapanSolved™ to purchase later as a private buyer / proxy",
        "tax_free_purchase_process": "Tax-free purchase process",
        "credit_card_acceptance": "Credit card acceptance",
        "identity_passport_requirements": "Identity / passport requirements",
        "pickup_timing": "Pickup timing",
        "delivery_to_hotel": "Delivery to hotel",
        "domestic_delivery_in_japan": "Domestic delivery in Japan",
        "international_shipping_possibility": "International shipping possibility",
        "return_exchange_policy": "Return / exchange policy",
        "gift_wrapping": "Gift wrapping",
        "receipt_documentation": "Receipt / documentation",
        "insurance_or_protected_packing": "Insurance or protected packing",
        "none": "None",
        "no_i_will_keep_the_item": "No, I will keep the item",
        "maybe_only_for_hotel_handoff": "Maybe, only for hotel handoff",
        "maybe_only_for_domestic_delivery_coordination": "Maybe, only for domestic delivery coordination",
        "maybe_only_for_shipping_logistics_escalation": "Maybe, only for shipping / logistics escalation",
        "yes_but_i_understand_this_requires_separate_approval_and_quote": "Yes, but I understand this requires separate approval and quote",
        "email": "Email",
        "whatsapp": "WhatsApp",
        "line": "LINE",
        "phone_call": "Phone call",
        "i_prefer_email_first": "I prefer email first",
        "emergency_within_24_hours": "Emergency / within 24 hours",
        "very_urgent_within_48_hours": "Very urgent / within 48 hours",
        "time_sensitive_within_3_7_days": "Time-sensitive / within 3–7 days",
        "normal": "Normal"
      },
      "native_bridge_status": "TALLY_RECONSTRUCTED_TO_CANONICAL_NATIVE_INTAKE_FINAL01",
      "option_value_mode": "human_readable_values_with_legacy_value_bridge",
      "review_display_policy": {
        "display_option_labels_not_machine_values": true,
        "use_legacy_display_map_for_cached_slug_answers": true,
        "never_show_snake_case_or_raw_tally_qid_as_client_answer": true
      },
      "required_identity_fields": [
        "client_name",
        "contact_email"
      ],
      "validation_policy": {
        "validate_required_fields_before_step_advance": true,
        "validate_email_fields_before_step_advance": true,
        "validate_contact_email_before_final_review": true,
        "validate_contact_email_before_submit": true,
        "contact_email_canonical_key": "contact_email",
        "contact_email_format_hint": "Use one @ symbol and a real domain, such as name@example.com.",
        "late_submit_email_error_fix": "The email field is canonicalized to contact_email and carries step_blocking email validation so the error appears on the email step, not only on final send.",
        "tally_reconstructed_record": true
      },
      "canonical_fields": {
        "client_name": "client_name",
        "contact_email": "contact_email",
        "payment_reference": "order_reference",
        "payment_status": "payment_status",
        "preferred_ginza_date": "preferred_ginza_date",
        "urgency": "urgency",
        "support_level": "desired_support_level"
      },
      "field_aliases": {
        "client_name": [
          "full_name_client_or_lead_contact",
          "lead_contact_name",
          "traveler_name",
          "Field 4",
          "Q4"
        ],
        "contact_email": [
          "checkout_email",
          "email_used_at_checkout",
          "best_contact_email",
          "email",
          "Field 3",
          "Q3"
        ],
        "payment_reference": [
          "order_reference",
          "shopify_order_number_or_payment_reference",
          "Field 2",
          "Q2"
        ],
        "payment_status": [
          "payment_path",
          "which_payment_path_applies",
          "Field 1",
          "Q1"
        ],
        "urgency": [
          "how_urgent_is_this_request",
          "Field 4 Page 8"
        ],
        "preferred_ginza_date": [
          "preferred_ginza_shopping_date",
          "shopping_date"
        ]
      },
      "email_preview_fields": [
        "payment_status",
        "order_reference",
        "contact_email",
        "client_name",
        "preferred_ginza_date",
        "japan_travel_status",
        "hotel_or_start_area",
        "desired_brands_boutiques",
        "item_categories",
        "shopping_budget_usd",
        "desired_support_level",
        "urgency",
        "related_routes"
      ]
    },
    {
      "page_title": "Japan Preloved Vintage Luxury Brand Shopping Desk™",
      "page_handle": "japan-preloved-vintage-luxury-shopping",
      "page_url": "https://japansolved.com/pages/japan-preloved-vintage-luxury-shopping",
      "intake_title": "Preloved Vintage Luxury Shopping Case File Intake",
      "service_label": "Japan preloved, vintage, and luxury brand shopping support",
      "subject_label": "Preloved Vintage Luxury Shopping Intake",
      "descriptor_line1": "Payment first. Case file second. Brand, category, listing, condition, seller, timing, route, and handoff details stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the payment path that matches the preloved luxury, vintage, resale, guided-shopping, proxy, or purchase-coordination request. If JapanSolved™ approved a private route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Preloved Luxury Shopping Review™",
          "value": "/products/japan-preloved-luxury-shopping-review",
          "render_as_link": true
        },
        {
          "label": "Japan Preloved Luxury Shopping Case Deposit™",
          "value": "/products/japan-preloved-luxury-shopping-case-deposit",
          "render_as_link": true
        },
        {
          "label": "Japan Preloved Purchase Coordination™",
          "value": "/products/japan-preloved-purchase-coordination",
          "render_as_link": true
        },
        {
          "label": "Japan Preloved Luxury Guided Shopping™",
          "value": "/products/japan-preloved-luxury-guided-shopping",
          "render_as_link": true
        },
        {
          "label": "Japan Preloved Luxury Condition & Seller Question Prep™",
          "value": "/products/japan-preloved-luxury-condition-seller-question-prep",
          "render_as_link": true
        },
        {
          "label": "Japan Luxury Resale Route Program™",
          "value": "/products/japan-luxury-resale-route-program",
          "render_as_link": true
        },
        {
          "label": "Japan Archive Fashion & Luxury Resale Buyer Program™",
          "value": "/products/japan-archive-fashion-luxury-resale-buyer-program",
          "render_as_link": true
        },
        {
          "label": "Japan Preloved Luxury Handoff & Shipping Coordination™",
          "value": "/products/japan-preloved-luxury-handoff-shipping-coordination",
          "render_as_link": true
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the case file for a paid preloved luxury review, guided shopping route, purchase coordination, case deposit, approved invoice, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet, I need the correct payment route first",
                  "value": "not_yet_i_need_the_correct_payment_route_first"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "helper": "Choose the closest path. If you have not paid yet, use the review payment path first unless JapanSolved™ gave you a private path.",
              "options": [
                {
                  "label": "Japan Preloved Luxury Shopping Review™",
                  "value": "/products/japan-preloved-luxury-shopping-review"
                },
                {
                  "label": "Japan Preloved Luxury Shopping Case Deposit™",
                  "value": "/products/japan-preloved-luxury-shopping-case-deposit"
                },
                {
                  "label": "Japan Preloved Purchase Coordination™",
                  "value": "/products/japan-preloved-purchase-coordination"
                },
                {
                  "label": "Japan Preloved Luxury Guided Shopping™",
                  "value": "/products/japan-preloved-luxury-guided-shopping"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the same payment email whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "Include the order number, invoice number, access deposit reference, retainer note, or private payment reference.",
              "placeholder": "Example: #1234, invoice number, or pending"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "tone": "Japan-side routing depends on exact names, decision authority, and a reliable contact channel.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text"
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Family member / companion",
                  "value": "family_member_companion"
                },
                {
                  "label": "Company representative",
                  "value": "company_representative"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "helper": "City/country is enough."
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Preloved Luxury Shopping request profile",
          "tone": "Give enough detail to classify the route without overloading the first review.",
          "fields": [
            {
              "id": "shopping_goal",
              "label": "What are you trying to source or evaluate?",
              "type": "textarea",
              "required": true,
              "helper": "Mention brand, category, model, era, size, color, condition target, and whether you already found listings."
            },
            {
              "id": "brand_category",
              "label": "Primary brand/category focus",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Hermès / Chanel / Louis Vuitton / Dior / Gucci / luxury bags",
                  "value": "herm_s_chanel_louis_vuitton_dior_gucci_luxury_bags"
                },
                {
                  "label": "Archive fashion / runway / rare vintage",
                  "value": "archive_fashion_runway_rare_vintage"
                },
                {
                  "label": "Watches / jewelry-adjacent luxury object",
                  "value": "watches_jewelry_adjacent_luxury_object"
                },
                {
                  "label": "Shoes / apparel / accessories",
                  "value": "shoes_apparel_accessories"
                },
                {
                  "label": "Multiple categories",
                  "value": "multiple_categories"
                },
                {
                  "label": "Other or not sure yet",
                  "value": "other_or_not_sure_yet"
                }
              ]
            },
            {
              "id": "listing_links",
              "label": "Known listings, store names, screenshots, or seller references",
              "type": "textarea",
              "helper": "Paste URLs or describe the shop/seller/source. Use “none yet” if discovery is needed."
            },
            {
              "id": "auth_condition_concerns",
              "label": "Authentication, condition, odor, sizing, alteration, or seller concerns",
              "type": "textarea"
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "tone": "Timing, spending limits, and destination rules decide whether the file is a review, deposit, retainer, or specialist escalation.",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": true,
              "helper": "Include travel dates, purchase deadline, export/import timing, appointment date, or decision date."
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "helper": "Use currency and clarify whether this includes product price, service fees, shipping, travel, taxes, or handling."
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, or appointment location",
              "type": "textarea"
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, accessibility needs, language issues, or people involved",
              "type": "textarea"
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "tone": "Screenshots, seller links, product pages, photos, and prior messages can prevent expensive wrong turns.",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, shop pages, seller messages, or product pages",
              "type": "textarea",
              "helper": "Paste links or describe what you will send after intake."
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, resale shop, boutique, concierge, buyer, courier, or logistics party?",
              "type": "textarea"
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "helper": "Examples: discretion, privacy, surprise gift, time pressure, high-value item, seller-risk concern, condition issue, shipping need, or unusual routing risk."
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "tone": "Confirm the file is accurate, authorized, and tied to the correct paid or approved route before submission.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_route",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, purchase, access, compliance approval, export/import clearance, reservation success, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "016",
      "record_id": "JSII_BANK_JAPAN_PRELOVED_VINTAGE_LUXURY_SHOPPING",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Preloved Vintage Luxury Brand Shopping Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Vintage, Thrift & Flea Market Guided Shopping Desk™",
      "page_handle": "japan-vintage-thrift-flea-market-guided-shopping",
      "page_url": "https://japansolved.com/pages/japan-vintage-thrift-flea-market-guided-shopping",
      "intake_title": "Vintage, Thrift & Flea Market Guided Shopping™ Case File Intake",
      "service_label": "Japan vintage, thrift, flea-market, discovery-shopping, route-planning, guided-shopping, and post-purchase handoff support",
      "subject_label": "Vintage, Thrift & Flea Market Guided Shopping Intake",
      "descriptor_line1": "Payment first. Case file second. Dates, districts, taste targets, market timing, support level, budget, group needs, and post-purchase handoff concerns stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the payment path that matches the vintage route review, guided shopping window, flea-market day, private discovery program, reseller route, bulky-find handoff, or approved private path.",
      "payment_block_fineprint": "Use the same payment email at intake so the vintage, thrift, and flea-market route file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid review, guided-shopping product, invoice, retainer, deposit, or JapanSolved™-approved payment path before the full discovery-route file opens. Use the correct payment route first, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Vintage & Thrift Guided Shopping Review™ — $395",
          "value": "/products/japan-vintage-thrift-guided-shopping-review",
          "render_as_link": true
        },
        {
          "label": "Japan Vintage Guided Shopping Half-Day™ — from $950 + travel/expenses",
          "value": "/products/japan-vintage-guided-shopping-half-day",
          "render_as_link": true
        },
        {
          "label": "Japan Vintage & Flea Market Full-Day Route™ — from $1,950 + travel/expenses",
          "value": "/products/japan-vintage-flea-market-full-day-route",
          "render_as_link": true
        },
        {
          "label": "Japan Private Discovery Shopping Program™ — scoped from $2,500/day",
          "value": "/products/japan-private-discovery-shopping-program",
          "render_as_link": true
        },
        {
          "label": "Japan Vintage Buyer / Reseller Route Planning Desk™",
          "value": "/products/japan-vintage-buyer-reseller-route-planning-desk",
          "render_as_link": true
        },
        {
          "label": "Japan Bulky Vintage Find Handoff & Shipping Coordination™",
          "value": "/products/japan-bulky-vintage-find-handoff-shipping-coordination",
          "render_as_link": true
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the route file for a paid vintage review, guided shopping product, approved invoice, access deposit, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the Vintage & Thrift Guided Shopping Review™",
                  "value": "yes_public_vintage_review_paid"
                },
                {
                  "label": "Yes, I completed payment for guided attendance, a half-day, full-day, or private discovery route",
                  "value": "yes_guided_attendance_or_program_paid"
                },
                {
                  "label": "Yes, I am on an approved invoice, access deposit, retainer, custom quote, or private payment path",
                  "value": "yes_approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit"
                },
                {
                  "label": "Not yet, I need the correct payment route first",
                  "value": "not_yet_need_payment_route"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "helper": "Choose the closest paid path. If you have not paid yet, use the review payment path first unless JapanSolved™ gave you a private route.",
              "options": [
                {
                  "label": "Japan Vintage & Thrift Guided Shopping Review™ — /products/japan-vintage-thrift-guided-shopping-review",
                  "value": "/products/japan-vintage-thrift-guided-shopping-review"
                },
                {
                  "label": "Japan Vintage Guided Shopping Half-Day™ — /products/japan-vintage-guided-shopping-half-day",
                  "value": "/products/japan-vintage-guided-shopping-half-day"
                },
                {
                  "label": "Japan Vintage & Flea Market Full-Day Route™ — /products/japan-vintage-flea-market-full-day-route",
                  "value": "/products/japan-vintage-flea-market-full-day-route"
                },
                {
                  "label": "Japan Private Discovery Shopping Program™ — /products/japan-private-discovery-shopping-program",
                  "value": "/products/japan-private-discovery-shopping-program"
                },
                {
                  "label": "Japan Vintage Buyer / Reseller Route Planning Desk™ — /products/japan-vintage-buyer-reseller-route-planning-desk",
                  "value": "/products/japan-vintage-buyer-reseller-route-planning-desk"
                },
                {
                  "label": "Japan Bulky Vintage Find Handoff & Shipping Coordination™ — /products/japan-bulky-vintage-find-handoff-shipping-coordination",
                  "value": "/products/japan-bulky-vintage-find-handoff-shipping-coordination"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the same payment email whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available.",
              "placeholder": "Example: #1234, invoice number, or pending"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "tone": "Route planning depends on exact travel dates, decision authority, group needs, and a contact channel that works while the client is in Japan.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true,
              "placeholder": "name@example.com"
            },
            {
              "id": "country_timezone",
              "label": "Current country / timezone",
              "type": "text",
              "required": true,
              "helper": "This helps us judge timing if the shopping date, market, or travel window is close."
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text"
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the shopper / traveler",
                  "value": "client_shopper_traveler"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Stylist / reseller / shop / agency representative",
                  "value": "stylist_reseller_shop_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "requester_authority",
              "label": "Are you authorized to make decisions and share details for this shopping file?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Yes, I can decide and communicate directly",
                  "value": "yes_decision_authorized"
                },
                {
                  "label": "Yes, but another person approves budget or route changes",
                  "value": "yes_but_another_approves"
                },
                {
                  "label": "I am gathering options before final approval",
                  "value": "gathering_options_before_approval"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "route_profile",
          "title": "Discovery route profile",
          "tone": "The best route depends on taste, date, city, market timing, walking rhythm, weather, group size, and how much surprise the shopper wants.",
          "fields": [
            {
              "id": "shopping_goal",
              "label": "What vintage, thrift, flea-market, reseller, styling, or discovery-shopping route do you want JapanSolved™ to design?",
              "type": "textarea",
              "required": true,
              "helper": "Include the city, shopping date, item categories, style references, budget, and what a successful route would feel like."
            },
            {
              "id": "desired_support_level",
              "label": "Which support level fits best?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Route review only",
                  "value": "route_review_only"
                },
                {
                  "label": "Focused half-day guided shopping",
                  "value": "focused_half_day_guided_shopping"
                },
                {
                  "label": "Full-day vintage / flea-market route",
                  "value": "full_day_vintage_flea_market_route"
                },
                {
                  "label": "Private discovery shopping program",
                  "value": "private_discovery_shopping_program"
                },
                {
                  "label": "Buyer / reseller route planning",
                  "value": "buyer_reseller_route_planning"
                },
                {
                  "label": "Bulky find handoff or shipping coordination",
                  "value": "bulky_find_handoff_shipping"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "route_targets",
              "label": "Preferred cities, neighborhoods, markets, stores, event dates, or starting area",
              "type": "textarea",
              "helper": "Examples: Tokyo, Osaka, Kyoto, Shimokitazawa, Koenji, shrine markets, recycle shops, textile routes, retro toy routes, record shops, flea-market events."
            },
            {
              "id": "shopping_categories",
              "label": "Categories, sizes, brands, eras, style preferences, must-find items, and avoid items",
              "type": "textarea",
              "helper": "Examples: denim, workwear, streetwear, kimono, obi, textiles, ceramics, toys, records, books, folk objects, furniture, signage, accessories, or odd treasures."
            }
          ]
        },
        {
          "id": "risk_and_route_layers",
          "title": "Route risks and support layers",
          "tone": "Vintage shopping has delicious uncertainty. This step separates fun discovery from condition risk, luggage chaos, and wrong-desk escalation.",
          "fields": [
            {
              "id": "experience_themes",
              "label": "Which route or risk layers apply?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Vintage fashion / streetwear / denim / workwear",
                  "value": "vintage_fashion_streetwear_denim_workwear"
                },
                {
                  "label": "Thrift and recycle shop discovery",
                  "value": "thrift_recycle_shop_discovery"
                },
                {
                  "label": "Flea market / shrine market / weekend event route",
                  "value": "flea_shrine_market_event_route"
                },
                {
                  "label": "Textiles / kimono / boro-inspired / remakes",
                  "value": "textiles_kimono_boro_remakes"
                },
                {
                  "label": "Retro toys / books / records / magazines / Showa goods",
                  "value": "retro_toys_books_records_showa_goods"
                },
                {
                  "label": "Ceramics / folk objects / home decor / odd-shaped finds",
                  "value": "ceramics_folk_objects_home_decor"
                },
                {
                  "label": "Professional stylist / reseller / buyer / creator route",
                  "value": "professional_stylist_reseller_buyer_creator"
                },
                {
                  "label": "Condition, odor, repair, sizing, or authenticity concern",
                  "value": "condition_odor_repair_sizing_authenticity_concern"
                },
                {
                  "label": "Bulky, fragile, heavy, or multi-item purchase risk",
                  "value": "bulky_fragile_heavy_multi_item_risk"
                },
                {
                  "label": "Hotel handoff, packing, shipping, or logistics escalation",
                  "value": "handoff_packing_shipping_logistics"
                }
              ]
            },
            {
              "id": "condition_concerns",
              "label": "Condition, sizing, odor, authenticity, material, seller, or repair concerns",
              "type": "textarea"
            },
            {
              "id": "group_and_pace",
              "label": "Group size, walking tolerance, mobility limits, weather concerns, children/family needs, or pace preferences",
              "type": "textarea"
            },
            {
              "id": "privacy_content_boundary",
              "label": "Any privacy, content creation, filming, reseller, or professional-use boundaries?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Private personal shopping only",
                  "value": "private_personal_shopping_only"
                },
                {
                  "label": "Content creation or filming may be involved",
                  "value": "content_creation_filming_may_be_involved"
                },
                {
                  "label": "Stylist / reseller / professional buyer route",
                  "value": "professional_buyer_route"
                },
                {
                  "label": "Family / group shopping route",
                  "value": "family_group_route"
                },
                {
                  "label": "Discreet route needed",
                  "value": "discreet_route_needed"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_budget_scope",
          "title": "Timing, budget, and handoff scope",
          "tone": "Dates, market timing, budget, cash needs, luggage limits, and handoff plans decide whether the file stays a route review or becomes guided support.",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target shopping date, travel window, or decision deadline",
              "type": "textarea",
              "required": true,
              "helper": "Include exact dates in Japan, preferred shopping day, backup dates, and whether this depends on a specific market or event."
            },
            {
              "id": "urgency",
              "label": "How urgent is this request?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "One month or more before the route",
                  "value": "one_month_or_more"
                },
                {
                  "label": "One to three weeks before the route",
                  "value": "one_to_three_weeks"
                },
                {
                  "label": "Within one week",
                  "value": "within_one_week"
                },
                {
                  "label": "Within 72 hours / already in Japan",
                  "value": "within_72_hours_already_in_japan"
                },
                {
                  "label": "Same-day or market/event is already active",
                  "value": "same_day_market_event_active"
                }
              ]
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "select",
              "required": true,
              "helper": "Use the shopping budget, not only the service fee.",
              "options": [
                {
                  "label": "Under $500",
                  "value": "under_500"
                },
                {
                  "label": "$500–$1,500",
                  "value": "500_1500"
                },
                {
                  "label": "$1,500–$5,000",
                  "value": "1500_5000"
                },
                {
                  "label": "$5,000–$10,000",
                  "value": "5000_10000"
                },
                {
                  "label": "$10,000+",
                  "value": "10000_plus"
                },
                {
                  "label": "Flexible / depends on finds",
                  "value": "flexible_depends_on_finds"
                },
                {
                  "label": "Confidential",
                  "value": "confidential"
                }
              ]
            },
            {
              "id": "destination_or_handoff",
              "label": "Hotel, handoff, shipping destination, luggage limit, or post-shopping movement plan",
              "type": "textarea"
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, accessibility needs, language issues, payment/cash limits, or people involved",
              "type": "textarea"
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "tone": "Style references, shop links, screenshots, and prior messages help us avoid designing the wrong hunt.",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, image references, shop pages, seller messages, route notes, or product pages",
              "type": "textarea",
              "helper": "Paste links or describe what you will send after intake."
            },
            {
              "id": "style_references",
              "label": "Style references, inspiration photos, Instagram/Pinterest links, brand examples, or mood notes",
              "type": "textarea"
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a shop, seller, event, market, hotel, courier, or logistics party?",
              "type": "textarea"
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "helper": "Examples: surprise gift, privacy, filming restrictions, professional buyer route, group sensitivity, fragile item risk, time pressure, or unusual routing risk."
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final confirmation",
          "tone": "Confirm the discovery-route file is accurate, authorized, and tied to the correct paid or approved route before review.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "I understand this intake is tied to the appropriate paid review, guided-shopping product, deposit, invoice, retainer, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_route",
              "label": "I understand unpaid users must use the correct product or payment path before full intake review, route planning, attendance, or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, rare finds, event operation, weather, seller cooperation, discounts, item availability, authenticity, condition accuracy, shipping, customs clearance, timing, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it for this client, group, company, shop, stylist, reseller, or private party.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "017",
      "record_id": "JSII_BANK_JAPAN_VINTAGE_THRIFT_FLEA_MARKET_GUIDED_SHOPPING",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Vintage, Thrift & Flea Market Guided Shopping Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Art, Antiques & Gallery Guided Shopping Desk™",
      "page_handle": "japan-art-antiques-gallery-guided-shopping",
      "page_url": "https://japansolved.com/pages/japan-art-antiques-gallery-guided-shopping",
      "subject_label": "Art, Antiques & Gallery Guided Shopping Intake",
      "intake_title": "Art & Gallery Guided Acquisition Case File Intake",
      "descriptor_line1": "Payment first. Case file second. Route, dates, object categories, dealer/gallery context, proof sensitivity, and purchase-support needs stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the payment path that matches the art, antiques, gallery, dealer-route, or guided acquisition request. If JapanSolved™ approved a private route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Art & Gallery Route Review™",
          "value": "/products/japan-art-gallery-route-review",
          "render_as_link": true
        },
        {
          "label": "Japan Dealer Question & Visit Prep Desk™",
          "value": "/products/japan-dealer-question-visit-prep-desk",
          "render_as_link": true
        },
        {
          "label": "Japan Art & Antiques Guided Visit™",
          "value": "/products/japan-art-antiques-guided-visit",
          "render_as_link": true
        },
        {
          "label": "Japan Private Dealer / Gallery Acquisition Day™",
          "value": "/products/japan-private-dealer-gallery-acquisition-day",
          "render_as_link": true
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the case file for a paid route review, guided visit, dealer prep desk, approved invoice, access deposit, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_public_review_paid"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, guided visit, or private payment path",
                  "value": "yes_private_approved_path_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "helper": "Choose the closest paid path. If you have not paid yet, use the route review first unless JapanSolved™ gave you a private path.",
              "options": [
                {
                  "label": "Japan Art & Gallery Route Review™",
                  "value": "/products/japan-art-gallery-route-review"
                },
                {
                  "label": "Japan Dealer Question & Visit Prep Desk™",
                  "value": "/products/japan-dealer-question-visit-prep-desk"
                },
                {
                  "label": "Japan Art & Antiques Guided Visit™",
                  "value": "/products/japan-art-antiques-guided-visit"
                },
                {
                  "label": "Japan Private Dealer / Gallery Acquisition Day™",
                  "value": "/products/japan-private-dealer-gallery-acquisition-day"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, guided visit, access deposit, invoice, retainer, or approved private route.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "Include the order number, invoice number, receipt ID, guided visit reference, retainer note, or private payment reference.",
              "placeholder": "Example: #1234, invoice number, or approved reference"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "tone": "Japan-side gallery, dealer, and guided-visit routing depends on exact names, decision authority, and a reliable contact channel.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / shop / dealer / agency representative",
                  "value": "business_shop_dealer_agency_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now, and when will they be in Japan?",
              "type": "text",
              "required": false,
              "helper": "City/country is enough. Add Japan travel dates if known."
            }
          ]
        },
        {
          "id": "acquisition_route",
          "title": "Art, antiques, gallery, and dealer-route profile",
          "tone": "Share the route, object category, and buying intent so the file can be classified before any gallery visit or dealer conversation becomes a serious acquisition.",
          "fields": [
            {
              "id": "route_goal",
              "label": "What art, antiques, gallery, craft, dealer, or acquisition route do you want JapanSolved™ to review?",
              "type": "textarea",
              "required": true,
              "placeholder": "Example: Kyoto ceramics route, Tokyo antique dealers, gallery day, byobu/screen search, textile shopping, specific dealer visit, etc."
            },
            {
              "id": "target_city_area",
              "label": "Target city, district, gallery area, dealer location, or craft route",
              "type": "text",
              "required": true,
              "placeholder": "Tokyo, Kyoto, Kanazawa, Mashiko, Ginza, Meguro, dealer address, exhibition venue, etc."
            },
            {
              "id": "object_interests",
              "label": "Object categories, maker/period/style interests, collection goals, and proof sensitivity",
              "type": "textarea",
              "required": true,
              "helper": "Include categories such as ceramics, lacquer, textiles, prints, bronze, screens, sculpture, Buddhist objects, fittings, contemporary craft, gallery works, or design objects."
            },
            {
              "id": "dealer_gallery_context",
              "label": "Known galleries, dealers, shops, exhibitions, maker studios, links, appointments, or introductions involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "support_needs",
          "title": "Support level and purchase caution",
          "tone": "Guided shopping can range from route planning to in-person attendance. Choose the layers that may be needed so the scope does not blur.",
          "fields": [
            {
              "id": "support_layers",
              "label": "Which support layers may be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Route review / visit sequence planning",
                  "value": "route_review"
                },
                {
                  "label": "Dealer or gallery question preparation",
                  "value": "dealer_gallery_question_prep"
                },
                {
                  "label": "In-person guided visit / interpretation",
                  "value": "guided_visit_interpretation"
                },
                {
                  "label": "Condition, attribution, provenance, paper, box, or price-logic caution",
                  "value": "proof_condition_caution"
                },
                {
                  "label": "Private dealer, appointment, or introduction handling",
                  "value": "private_dealer_appointment"
                },
                {
                  "label": "Purchase, pickup, payment, custody, or handoff support",
                  "value": "purchase_pickup_custody"
                },
                {
                  "label": "Packing, shipping, fragile-object, cargo, or export routing",
                  "value": "packing_shipping_cargo_export"
                },
                {
                  "label": "High discretion / private client handling",
                  "value": "high_discretion"
                }
              ]
            },
            {
              "id": "purchase_intent",
              "label": "How serious is the purchase intent?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Browsing / learning route only",
                  "value": "browsing_learning"
                },
                {
                  "label": "Likely purchase if the right object appears",
                  "value": "likely_purchase"
                },
                {
                  "label": "Specific object or dealer already identified",
                  "value": "specific_object_or_dealer"
                },
                {
                  "label": "High-value or proof-sensitive acquisition",
                  "value": "high_value_proof_sensitive"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "acquisition_export_concerns",
              "label": "Acquisition, authenticity, provenance, fragile handling, export, customs, insurance, cargo, or handoff concerns",
              "type": "textarea",
              "required": false
            },
            {
              "id": "avoid_list",
              "label": "What should be avoided during the route or purchase process?",
              "type": "textarea",
              "required": false,
              "placeholder": "Hard-sell dealers, fragile shipping, regulated categories, public exposure, rushed purchases, long walking, stairs, etc."
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, urgency, and route constraints",
          "tone": "Dates, budget, privacy, movement needs, and urgency decide whether the file stays a review or needs guided attendance, specialist review, private buyer, or cargo routing.",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing, Japan travel dates, appointment window, or purchase deadline",
              "type": "textarea",
              "required": true,
              "helper": "Include priority, secondary, and tertiary dates when possible."
            },
            {
              "id": "urgency",
              "label": "Timing urgency",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "One month or more before target date",
                  "value": "one_month_plus"
                },
                {
                  "label": "About one to three weeks before target date",
                  "value": "one_to_three_weeks"
                },
                {
                  "label": "About one week before target date",
                  "value": "one_week"
                },
                {
                  "label": "Within 72 hours / rush review may be needed",
                  "value": "within_72"
                },
                {
                  "label": "Already in Japan / same-day or next-day concern",
                  "value": "same_day_next_day"
                }
              ]
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling in USD",
              "type": "text",
              "required": true,
              "helper": "Clarify whether this includes object price, service fees, guide fees, travel, packing, shipping, taxes, or handling."
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, appointment, or route location",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, accessibility needs, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, photos, and supporting context",
          "tone": "Images, seller links, dealer messages, route notes, object references, and appointment details can prevent expensive wrong turns.",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, seller messages, route notes, product pages, or appointment details",
              "type": "textarea",
              "required": false,
              "helper": "Paste links or describe what you will send after intake."
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a dealer, gallery, seller, maker, shop, venue, specialist, or logistics party?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false,
              "helper": "Examples: discretion, surprise gift, high-value object, proof sensitivity, cultural-property concern, public-profile client, unusual risk, or time pressure."
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid intake boundary",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, guided visit, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users may be routed to the correct product, payment path, or review before the case file is processed."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, purchase, access, authenticity, attribution, provenance, appointment, visit, or purchase-route success, dealer cooperation, export clearance, shipping outcome, timing, or result."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate, authorized, and safe for JapanSolved™ to review for this paid request."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "018",
      "record_id": "JSII_BANK_JAPAN_ART_ANTIQUES_GALLERY_GUIDED_SHOPPING",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Art, Antiques & Gallery Guided Shopping Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Medical Tourism Entourage & Support Desk™",
      "page_handle": "japan-medical-tourism-entourage-support",
      "page_url": "https://japansolved.com/pages/japan-medical-tourism-entourage-support",
      "subject_label": "Japan Medical Tourism Entourage & Support Intake",
      "intake_title": "Medical Tourism Entourage & Support™ Case File Intake",
      "service_label": "Non-medical Japan-side care logistics, visit support triage, appointment-day movement planning, interpreter coordination, privacy handling, family or assistant support, and entourage routing",
      "descriptor_line1": "Payment first. Case file second. Visit dates, provider status, appointment type, documents, interpretation needs, privacy concerns, family or assistant coordination, mobility needs, hotel area, and requested non-medical support stay attached to the paid medical tourism support review, entourage deposit, retainer, or approved payment path.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private medical-tourism support payment path.",
      "descriptor_paragraphs": [
        "Payment first. Case file second.",
        "Visit dates, provider status, appointment type, documents, interpretation needs, privacy concerns, family or assistant coordination, mobility needs, hotel area, and requested non-medical support stay attached to the paid medical tourism support review, entourage deposit, retainer, or approved payment path.",
        "Use this native intake after checkout or after JapanSolved™ approves a private medical-tourism support payment path."
      ],
      "payment_block_title": "Complete the medical tourism support payment first",
      "payment_block_copy": "Choose the paid support review, entourage case deposit, private entourage retainer, or approved private invoice before submitting detailed care-related logistics, provider, document, or privacy information.",
      "payment_block_fineprint": "Use the same payment email at intake so the support file can be matched to the paid path.",
      "not_paid_error": "This medical tourism entourage and support intake requires a matched paid or JapanSolved™-approved payment path before submission.",
      "product_routes": [
        {
          "label": "Japan Medical Tourism Support Review™",
          "value": "/products/japan-medical-tourism-support-review"
        },
        {
          "label": "Japan Medical Tourism Entourage Case Deposit™",
          "value": "/products/japan-medical-tourism-entourage-case-deposit"
        },
        {
          "label": "Japan Private Entourage Support Retainer™",
          "value": "/products/japan-private-entourage-support-retainer"
        },
        {
          "label": "Approved invoice / custom quote / private support payment path",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and support-path match",
          "tone": "Payment-first, case-file-second. Match the care-related logistics request to the correct paid path before sensitive visit details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "type": "radio",
              "label": "Have you already secured the correct paid path for this medical tourism support request?",
              "required": true,
              "options": [
                "Yes — I purchased the Japan Medical Tourism Support Review™",
                "Yes — I secured the Medical Tourism Entourage Case Deposit™",
                "Yes — I purchased or was approved for a private entourage retainer, quote, invoice, or private payment path",
                "Not yet — I need to purchase or confirm the correct payment path first"
              ]
            },
            {
              "id": "selected_product_path",
              "type": "select",
              "label": "Which product or payment path applies?",
              "required": true,
              "options": [
                "Japan Medical Tourism Support Review™",
                "Japan Medical Tourism Entourage Case Deposit™",
                "Japan Private Entourage Support Retainer™",
                "Approved private payment path / invoice / custom quote"
              ]
            },
            {
              "id": "checkout_email",
              "type": "email",
              "label": "Payment email address",
              "required": true,
              "placeholder": "Use the same email used at checkout or invoice payment."
            },
            {
              "id": "order_reference",
              "type": "text",
              "label": "Order number, invoice number, or payment reference",
              "required": true,
              "placeholder": "Example: JS-1001, order number, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_visit_profile",
          "title": "Client, submitter, and visit profile",
          "tone": "Give the support file enough context to understand who is traveling, who is authorized, and what non-medical support may be needed.",
          "fields": [
            {
              "id": "client_name",
              "type": "text",
              "label": "Client or patient-traveler name",
              "required": true
            },
            {
              "id": "contact_email",
              "type": "email",
              "label": "Best contact email",
              "required": true
            },
            {
              "id": "submitter_role",
              "type": "select",
              "label": "Who is submitting this file?",
              "required": true,
              "options": [
                "Client directly",
                "Assistant / family office / staff member submitting for the client",
                "Family member or traveling companion submitting for the client",
                "Travel advisor, concierge, clinic-side coordinator, or agency submitting for the client",
                "Other authorized representative"
              ]
            },
            {
              "id": "authorization_notes",
              "type": "textarea",
              "label": "Authorization, privacy, and who may receive updates",
              "required": true,
              "placeholder": "Who is authorized to communicate about logistics, documents, schedules, hotel movement, family updates, or provider coordination?"
            },
            {
              "id": "country_timezone",
              "type": "text",
              "label": "Current country / timezone",
              "required": true
            },
            {
              "id": "target_city_area",
              "type": "text",
              "label": "Japan city, clinic area, hotel area, or appointment route zone",
              "required": true,
              "placeholder": "Example: Tokyo, Ginza, Shinjuku, Osaka, clinic area, hotel area"
            },
            {
              "id": "date_window",
              "type": "textarea",
              "label": "Target appointment date, backup dates, arrival/departure windows, and time constraints",
              "required": true,
              "placeholder": "Include appointment date if known, secondary/tertiary dates, travel dates, hotel dates, and timing constraints."
            }
          ]
        },
        {
          "id": "provider_and_appointment_status",
          "title": "Provider and appointment status",
          "tone": "JapanSolved™ can support logistics around a care-related visit, but medical decisions and provider decisions remain outside this desk.",
          "fields": [
            {
              "id": "provider_status",
              "type": "select",
              "label": "What is the current provider or appointment status?",
              "required": true,
              "options": [
                "Provider / clinic / hospital already selected and appointment confirmed",
                "Provider already selected but appointment not yet confirmed",
                "Provider or wellness program is being considered but not confirmed",
                "Client needs logistics review before deciding whether support is viable",
                "Not sure yet"
              ]
            },
            {
              "id": "provider_details",
              "type": "textarea",
              "label": "Provider, clinic, hospital, wellness program, appointment, or instruction details",
              "required": true,
              "placeholder": "Names, locations, official links, appointment type, provider instructions, forms requested, and what has already been confirmed."
            },
            {
              "id": "visit_category",
              "type": "checkbox_group",
              "label": "Which care-related visit lanes may apply?",
              "required": true,
              "options": [
                "Health checkup or executive screening",
                "Specialist clinic visit where provider is already selected",
                "Wellness, longevity, rehabilitation-adjacent, or non-emergency care visit",
                "Appointment-day logistics attendance may be needed",
                "Professional interpreter coordination may be needed",
                "Family, assistant, or companion coordination may be needed",
                "Privacy-sensitive or VIP/entourage-aware movement may be needed",
                "Document, receipt, results, or follow-up logistics may be needed"
              ]
            },
            {
              "id": "medical_boundary_confirmation",
              "type": "checkbox_group",
              "label": "Boundary confirmation for this non-medical support desk",
              "required": true,
              "options": [
                "I understand JapanSolved™ does not diagnose, recommend treatment, choose procedures, or judge clinical suitability",
                "I understand medical decisions belong to licensed providers and the client’s medical team",
                "I understand emergencies must go through official emergency, clinic, hospital, insurer, or local authority channels first",
                "I understand prescription medication, restricted products, and regulated medical goods may be declined or require licensed channels"
              ]
            }
          ]
        },
        {
          "id": "support_needs",
          "title": "Non-medical logistics and entourage needs",
          "tone": "Describe the practical support layer around the visit: movement, documents, timing, family communication, interpretation coordination, and privacy.",
          "fields": [
            {
              "id": "support_needed",
              "type": "checkbox_group",
              "label": "What kind of support is being requested?",
              "required": true,
              "options": [
                "Visit support review only",
                "Appointment logistics preparation",
                "Transport, hotel movement, route timing, or check-in support",
                "Professional interpreter coordination or provider-approved communication support",
                "Document organization, form-routing, receipts, or follow-up logistics",
                "Family, assistant, spouse, parent, child, or traveling-companion coordination",
                "Privacy-sensitive, VIP, executive, or low-visibility movement planning",
                "Local attendance, waiting-area support, or multi-day entourage support may be needed"
              ]
            },
            {
              "id": "requested_support_summary",
              "type": "textarea",
              "label": "Describe the support mission in plain language",
              "required": true,
              "placeholder": "What should JapanSolved™ help organize? What is the desired result, and what would count as a failed support day?"
            },
            {
              "id": "language_needs",
              "type": "textarea",
              "label": "Language, interpretation, Japanese wording, or communication needs",
              "required": false,
              "placeholder": "Where might professional interpretation, careful wording, or provider-approved communication be needed?"
            },
            {
              "id": "document_needs",
              "type": "textarea",
              "label": "Documents, forms, instructions, receipts, follow-up, or file-handling concerns",
              "required": false,
              "placeholder": "List document types, deadlines, languages, who may handle them, and any privacy restrictions."
            },
            {
              "id": "privacy_concerns",
              "type": "textarea",
              "label": "Privacy, discretion, visibility, family communication, or name-use constraints",
              "required": false,
              "placeholder": "What should not be disclosed unnecessarily? Who can receive updates? Any VIP, family-office, executive, or sensitive-context handling?"
            }
          ]
        },
        {
          "id": "mobility_family_schedule",
          "title": "Mobility, companions, and schedule pressure",
          "tone": "Care-related logistics can fail through timing, movement, fasting windows, recovery pacing, companions, hotel placement, and waiting arrangements.",
          "fields": [
            {
              "id": "companions_group",
              "type": "textarea",
              "label": "Traveling companions, assistants, family members, or entourage size",
              "required": false,
              "placeholder": "Who is present in Japan? Who needs help moving, waiting, receiving updates, or coordinating around the appointment?"
            },
            {
              "id": "mobility_timing",
              "type": "checkbox_group",
              "label": "Practical conditions that may affect the support plan",
              "required": true,
              "options": [
                "Mobility limits, wheelchair, taxi, elevator, or walking-distance concern",
                "Fasting, sedation, recovery pacing, fatigue, waiting time, or aftercare timing may affect movement",
                "Multiple appointments, multiple locations, or tight transport windows",
                "Hotel, airport, station, family, or assistant handoff needed",
                "Private room, quiet waiting, low-visibility movement, or minimal-exposure routing desired",
                "No special mobility or schedule constraints known yet"
              ]
            },
            {
              "id": "hotel_transport_notes",
              "type": "textarea",
              "label": "Hotel, transport, arrival, departure, and movement notes",
              "required": false,
              "placeholder": "Hotel area, airport/station plans, taxi/driver needs, clinic route, waiting times, pickup/handoff points, or travel pressure."
            },
            {
              "id": "rush_timing",
              "type": "select",
              "label": "How urgent is the requested support?",
              "required": true,
              "options": [
                "Planning window is one month or more",
                "Planning window is one to four weeks",
                "Target date is within one week",
                "Target date is within three days and may require rush review",
                "Date not yet confirmed"
              ]
            }
          ]
        },
        {
          "id": "scope_budget_confirmation",
          "title": "Scope, budget, and final confirmation",
          "tone": "Clarify cost authority, support boundaries, outside costs, and the next decision before the case file is reviewed.",
          "fields": [
            {
              "id": "budget_authority",
              "type": "textarea",
              "label": "Budget range, outside costs, interpreter costs, transport costs, and approval authority",
              "required": false,
              "placeholder": "Review fee/deposit/retainer status, expected support budget, who can approve interpreter, transport, waiting time, hotel, vendor, or local attendance costs."
            },
            {
              "id": "must_not_happen",
              "type": "textarea",
              "label": "What should not happen?",
              "required": false,
              "placeholder": "Examples: no unnecessary disclosure, no casual interpretation during clinical discussion, no family updates without authorization, no medical advice, no provider contact before approval."
            },
            {
              "id": "attachments_summary",
              "type": "textarea",
              "label": "Links, documents, screenshots, provider instructions, or files you may send separately",
              "required": false,
              "placeholder": "Do not paste sensitive medical records unless requested. Summarize what exists and how JapanSolved™ should receive it if needed."
            },
            {
              "id": "final_notes",
              "type": "textarea",
              "label": "Anything else JapanSolved™ should know before reviewing the support file?",
              "required": false
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ does not provide medical advice, diagnosis, treatment guarantees, regulatory guarantees, provider acceptance, availability, pricing, or suitability guarantees, and that additional clarification, documents, authorization, payment, or quote may be required before this file can proceed."
            }
          ]
        }
      ],
      "page_sequence": "019",
      "record_id": "JSII_BANK_JAPAN_MEDICAL_TOURISM_ENTOURAGE_SUPPORT",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Medical Tourism Entourage & Support Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Beauty & Longevity Product Sourcing Compliance Desk™",
      "page_handle": "japan-beauty-longevity-product-sourcing-compliance",
      "page_url": "https://japansolved.com/pages/japan-beauty-longevity-product-sourcing-compliance",
      "intake_title": "Beauty & Longevity Product Sourcing Compliance™ Case File Intake",
      "service_label": "Japan beauty, wellness, and longevity-adjacent product sourcing compliance support",
      "subject_label": "Beauty & Longevity Product Sourcing Compliance Intake",
      "descriptor_line1": "Payment first. Case file second. Product, seller, quantity, destination, claim sensitivity, sourcing route, and movement-risk details stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the payment path that matches the product sourcing, compliance-risk, procurement, supplier, logistics, or repeat-order request. If JapanSolved™ approved a private route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid review, deposit, retainer, invoice, or JapanSolved™-approved payment path before the full product file opens. Use the correct payment route first, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Beauty Product Sourcing Compliance Review™",
          "value": "/products/japan-beauty-product-sourcing-compliance-review",
          "render_as_link": true
        },
        {
          "label": "Japan Product Sourcing Case Deposit™",
          "value": "/products/japan-product-sourcing-case-deposit",
          "render_as_link": true
        },
        {
          "label": "Japan Product Procurement Desk Retainer™",
          "value": "/products/japan-product-procurement-desk-retainer",
          "render_as_link": true
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the product sourcing compliance file for a paid review, approved invoice, access deposit, case deposit, retainer, or JapanSolved™-approved private route.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_public_review_paid"
                },
                {
                  "label": "Yes, I completed payment for a case deposit, retainer, invoice, or approved private route",
                  "value": "yes_private_or_deposit_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me"
                },
                {
                  "label": "Not yet, I need the correct payment route first",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "helper": "Choose the closest paid path. If you have not paid yet, use the baseline review first unless JapanSolved™ gave you a private route.",
              "options": [
                {
                  "label": "Japan Beauty Product Sourcing Compliance Review™ — /products/japan-beauty-product-sourcing-compliance-review",
                  "value": "/products/japan-beauty-product-sourcing-compliance-review"
                },
                {
                  "label": "Japan Product Sourcing Case Deposit™ — /products/japan-product-sourcing-case-deposit",
                  "value": "/products/japan-product-sourcing-case-deposit"
                },
                {
                  "label": "Japan Product Procurement Desk Retainer™ — /products/japan-product-procurement-desk-retainer",
                  "value": "/products/japan-product-procurement-desk-retainer"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the same payment email whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "Include the order number, invoice number, access deposit reference, retainer note, or private payment reference.",
              "placeholder": "Example: #1234, invoice number, or approved private reference"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and request authority",
          "tone": "Product sourcing and compliance routing depends on who is requesting, who will use or sell the product, and which contact channel is reliable.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true,
              "placeholder": "name@example.com"
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text"
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client / buyer",
                  "value": "client_buyer"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Founder / small retailer / business owner",
                  "value": "founder_retailer_business_owner"
                },
                {
                  "label": "Salon / spa / wellness operator",
                  "value": "salon_spa_wellness_operator"
                },
                {
                  "label": "Concierge / travel advisor / partner",
                  "value": "concierge_travel_advisor_partner"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client or business based?",
              "type": "text",
              "helper": "City/country is enough."
            },
            {
              "id": "request_intent",
              "label": "Primary use case",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Personal use",
                  "value": "personal_use"
                },
                {
                  "label": "Gift / concierge request",
                  "value": "gift_concierge_request"
                },
                {
                  "label": "Sampling / product research",
                  "value": "sampling_product_research"
                },
                {
                  "label": "Retail / resale / marketplace intent",
                  "value": "retail_resale_marketplace_intent"
                },
                {
                  "label": "Salon / spa / clinic-adjacent business use",
                  "value": "salon_spa_clinic_adjacent_business_use"
                },
                {
                  "label": "Wholesale / distributor / repeat procurement",
                  "value": "wholesale_distributor_repeat_procurement"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "product_profile",
          "title": "Product and seller profile",
          "tone": "Give enough product detail to classify the route without treating the intake as medical, legal, customs, or regulatory advice.",
          "fields": [
            {
              "id": "product_goal",
              "label": "What beauty, wellness, longevity-adjacent, skincare, personal-care, device, or product-sourcing path are you considering?",
              "type": "textarea",
              "required": true,
              "helper": "Include product name, brand, item type, seller, quantity, destination country, intended use, and why the product matters."
            },
            {
              "id": "product_category",
              "label": "Primary product category",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Cosmetics / skincare / beauty product",
                  "value": "cosmetics_skincare_beauty_product"
                },
                {
                  "label": "Hair care / fragrance-adjacent / personal care",
                  "value": "hair_fragrance_personal_care"
                },
                {
                  "label": "Longevity / wellness lifestyle product",
                  "value": "longevity_wellness_lifestyle_product"
                },
                {
                  "label": "Supplement-like or ingestible wellness product requiring caution",
                  "value": "supplement_like_ingestible_wellness_caution"
                },
                {
                  "label": "Device / tool / equipment",
                  "value": "device_tool_equipment"
                },
                {
                  "label": "Clinic-adjacent or treatment-adjacent product requiring boundary review",
                  "value": "clinic_adjacent_treatment_adjacent_boundary_review"
                },
                {
                  "label": "Retail procurement / wholesale inquiry",
                  "value": "retail_procurement_wholesale_inquiry"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "brand_seller_links",
              "label": "Product names, brand names, seller pages, marketplace links, or reference URLs",
              "type": "textarea",
              "helper": "Paste links or describe the product source. Screenshots and label photos can be sent after intake if needed."
            },
            {
              "id": "quantity_request",
              "label": "Quantity and repeat-order expectation",
              "type": "textarea",
              "required": true,
              "helper": "Mention units, sets, monthly volume, samples, personal-use quantity, wholesale intent, or repeat procurement expectations."
            },
            {
              "id": "destination_country",
              "label": "Destination country / import side",
              "type": "text",
              "required": true,
              "helper": "Include final country and any known customs/import platform requirements."
            }
          ]
        },
        {
          "id": "compliance_and_movement",
          "title": "Compliance, claim, format, and movement concerns",
          "tone": "This step helps JapanSolved™ decide whether the file is simple sourcing, procurement coordination, logistics review, specialist escalation, or a decline.",
          "fields": [
            {
              "id": "support_layers",
              "label": "What should the first review focus on?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Product category and visible label caution",
                  "value": "product_category_label_caution"
                },
                {
                  "label": "Japanese page / label / warning interpretation for sourcing purposes",
                  "value": "japanese_label_warning_interpretation"
                },
                {
                  "label": "Seller reliability and official-source review",
                  "value": "seller_reliability_official_source_review"
                },
                {
                  "label": "Ingredient, claim, or medicine-adjacent risk signals",
                  "value": "ingredient_claim_medicine_adjacent_risk_signals"
                },
                {
                  "label": "Shipping format concerns: liquid, aerosol, powder, battery, device, temperature, shelf life",
                  "value": "shipping_format_concerns"
                },
                {
                  "label": "Personal-use vs. resale / business import boundary",
                  "value": "personal_resale_business_import_boundary"
                },
                {
                  "label": "Supplier route, repeat procurement, or wholesale feasibility",
                  "value": "supplier_repeat_procurement_wholesale_feasibility"
                },
                {
                  "label": "Logistics, packing, storage, carrier, or customs-routing concern",
                  "value": "logistics_packing_storage_carrier_customs"
                },
                {
                  "label": "Decline / specialist review risk before purchase",
                  "value": "decline_specialist_review_risk"
                }
              ]
            },
            {
              "id": "product_format",
              "label": "Product format or movement-sensitive feature",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Ordinary sealed consumer product",
                  "value": "ordinary_sealed_consumer_product"
                },
                {
                  "label": "Liquid / cream / gel / oil",
                  "value": "liquid_cream_gel_oil"
                },
                {
                  "label": "Aerosol / pressurized / fragrance / alcohol-adjacent",
                  "value": "aerosol_pressurized_fragrance_alcohol_adjacent"
                },
                {
                  "label": "Powder / ingestible / supplement-like item",
                  "value": "powder_ingestible_supplement_like_item"
                },
                {
                  "label": "Battery / electric device / tool",
                  "value": "battery_electric_device_tool"
                },
                {
                  "label": "Temperature-sensitive / short shelf life",
                  "value": "temperature_sensitive_short_shelf_life"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "known_restrictions",
              "label": "Known restrictions, ingredients, claims, prescription/medical concerns, customs issues, platform rules, or seller warnings",
              "type": "textarea"
            },
            {
              "id": "claim_boundary",
              "label": "Does the product page make medical, treatment, anti-aging, slimming, whitening, disease, diagnostic, or regulated-style claims?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "No obvious regulated-style claims",
                  "value": "no_obvious_regulated_claims"
                },
                {
                  "label": "Some claim sensitivity may exist",
                  "value": "some_claim_sensitivity"
                },
                {
                  "label": "Yes, claims appear strong or medical-adjacent",
                  "value": "strong_medical_adjacent_claims"
                },
                {
                  "label": "I am not sure and need review",
                  "value": "not_sure_need_review"
                }
              ]
            },
            {
              "id": "commercial_disclosure",
              "label": "Commercial intent disclosure",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Personal use only",
                  "value": "personal_use_only"
                },
                {
                  "label": "Gift / concierge request",
                  "value": "gift_concierge_request"
                },
                {
                  "label": "Sampling / product research",
                  "value": "sampling_product_research"
                },
                {
                  "label": "Resale / marketplace / retail intent",
                  "value": "resale_marketplace_retail_intent"
                },
                {
                  "label": "Salon / spa / clinic-adjacent use",
                  "value": "salon_spa_clinic_adjacent_use"
                },
                {
                  "label": "Wholesale / distributor / repeat procurement",
                  "value": "wholesale_distributor_repeat_procurement"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_budget_scope",
          "title": "Timing, budget, and desired output",
          "tone": "Timing, budget, destination, quantity, and intended use decide whether the file remains a review or escalates to procurement, logistics, or specialist routing.",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "textarea",
              "required": true,
              "helper": "Include purchase deadline, shipment goal, launch date, travel date, sampling window, or decision deadline."
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "One month or more",
                  "value": "one_month_plus"
                },
                {
                  "label": "One to three weeks",
                  "value": "one_to_three_weeks"
                },
                {
                  "label": "About one week",
                  "value": "one_week"
                },
                {
                  "label": "Within 72 hours",
                  "value": "within_72_hours"
                },
                {
                  "label": "Already close to purchase, shipment, launch, or customs issue",
                  "value": "already_close_to_purchase_shipment_launch_customs_issue"
                }
              ]
            },
            {
              "id": "budget_range",
              "label": "Budget range or spending ceiling",
              "type": "text",
              "required": true,
              "helper": "Use currency and clarify whether this includes product price, service fees, shipping, testing, legal/compliance input, taxes, or handling."
            },
            {
              "id": "desired_deliverable",
              "label": "Desired first deliverable",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Baseline product sourcing compliance review",
                  "value": "baseline_product_sourcing_compliance_review"
                },
                {
                  "label": "Procurement quote / purchase coordination path",
                  "value": "procurement_quote_purchase_coordination_path"
                },
                {
                  "label": "Supplier / brand / repeat procurement route review",
                  "value": "supplier_brand_repeat_procurement_route_review"
                },
                {
                  "label": "Logistics / carrier / packing route caution",
                  "value": "logistics_carrier_packing_route_caution"
                },
                {
                  "label": "Specialist legal, customs, regulatory, or importer review routing",
                  "value": "specialist_legal_customs_regulatory_importer_review_routing"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff, shipment, storage, or receiving location",
              "type": "textarea"
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, business restrictions, platform requirements, or people involved",
              "type": "textarea"
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "tone": "Screenshots, product pages, seller notes, label photos, warnings, invoices, and prior messages can prevent costly wrong turns.",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, image references, shop pages, seller messages, labels, warnings, or product pages",
              "type": "textarea",
              "helper": "Paste links or describe what you will send after intake."
            },
            {
              "id": "prior_attempts",
              "label": "Have you already contacted a seller, brand, supplier, shop, marketplace, carrier, customs broker, or logistics party?",
              "type": "textarea"
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "helper": "Examples: privacy, commercial launch, high-value order, medical/compliance boundary, urgent shipment, destination restriction, or unusual risk."
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final confirmation",
          "tone": "Confirm the file is accurate, authorized, and tied to the correct paid or approved route before submission.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "I understand this intake is tied to the appropriate paid product review, case deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_route",
              "label": "I understand unpaid users must use the correct payment route before full intake review, sourcing work, procurement, supplier contact, or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, sourcing, purchase, supplier cooperation, product safety, claim validation, medical suitability, legal/compliance approval, customs clearance, carrier acceptance, import/export clearance, shipment timing, or outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate, authorized, and that personal, commercial, resale, clinic-adjacent, or regulated-use intent has been disclosed truthfully.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ does not provide medical advice, diagnosis, treatment guarantees, regulatory guarantees, provider acceptance, availability, pricing, or suitability guarantees, and that additional clarification, documents, authorization, payment, or quote may be required before this file can proceed."
            }
          ]
        }
      ],
      "page_sequence": "020",
      "record_id": "JSII_BANK_JAPAN_BEAUTY_LONGEVITY_PRODUCT_SOURCING_COMPLIANCE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Beauty & Longevity Product Sourcing Compliance Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "JapanSolved™ Sourcing, Procurement & Export Hub™",
      "page_handle": "japansolved-sourcing-procurement-export-hub",
      "page_url": "https://japansolved.com/pages/japansolved-sourcing-procurement-export-hub",
      "intake_title": "JapanSolved™ Sourcing, Procurement & Export Intake",
      "service_label": "Japan-side sourcing, procurement, category routing, acquisition/export pathway, seller status, compliance, cargo risk, and multi-desk route review",
      "subject_label": "Sourcing, Procurement & Export",
      "descriptor_line1": "A guided, paginated case-file intake for JapanSolved™ Sourcing, Procurement & Export Hub™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, privacy, compliance, custody, and private-payment boundaries protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Sourcing & Export Pathway Review™",
          "value": "/products/japan-sourcing-export-pathway-review",
          "render_as_link": true
        },
        {
          "label": "Secure the Japan Sourcing & Procurement Case Deposit™",
          "value": "/products/japan-sourcing-procurement-case-deposit",
          "render_as_link": true
        },
        {
          "label": "Request the Japan Acquisition & Export Desk Retainer™",
          "value": "/products/japan-acquisition-export-desk-retainer",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Sourcing & Export Pathway Review™ — /products/japan-sourcing-export-pathway-review",
                  "value": "/products/japan-sourcing-export-pathway-review"
                },
                {
                  "label": "Japan Sourcing & Procurement Case Deposit™ — /products/japan-sourcing-procurement-case-deposit",
                  "value": "/products/japan-sourcing-procurement-case-deposit"
                },
                {
                  "label": "Japan Acquisition & Export Desk Retainer™ — /products/japan-acquisition-export-desk-retainer",
                  "value": "/products/japan-acquisition-export-desk-retainer"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client, company, item, vendor, property, or support need currently located?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Sourcing, procurement, and export pathway request profile",
          "fields": [
            {
              "id": "request_objective",
              "label": "What do you want sourced, procured, routed, reviewed, exported, purchased, or coordinated from Japan?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "item_category_details",
              "label": "Item/category details, examples, links, photos, quantity, condition, brands/makers, seller status, purchase status, and budget context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "route_risk",
              "label": "Which risks may apply: sourcing, seller communication, authenticity/proof, compliance, regulated category, cargo, local pickup, destination-country rules, or import limits?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "desired_next_step",
              "label": "What should happen next: pathway review, sourcing, proxy QA, private buyer execution, compliance review, cargo planning, local representation, deposit, or retainer?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing, deadline, appointment window, seller deadline, pickup window, export timing, or urgency level",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, spending ceiling, deposit context, retainer context, vendor-cost limit, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff route, delivery address, property/site, vendor location, appointment place, cargo route, or country of import",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, safety concerns, custody concerns, language issues, compliance concerns, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, image references, messages, product pages, vendor pages, listings, documents, maps, schedules, or prior correspondence",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, booked, checked, paid, purchased, sourced, reported, shipped, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, sourcing success, purchase, vendor cooperation, local attendance, item availability, pickup, custody, export/import clearance, delivery, appointment outcome, or any specific result.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "HUB-SOURCE",
      "record_id": "JSII_BANK_JAPANSOLVED_SOURCING_PROCUREMENT_EXPORT_HUB",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "JapanSolved Sourcing, Procurement & Export Hub.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "JapanSolved™ Logistics & Local Representation Hub™",
      "page_handle": "japansolved-logistics-local-representation-hub",
      "page_url": "https://japansolved.com/pages/japansolved-logistics-local-representation-hub",
      "intake_title": "JapanSolved™ Logistics & Local Representation Intake",
      "service_label": "Japan-side local representation, pickup, custody, vendor coordination, appointment attendance, handoff, storage, cargo routing, and local action review",
      "subject_label": "Logistics & Local Representation",
      "descriptor_line1": "A guided, paginated case-file intake for JapanSolved™ Logistics & Local Representation Hub™.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, privacy, compliance, custody, and private-payment boundaries protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Local Representation & Logistics Review™",
          "value": "/products/japan-local-representation-logistics-review",
          "render_as_link": true
        },
        {
          "label": "Secure the Japan Local Representation Case Deposit™",
          "value": "/products/japan-local-representation-case-deposit",
          "render_as_link": true
        },
        {
          "label": "Request the Japan Local Representation Retainer™",
          "value": "/products/japan-local-representation-retainer",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Local Representation & Logistics Review™ — /products/japan-local-representation-logistics-review",
                  "value": "/products/japan-local-representation-logistics-review"
                },
                {
                  "label": "Japan Local Representation Case Deposit™ — /products/japan-local-representation-case-deposit",
                  "value": "/products/japan-local-representation-case-deposit"
                },
                {
                  "label": "Japan Local Representation Retainer™ — /products/japan-local-representation-retainer",
                  "value": "/products/japan-local-representation-retainer"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client, company, item, vendor, property, or support need currently located?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Local representation, logistics, and handoff request profile",
          "fields": [
            {
              "id": "local_action_need",
              "label": "What Japan-side action needs review: pickup, attendance, custody, handoff, vendor coordination, storage, transport, cargo, property setup, or local support?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "people_places_vendors",
              "label": "People, vendors, sellers, clinics, service centers, warehouses, properties, boutiques, offices, appointment locations, or third parties involved",
              "type": "textarea",
              "required": false
            },
            {
              "id": "item_or_support_details",
              "label": "Item, document, client-support, appointment, property, cargo, privacy, access, authorization, or custody details",
              "type": "textarea",
              "required": false
            },
            {
              "id": "risk_disclosure",
              "label": "Disclose any high-value item, regulated category, medical-adjacent appointment, property access, private transport, live plant, vehicle, cultural property, family support, or third-party authorization issue",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing, deadline, appointment window, seller deadline, pickup window, export timing, or urgency level",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, spending ceiling, deposit context, retainer context, vendor-cost limit, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, handoff route, delivery address, property/site, vendor location, appointment place, cargo route, or country of import",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, safety concerns, custody concerns, language issues, compliance concerns, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, image references, messages, product pages, vendor pages, listings, documents, maps, schedules, or prior correspondence",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, booked, checked, paid, purchased, sourced, reported, shipped, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, sourcing success, purchase, vendor cooperation, local attendance, item availability, pickup, custody, export/import clearance, delivery, appointment outcome, or any specific result.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling rules, export/import rules, customs review, carrier acceptance, inspection results, seller cooperation, documentation requirements, timing windows, and the need for additional authorization, payment, route correction, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "HUB-LOGISTICS",
      "record_id": "JSII_BANK_JAPANSOLVED_LOGISTICS_LOCAL_REPRESENTATION_HUB",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "JapanSolved Logistics & Local Representation Hub.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "record_id": "JSII_24",
      "page_sequence": "24",
      "page_title": "Japan Ticket, Event & Entertainment Access Desk™",
      "page_handle": "japan-ticket-event-entertainment-access",
      "page_url": "https://www.japansolved.com/pages/japan-ticket-event-entertainment-access",
      "page_type": "specialist",
      "service_family": "tickets events entertainment access",
      "archetype": "travel_access",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Ticket, Event & Entertainment Access Intake",
      "intake_title": "Ticket, Event & Entertainment Access Case File Intake",
      "intake_version": "original-nif-backend-reconciliation-v1-4-theme-stable-five-confirmation-followup-link",
      "service_label": "Japan ticket, event, entertainment, attraction, concert, festival, timed-entry, official-route, and event-day access review",
      "descriptor_line1": "Payment first. Case file second. Event target, dates, official links, timing windows, ticket-system constraints, identity or pickup rules, group needs, privacy boundaries, and event-day support needs stay attached to the paid access review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private ticket or event access payment path.",
      "payment_block_title": "Complete the ticket and event access payment first",
      "payment_block_copy": "Choose the paid ticket and event access review, approved case deposit, event-day support path, retainer, or approved private payment route that matches this attraction, concert, festival, exhibition, live show, timed-entry, or entertainment-access request.",
      "payment_block_fineprint": "Use the same payment email at intake so the ticket and event access file can be matched to the paid path.",
      "not_paid_error": "This ticket, event, and entertainment access intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        "/products/japan-ticket-event-access-review",
        "/products/japan-ticket-event-access-review",
        "/products/japan-ticket-event-access-review"
      ],
      "product_route_objects": [
        {
          "label": "Japan Ticket & Event Access Review™ — $295",
          "value": "/products/japan-ticket-event-access-review",
          "route": "/products/japan-ticket-event-access-review",
          "render_as_link": true,
          "status": "ready_path"
        },
        {
          "label": "Japan Ticket Access Case Deposit™ — from $750 / approved after review",
          "value": "/products/japan-ticket-event-access-review",
          "route": "/products/japan-ticket-event-access-review",
          "render_as_link": true,
          "status": "ready_path"
        },
        {
          "label": "Japan Event Access Concierge Retainer™ — from $1,950 per active event day / quoted",
          "value": "/products/japan-ticket-event-access-review",
          "route": "/products/japan-ticket-event-access-review",
          "render_as_link": true,
          "status": "ready_path"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "route": "",
          "render_as_link": false,
          "status": "approved_private_path"
        }
      ],
      "unpaid_behavior": "show_product_routes_and_allow_routing_note_only",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and access-route match",
          "tone": "Payment-first, case-file-second. Match the ticket or event request to the correct paid path before sensitive dates, links, identities, and access constraints are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this ticket or event request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public Japan Ticket & Event Access Review™",
                  "value": "yes_public_review_paid"
                },
                {
                  "label": "Yes, I am on an approved case deposit, invoice, retainer, quote, or private payment path",
                  "value": "yes_private_approved_path_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Ticket & Event Access Review™ — $295",
                  "value": "/products/japan-ticket-event-access-review"
                },
                {
                  "label": "Japan Ticket Access Case Deposit™ — from $750 / approved after review",
                  "value": "/products/japan-ticket-event-access-review"
                },
                {
                  "label": "Japan Event Access Concierge Retainer™ — from $1,950 per active event day / quoted",
                  "value": "/products/japan-ticket-event-access-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "placeholder": "Use the same email used at checkout or invoice payment."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: JS-1001, Shopify order number, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_trip_identity",
          "title": "Client, party, and Japan schedule",
          "tone": "Give the access file enough context to understand who is traveling, who the ticket must serve, and how fixed the Japan schedule already is.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead traveler name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "traveler_profile",
              "label": "Client or party profile",
              "type": "select",
              "required": true,
              "options": [
                "Solo traveler or fan traveling for one event",
                "Couple or small private party",
                "Family with children",
                "Collector / culture traveler / exhibition-focused guest",
                "Executive, VIP, celebrity, family office, or privacy-sensitive client",
                "Travel advisor, assistant, or concierge submitting for the client"
              ]
            },
            {
              "id": "group_size",
              "label": "Group size and ages where relevant",
              "type": "text",
              "required": true,
              "placeholder": "Example: 2 adults; family of 4 with children ages 8 and 11; VIP + assistant"
            },
            {
              "id": "travel_dates",
              "label": "Japan travel dates and city base",
              "type": "text",
              "required": true,
              "placeholder": "Example: Tokyo base June 10–16, Kyoto June 17–19"
            },
            {
              "id": "japan_city_region",
              "label": "Event city, venue area, or desired region",
              "type": "text",
              "required": true,
              "placeholder": "Example: Tokyo, Osaka, Nagoya, Yokohama, Saitama, Fuji area"
            }
          ]
        },
        {
          "id": "event_target",
          "title": "Event, attraction, or access target",
          "tone": "Describe the exact access wish and any official route already known. The cleaner the target, the faster the route can be read.",
          "fields": [
            {
              "id": "event_name",
              "label": "Event, attraction, venue, exhibition, performance, or target experience",
              "type": "text",
              "required": true,
              "placeholder": "Example: Ghibli Museum, Ghibli Park, concert name, theme park date, exhibition title, festival"
            },
            {
              "id": "event_category",
              "label": "Access category",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Theme park / amusement park / character attraction",
                "Ghibli-style museum or animation route",
                "Concert / live house / stage event / artist appearance",
                "Music festival / seasonal festival / multi-day event",
                "Museum / exhibition / pop-up / timed-entry cultural route",
                "Sports event / entertainment event / special venue access",
                "Private, VIP, or high-discretion access request",
                "Already purchased ticket needs risk review"
              ]
            },
            {
              "id": "desired_date_time",
              "label": "Desired date, time window, and flexibility",
              "type": "textarea",
              "required": true,
              "placeholder": "List first-choice date/time, backup dates, fixed travel constraints, and whether timed entry matters."
            },
            {
              "id": "official_link",
              "label": "Official website, ticket page, or reference link",
              "type": "url",
              "required": false,
              "placeholder": "Paste the official event page if available."
            },
            {
              "id": "priority_goal",
              "label": "What outcome matters most?",
              "type": "textarea",
              "required": true,
              "placeholder": "Example: any valid entry, specific date/time, best seat category, family-safe day plan, avoid invalid resale, event-day support."
            }
          ]
        },
        {
          "id": "access_rules_risk",
          "title": "Access rules, risks, and timing pressure",
          "tone": "Ticket work fails when the rule system is ignored. Share the constraints early so the route can be judged before money or expectation moves too far.",
          "fields": [
            {
              "id": "urgency",
              "label": "Timing pressure",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Planning ahead — more than one month before the target date",
                  "value": "planning_ahead_more_than_one_month"
                },
                {
                  "label": "Soon — within one month",
                  "value": "within_one_month"
                },
                {
                  "label": "Urgent — within 7 days",
                  "value": "urgent_within_7_days"
                },
                {
                  "label": "Rush / same-day / next-day / release window already active",
                  "value": "rush_same_day_or_release_window"
                },
                {
                  "label": "Past purchase needs risk review",
                  "value": "past_purchase_risk_review"
                }
              ]
            },
            {
              "id": "ticket_status",
              "label": "Current ticket or reservation status",
              "type": "select",
              "required": true,
              "options": [
                "No ticket yet — route needs review",
                "Ticket window is upcoming and needs monitoring",
                "Ticket window is currently open",
                "Lottery, fan-club, membership, or staged-release route may apply",
                "Tickets already purchased and I need usability/risk review",
                "Only resale or third-party options appear visible",
                "Unsure"
              ]
            },
            {
              "id": "access_constraints",
              "label": "Known constraints or warning signs",
              "type": "checkbox_group",
              "required": false,
              "options": [
                "Japanese-only ticketing site or app",
                "Japanese phone number or local account may be required",
                "Name match, ID check, or non-transferable ticket concern",
                "Lottery / fan-club / membership / app-only ticketing",
                "Pickup, wristband, QR, convenience-store, or venue handoff issue",
                "Overseas card or payment pathway issue",
                "Group seats / family timing / accessibility concern",
                "Suspicious resale, inflated pricing, or unclear seller source"
              ]
            },
            {
              "id": "identity_pickup_notes",
              "label": "Identity, pickup, app, account, or delivery notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Mention name requirements, phone/app/account concerns, QR delivery, convenience-store pickup, ID checks, or transferability issues."
            },
            {
              "id": "budget_range",
              "label": "Budget range for ticket cost and support work",
              "type": "text",
              "required": false,
              "placeholder": "Example: ticket budget up to $500/person; support budget separate; flexible if route is legitimate."
            }
          ]
        },
        {
          "id": "support_layer",
          "title": "Support layer and related desk routing",
          "tone": "Clarify whether you need only route intelligence or a Japan-side support layer around the access path and event day.",
          "fields": [
            {
              "id": "support_layers",
              "label": "What support might be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Access-route review only",
                "Official window monitoring or timing guidance after review",
                "Japanese-language inquiry or local communication if viable",
                "Japan-side purchase or reservation coordination if legitimate and accepted",
                "Event-day navigation, station route, queue, or entry support",
                "Restaurant, activity, timed-entry, or travel-day coordination around the event",
                "VIP / celebrity / privacy-sensitive movement support",
                "Lost item, logistics, or post-event handoff routing"
              ]
            },
            {
              "id": "event_day_support",
              "label": "Do you need event-day support in Japan?",
              "type": "select",
              "required": true,
              "options": [
                "No, only access review is needed right now",
                "Maybe — depends on route, venue, timing, language, or group needs",
                "Yes, we want event-day navigation or companion support reviewed",
                "Yes, VIP/private/low-noise movement support may be needed",
                "Unsure"
              ]
            },
            {
              "id": "privacy_boundary",
              "label": "Privacy or discretion level",
              "type": "select",
              "required": true,
              "options": [
                "Standard traveler request",
                "Family or child-centered trip with normal privacy needs",
                "Private client / executive / assistant-managed request",
                "High discretion / public figure / team coordination",
                "Do not know yet"
              ]
            },
            {
              "id": "related_routes",
              "label": "Related routes that may matter",
              "type": "checkbox_group",
              "required": false,
              "options": [
                "Restaurant, activity, or timed-entry reservation support",
                "VIP travel navigation / cultural support",
                "Nightlife companion and safety support",
                "Celebrity concierge and private access",
                "Private travel companion / sabbatical reset",
                "Lost item recovery after event or venue visit",
                "Bespoke itinerary or full Japan program design"
              ]
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, backup options, and final context",
          "tone": "Add anything that helps JapanSolved™ read the access route cleanly and avoid wrong assumptions.",
          "fields": [
            {
              "id": "reference_links",
              "label": "Links, screenshots, seller/source details, or references",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste official links, ticket page links, screenshots summarized in text, seller pages, venue notes, or previous messages."
            },
            {
              "id": "backup_options",
              "label": "Backup dates, alternate events, or acceptable substitutes",
              "type": "textarea",
              "required": false,
              "placeholder": "List fallback dates, other cities, alternate seat categories, other exhibitions, or whether the trip can shift."
            },
            {
              "id": "special_context",
              "label": "Special context, accessibility needs, family needs, or must-avoid outcomes",
              "type": "textarea",
              "required": false,
              "placeholder": "Example: child’s birthday, wheelchair/stroller needs, client cannot stand long, no questionable resale, avoid public exposure."
            },
            {
              "id": "desired_deliverable",
              "label": "What do you want JapanSolved™ to return first?",
              "type": "select",
              "required": true,
              "options": [
                "Access route read and next-step recommendation",
                "Risk review of an already-found ticket or source",
                "Payment/deposit path for active coordination if viable",
                "Event-day support quote if viable",
                "Route to a related JapanSolved™ desk if this is not primarily ticket access"
              ]
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid intake boundary",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, event-day support path, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users may be routed to the correct product, payment path, or review before the case file is processed."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of tickets or entry",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee ticket availability, lottery success, venue approval, official outlet behavior, seller cooperation, transferability, event-day entry, timing, access, or outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate, authorized, and safe for JapanSolved™ to review for this paid ticket or event access request."
            },
            {
              "id": "confirm_access_boundaries",
              "label": "Ticket and event access boundaries",
              "type": "checkbox",
              "required": true,
              "text": "I understand ticket and event access may be limited by official-route rules, availability, timing windows, identity checks, pickup or transferability conditions, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, event-day support path, or JapanSolved™-approved payment path.",
        "I understand unpaid users may be routed to the correct product, payment path, or review before the case file is processed.",
        "I understand submission does not guarantee ticket availability, lottery success, venue approval, official outlet behavior, seller cooperation, transferability, event-day entry, timing, access, or outcome.",
        "I confirm the information is accurate, authorized, and safe for JapanSolved™ to review for this paid ticket or event access request.",
        "I understand ticket and event access may be limited by official-route rules, availability, timing windows, identity checks, pickup or transferability conditions, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
      ],
      "conditional_rules": [
        "RULE_UNPAID_GATE",
        "RULE_REQUIRED_IF_PAID_ORDER_REFERENCE",
        "RULE_RUSH_DEPOSIT_WARNING",
        "RULE_FINAL_GATE_REQUIRE_ALL",
        "RULE_AUTOSAVE_LOCAL_DRAFT"
      ],
      "email_subject": "[JS Native Intake] 24 - Japan Ticket, Event & Entertainment Access Desk™ - {client_name} - {payment_status}",
      "hidden_fields": [
        "submission_id",
        "intake_version",
        "page_sequence",
        "page_title",
        "page_handle",
        "page_url",
        "service_family",
        "selected_product_path",
        "payment_status",
        "checkout_email",
        "order_reference",
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "referrer",
        "submitted_at_jst",
        "routing_tags"
      ],
      "admin_tags": [
        "JS_NATIVE_INTAKE",
        "JAPAN_TICKET_EVENT_ENTERTAINMENT_ACCESS_DESK",
        "PAYMENT_FIRST",
        "LEGACY_LP_VISUAL_RESTORED"
      ],
      "qa_notes": "Ticket-first, no access guarantees, no policy bypass. v1.4 preserves the successful Shopify-native submission pipeline, stabilizes theme locking to stop scroll flicker, restores the page-specific five-confirmation final gate, and corrects the success follow-up route copy.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "private_order_verification_file_uploads_database_case_ids",
      "intake_bank_extraction": {
        "source_file": "Japan Ticket, Event & Entertainment Access Desk.txt",
        "source_mode": "v1_4_working_ticket_record_supersedes_uploaded_embedded_record",
        "scraped_from_page_body_embedded_nif": false,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 5,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Restaurant, Activity & Reservation Concierge Desk™",
      "page_handle": "japan-restaurant-activity-reservation-concierge",
      "page_url": "https://japansolved.com/pages/japan-restaurant-activity-reservation-concierge",
      "intake_title": "Japan Restaurant, Activity & Reservation Concierge™ Intake",
      "service_label": "Japan restaurant, activity, and reservation concierge support",
      "subject_label": "Reservation Concierge",
      "descriptor_line1": "A guided, paginated reservation-path intake for Japan Restaurant, Activity & Reservation Concierge Desk™.",
      "descriptor_line2": "Payment first. Case file second. Booking routes, provider rules, timing, and private-payment boundaries protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the review path that matches this reservation or activity request. If JapanSolved™ gave you a private invoice, access deposit, concierge case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same email at checkout and intake so the reservation file can be matched.",
      "not_paid_error": "This reservation concierge path requires a matched paid or JapanSolved™-approved payment path before the full reservation file opens. Use the payment route above, then return with your checkout email and order reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Reservation Route Review",
          "value": "/products/japan-reservation-route-review",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the reservation support file for a paid review, approved invoice, access deposit, custom quote, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this reservation request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed checkout for the reservation route review",
                  "value": "reservation_review_paid"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "approved_private_payment"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "Not yet, I need the correct payment route first",
                  "value": "not_paid_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "helper": "Choose the closest path. If you have not paid yet, use the review checkout first unless JapanSolved™ gave you a private path.",
              "options": [
                {
                  "label": "Japan Reservation Route Review™ — /products/japan-reservation-route-review",
                  "value": "/products/japan-reservation-route-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment checkout email address",
              "type": "email",
              "required": true,
              "helper": "Use the same email used at checkout whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the Shopify order number, invoice number, or private payment reference if available.",
              "placeholder": "Example: #1234, invoice number, or pending"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "tone": "Reservations often depend on exact names, party roles, contact timing, and who has authority to approve provider terms.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_partner"
                },
                {
                  "label": "Family member / travel companion",
                  "value": "family_or_companion"
                },
                {
                  "label": "Company representative",
                  "value": "company_representative"
                },
                {
                  "label": "Other authorized requester",
                  "value": "authorized_other"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving in Japan soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Outside Japan, planning ahead",
                  "value": "outside_japan_planning"
                },
                {
                  "label": "Submitting on behalf of someone else",
                  "value": "on_behalf"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "reservation_target",
          "title": "Reservation target",
          "tone": "Name the door clearly before asking anyone to knock. A restaurant, exhibition, spa, shoot, workshop, sports day, or seasonal event may each require a different route.",
          "fields": [
            {
              "id": "request_categories",
              "label": "What kind of reservation or activity is this?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Restaurant / omakase / sushi / teppanyaki / dining",
                  "value": "dining"
                },
                {
                  "label": "TeamLab / museum / gallery / private exhibition",
                  "value": "timed_art_entry"
                },
                {
                  "label": "Kimono rental / wedding photo / pre-nuptial shoot",
                  "value": "kimono_photo"
                },
                {
                  "label": "Street-fashion / editorial / creative shoot",
                  "value": "editorial_shoot"
                },
                {
                  "label": "Private show / fashion show / pop-up / limited event",
                  "value": "private_event"
                },
                {
                  "label": "Private onsen / spa / massage / wellness booking",
                  "value": "wellness"
                },
                {
                  "label": "Tattoo artist / artisan / craftsman / workshop",
                  "value": "artisan_workshop"
                },
                {
                  "label": "Sports / nature / seasonal activity / festival",
                  "value": "sports_nature_festival"
                },
                {
                  "label": "Queue, release-day, pickup, or local representation review",
                  "value": "queue_representation"
                },
                {
                  "label": "Not sure / needs triage",
                  "value": "needs_triage"
                }
              ]
            },
            {
              "id": "target_name",
              "label": "Name of place, provider, event, artist, venue, restaurant, or activity",
              "type": "textarea",
              "required": true,
              "placeholder": "Include names, URLs, social accounts, screenshots summarized in text, or any provider details you already have."
            },
            {
              "id": "desired_result",
              "label": "Preferred result",
              "type": "textarea",
              "required": true,
              "placeholder": "Example: secure a table, review booking route, confirm deposit rules, arrange a shoot, coordinate timed entry, ask provider questions, or build backup options."
            },
            {
              "id": "backup_acceptance",
              "label": "Backup option tolerance",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Exact target only",
                  "value": "exact_only"
                },
                {
                  "label": "Same category alternatives are acceptable",
                  "value": "same_category_alternatives"
                },
                {
                  "label": "JapanSolved™ may suggest better-fit alternatives",
                  "value": "suggest_alternatives"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "dates_party",
          "title": "Dates, party, and timing pressure",
          "tone": "The reservation route depends on date windows, party size, release timing, provider rules, and whether the request is already urgent.",
          "fields": [
            {
              "id": "preferred_dates",
              "label": "Preferred date(s) and time window(s)",
              "type": "textarea",
              "required": true,
              "placeholder": "Include first choice, second choice, third choice, arrival/departure dates, and any fixed schedule constraints."
            },
            {
              "id": "party_size",
              "label": "Party size and participant details",
              "type": "textarea",
              "required": true,
              "placeholder": "Number of adults/children, ages if relevant, solo/client/VIP/family/group, mobility or privacy notes."
            },
            {
              "id": "urgency",
              "label": "How time-sensitive is this?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "No fixed deadline",
                  "value": "no_fixed_deadline"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 week",
                  "value": "within_1_week"
                },
                {
                  "label": "Within 72 hours",
                  "value": "within_72_hours"
                },
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Same day / already urgent",
                  "value": "same_day_urgent"
                },
                {
                  "label": "Release window / lottery / ticket drop is already near",
                  "value": "release_window_near"
                }
              ]
            },
            {
              "id": "rush_ack",
              "label": "Rush handling acknowledgement",
              "type": "checkbox",
              "required_logic": "urgent",
              "text": "I understand urgent, same-day, within-72-hour, already-overdue, release-window, or high-pressure reservation requests may require a rush premium, deposit, retainer, or separate quote before action."
            },
            {
              "id": "hard_constraints",
              "label": "Hard constraints or no-go windows",
              "type": "textarea",
              "required": false,
              "placeholder": "Unavailable days, hotel check-in/out, meeting times, trains/flights, dietary or mobility constraints, child nap times, etc."
            }
          ]
        },
        {
          "id": "requirements",
          "title": "Requirements, rules, and provider fit",
          "tone": "Good reservation support protects both the client and provider. Hidden requirements should surface before contact begins.",
          "fields": [
            {
              "id": "requirements_notes",
              "label": "Dietary, allergy, accessibility, tattoo, gender/privacy, dress-code, age, language, or seating requirements",
              "type": "textarea",
              "required": false,
              "placeholder": "Include anything that could affect whether the provider can safely or respectfully accept the booking."
            },
            {
              "id": "provider_terms",
              "label": "Known provider terms or risks",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Deposit or prepayment may be required",
                  "value": "deposit_prepay"
                },
                {
                  "label": "Cancellation penalty may apply",
                  "value": "cancellation_penalty"
                },
                {
                  "label": "Name/identity/phone may be required",
                  "value": "identity_required"
                },
                {
                  "label": "Membership/referral/hotel concierge route may be needed",
                  "value": "membership_referral_hotel"
                },
                {
                  "label": "Release window, lottery, queue, or timed drop may be involved",
                  "value": "release_lottery_queue"
                },
                {
                  "label": "Photoshoot permit, venue rules, or public-space judgment may be involved",
                  "value": "permit_rules"
                },
                {
                  "label": "No special provider terms known yet",
                  "value": "none_known"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "privacy_level",
              "label": "Privacy / discretion level",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Standard reservation support",
                  "value": "standard"
                },
                {
                  "label": "Moderate privacy concern",
                  "value": "moderate_privacy"
                },
                {
                  "label": "High-discretion / VIP / public-facing client",
                  "value": "high_discretion"
                },
                {
                  "label": "Do not disclose client identity until instructed",
                  "value": "controlled_identity"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "disclosure_limits",
              "label": "What should not be disclosed to providers unless approved?",
              "type": "textarea",
              "required": false,
              "placeholder": "Client name, hotel, budget, public profile, family details, reason for request, company identity, etc."
            }
          ]
        },
        {
          "id": "support_scope",
          "title": "Support scope and cost control",
          "tone": "Clarify whether this is review-only, Japanese communication, active coordination, local representation, or a broader private experience bridge.",
          "fields": [
            {
              "id": "support_lane",
              "label": "Which support lane seems closest?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Review / route intelligence only for now",
                  "value": "review_only"
                },
                {
                  "label": "Japanese call / email / provider communication may be needed",
                  "value": "provider_communication"
                },
                {
                  "label": "Active reservation attempt / schedule coordination",
                  "value": "active_reservation"
                },
                {
                  "label": "Queue, release-window, pickup, or local representation review",
                  "value": "local_representation"
                },
                {
                  "label": "Dining companion / cultural presence bridge may be needed",
                  "value": "presence_bridge"
                },
                {
                  "label": "Multi-day or retainer-style reservation planning",
                  "value": "retainer_multi_day"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "language_needs",
              "label": "Language needs",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Japanese phone call likely needed",
                  "value": "japanese_call"
                },
                {
                  "label": "Japanese email/message wording likely needed",
                  "value": "japanese_message"
                },
                {
                  "label": "English summary needed",
                  "value": "english_summary"
                },
                {
                  "label": "Client may communicate directly after prep",
                  "value": "client_direct_after_prep"
                },
                {
                  "label": "Interpreter-style support may be needed",
                  "value": "interpretation_possible"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "budget_range",
              "label": "Budget range to keep in mind for coordination beyond the review",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Review only for now",
                  "value": "review_only"
                },
                {
                  "label": "Under $500 additional",
                  "value": "under_500"
                },
                {
                  "label": "$500 to $950",
                  "value": "500_950"
                },
                {
                  "label": "$950 to $1,500",
                  "value": "950_1500"
                },
                {
                  "label": "$1,500 to $3,500",
                  "value": "1500_3500"
                },
                {
                  "label": "$3,500+",
                  "value": "3500_plus"
                },
                {
                  "label": "Retainer / repeated reservation windows may be appropriate",
                  "value": "retainer_possible"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "cost_authorization",
              "label": "Cost authorization preference",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Quote everything before proceeding",
                  "value": "quote_first"
                },
                {
                  "label": "Minor costs may be approved case by case",
                  "value": "minor_costs_case_by_case"
                },
                {
                  "label": "I may approve a working budget after review",
                  "value": "working_budget_after_review"
                },
                {
                  "label": "Do not incur any cost without written approval",
                  "value": "no_cost_without_approval"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "boundaries",
          "title": "Boundaries and lawful access check",
          "tone": "Reservation concierge support must remain lawful, respectful, authorized, and aligned with provider rules.",
          "fields": [
            {
              "id": "boundary_flags",
              "label": "Do any of these boundaries apply?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Deposit, cancellation, prepayment, or vendor policy is involved",
                  "value": "payment_policy_involved"
                },
                {
                  "label": "Food allergy, dietary restriction, accessibility, child/elder, medical, tattoo, or safety consideration is involved",
                  "value": "safety_accessibility_involved"
                },
                {
                  "label": "Provider identity, client identity, or privacy details are sensitive",
                  "value": "privacy_sensitive"
                },
                {
                  "label": "Queue, release-day, lottery, resale, or ticketing rule may be involved",
                  "value": "queue_release_ticketing"
                },
                {
                  "label": "Photo/video/permit/public-space or intellectual-property rule may be involved",
                  "value": "photo_permit_ip"
                },
                {
                  "label": "No obvious boundary issue yet",
                  "value": "none_obvious"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "conduct_confirm",
              "label": "Lawful and respectful request confirmation",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this request does not ask JapanSolved™ to use fake names, misrepresent identity, bypass provider rules, pressure venues, abuse queues, scalp/resell access, arrange adult services, violate privacy, or make guarantees that providers control."
            },
            {
              "id": "authority_confirm",
              "label": "Authority to request support",
              "type": "checkbox",
              "required": true,
              "text": "I confirm I have authority to submit the relevant names, contacts, schedule details, provider details, payment references, and constraints included in this intake."
            }
          ]
        },
        {
          "id": "final_confirm",
          "title": "Final confirmation before submission",
          "tone": "The lock before the reservation file is reviewed.",
          "fields": [
            {
              "id": "final_notes",
              "label": "Anything else JapanSolved™ should know before reviewing this reservation file?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "final_confirmations",
              "label": "Required intake confirmations",
              "type": "checkbox_group",
              "required": true,
              "require_all": true,
              "options": [
                {
                  "label": "I confirm this intake is tied to the appropriate paid review, approved invoice, access deposit, custom quote, retainer, or JapanSolved™-approved payment path.",
                  "value": "paid_path_confirmed"
                },
                {
                  "label": "I understand unpaid submissions may be treated as routing reference only and may be routed to the correct payment path before review.",
                  "value": "unpaid_routing_only"
                },
                {
                  "label": "I understand submission does not guarantee acceptance, availability, reservation success, provider cooperation, table/slot access, ticket availability, queue outcome, deposit approval, cancellation flexibility, or third-party decisions.",
                  "value": "no_guarantee"
                },
                {
                  "label": "I understand urgent, release-window, provider-contact, purchase, deposit, local attendance, queue, handoff, or out-of-pocket requests may require additional pricing or written approval before action.",
                  "value": "extra_pricing_ack"
                },
                {
                  "label": "I confirm the information is accurate, authorized, and may be used to evaluate and route this reservation concierge request.",
                  "value": "accuracy_authority"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "025",
      "record_id": "JSII_BANK_JAPAN_RESTAURANT_ACTIVITY_RESERVATION_CONCIERGE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Restaurant, Activity & Reservation Concierge Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 2,
        "hardened_final_confirmation_field_count": 3
      }
    },
    {
      "page_title": "Japan Private Travel Companion & Sabbatical Reset Desk™",
      "page_handle": "japan-private-travel-companion-sabbatical-reset",
      "page_url": "https://japansolved.com/pages/japan-private-travel-companion-sabbatical-reset",
      "intake_title": "Private Travel Companion & Sabbatical Reset™ Case File Intake",
      "service_label": "Japan private travel companion compatibility, sabbatical reset rhythm, private day-presence fit, Yamato review, mood, schedule, privacy, and route suitability support",
      "subject_label": "Private Travel Companion & Sabbatical Reset Intake",
      "descriptor_line1": "Payment first. Case file second. Travel dates, privacy level, companion fit, route rhythm, Yamato interest, budget, boundaries, and reset needs stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the companion compatibility review payment first",
      "payment_block_copy": "Choose the private companion review, Yamato request review, reset design brief, bespoke private experience program, celebrity concierge review, approved invoice, access deposit, custom quote, or private service path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the companion/reset file can be matched to the paid path.",
      "not_paid_error": "This private travel companion and sabbatical reset intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Private Travel Companion Compatibility Review™ — $495",
          "value": "/products/japan-private-travel-companion-compatibility-review",
          "render_as_link": true
        },
        {
          "label": "Yamato Private Companion Request Review™",
          "value": "/products/yamato-private-companion-request-review",
          "render_as_link": true
        },
        {
          "label": "Japan Custom Itinerary & Experience Design Brief™ — from $1,250",
          "value": "/products/japan-custom-itinerary-experience-design-brief",
          "render_as_link": true
        },
        {
          "label": "Japan Bespoke Private Experience Program™ — from $2,950/day",
          "value": "/products/japan-bespoke-private-experience-program",
          "render_as_link": true
        },
        {
          "label": "Japan Celebrity Concierge Compatibility Review™ — high-discretion route",
          "value": "/products/japan-celebrity-concierge-compatibility-review",
          "render_as_link": true
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, retainer, or private companion path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Private Travel Companion Compatibility Review™ — /products/japan-private-travel-companion-compatibility-review",
                  "value": "/products/japan-private-travel-companion-compatibility-review"
                },
                {
                  "label": "Yamato Private Companion Request Review™ — /products/yamato-private-companion-request-review",
                  "value": "/products/yamato-private-companion-request-review"
                },
                {
                  "label": "Japan Custom Itinerary & Experience Design Brief™ — /products/japan-custom-itinerary-experience-design-brief",
                  "value": "/products/japan-custom-itinerary-experience-design-brief"
                },
                {
                  "label": "Japan Bespoke Private Experience Program™ — /products/japan-bespoke-private-experience-program",
                  "value": "/products/japan-bespoke-private-experience-program"
                },
                {
                  "label": "Japan Celebrity Concierge Compatibility Review™ — /products/japan-celebrity-concierge-compatibility-review",
                  "value": "/products/japan-celebrity-concierge-compatibility-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "companion_profile",
          "title": "Private companion and reset request profile",
          "fields": [
            {
              "id": "companion_goal",
              "label": "What kind of private companion, sabbatical reset, cultural ease, day presence, or support rhythm are you requesting?",
              "type": "textarea",
              "required": true,
              "helper": "Describe the feeling of the day: quiet reset, conversation, dining rhythm, route ease, social buffering, Yamato-led presence, or private program architecture."
            },
            {
              "id": "support_style",
              "label": "Which support style feels closest?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Quiet Tokyo companion day",
                  "value": "quiet_tokyo_companion_day"
                },
                {
                  "label": "Dinner and conversation companion",
                  "value": "dinner_and_conversation_companion"
                },
                {
                  "label": "Yamato-led private presence review",
                  "value": "yamato_led_private_presence_review"
                },
                {
                  "label": "Soft social recalibration / reset day",
                  "value": "soft_social_recalibration_reset_day"
                },
                {
                  "label": "Out-of-Tokyo reflective route",
                  "value": "out_of_tokyo_reflective_route"
                },
                {
                  "label": "Multi-day sabbatical/private experience program",
                  "value": "multi_day_sabbatical_private_experience_program"
                },
                {
                  "label": "High-discretion / celebrity or executive privacy layer",
                  "value": "high_discretion_celebrity_executive_privacy_layer"
                },
                {
                  "label": "Not sure yet; I need JapanSolved™ to classify the route",
                  "value": "not_sure_need_classification"
                }
              ]
            },
            {
              "id": "mood_fit",
              "label": "Desired mood, conversation level, pace, privacy, social comfort, language preference, and companion-style expectations",
              "type": "textarea",
              "required": false
            },
            {
              "id": "yamato_interest",
              "label": "Are you specifically requesting Yamato-led presence?",
              "type": "radio",
              "required": false,
              "options": [
                {
                  "label": "Yes, Yamato is the preferred review path",
                  "value": "yes_yamato_preferred"
                },
                {
                  "label": "Maybe, but I want JapanSolved™ to decide suitability",
                  "value": "maybe_japansolved_decide"
                },
                {
                  "label": "No, general private companion/support routing is fine",
                  "value": "no_general_routing_fine"
                }
              ]
            }
          ]
        },
        {
          "id": "route_and_privacy",
          "title": "Route, rhythm, privacy, and boundaries",
          "fields": [
            {
              "id": "dates_and_route",
              "label": "Target dates, city, hotel/area, route idea, daily rhythm, and how flexible the timing can be",
              "type": "textarea",
              "required": true
            },
            {
              "id": "desired_day_shape",
              "label": "What should the day include or avoid: walking, dining, cafés, bookstores, gardens, shopping, nightlife, cultural routes, quiet time, conversation, silence, or transport support?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "privacy_visibility",
              "label": "Privacy level and visibility concerns",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Low-profile ordinary traveler",
                  "value": "low_profile_ordinary_traveler"
                },
                {
                  "label": "Very private client, but not public-facing",
                  "value": "very_private_client_not_public_facing"
                },
                {
                  "label": "Founder / executive / family-office / high-discretion client",
                  "value": "founder_executive_family_office_high_discretion"
                },
                {
                  "label": "Public figure / talent / artist / reputation-sensitive route",
                  "value": "public_figure_talent_artist_reputation_sensitive_route"
                },
                {
                  "label": "I am not sure how to classify the privacy level",
                  "value": "not_sure_privacy_level"
                }
              ]
            },
            {
              "id": "boundaries_safety",
              "label": "Boundaries, sensitivities, mobility concerns, public visibility concerns, no-go settings, safety concerns, or reset needs",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, spending ceiling, retainer context, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, city, route, hotel zone, handoff point, dining area, movement support, or service context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, timing restrictions, language issues, entourage/staff needs, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, itinerary notes, hotel area, venue ideas, product pages, messages, images, or prior correspondence",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, booked, checked, contacted, ruled out, or discussed?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false,
              "helper": "Do not include unnecessary secrets. Include only what matters for privacy, safety, suitability, boundaries, timing, or correct routing."
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid review path confirmation",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid companion review, Yamato review, reset design brief, private program, retainer, invoice, or approved private payment route."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing boundary",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users must be routed to the correct product/payment path before intake submission can be reviewed or private companion/reset work can begin."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, companion assignment, Yamato availability, chemistry/fit approval, timing, booking success, provider cooperation, privacy by third parties, travel outcome, emotional result, or any specific outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate and I am authorized to submit it on behalf of the client or principal traveler."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "026",
      "record_id": "JSII_BANK_JAPAN_PRIVATE_TRAVEL_COMPANION_SABBATICAL_RESET",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Private Travel Companion & Sabbatical Reset Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan VIP Travel Navigation & Cultural Support Desk™",
      "page_handle": "japan-vip-travel-navigation-cultural-support",
      "page_url": "https://japansolved.com/pages/japan-vip-travel-navigation-cultural-support",
      "intake_title": "Japan VIP Travel Navigation & Cultural Support™ Intake",
      "product_routes": [
        {
          "label": "Purchase the VIP travel navigation review",
          "value": "/products/japan-vip-travel-navigation-review",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, deposit, invoice, or private payment path",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the travel-day support file for a paid review, approved invoice, deposit, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this VIP navigation request?",
              "type": "radio",
              "required": true,
              "options": [
                "Yes, I completed checkout for the VIP travel navigation review",
                "Yes, I am on an approved deposit, invoice, retainer, or private payment path",
                "JapanSolved™ instructed me to submit this intake",
                "Not yet, I need the correct payment route first"
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options_from": "product_routes",
              "helper": "Choose the closest path. If you have not paid yet, use the review checkout first unless JapanSolved™ gave you a private payment path."
            },
            {
              "id": "checkout_email",
              "label": "Payment checkout email address",
              "type": "email",
              "required": true,
              "helper": "Use the same email used at checkout whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required_logic": "required_if_paid",
              "placeholder": "Example: #JS1234, invoice reference, or private payment note"
            }
          ]
        },
        {
          "id": "identity",
          "title": "Client identity and authority",
          "tone": "Tell us who the travel-day file belongs to and who can authorize route changes, communication, or coordination.",
          "fields": [
            {
              "id": "client_name",
              "label": "Full name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for this case",
              "type": "email",
              "required": true
            },
            {
              "id": "country_region",
              "label": "Country / region",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_method",
              "label": "Phone / WhatsApp / LINE / preferred contact method",
              "type": "text",
              "required": false,
              "placeholder": "Optional, but useful for time-sensitive travel days"
            },
            {
              "id": "client_role",
              "label": "Your role in this request",
              "type": "select",
              "required": true,
              "options": [
                "I am the traveler / client",
                "I am submitting for my family or group",
                "I am submitting for an executive, guest, client, or family office",
                "I am a travel advisor / assistant / authorized representative",
                "Other / explain below"
              ]
            },
            {
              "id": "authority_note",
              "label": "If you are submitting for someone else, explain your authority",
              "type": "textarea",
              "required": false,
              "helper": "Include enough context for route, privacy, and communication decisions to be handled responsibly."
            }
          ]
        },
        {
          "id": "travel_profile",
          "title": "Travel day profile",
          "tone": "Give us the shape of the day before the route starts moving.",
          "fields": [
            {
              "id": "city_area",
              "label": "Cities / areas in Japan",
              "type": "text",
              "required": true,
              "placeholder": "Tokyo, Kyoto, Osaka, Hakone, Niseko, etc."
            },
            {
              "id": "hotel_or_base",
              "label": "Hotel, neighborhood, station area, or starting base",
              "type": "text",
              "required": false
            },
            {
              "id": "party_profile",
              "label": "Party size and traveler profile",
              "type": "textarea",
              "required": true,
              "placeholder": "Number of travelers, guest importance, ages if relevant, mobility limits, luggage, language comfort, privacy concerns, family/office/executive context."
            },
            {
              "id": "visit_purpose",
              "label": "What kind of day or movement is this?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Airport / hotel / station navigation",
                "Restaurant or reservation arrival",
                "Business or executive movement",
                "Family or multi-generation movement",
                "Shopping / styling day movement",
                "Cultural venue / gallery / temple / activity route",
                "Event or ticket-day route",
                "Private local experience support",
                "High-profile or privacy-sensitive movement",
                "Other / not sure"
              ]
            }
          ]
        },
        {
          "id": "route_details",
          "title": "Route, stops, and timing",
          "tone": "The hidden work is usually in the gaps between places.",
          "fields": [
            {
              "id": "itinerary_outline",
              "label": "Describe the planned route, stops, or day sequence",
              "type": "textarea",
              "required": true,
              "placeholder": "Paste the current itinerary, route idea, hotel-to-venue movement, station transfers, dinner timing, driver/taxi assumptions, or places you need connected."
            },
            {
              "id": "venue_links",
              "label": "Venue, map, reservation, ticket, hotel, or reference links",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste Google Maps links, hotel pages, restaurant pages, event pages, reservation notes, screenshots links, or itinerary documents."
            },
            {
              "id": "route_pressure_points",
              "label": "Where do you feel the route may break?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Station exits / transfers",
                "Taxi / car handoff",
                "Luggage or mobility burden",
                "Tight timing / impossible buffers",
                "Restaurant or venue arrival etiquette",
                "Language or phone-call friction",
                "Privacy / visibility risk",
                "Guest handling / who speaks first",
                "Weather / crowd / contingency risk",
                "I am not sure yet"
              ]
            },
            {
              "id": "must_not_happen",
              "label": "What should absolutely not happen during this travel day?",
              "type": "textarea",
              "required": false,
              "placeholder": "Examples: do not be late to dinner, do not expose the guest publicly, avoid stairs, avoid confusing transfers, avoid awkward Japanese communication, avoid over-scheduled pacing."
            }
          ]
        },
        {
          "id": "support_scope",
          "title": "Support requested",
          "tone": "Tell us whether you need intelligence only, coordination, or possible Japan-side presence.",
          "fields": [
            {
              "id": "support_requested",
              "label": "Which VIP navigation support may be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Pre-arrival route review",
                "Written travel-day route brief",
                "Station / transfer logic",
                "Hotel-to-venue arrival choreography",
                "Etiquette and cultural cue briefing",
                "Japanese wording / communication support",
                "Restaurant / venue arrival support",
                "Privacy-sensitive movement planning",
                "Driver / taxi / interpreter coordination review",
                "Possible in-person support or local representation",
                "Route into another JapanSolved™ desk",
                "Not sure"
              ]
            },
            {
              "id": "communication_needs",
              "label": "Communication or language concerns",
              "type": "textarea",
              "required": false,
              "placeholder": "Japanese phone calls, venue wording, staff interaction, interpreter boundary, how to introduce the guest, what not to say, special requests that need careful phrasing."
            },
            {
              "id": "in_person_interest",
              "label": "Are you asking for possible in-person attendance or day-of support?",
              "type": "select",
              "required": true,
              "options": [
                "No, review / brief only for now",
                "Maybe, please advise after review",
                "Yes, local support may be needed",
                "Yes, but only if discreet/private",
                "Not sure"
              ]
            }
          ]
        },
        {
          "id": "privacy_boundaries",
          "title": "Privacy, boundaries, and suitability",
          "tone": "The route must remain lawful, realistic, and appropriate for the client and venue.",
          "fields": [
            {
              "id": "privacy_level",
              "label": "Privacy or discretion level",
              "type": "select",
              "required": true,
              "options": [
                "Standard travel support",
                "Moderate privacy concern",
                "High discretion / public-facing client",
                "Executive / family office / assistant-led request",
                "Celebrity / public figure / high-visibility guest",
                "Not sure"
              ]
            },
            {
              "id": "access_risks",
              "label": "Which access or conduct risks apply?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Timed entry / ticket dependency",
                "Reservation dependency",
                "Private room / etiquette-sensitive arrival",
                "Public-profile / reputation-sensitive",
                "Nightlife or safety-adjacent movement",
                "Medical or vulnerable traveler adjacent",
                "Minor / elderly / mobility support involved",
                "Within 3 days",
                "No obvious risk yet",
                "Not sure"
              ]
            },
            {
              "id": "conduct_confirm",
              "label": "Lawful access and conduct confirmation",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ will not bypass venue rules, ticketing rules, age rules, security policies, identity requirements, consent boundaries, house rules, or lawful access limits."
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, urgency, and budget control",
          "tone": "Calendar pressure changes what can be promised.",
          "fields": [
            {
              "id": "urgency",
              "label": "How time-sensitive is this?",
              "type": "select",
              "required": true,
              "options": [
                "No fixed deadline",
                "Within 1 month",
                "Within 2 weeks",
                "Within 1 week",
                "Within 72 hours",
                "Within 24 hours",
                "Already overdue / already committed",
                "Travel / event / pickup / seller deadline exists"
              ]
            },
            {
              "id": "target_dates",
              "label": "Target dates, backup dates, or deadline details",
              "type": "textarea",
              "required": true,
              "placeholder": "Include primary date, backup date, third option if possible, arrival/departure windows, venue times, and whether the date is fixed or flexible."
            },
            {
              "id": "rush_ack",
              "label": "Rush handling acknowledgement",
              "type": "checkbox",
              "required_logic": "required_if_urgent",
              "text": "I understand requests within 72 hours, already-committed travel days, event deadlines, or urgent route corrections may require a rush premium, deposit, retainer, or separate quote before action."
            },
            {
              "id": "budget_range",
              "label": "Budget range to keep in mind",
              "type": "select",
              "required": true,
              "options": [
                "Review only for now",
                "Under $500 additional",
                "$500 to $1,500",
                "$1,500 to $3,500",
                "$3,500 to $7,500",
                "$7,500+",
                "Retainer-level support may be appropriate",
                "Not sure yet"
              ]
            },
            {
              "id": "cost_authorization",
              "label": "Cost authorization preference",
              "type": "select",
              "required": true,
              "options": [
                "Quote everything before proceeding",
                "Minor costs may be approved case by case",
                "I may approve a working budget after review",
                "Do not incur any cost without written approval",
                "Not sure yet"
              ]
            }
          ]
        },
        {
          "id": "final_confirm",
          "title": "Final confirmation before submission",
          "tone": "The lock before the route opens.",
          "fields": [
            {
              "id": "final_notes",
              "label": "Anything else we should know before reviewing this travel-day file?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "final_confirmations",
              "label": "Required intake confirmations",
              "type": "checkbox_group",
              "required": true,
              "require_all": true,
              "options": [
                "I confirm that this intake is connected to the appropriate paid review, deposit, retainer, invoice, or JapanSolved™-approved payment path for the service I am requesting.",
                "If I have not completed payment yet, I understand JapanSolved™ may route me to the correct product/payment path before reviewing or acting on this intake.",
                "I understand this intake does not guarantee acceptance, availability, route feasibility, timing, venue cooperation, booking success, in-person support, interpreter availability, private access, or third-party decisions.",
                "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to share it.",
                "I understand JapanSolved™ may request clarification, documents, links, payment, authorization, route correction, or a separate quote before the case can proceed."
              ]
            },
            {
              "id": "digital_signature",
              "label": "Digital signature",
              "type": "text",
              "required": true,
              "helper": "Type your full name to confirm this submission."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "027",
      "record_id": "JSII_BANK_JAPAN_VIP_TRAVEL_NAVIGATION_CULTURAL_SUPPORT",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan VIP Travel Navigation & Cultural Support Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 3,
        "hardened_final_confirmation_field_count": 4
      }
    },
    {
      "page_title": "Japan Bespoke Experience Design & Custom Itinerary Desk™",
      "page_handle": "japan-bespoke-experience-custom-itinerary",
      "page_url": "https://japansolved.com/pages/japan-bespoke-experience-custom-itinerary",
      "subject_label": "Bespoke Experience Design Intake",
      "intake_title": "Japan Bespoke Experience Design™ Case File Intake",
      "descriptor_line1": "Payment first. Case file second. Themes, dates, cities, support layers, privacy, and program scope stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the paid design, brief, private program, consulting, or approved private path that matches this custom Japan request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Bespoke Experience Design Review™ — /products/japan-bespoke-experience-design-review",
          "value": "/products/japan-bespoke-experience-design-review"
        },
        {
          "label": "Japan Custom Itinerary & Experience Design Brief™ — /products/japan-custom-itinerary-experience-design-brief",
          "value": "/products/japan-custom-itinerary-experience-design-brief"
        },
        {
          "label": "Japan Bespoke Private Experience Program™ — /products/japan-bespoke-private-experience-program",
          "value": "/products/japan-bespoke-private-experience-program"
        },
        {
          "label": "Japan Total Experience Program Consulting™ — /products/japan-total-experience-program-consulting",
          "value": "/products/japan-total-experience-program-consulting"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the case file for a paid review, approved invoice, access deposit, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_public_review_paid"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_private_approved_path_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Bespoke Experience Design Review™ — /products/japan-bespoke-experience-design-review",
                  "value": "/products/japan-bespoke-experience-design-review"
                },
                {
                  "label": "Japan Custom Itinerary & Experience Design Brief™ — /products/japan-custom-itinerary-experience-design-brief",
                  "value": "/products/japan-custom-itinerary-experience-design-brief"
                },
                {
                  "label": "Japan Bespoke Private Experience Program™ — /products/japan-bespoke-private-experience-program",
                  "value": "/products/japan-bespoke-private-experience-program"
                },
                {
                  "label": "Japan Total Experience Program Consulting™ — /products/japan-total-experience-program-consulting",
                  "value": "/products/japan-total-experience-program-consulting"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "If JapanSolved™ told you to submit before a public checkout exists, enter the approved instruction or invoice reference."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client and program identity",
          "tone": "Tell us who the custom Japan file belongs to and how the paid design review should be matched.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "country_timezone",
              "label": "Country / timezone",
              "type": "text",
              "required": true
            },
            {
              "id": "traveler_profile",
              "label": "Traveler profile",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Solo traveler",
                  "value": "solo"
                },
                {
                  "label": "Couple / pair",
                  "value": "couple_pair"
                },
                {
                  "label": "Family / multi-generation",
                  "value": "family"
                },
                {
                  "label": "Executive / founder / private team",
                  "value": "executive_team"
                },
                {
                  "label": "Public figure / high discretion",
                  "value": "public_profile"
                },
                {
                  "label": "Group / friends / mixed party",
                  "value": "group"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "program_architecture",
          "title": "Experience architecture",
          "tone": "Choose the doors that match the trip. A strong custom Japan program can mix several themes, but the sequence matters.",
          "fields": [
            {
              "id": "experience_themes",
              "label": "Which architecture doors should be considered?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Cultural, history, craft, tea, swords, gardens, artisan routes",
                  "value": "culture_history_craft"
                },
                {
                  "label": "Social, subculture, fashion districts, human-layer Tokyo",
                  "value": "social_subculture_human"
                },
                {
                  "label": "Movement, nature, activity, onsen, soft adventure",
                  "value": "movement_nature_activity"
                },
                {
                  "label": "Food and dining route",
                  "value": "food_dining"
                },
                {
                  "label": "Shopping and style route",
                  "value": "shopping_style"
                },
                {
                  "label": "Arts, museums, galleries, design, architecture",
                  "value": "arts_museums_gallery"
                },
                {
                  "label": "Technology, future culture, gadgets, trains, gaming, cameras",
                  "value": "technology_future"
                },
                {
                  "label": "Location-based route or multi-city itinerary",
                  "value": "location_based"
                },
                {
                  "label": "Wellness, beauty, longevity, soft reset",
                  "value": "wellness_beauty_reset"
                },
                {
                  "label": "Seasonal or festival window",
                  "value": "seasonal_festival"
                },
                {
                  "label": "Family or multi-generation Japan",
                  "value": "family_multigeneration"
                },
                {
                  "label": "Collector, hobbyist, rare-object, sourcing-adjacent Japan",
                  "value": "collector_hobbyist"
                }
              ]
            },
            {
              "id": "city_route_window",
              "label": "Target cities, trip length, and preferred date windows",
              "type": "textarea",
              "required": true,
              "helper": "Include priority, secondary, and tertiary dates if available."
            },
            {
              "id": "must_have_moments",
              "label": "Must-have moments, places, objects, or feelings",
              "type": "textarea",
              "required": true
            },
            {
              "id": "hard_no_list",
              "label": "Hard no list / avoid list",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "deep_japan_layer",
          "title": "Deep Japan Layer and human support",
          "tone": "A custom itinerary can stay written and logistical, or it can include human presence, scene-reading, local context, and companionable support.",
          "fields": [
            {
              "id": "deep_japan_layer_needs",
              "label": "Which human or local-context layers may be relevant?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Local context / cultural interpretation",
                  "value": "local_context"
                },
                {
                  "label": "Human warmth / companionable day",
                  "value": "human_warmth"
                },
                {
                  "label": "Scene-reading / etiquette / timing support",
                  "value": "scene_reading"
                },
                {
                  "label": "Dining presence or conversation layer",
                  "value": "dining_presence"
                },
                {
                  "label": "Shopping feedback / style route support",
                  "value": "shopping_feedback"
                },
                {
                  "label": "Nightlife or safe-return support",
                  "value": "nightlife_support"
                },
                {
                  "label": "Yamato-led presence may be requested for suitability review",
                  "value": "yamato_request"
                },
                {
                  "label": "No human layer. I only need itinerary design.",
                  "value": "no_human_layer"
                }
              ]
            },
            {
              "id": "support_tone",
              "label": "How should the support feel?",
              "type": "textarea",
              "required": false,
              "placeholder": "Discreet, elegant, playful, soft, practical, stylish, family-safe, romantic in atmosphere, low-profile, etc."
            },
            {
              "id": "privacy_boundary",
              "label": "Privacy, visibility, public-profile, or family discretion level",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Normal private client handling",
                  "value": "normal_private"
                },
                {
                  "label": "High discretion",
                  "value": "high_discretion"
                },
                {
                  "label": "Public figure / team coordination",
                  "value": "public_profile_team"
                },
                {
                  "label": "Very sensitive. Explain below.",
                  "value": "very_sensitive"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "safety_boundary_notes",
              "label": "Safety, mobility, medical-adjacent, alcohol/nightlife, or accessibility boundaries",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "budget_and_scope",
          "title": "Budget, scope, and urgency",
          "tone": "This helps decide whether the file stays a design review, becomes a written brief, opens a private program, or needs total experience consulting.",
          "fields": [
            {
              "id": "budget_range",
              "label": "Approximate budget range in USD",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "$495 design review only",
                  "value": "495_review"
                },
                {
                  "label": "$1,250–$2,950 written design brief / small program planning",
                  "value": "1250_2950"
                },
                {
                  "label": "$2,950–$7,500 private day or active coordination",
                  "value": "2950_7500"
                },
                {
                  "label": "$7,500–$20,000+ multi-day / multi-desk program",
                  "value": "7500_20000_plus"
                },
                {
                  "label": "$20,000+ VIP, celebrity, family, or extended program",
                  "value": "20000_plus"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_budget"
                }
              ]
            },
            {
              "id": "desired_deliverable",
              "label": "What do you want after this review?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Route classification and next paid step",
                  "value": "route_classification"
                },
                {
                  "label": "Written custom itinerary / experience design brief",
                  "value": "written_design_brief"
                },
                {
                  "label": "Active private day or private program coordination",
                  "value": "private_program"
                },
                {
                  "label": "Total Japan program consulting",
                  "value": "total_program"
                },
                {
                  "label": "Not sure. I need recommendation.",
                  "value": "not_sure_recommendation"
                }
              ]
            },
            {
              "id": "urgency",
              "label": "Timing urgency",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "One month or more before target date",
                  "value": "one_month_plus"
                },
                {
                  "label": "About one to three weeks before target date",
                  "value": "one_to_three_weeks"
                },
                {
                  "label": "About one week before target date",
                  "value": "one_week"
                },
                {
                  "label": "Within 72 hours / rush review may be needed",
                  "value": "within_72"
                },
                {
                  "label": "Already in Japan / same-day or next-day concern",
                  "value": "same_day_next_day"
                }
              ]
            },
            {
              "id": "additional_context",
              "label": "Additional context for the design desk",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid intake boundary",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users may be routed to the correct product, payment path, or review before the case file is processed."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, access, reservation success, provider cooperation, availability, timing, or outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate, authorized, and safe for JapanSolved™ to review for this paid request."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "028A",
      "record_id": "JSII_BANK_JAPAN_BESPOKE_EXPERIENCE_CUSTOM_ITINERARY",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Bespoke Experience Design & Custom Itinerary Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Private Local Experiences & Cultural Access Desk™",
      "page_handle": "private-cultural-experiences-japan-local-access",
      "page_url": "https://japansolved.com/pages/private-cultural-experiences-japan-local-access",
      "intake_title": "Japan Private Local Experiences & Cultural Access Intake™",
      "product_routes": [
        {
          "label": "Purchase the Japan Private Local Experience Review",
          "value": "/products/japan-private-local-experience-review",
          "render_as_link": true
        },
        {
          "label": "Approved private payment path (invoice, access deposit, retainer, or custom quote)",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the cultural-access support file for a paid review, approved invoice, access deposit, custom quote, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this cultural access request?",
              "type": "radio",
              "required": true,
              "options": [
                "Yes, I completed payment for the local experience review",
                "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                "Yes, JapanSolved™ instructed me to submit through an approved private route",
                "Not yet, I need the correct payment route first"
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options_from": "product_routes",
              "helper": "Choose the review payment path unless JapanSolved™ has already given you an invoice, deposit, retainer, custom quote, or other approved private route."
            },
            {
              "id": "payment_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the same email used for payment whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available.",
              "placeholder": "Example: order number, invoice ID, receipt ID, or private reference"
            }
          ]
        },
        {
          "id": "identity",
          "title": "Client identity and authority",
          "tone": "Cultural access may involve hosts, private spaces, artisans, local communities, or paid third parties. We need to know who is asking and who the experience is for.",
          "fields": [
            {
              "id": "client_name",
              "label": "Full name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for this case",
              "type": "email",
              "required": true
            },
            {
              "id": "country_region",
              "label": "Country / region",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_method",
              "label": "Phone / WhatsApp / LINE / preferred contact method",
              "type": "text",
              "required": false
            },
            {
              "id": "client_role",
              "label": "Your role in this request",
              "type": "select",
              "required": true,
              "options": [
                "I am the traveler / primary client",
                "I am submitting for my family or travel group",
                "I am an assistant, family office, advisor, or concierge submitting for someone else",
                "I am submitting for a company, brand, media, or creator project",
                "Other"
              ]
            },
            {
              "id": "authority_note",
              "label": "If you are submitting for someone else, explain your authority to do so",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "experience_concept",
          "title": "Experience concept",
          "tone": "Tell us the door you are trying to open: craft, neighborhood, host, private lesson, local route, gallery-adjacent day, family-friendly depth, or another cultural layer.",
          "fields": [
            {
              "id": "target_city_area",
              "label": "Target city, neighborhood, region, or starting area",
              "type": "text",
              "required": true,
              "placeholder": "Tokyo, Kyoto, Kanazawa, rural area, hotel base, etc."
            },
            {
              "id": "experience_types",
              "label": "What kind of local or cultural access are you seeking?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Artisan or craft visit",
                "Private lesson or cultural session",
                "Neighborhood immersion / ordinary-life route",
                "Gallery, museum, dealer, or collector-adjacent day",
                "Food, tea, sweets, market, or dining-linked culture",
                "Family-friendly cultural depth",
                "Soft local presence / companionable explanation layer",
                "Rural, seasonal, festival, or community-linked experience",
                "Other / unusual request"
              ]
            },
            {
              "id": "experience_description",
              "label": "Describe the experience you imagine",
              "type": "textarea",
              "required": true,
              "helper": "Include mood, examples, host type, places, links, what you want to feel or understand, and what would make the day meaningful."
            },
            {
              "id": "why_it_matters",
              "label": "Why does this experience matter to you or your group?",
              "type": "textarea",
              "required": false,
              "helper": "This helps us frame the request respectfully if host outreach is needed."
            }
          ]
        },
        {
          "id": "access_context",
          "title": "Access, host, and request context",
          "tone": "Private cultural access depends on consent, fit, privacy, timing, compensation, and whether the request should be asked directly, softened, redesigned, or routed elsewhere.",
          "fields": [
            {
              "id": "known_targets",
              "label": "Do you already have a target host, venue, studio, person, community, shop, gallery, or reference?",
              "type": "textarea",
              "required": false,
              "helper": "Paste names, links, Instagram, articles, map pins, screenshots, or prior messages if relevant."
            },
            {
              "id": "access_status",
              "label": "Current access status",
              "type": "select",
              "required": true,
              "options": [
                "I have not contacted anyone yet",
                "I contacted someone but need help wording or following up",
                "A host or venue has shown interest but details are unclear",
                "I already have a tentative appointment and need support around it",
                "I only have a broad idea and need route/design help"
              ]
            },
            {
              "id": "host_sensitivity",
              "label": "Which host or access sensitivities may apply?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Private home, studio, workshop, or small venue",
                "Limited photography or no public posting likely",
                "Language or interpretation likely needed",
                "Host compensation or honorarium may be appropriate",
                "Schedule flexibility is needed",
                "Small group or low-profile handling is important",
                "The request may be unusual, delicate, or hard to explain",
                "None known yet"
              ]
            },
            {
              "id": "content_use",
              "label": "Photography, filming, social media, commercial, or publication use",
              "type": "select",
              "required": true,
              "options": [
                "Private personal memory only",
                "I may want normal travel photos if permitted",
                "I want to post on social media if permitted",
                "This may involve brand, media, creator, commercial, interview, or publication use",
                "Not sure yet"
              ]
            }
          ]
        },
        {
          "id": "support_scope",
          "title": "Support requested",
          "tone": "Some files only need review. Others need route design, host outreach, translation, local presence, companion support, VIP navigation, or a larger bespoke itinerary layer.",
          "fields": [
            {
              "id": "support_requested",
              "label": "Which support may be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Feasibility review only",
                "Private cultural route design",
                "Host or venue outreach / request framing",
                "Translation or written Japanese wording",
                "Interpreter, guide, cultural host, or local presence",
                "Companion-style soft support or social ease layer",
                "VIP navigation, transfers, timing, or arrival choreography",
                "Restaurant, ticket, shopping, gallery, or itinerary escalation",
                "Not sure, please route the case"
              ]
            },
            {
              "id": "language_needs",
              "label": "Language, interpretation, or communication needs",
              "type": "textarea",
              "required": false,
              "helper": "Mention Japanese ability, whether a host may need English support, and whether live interpretation may be needed."
            },
            {
              "id": "party_profile",
              "label": "Party size and traveler profile",
              "type": "textarea",
              "required": true,
              "helper": "Include adults, children, elderly guests, mobility concerns, cultural familiarity, dietary issues, or any group sensitivities."
            },
            {
              "id": "fit_boundaries",
              "label": "What should this experience not become?",
              "type": "textarea",
              "required": false,
              "placeholder": "Too touristy, too performative, too rushed, too formal, too physically demanding, too public, etc."
            }
          ]
        },
        {
          "id": "privacy_boundaries",
          "title": "Privacy, ethics, and boundaries",
          "tone": "This desk protects respectful access. We do not pressure hosts, force private doors, bypass rules, or treat people and communities as tourist inventory.",
          "fields": [
            {
              "id": "privacy_level",
              "label": "Privacy or discretion level",
              "type": "select",
              "required": true,
              "options": [
                "Standard private-client handling",
                "Low-profile / no public attention preferred",
                "High-discretion client or sensitive guest",
                "Family / child-sensitive handling",
                "Media, creator, brand, or commercial context",
                "Not sure"
              ]
            },
            {
              "id": "boundary_flags",
              "label": "Which boundaries or risks apply?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Private host or non-public space may be involved",
                "Photography / filming permissions must be clarified",
                "Compensation, honorarium, or material costs may be needed",
                "Cultural, religious, community, or etiquette sensitivity may apply",
                "Children, elderly guests, mobility, dietary, or accessibility needs apply",
                "The request could be misunderstood if worded bluntly",
                "No special risks known yet"
              ]
            },
            {
              "id": "conduct_confirm",
              "label": "Lawful and respectful access confirmation",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may decline, redesign, or reroute requests that are unlawful, unsafe, disrespectful, exploitative, too intrusive, or not appropriate for the host/community."
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and cost control",
          "tone": "Cultural access is calendar-sensitive. Hosts, interpreters, local guides, materials, transportation, tickets, dining, and outreach can all affect feasibility and cost.",
          "fields": [
            {
              "id": "urgency",
              "label": "How time-sensitive is this?",
              "type": "select",
              "required": true,
              "options": [
                "Flexible / exploratory",
                "More than one month away",
                "One to four weeks away",
                "Within seven days",
                "Within three days / urgent",
                "Date already fixed"
              ]
            },
            {
              "id": "target_dates",
              "label": "Target dates, backup dates, or deadline details",
              "type": "textarea",
              "required": true,
              "helper": "Include priority, secondary, and tertiary dates when possible."
            },
            {
              "id": "rush_ack",
              "label": "Rush handling acknowledgement",
              "type": "checkbox",
              "required": false,
              "text": "I understand requests within three days may not be feasible and may require priority-handling premiums if accepted."
            },
            {
              "id": "budget_range",
              "label": "Budget range to keep in mind, excluding the paid review",
              "type": "select",
              "required": true,
              "options": [
                "Under $500 additional budget",
                "$500–$1,500",
                "$1,500–$3,000",
                "$3,000–$7,500",
                "$7,500+",
                "Please advise based on scope"
              ]
            },
            {
              "id": "cost_authorization",
              "label": "Cost authorization preference",
              "type": "select",
              "required": true,
              "options": [
                "Do not incur any third-party cost without approval",
                "Small pre-approved costs may be acceptable after review",
                "Quote all outreach, host fees, interpretation, transport, and execution separately",
                "Not sure yet"
              ]
            }
          ]
        },
        {
          "id": "final_confirm",
          "title": "Final confirmation before submission",
          "tone": "Confirm the intake is tied to the correct paid review or JapanSolved™-approved route, and that the request is accurate, authorized, and realistic.",
          "fields": [
            {
              "id": "final_notes",
              "label": "Anything else we should know before reviewing this cultural access request?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "final_confirmations",
              "label": "Required intake confirmations",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
                "I understand unpaid submissions may be routed to the correct product/payment path before review or outreach begins.",
                "I understand submission does not guarantee acceptance, host approval, access, availability, route feasibility, booking success, interpretation availability, or third-party cooperation.",
                "I confirm the information provided is accurate, authorized, and respectful of host/community boundaries.",
                "I understand JapanSolved™ may decline or reroute requests that are unlawful, unsafe, exploitative, overly intrusive, commercially unclear, or culturally inappropriate."
              ]
            },
            {
              "id": "digital_signature",
              "label": "Digital signature",
              "type": "text",
              "required": true,
              "helper": "Type your full name to confirm the intake."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "028",
      "record_id": "JSII_BANK_PRIVATE_CULTURAL_EXPERIENCES_JAPAN_LOCAL_ACCESS",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Private Local Experiences & Cultural Access Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 3,
        "hardened_final_confirmation_field_count": 4
      }
    },
    {
      "page_title": "Japan Nightlife Companion & Safety Support Desk™",
      "page_handle": "japan-nightlife-companion-safety-support",
      "page_url": "https://japansolved.com/pages/japan-nightlife-companion-safety-support",
      "intake_title": "Japan Nightlife Companion & Safety Support Intake™",
      "product_routes": [
        {
          "label": "Purchase the Japan Nightlife Safety Route Review",
          "value": "/products/japan-nightlife-safety-route-review",
          "meta": "Primary after-dark route review path",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, deposit, invoice, retainer, or private payment path",
          "value": "approved_private_payment_path",
          "meta": "",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the after-dark support file for a paid review, approved invoice, deposit, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this nightlife support request?",
              "type": "radio",
              "required": true,
              "options": [
                "Yes, I completed checkout for the nightlife safety route review",
                "Yes, I am on an approved deposit, invoice, retainer, or private payment path",
                "JapanSolved™ instructed me to submit this intake",
                "Not yet, I need the correct payment route first"
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options_from": "product_routes",
              "helper": "Choose the closest path. If you have not paid yet, use the review checkout first unless JapanSolved™ gave you a private payment path."
            },
            {
              "id": "checkout_email",
              "label": "Payment checkout email address",
              "type": "email",
              "required": true,
              "helper": "Use the same email used at checkout whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the Shopify order number, invoice number, or any private payment reference if available."
            }
          ]
        },
        {
          "id": "identity",
          "title": "Client identity and authority",
          "tone": "Tell us who the evening file belongs to and who can authorize route changes, companion requests, coordination, or escalation.",
          "fields": [
            {
              "id": "client_name",
              "label": "Full name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for this case",
              "type": "email",
              "required": true
            },
            {
              "id": "country_region",
              "label": "Country / region",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_method",
              "label": "Phone / WhatsApp / LINE / preferred contact method",
              "type": "text",
              "required": false,
              "placeholder": "Optional, but useful for date-specific nights"
            },
            {
              "id": "client_role",
              "label": "Your role in this request",
              "type": "select",
              "required": true,
              "options": [
                "I am the traveler / primary client",
                "I am submitting for my partner, friend, family, or group",
                "I am an assistant, concierge, advisor, or family office submitting for someone else",
                "I am submitting for a company, brand, media, or creator project",
                "Other / explain below"
              ]
            },
            {
              "id": "authority_note",
              "label": "If you are submitting for someone else, explain your authority",
              "type": "textarea",
              "required": false,
              "helper": "Include enough context for privacy, conduct, payment, and communication decisions to be handled responsibly."
            }
          ]
        },
        {
          "id": "evening_profile",
          "title": "Evening profile",
          "tone": "Give us the shape of the night before the neon starts negotiating.",
          "fields": [
            {
              "id": "city_area",
              "label": "City, district, neighborhood, or starting area",
              "type": "text",
              "required": true,
              "placeholder": "Tokyo, Shinjuku, Ginza, Kyoto, Osaka, hotel base, etc."
            },
            {
              "id": "hotel_or_base",
              "label": "Hotel, station, neighborhood, or return base",
              "type": "text",
              "required": false
            },
            {
              "id": "party_profile",
              "label": "Party size and traveler profile",
              "type": "textarea",
              "required": true,
              "helper": "Include number of travelers, solo/friend/group context, age range if relevant, mobility notes, language comfort, privacy sensitivity, and alcohol comfort level."
            },
            {
              "id": "night_mood",
              "label": "What kind of night are you hoping for?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Quiet stylish bar / lounge route",
                "Izakaya, food alley, late dining, or casual local night",
                "Live house, jazz room, music, karaoke, or performance-adjacent night",
                "Night views, walking route, photography, or calm after-dinner route",
                "Social ease / solo traveler support",
                "Friend group route planning",
                "Companionable presence or soft social buffering",
                "High-discretion or privacy-sensitive evening",
                "Not sure yet, please route the idea"
              ]
            },
            {
              "id": "desired_feeling",
              "label": "Describe the mood, energy, or story you want the night to have",
              "type": "textarea",
              "required": false,
              "placeholder": "Soft, stylish, local, musical, private, social, romantic but not forced, celebratory, calm, unusual, low-key, etc."
            }
          ]
        },
        {
          "id": "route_details",
          "title": "Route, venues, and pressure points",
          "tone": "The night usually breaks between places, not inside the idea.",
          "fields": [
            {
              "id": "evening_outline",
              "label": "Describe the planned evening or route idea",
              "type": "textarea",
              "required": true,
              "placeholder": "Dinner to bar, live house to taxi, solo night route, hotel to district, venue list, preferred ending time, or the current plan you want checked."
            },
            {
              "id": "venue_links",
              "label": "Venue, map, ticket, reservation, hotel, or reference links",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste Google Maps links, bar/venue pages, event pages, reservation notes, screenshots links, hotel links, or inspiration references."
            },
            {
              "id": "pressure_points",
              "label": "Where do you feel the night could go wrong?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Entering a venue alone or awkwardly",
                "Language or phone-call friction",
                "Wrong venue mood / too touristy / too intense",
                "Last train, taxi, or safe return risk",
                "Group splitting up or pacing problems",
                "Alcohol, conduct, or safety boundaries",
                "Privacy / visibility / reputation sensitivity",
                "LGBTQ+, identity-sensitive, or comfort-sensitive routing",
                "Companion fit, role, or chemistry uncertainty",
                "I am not sure yet"
              ]
            },
            {
              "id": "must_not_happen",
              "label": "What should absolutely not happen during this night?",
              "type": "textarea",
              "required": false,
              "placeholder": "Examples: do not get stranded, avoid clubs, avoid awkward social pressure, avoid public attention, avoid unsafe districts, avoid intoxication-heavy settings, avoid being alone entering venues."
            }
          ]
        },
        {
          "id": "support_scope",
          "title": "Support requested",
          "tone": "Some nights only need route intelligence. Others need reservations, translation, local presence, companion review, VIP navigation, or high-discretion escalation.",
          "fields": [
            {
              "id": "support_requested",
              "label": "Which nightlife support may be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "After-dark route review only",
                "Written night route brief",
                "Venue shortlist / district logic",
                "Japanese wording, venue inquiry, or arrival script",
                "Restaurant / reservation / ticket escalation",
                "Safe return, last train, taxi, or hotel-return planning",
                "Companionable presence or social buffering review",
                "Yamato-led quiet presence consideration",
                "VIP navigation or local representation escalation",
                "Celebrity / high-discretion private access escalation",
                "Not sure, please route the case"
              ]
            },
            {
              "id": "in_person_interest",
              "label": "Are you asking for possible in-person attendance, companion support, or day-of/night-of local presence?",
              "type": "select",
              "required": true,
              "options": [
                "No, review / route design only for now",
                "Maybe, please advise after review",
                "Yes, local support may be needed",
                "Yes, companion-style social buffering may be needed",
                "Yes, but only if discreet/private",
                "Not sure"
              ]
            },
            {
              "id": "communication_needs",
              "label": "Language, communication, or interpretation concerns",
              "type": "textarea",
              "required": false,
              "placeholder": "Japanese phone calls, venue wording, companion introduction, what not to say, arrival etiquette, or live interpretation concerns."
            },
            {
              "id": "companion_context",
              "label": "If companion-style support is requested, describe the role you imagine",
              "type": "textarea",
              "required": false,
              "helper": "Keep this lawful, respectful, non-adult, consent-based, and route/support focused. Include social ease, translation, room reading, walking, venue support, or calm presence needs."
            }
          ]
        },
        {
          "id": "privacy_boundaries",
          "title": "Privacy, safety, and boundaries",
          "tone": "The night must remain lawful, respectful, venue-safe, and reputation-safe. This desk protects the corridor, not chaos.",
          "fields": [
            {
              "id": "privacy_level",
              "label": "Privacy or discretion level",
              "type": "select",
              "required": true,
              "options": [
                "Standard private-client handling",
                "Low-profile / no public attention preferred",
                "High-discretion client or sensitive guest",
                "Executive / public-facing / reputation-sensitive guest",
                "Family, couple, or identity-sensitive comfort context",
                "Not sure"
              ]
            },
            {
              "id": "boundary_flags",
              "label": "Which safety or boundary notes apply?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Late-night return path must be protected",
                "Alcohol comfort or conduct boundaries matter",
                "Client may be solo or socially uncomfortable",
                "Language support likely needed",
                "Photography / filming / posting should be controlled",
                "Public attention or privacy sensitivity applies",
                "LGBTQ+, identity-sensitive, or comfort-sensitive routing applies",
                "Mobility, dietary, sensory, or accessibility needs apply",
                "No special risks known yet"
              ]
            },
            {
              "id": "lawful_corridor_confirm",
              "label": "Lawful corridor confirmation",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may decline, redesign, or reroute requests involving unlawful activity, venue rule-bypassing, harassment, stalking, non-consensual contact, adult/sexual arrangements, controlled substances, intoxication babysitting, bodyguard/security work, medical supervision, or unsafe conduct."
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, urgency, and budget control",
          "tone": "After-dark support is calendar-sensitive. Late requests narrow the room before anyone enters it.",
          "fields": [
            {
              "id": "urgency",
              "label": "How time-sensitive is this?",
              "type": "select",
              "required": true,
              "options": [
                "Flexible / exploratory",
                "More than one month away",
                "One to four weeks away",
                "Within seven days",
                "Within three days / urgent",
                "Date already fixed",
                "Already in Japan / immediate route correction needed"
              ]
            },
            {
              "id": "target_dates",
              "label": "Target dates, backup dates, or deadline details",
              "type": "textarea",
              "required": true,
              "helper": "Include priority, secondary, and tertiary dates when possible, plus expected start/end time."
            },
            {
              "id": "rush_ack",
              "label": "Rush handling acknowledgement",
              "type": "checkbox",
              "required_logic": "required_if_urgent",
              "text": "I understand requests within three days, fixed nightlife dates, or urgent route corrections may require priority-handling premiums, deposits, retainers, or separate quotes before action."
            },
            {
              "id": "budget_range",
              "label": "Budget range to keep in mind, excluding the paid review",
              "type": "select",
              "required": true,
              "options": [
                "Review only for now",
                "Under $500 additional budget",
                "$500–$1,500",
                "$1,500–$3,500",
                "$3,500–$7,500",
                "$7,500+",
                "Please advise based on scope"
              ]
            },
            {
              "id": "cost_authorization",
              "label": "Cost authorization preference",
              "type": "select",
              "required": true,
              "options": [
                "Do not incur any third-party cost without approval",
                "Quote all outreach, venue, support, transport, and execution separately",
                "Small pre-approved costs may be acceptable after review",
                "I may approve a working budget after review",
                "Not sure yet"
              ]
            }
          ]
        },
        {
          "id": "final_confirm",
          "title": "Final confirmation before submission",
          "tone": "Confirm the intake is tied to the correct paid review or JapanSolved™-approved route, and that the request is accurate, authorized, and safe to review.",
          "fields": [
            {
              "id": "final_notes",
              "label": "Anything else we should know before reviewing this nightlife support request?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "final_confirmations",
              "label": "Required intake confirmations",
              "type": "checkbox_group",
              "required": true,
              "require_all": true,
              "options": [
                "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
                "I understand unpaid submissions may be routed to the correct product/payment path before review or coordination begins.",
                "I understand submission does not guarantee acceptance, availability, route feasibility, venue cooperation, booking success, companion availability, in-person support, Yamato availability, private access, safety outcome, or third-party decisions.",
                "I confirm the information provided is accurate, authorized, lawful, and respectful of venue, companion, staff, community, and client boundaries.",
                "I understand JapanSolved™ may decline, redesign, or reroute requests that are unlawful, unsafe, adult/sexual, exploitative, overly intrusive, commercially unclear, or inappropriate for the after-dark corridor."
              ]
            },
            {
              "id": "digital_signature",
              "label": "Digital signature",
              "type": "text",
              "required": true,
              "helper": "Type your full name to confirm this intake."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "029",
      "record_id": "JSII_BANK_JAPAN_NIGHTLIFE_COMPANION_SAFETY_SUPPORT",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Nightlife Companion & Safety Support Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 3,
        "hardened_final_confirmation_field_count": 4
      }
    },
    {
      "page_title": "Japan Personal Shopping, Styling & Companion Support Desk™",
      "page_handle": "japan-personal-shopping-styling-companion-support",
      "page_url": "https://japansolved.com/pages/japan-personal-shopping-styling-companion-support",
      "intake_title": "Japan Personal Shopping, Styling & Companion Support Intake™",
      "service_label": "Japan personal shopping, styling route, companion support, wardrobing, boutique navigation, fit, taste, timing, and privacy review",
      "subject_label": "Personal Shopping, Styling & Companion Support",
      "descriptor_line1": "A guided, paginated case-file intake for personal shopping, styling, and companion support review.",
      "descriptor_line2": "Payment first. Case file second. Route, scope, timing, privacy, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review path that matches this request. Private invoice, deposit, quote, or retainer cases should use the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Japan Personal Styling & Shopping Route Review™",
          "value": "/products/japan-personal-styling-shopping-route-review",
          "render_as_link": true
        },
        {
          "label": "Japan Shopping & Style Experience Route Design™",
          "value": "/products/japan-shopping-style-experience-route-design",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, deposit, quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Personal Styling & Shopping Route Review™",
                  "value": "/products/japan-personal-styling-shopping-route-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Personal shopping, styling, and companion support request profile",
          "fields": [
            {
              "id": "shopping_style_goal",
              "label": "What shopping, styling, wardrobe, boutique, companion, or personal route support are you requesting?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "style_profile",
              "label": "Taste direction, sizes/measurements, favorite brands, budget, desired stores/areas, modesty/fit preferences, and what to avoid",
              "type": "textarea",
              "required": false
            },
            {
              "id": "route_shape",
              "label": "Target city, date window, solo or accompanied route, Yamato/private companion interest, mobility, language, dining/rest breaks, and pace",
              "type": "textarea",
              "required": false
            },
            {
              "id": "privacy_boundaries",
              "label": "Privacy needs, public visibility concerns, gender/presentation comfort, cultural fit, gift context, entourage needs, or safety boundaries",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, spending ceiling, retainer context, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, city, route, handoff, appointment, movement, support location, delivery address, or service context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, safety concerns, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, image references, messages, route notes, product pages, public listings, documents, or prior correspondence",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, booked, checked, reported, sourced, purchased, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, access, assignment, availability, coordination, purchase, meeting, location result, family outcome, recovery, approval, export/import clearance, service completion, or any specific outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "030",
      "record_id": "JSII_BANK_JAPAN_PERSONAL_SHOPPING_STYLING_COMPANION_SUPPORT",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Personal Shopping, Styling & Companion Support Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
          "record_id": "japan-celebrity-concierge-private-access",
          "page_sequence": "031",
          "page_title": "Japan Celebrity Concierge & Private Access Desk™",
          "page_handle": "japan-celebrity-concierge-private-access",
          "alternate_page_handles": [],
          "page_url": "https://japansolved.com/pages/japan-celebrity-concierge-private-access",
          "page_type": "native_intake_registry_record",
          "service_family": "Access / Presence / Discretion",
          "template_system": "centralized_liquid_call_old_visual_nif_v1_9_12_payment_gate_aligned",
          "question_intelligence_status": "FINAL_Q1_Q62_WITH_PAYMENT_GATE_AND_IDEAL_HEADER_COPY",
          "payment_policy": "payment_first_case_file_second",
          "native_anchor": "#jslp-intake",
          "subject_label": "Celebrity Concierge & Private Access Intake",
          "intake_title": "Japan Celebrity Concierge & Private Access Desk™ Intake",
          "intake_version": "native-intake-registry-bank-v1.9.12-page31-payment-gate-route-links",
          "service_label": "Discretion-sensitive Japan routing for legitimate private-client, celebrity, executive, founder, family-office, talent-team, or high-discretion support",
          "descriptor_line1": "Payment first. Case file second.",
          "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path. Keep sensitive third-party information minimum-necessary until requested.",
          "descriptor_paragraphs": [
                "Payment first. Case file second.",
                "This intake is for legitimate private-client, celebrity, executive, founder, family-office, talent team, or high-discretion Japan support. It is not a fan-access, paparazzi stalking, private-address, unauthorized backstage, hotel-floor, or venue-rule bypass channel.",
                "Use this native intake after checkout or after JapanSolved™ approves a private payment path. Keep sensitive third-party information minimum-necessary until requested."
          ],
          "payment_block_title": "Complete the private access payment path first",
          "payment_block_copy": "Choose the paid compatibility review, elite retainer, approved invoice, access deposit, custom quote, or private payment path that matches this private-access request before submitting sensitive itinerary, identity, venue, or third-party details.",
          "payment_block_fineprint": "Use the same payment email at intake so the private-access file can be matched to the paid path.",
          "not_paid_error": "This private access intake requires a matched paid or JapanSolved™-approved payment path before sensitive details are reviewed.",
          "product_routes": [
                {
                      "label": "Japan Celebrity Concierge Compatibility Review™",
                      "value": "/products/japan-celebrity-concierge-compatibility-review"
                },
                {
                      "label": "Japan Discreet Executive / Celebrity Companion Retainer™",
                      "value": "/products/japan-discreet-executive-celebrity-companion-retainer"
                },
                {
                      "label": "Approved private payment path / invoice / custom quote / retainer",
                      "value": "approved_private_payment_path",
                      "render_as_link": false
                }
          ],
          "product_route_objects": [
                {
                      "label": "Japan Celebrity Concierge Compatibility Review™",
                      "url": "/products/japan-celebrity-concierge-compatibility-review",
                      "kind": "primary_review",
                      "price_note": "$395-$750 gateway review"
                },
                {
                      "label": "Japan Discreet Executive / Celebrity Companion Retainer™",
                      "url": "/products/japan-discreet-executive-celebrity-companion-retainer",
                      "kind": "retainer",
                      "price_note": "quoted from $25,000+"
                },
                {
                      "label": "Approved private payment path / invoice / custom quote / retainer",
                      "url": "approved_private_payment_path",
                      "kind": "private_payment",
                      "render_as_link": false
                }
          ],
          "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
          "hidden_fields": {
                "page_title": "Japan Celebrity Concierge & Private Access Desk™",
                "page_handle": "japan-celebrity-concierge-private-access",
                "page_url": "https://www.japansolved.com/pages/japan-celebrity-concierge-private-access",
                "service_family": "Access / Presence / Discretion",
                "primary_product": "Japan Celebrity Concierge Compatibility Review™",
                "primary_product_url": "/products/japan-celebrity-concierge-compatibility-review",
                "native_intake_anchor": "#jslp-intake",
                "tally_form_context": "Page 31 private access sensitive intake reconstructed into Native Intake registry",
                "routing_default": "celebrity_private_access_review",
                "payment_first_policy": "paid_review_or_approved_private_path_before_sensitive_private_access_details",
                "registry_version": "registry-bank-v1.9.12-page31-payment-gate-route-links",
                "secondary_product": "Japan Discreet Executive / Celebrity Companion Retainer™",
                "secondary_product_url": "/products/japan-discreet-executive-celebrity-companion-retainer"
          },
          "source_docx": "Missing Tally Intake Intelligence.docx",
          "steps": [
                {
                      "id": "payment_gate",
                      "title": "Payment and private-access path match",
                      "tone": "Payment-first, case-file-second. Match the private-access request to the correct paid review, retainer, invoice, or approved private route before sensitive details are sent.",
                      "fields": [
                            {
                                  "id": "payment_status",
                                  "type": "radio",
                                  "label": "Have you already secured the correct paid path for this private access request?",
                                  "required": true,
                                  "options": [
                                        "Yes — I purchased the Japan Celebrity Concierge Compatibility Review™",
                                        "Yes — I purchased or was approved for the Japan Discreet Executive / Celebrity Companion Retainer™",
                                        "Yes — JapanSolved™ approved a private invoice, access deposit, quote, or retainer payment path",
                                        "JapanSolved™ instructed me to submit this intake before a public checkout exists",
                                        "Not yet — I need to purchase or confirm the correct payment path first"
                                  ]
                            },
                            {
                                  "id": "selected_product_path",
                                  "type": "select",
                                  "label": "Which product or payment path applies?",
                                  "required": true,
                                  "options_from": "product_routes",
                                  "helper": "Choose the closest path. If you have not paid yet, use one of the payment routes below before submitting the full private-access file."
                            },
                            {
                                  "id": "checkout_email",
                                  "type": "email",
                                  "label": "Payment email address",
                                  "required": true,
                                  "helper": "Use the same email used for checkout or invoice payment whenever possible.",
                                  "placeholder": "name@example.com"
                            },
                            {
                                  "id": "order_reference",
                                  "type": "text",
                                  "label": "Order number, invoice number, or payment reference",
                                  "required": true,
                                  "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or approved private-payment reference if available.",
                                  "placeholder": "Example: JS-1001, order number, invoice number, or approved private-payment note"
                            }
                      ]
                },
                {
                      "id": "private_access_gate",
                      "title": "Private Access Gate",
                      "tone": "This form is for legitimate private-client, celebrity, executive, founder, family-office, talent-team, or high-discretion Japan support. It is not a fan-access, paparazzi, stalking, private-address, unauthorized backstage, hotel-floor, or venue-rule bypass channel.",
                      "fields": [
                            {
                                  "id": "q1",
                                  "source_tally_qid": "Q1",
                                  "label": "What best describes your request?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "I am requesting support for myself as the principal traveler",
                                              "value": "I am requesting support for myself as the principal traveler"
                                        },
                                        {
                                              "label": "I am an authorized assistant, manager, agent, producer, family-office contact, travel planner, concierge, or representative",
                                              "value": "I am an authorized assistant, manager, agent, producer, family-office contact, travel planner, concierge, or representative"
                                        },
                                        {
                                              "label": "I am requesting on behalf of a private family, executive, artist, public figure, founder, or VIP guest",
                                              "value": "I am requesting on behalf of a private family, executive, artist, public figure, founder, or VIP guest"
                                        },
                                        {
                                              "label": "I am exploring whether this desk is appropriate before sharing sensitive details",
                                              "value": "I am exploring whether this desk is appropriate before sharing sensitive details"
                                        },
                                        {
                                              "label": "I am trying to meet, contact, follow, photograph, locate, or access a public figure without authorization",
                                              "value": "I am trying to meet, contact, follow, photograph, locate, or access a public figure without authorization"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "disqualify_values": [
                                        "i_am_trying_to_meet_contact_follow_photograph_locate_or_access_a_public_figure_without_authorization"
                                  ],
                                  "disqualify_screen": "disqualified_unauthorized_access",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q2",
                                  "source_tally_qid": "Q2",
                                  "label": "Are you authorized to submit this request?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Yes, I am the principal traveler",
                                              "value": "Yes, I am the principal traveler"
                                        },
                                        {
                                              "label": "Yes, I am an authorized representative",
                                              "value": "Yes, I am an authorized representative"
                                        },
                                        {
                                              "label": "Yes, I am part of the client’s team or household",
                                              "value": "Yes, I am part of the client’s team or household"
                                        },
                                        {
                                              "label": "I am exploring first and will provide authorization later",
                                              "value": "I am exploring first and will provide authorization later"
                                        },
                                        {
                                              "label": "No, I am not authorized",
                                              "value": "No, I am not authorized"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "warning": "Do not submit private schedules, addresses, hotel names, private contact information, or confidential details about another person unless authorized. General feasibility can be reviewed without naming the principal.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q3",
                                  "source_tally_qid": "Q3",
                                  "label": "Which boundary statement do you confirm?",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "I understand this desk does not guarantee access to people, venues, events, clubs, private rooms, restaurants, backstage areas, member spaces, or private residences.",
                                              "value": "I understand this desk does not guarantee access to people, venues, events, clubs, private rooms, restaurants, backstage areas, member spaces, or private residences."
                                        },
                                        {
                                              "label": "I understand this desk does not assist with stalking, paparazzi work, private-address hunting, unauthorized celebrity contact, private schedules, hotel-floor access, or bypassing staff.",
                                              "value": "I understand this desk does not assist with stalking, paparazzi work, private-address hunting, unauthorized celebrity contact, private schedules, hotel-floor access, or bypassing staff."
                                        },
                                        {
                                              "label": "I understand paid files are prioritized and unpaid submissions may be treated only as routing reference.",
                                              "value": "I understand paid files are prioritized and unpaid submissions may be treated only as routing reference."
                                        },
                                        {
                                              "label": "I understand professional security, medical support, close protection, and licensed specialist services must be scoped separately if needed.",
                                              "value": "I understand professional security, medical support, close protection, and licensed specialist services must be scoped separately if needed."
                                        }
                                  ],
                                  "require_all": true,
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "payment_and_case_status",
                      "title": "Payment / Review Status",
                      "tone": "Celebrity, executive, and private-access support begins with fit review. The sensitive part is what should be disclosed, what should stay quiet, what is legitimate to request, and which JapanSolved™ desk should handle each layer.",
                      "fields": [
                            {
                                  "id": "q4",
                                  "source_tally_qid": "Q4",
                                  "label": "Have you already purchased the private access review?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Yes, I purchased Japan Celebrity Concierge Compatibility Review™",
                                              "value": "Yes, I purchased Japan Celebrity Concierge Compatibility Review™"
                                        },
                                        {
                                              "label": "Not yet, but I intend to purchase before review",
                                              "value": "Not yet, but I intend to purchase before review"
                                        },
                                        {
                                              "label": "I was instructed to submit this intake first",
                                              "value": "I was instructed to submit this intake first"
                                        },
                                        {
                                              "label": "I am submitting an unpaid routing reference only",
                                              "value": "I am submitting an unpaid routing reference only"
                                        },
                                        {
                                              "label": "I am requesting elite retainer consideration",
                                              "value": "I am requesting elite retainer consideration"
                                        }
                                  ],
                                  "payment_first_note": "If no payment has been made, this submission may be used only to understand routing and may not be reviewed as an active case file.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q5",
                                  "source_tally_qid": "Q5",
                                  "label": "Payment order number or checkout email",
                                  "type": "text",
                                  "required": false,
                                  "placeholder": "Example: #JS1234 or checkout email used",
                                  "show_if": {
                                        "field": "q4",
                                        "operator": "equals",
                                        "value": "Yes, I purchased Japan Celebrity Concierge Compatibility Review™"
                                  },
                                  "legacy_ids": [
                                        "Q5",
                                        "checkout_email_if_used_as_reference",
                                        "payment_reference"
                                  ],
                                  "canonical_role": "order_reference_or_checkout_email"
                            },
                            {
                                  "id": "q6",
                                  "source_tally_qid": "Q6",
                                  "label": "Desired pathway",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Japan Celebrity Concierge Compatibility Review™",
                                              "value": "Japan Celebrity Concierge Compatibility Review™"
                                        },
                                        {
                                              "label": "Japan Low-Profile Access Route Brief™",
                                              "value": "Japan Low-Profile Access Route Brief™"
                                        },
                                        {
                                              "label": "Japan Private Access Coordination File™",
                                              "value": "Japan Private Access Coordination File™"
                                        },
                                        {
                                              "label": "Japan Discreet Executive / Celebrity Companion Retainer™",
                                              "value": "Japan Discreet Executive / Celebrity Companion Retainer™"
                                        },
                                        {
                                              "label": "Not sure, please route the case",
                                              "value": "Not sure, please route the case"
                                        },
                                        {
                                              "label": "I need urgent triage",
                                              "value": "I need urgent triage"
                                        }
                                  ],
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "requester_details",
                      "title": "Requester Details",
                      "fields": [
                            {
                                  "id": "client_name",
                                  "source_tally_qid": "Q7",
                                  "label": "Your full name",
                                  "type": "text",
                                  "required": true,
                                  "legacy_id": "q7",
                                  "step_blocking": true,
                                  "canonical_role": "client_name",
                                  "native_required_key": "client_name",
                                  "legacy_ids": [
                                        "Q7",
                                        "full_name",
                                        "q7",
                                        "requester_name",
                                        "your_full_name"
                                  ],
                                  "autocomplete": "name"
                            },
                            {
                                  "id": "contact_email",
                                  "source_tally_qid": "Q8",
                                  "label": "Your email address",
                                  "type": "email",
                                  "required": true,
                                  "legacy_id": "q8",
                                  "helper": "Use a valid email address with one @ symbol and a real domain, such as name@example.com.",
                                  "placeholder": "name@example.com",
                                  "step_blocking": true,
                                  "validation": {
                                        "kind": "email",
                                        "required": true,
                                        "step_blocking": true,
                                        "review_blocking": true,
                                        "submit_blocking": true,
                                        "message": "Please enter a valid best contact email before continuing. Use one @ symbol and a real domain, such as name@example.com."
                                  },
                                  "autocomplete": "email",
                                  "inputmode": "email",
                                  "canonical_role": "contact_email",
                                  "native_required_key": "contact_email",
                                  "legacy_ids": [
                                        "Q8",
                                        "best_contact_email",
                                        "checkout_email",
                                        "client_email",
                                        "email",
                                        "q8",
                                        "your_email_address"
                                  ]
                            },
                            {
                                  "id": "phone_or_messenger",
                                  "source_tally_qid": "Q9",
                                  "label": "Phone / WhatsApp / Signal contact",
                                  "type": "text",
                                  "required": false,
                                  "helper": "Use the contact method you prefer for time-sensitive coordination. Do not include private numbers belonging to the principal unless authorized.",
                                  "legacy_id": "q9",
                                  "legacy_ids": [
                                        "Q9",
                                        "phone_whatsapp_signal_contact",
                                        "q9"
                                  ]
                            },
                            {
                                  "id": "q10",
                                  "source_tally_qid": "Q10",
                                  "label": "Your role",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Principal traveler",
                                              "value": "Principal traveler"
                                        },
                                        {
                                              "label": "Personal assistant",
                                              "value": "Personal assistant"
                                        },
                                        {
                                              "label": "Executive assistant",
                                              "value": "Executive assistant"
                                        },
                                        {
                                              "label": "Manager / agent",
                                              "value": "Manager / agent"
                                        },
                                        {
                                              "label": "Family office",
                                              "value": "Family office"
                                        },
                                        {
                                              "label": "Producer / production coordinator",
                                              "value": "Producer / production coordinator"
                                        },
                                        {
                                              "label": "Private travel planner",
                                              "value": "Private travel planner"
                                        },
                                        {
                                              "label": "Concierge / lifestyle manager",
                                              "value": "Concierge / lifestyle manager"
                                        },
                                        {
                                              "label": "Family member",
                                              "value": "Family member"
                                        },
                                        {
                                              "label": "Security / close protection contact",
                                              "value": "Security / close protection contact"
                                        },
                                        {
                                              "label": "Friend or invited guest",
                                              "value": "Friend or invited guest"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q11",
                                  "source_tally_qid": "Q11",
                                  "label": "Organization / team name",
                                  "type": "text",
                                  "required": false,
                                  "helper": "Optional. You may write “private” if discretion is preferred at this stage."
                            },
                            {
                                  "id": "q12",
                                  "source_tally_qid": "Q12",
                                  "label": "Best communication style",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Email first",
                                              "value": "Email first"
                                        },
                                        {
                                              "label": "WhatsApp preferred",
                                              "value": "WhatsApp preferred"
                                        },
                                        {
                                              "label": "Signal preferred",
                                              "value": "Signal preferred"
                                        },
                                        {
                                              "label": "Phone call only after initial review",
                                              "value": "Phone call only after initial review"
                                        },
                                        {
                                              "label": "Assistant/team contact only",
                                              "value": "Assistant/team contact only"
                                        },
                                        {
                                              "label": "Not sure yet",
                                              "value": "Not sure yet"
                                        }
                                  ],
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "principal_client_profile",
                      "title": "Principal Traveler / Client Profile",
                      "tone": "You may describe the client without naming them if that is safer at this stage. Minimum necessary information is preferred.",
                      "fields": [
                            {
                                  "id": "q13",
                                  "source_tally_qid": "Q13",
                                  "label": "What type of client is this for?",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Public figure",
                                              "value": "Public figure"
                                        },
                                        {
                                              "label": "Artist / performer",
                                              "value": "Artist / performer"
                                        },
                                        {
                                              "label": "Actor / media personality",
                                              "value": "Actor / media personality"
                                        },
                                        {
                                              "label": "Musician / DJ / creative talent",
                                              "value": "Musician / DJ / creative talent"
                                        },
                                        {
                                              "label": "Athlete",
                                              "value": "Athlete"
                                        },
                                        {
                                              "label": "Founder / entrepreneur",
                                              "value": "Founder / entrepreneur"
                                        },
                                        {
                                              "label": "Executive / board-level client",
                                              "value": "Executive / board-level client"
                                        },
                                        {
                                              "label": "Family-office guest",
                                              "value": "Family-office guest"
                                        },
                                        {
                                              "label": "Private family",
                                              "value": "Private family"
                                        },
                                        {
                                              "label": "Collector / patron",
                                              "value": "Collector / patron"
                                        },
                                        {
                                              "label": "Production or appearance-related team",
                                              "value": "Production or appearance-related team"
                                        },
                                        {
                                              "label": "High-discretion traveler who is not publicly known",
                                              "value": "High-discretion traveler who is not publicly known"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q14",
                                  "source_tally_qid": "Q14",
                                  "label": "Do you need to disclose the client’s name now?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "No, general profile is enough for now",
                                              "value": "No, general profile is enough for now"
                                        },
                                        {
                                              "label": "Yes, I am authorized to disclose the name",
                                              "value": "Yes, I am authorized to disclose the name"
                                        },
                                        {
                                              "label": "Yes, but I prefer to disclose after paid review / NDA discussion",
                                              "value": "Yes, but I prefer to disclose after paid review / NDA discussion"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q15",
                                  "source_tally_qid": "Q15",
                                  "label": "Client name or alias",
                                  "type": "text",
                                  "required": false,
                                  "helper": "Only include this if authorized. An alias or initials are acceptable for first review.",
                                  "show_if": {
                                        "field": "q14",
                                        "operator": "equals",
                                        "value": "Yes, I am authorized to disclose the name"
                                  }
                            },
                            {
                                  "id": "q16",
                                  "source_tally_qid": "Q16",
                                  "label": "Visibility level in Japan",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Very high visibility, likely to be recognized",
                                              "value": "Very high visibility, likely to be recognized"
                                        },
                                        {
                                              "label": "Moderate visibility, may be recognized in certain areas",
                                              "value": "Moderate visibility, may be recognized in certain areas"
                                        },
                                        {
                                              "label": "Industry visibility, not broadly public",
                                              "value": "Industry visibility, not broadly public"
                                        },
                                        {
                                              "label": "Private high-net-worth / family office, not publicly known",
                                              "value": "Private high-net-worth / family office, not publicly known"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        },
                                        {
                                              "label": "Prefer not to say yet",
                                              "value": "Prefer not to say yet"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q17",
                                  "source_tally_qid": "Q17",
                                  "label": "What creates the privacy risk?",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Public recognition",
                                              "value": "Public recognition"
                                        },
                                        {
                                              "label": "Social media attention",
                                              "value": "Social media attention"
                                        },
                                        {
                                              "label": "Fan attention",
                                              "value": "Fan attention"
                                        },
                                        {
                                              "label": "Press / paparazzi risk",
                                              "value": "Press / paparazzi risk"
                                        },
                                        {
                                              "label": "Business reputation",
                                              "value": "Business reputation"
                                        },
                                        {
                                              "label": "Family privacy",
                                              "value": "Family privacy"
                                        },
                                        {
                                              "label": "Staff / entourage complexity",
                                              "value": "Staff / entourage complexity"
                                        },
                                        {
                                              "label": "Prior incident or concern",
                                              "value": "Prior incident or concern"
                                        },
                                        {
                                              "label": "Sensitive venue or event",
                                              "value": "Sensitive venue or event"
                                        },
                                        {
                                              "label": "Medical / recovery / wellness context",
                                              "value": "Medical / recovery / wellness context"
                                        },
                                        {
                                              "label": "Security concern",
                                              "value": "Security concern"
                                        },
                                        {
                                              "label": "Client simply wants a low-profile trip",
                                              "value": "Client simply wants a low-profile trip"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "japan_trip_timing",
                      "title": "Dates, Cities, and Timing Pressure",
                      "fields": [
                            {
                                  "id": "q18",
                                  "source_tally_qid": "Q18",
                                  "label": "Is the client already in Japan?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Yes, already in Japan",
                                              "value": "Yes, already in Japan"
                                        },
                                        {
                                              "label": "Arriving soon",
                                              "value": "Arriving soon"
                                        },
                                        {
                                              "label": "Trip is planned but not booked",
                                              "value": "Trip is planned but not booked"
                                        },
                                        {
                                              "label": "Exploring before booking",
                                              "value": "Exploring before booking"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q19",
                                  "source_tally_qid": "Q19",
                                  "label": "Target city or cities",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Tokyo",
                                              "value": "Tokyo"
                                        },
                                        {
                                              "label": "Kyoto",
                                              "value": "Kyoto"
                                        },
                                        {
                                              "label": "Osaka",
                                              "value": "Osaka"
                                        },
                                        {
                                              "label": "Kobe",
                                              "value": "Kobe"
                                        },
                                        {
                                              "label": "Nara",
                                              "value": "Nara"
                                        },
                                        {
                                              "label": "Hakone",
                                              "value": "Hakone"
                                        },
                                        {
                                              "label": "Fuji area",
                                              "value": "Fuji area"
                                        },
                                        {
                                              "label": "Hokkaido",
                                              "value": "Hokkaido"
                                        },
                                        {
                                              "label": "Okinawa",
                                              "value": "Okinawa"
                                        },
                                        {
                                              "label": "Nagoya",
                                              "value": "Nagoya"
                                        },
                                        {
                                              "label": "Fukuoka",
                                              "value": "Fukuoka"
                                        },
                                        {
                                              "label": "Multiple cities",
                                              "value": "Multiple cities"
                                        },
                                        {
                                              "label": "Not sure yet",
                                              "value": "Not sure yet"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q20",
                                  "source_tally_qid": "Q20",
                                  "label": "Target start date",
                                  "type": "date",
                                  "required": true,
                                  "step_blocking": true
                            },
                            {
                                  "id": "q21",
                                  "source_tally_qid": "Q21",
                                  "label": "Target end date",
                                  "type": "date",
                                  "required": false
                            },
                            {
                                  "id": "q22",
                                  "source_tally_qid": "Q22",
                                  "label": "Secondary date window",
                                  "type": "text",
                                  "required": false,
                                  "placeholder": "Example: May 14-16 if May 12 is not possible"
                            },
                            {
                                  "id": "q23",
                                  "source_tally_qid": "Q23",
                                  "label": "Tertiary backup window",
                                  "type": "text",
                                  "required": false
                            },
                            {
                                  "id": "q24",
                                  "source_tally_qid": "Q24",
                                  "label": "How urgent is this request?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Today / within 24 hours",
                                              "value": "Today / within 24 hours"
                                        },
                                        {
                                              "label": "Within 2-3 days",
                                              "value": "Within 2-3 days"
                                        },
                                        {
                                              "label": "Within 4-7 days",
                                              "value": "Within 4-7 days"
                                        },
                                        {
                                              "label": "Within 2 weeks",
                                              "value": "Within 2 weeks"
                                        },
                                        {
                                              "label": "Within 1 month",
                                              "value": "Within 1 month"
                                        },
                                        {
                                              "label": "More than 1 month away",
                                              "value": "More than 1 month away"
                                        },
                                        {
                                              "label": "Flexible",
                                              "value": "Flexible"
                                        }
                                  ],
                                  "warning": "Sensitive private access work is safest with one month of lead time. Target execution dates within three days may require priority-handling premiums, reduced options, or refusal if proper handling is not possible.",
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "request_type",
                      "title": "What Do You Need Us To Review?",
                      "fields": [
                            {
                                  "id": "q25",
                                  "source_tally_qid": "Q25",
                                  "label": "Main request category",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Low-profile Japan itinerary / private access review",
                                              "value": "Low-profile Japan itinerary / private access review"
                                        },
                                        {
                                              "label": "Private dining or chef-counter privacy",
                                              "value": "Private dining or chef-counter privacy"
                                        },
                                        {
                                              "label": "Restaurant private room / arrival route",
                                              "value": "Restaurant private room / arrival route"
                                        },
                                        {
                                              "label": "Event, concert, sports, exhibition, or entertainment access",
                                              "value": "Event, concert, sports, exhibition, or entertainment access"
                                        },
                                        {
                                              "label": "Appointment-style shopping route",
                                              "value": "Appointment-style shopping route"
                                        },
                                        {
                                              "label": "Luxury / vintage / jewelry / styling support",
                                              "value": "Luxury / vintage / jewelry / styling support"
                                        },
                                        {
                                              "label": "Art, antiques, gallery, or collector access",
                                              "value": "Art, antiques, gallery, or collector access"
                                        },
                                        {
                                              "label": "Nightlife route with companion / safe return layer",
                                              "value": "Nightlife route with companion / safe return layer"
                                        },
                                        {
                                              "label": "Hotel-to-venue movement planning",
                                              "value": "Hotel-to-venue movement planning"
                                        },
                                        {
                                              "label": "Local liaison / Japan-side representation",
                                              "value": "Local liaison / Japan-side representation"
                                        },
                                        {
                                              "label": "Yamato-led private presence review",
                                              "value": "Yamato-led private presence review"
                                        },
                                        {
                                              "label": "Cultural access / host-style introduction",
                                              "value": "Cultural access / host-style introduction"
                                        },
                                        {
                                              "label": "Multi-day executive or celebrity itinerary architecture",
                                              "value": "Multi-day executive or celebrity itinerary architecture"
                                        },
                                        {
                                              "label": "Elite retainer / full discretion wrap",
                                              "value": "Elite retainer / full discretion wrap"
                                        },
                                        {
                                              "label": "Not sure, please classify the request",
                                              "value": "Not sure, please classify the request"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q26",
                                  "source_tally_qid": "Q26",
                                  "label": "Describe the request in plain language",
                                  "type": "textarea",
                                  "required": true,
                                  "helper": "Tell us what the client wants to happen, what must not happen, and what kind of Japan experience you are trying to create. Avoid private addresses, confidential schedules, hotel room numbers, passport data, or medical records.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q27",
                                  "source_tally_qid": "Q27",
                                  "label": "What would success look like?",
                                  "type": "textarea",
                                  "required": true,
                                  "placeholder": "Example: Client arrives quietly, has a private-room dinner, avoids lobby exposure, enjoys a short gallery route, and exits without staff confusion.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q28",
                                  "source_tally_qid": "Q28",
                                  "label": "What would failure look like?",
                                  "type": "textarea",
                                  "required": true,
                                  "placeholder": "Example: Crowded lobby, fan attention, wrong entrance, venue misunderstands privacy need, client has to explain the request in public.",
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "privacy_attention_flow",
                      "title": "Privacy / Attention Flow",
                      "fields": [
                            {
                                  "id": "q29",
                                  "source_tally_qid": "Q29",
                                  "label": "Which privacy outcomes matter?",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Avoid public queues",
                                              "value": "Avoid public queues"
                                        },
                                        {
                                              "label": "Avoid crowded entrances",
                                              "value": "Avoid crowded entrances"
                                        },
                                        {
                                              "label": "Avoid lobby exposure",
                                              "value": "Avoid lobby exposure"
                                        },
                                        {
                                              "label": "Avoid being photographed",
                                              "value": "Avoid being photographed"
                                        },
                                        {
                                              "label": "Avoid public discussion of the client’s identity",
                                              "value": "Avoid public discussion of the client’s identity"
                                        },
                                        {
                                              "label": "Avoid staff confusion",
                                              "value": "Avoid staff confusion"
                                        },
                                        {
                                              "label": "Avoid fan interaction",
                                              "value": "Avoid fan interaction"
                                        },
                                        {
                                              "label": "Avoid press / paparazzi attention",
                                              "value": "Avoid press / paparazzi attention"
                                        },
                                        {
                                              "label": "Avoid social media tagging",
                                              "value": "Avoid social media tagging"
                                        },
                                        {
                                              "label": "Avoid over-formal VIP treatment",
                                              "value": "Avoid over-formal VIP treatment"
                                        },
                                        {
                                              "label": "Avoid awkward restaurant or venue explanations",
                                              "value": "Avoid awkward restaurant or venue explanations"
                                        },
                                        {
                                              "label": "Avoid the client solving logistics directly",
                                              "value": "Avoid the client solving logistics directly"
                                        },
                                        {
                                              "label": "Keep the trip warm, personal, and human, not sterile",
                                              "value": "Keep the trip warm, personal, and human, not sterile"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q30",
                                  "source_tally_qid": "Q30",
                                  "label": "How visible should the support team be?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Very invisible, background coordination only",
                                              "value": "Very invisible, background coordination only"
                                        },
                                        {
                                              "label": "Low-profile local liaison if needed",
                                              "value": "Low-profile local liaison if needed"
                                        },
                                        {
                                              "label": "Discreet in-room / on-route companion presence",
                                              "value": "Discreet in-room / on-route companion presence"
                                        },
                                        {
                                              "label": "Visible concierge support is acceptable",
                                              "value": "Visible concierge support is acceptable"
                                        },
                                        {
                                              "label": "Depends on the situation",
                                              "value": "Depends on the situation"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q31",
                                  "source_tally_qid": "Q31",
                                  "label": "Are there photography or social media restrictions?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "No photography preferred",
                                              "value": "No photography preferred"
                                        },
                                        {
                                              "label": "No social posting / tagging",
                                              "value": "No social posting / tagging"
                                        },
                                        {
                                              "label": "No staff photos",
                                              "value": "No staff photos"
                                        },
                                        {
                                              "label": "No public mention of the client",
                                              "value": "No public mention of the client"
                                        },
                                        {
                                              "label": "Normal discretion is enough",
                                              "value": "Normal discretion is enough"
                                        },
                                        {
                                              "label": "Not sure yet",
                                              "value": "Not sure yet"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q32",
                                  "source_tally_qid": "Q32",
                                  "label": "Any known sensitivity?",
                                  "type": "checkbox_group",
                                  "required": false,
                                  "options": [
                                        {
                                              "label": "Recent public attention",
                                              "value": "Recent public attention"
                                        },
                                        {
                                              "label": "Press risk",
                                              "value": "Press risk"
                                        },
                                        {
                                              "label": "Fan risk",
                                              "value": "Fan risk"
                                        },
                                        {
                                              "label": "Family / child privacy",
                                              "value": "Family / child privacy"
                                        },
                                        {
                                              "label": "Business confidentiality",
                                              "value": "Business confidentiality"
                                        },
                                        {
                                              "label": "Health / recovery context",
                                              "value": "Health / recovery context"
                                        },
                                        {
                                              "label": "Relationship / social sensitivity",
                                              "value": "Relationship / social sensitivity"
                                        },
                                        {
                                              "label": "Security concern",
                                              "value": "Security concern"
                                        },
                                        {
                                              "label": "Prior incident",
                                              "value": "Prior incident"
                                        },
                                        {
                                              "label": "None known",
                                              "value": "None known"
                                        },
                                        {
                                              "label": "Prefer to discuss later",
                                              "value": "Prefer to discuss later"
                                        }
                                  ]
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "access_targets",
                      "title": "Venues, Events, Dining, Shopping, and Local Doors",
                      "fields": [
                            {
                                  "id": "q33",
                                  "source_tally_qid": "Q33",
                                  "label": "Do you already have target venues or experiences?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Yes, we have specific targets",
                                              "value": "Yes, we have specific targets"
                                        },
                                        {
                                              "label": "Some ideas, but flexible",
                                              "value": "Some ideas, but flexible"
                                        },
                                        {
                                              "label": "No, we need recommendations and routing",
                                              "value": "No, we need recommendations and routing"
                                        },
                                        {
                                              "label": "We only need discretion strategy",
                                              "value": "We only need discretion strategy"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q34",
                                  "source_tally_qid": "Q34",
                                  "label": "Target venues / restaurants / events / shops / experiences",
                                  "type": "textarea",
                                  "required": false,
                                  "helper": "List names only if appropriate. Do not include private addresses, staff personal contact details, hotel room numbers, or non-public schedule details unless necessary and authorized.",
                                  "show_if": {
                                        "field": "q33",
                                        "operator": "in",
                                        "values": [
                                              "Yes, we have specific targets",
                                              "Some ideas, but flexible"
                                        ]
                                  }
                            },
                            {
                                  "id": "q35",
                                  "source_tally_qid": "Q35",
                                  "label": "Access type requested",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Public booking handled discreetly",
                                              "value": "Public booking handled discreetly"
                                        },
                                        {
                                              "label": "Private room / private table request",
                                              "value": "Private room / private table request"
                                        },
                                        {
                                              "label": "Appointment-style shopping",
                                              "value": "Appointment-style shopping"
                                        },
                                        {
                                              "label": "Timed entry / timed arrival",
                                              "value": "Timed entry / timed arrival"
                                        },
                                        {
                                              "label": "Separate entrance or quieter arrival logic",
                                              "value": "Separate entrance or quieter arrival logic"
                                        },
                                        {
                                              "label": "Local liaison call / Japanese-language coordination",
                                              "value": "Local liaison call / Japanese-language coordination"
                                        },
                                        {
                                              "label": "Private guide / companion layer",
                                              "value": "Private guide / companion layer"
                                        },
                                        {
                                              "label": "After-hours or special viewing request",
                                              "value": "After-hours or special viewing request"
                                        },
                                        {
                                              "label": "Event ticket / access path review",
                                              "value": "Event ticket / access path review"
                                        },
                                        {
                                              "label": "Staff communication / wording support",
                                              "value": "Staff communication / wording support"
                                        },
                                        {
                                              "label": "Exit plan / safe return route",
                                              "value": "Exit plan / safe return route"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q36",
                                  "source_tally_qid": "Q36",
                                  "label": "Are any of these requests member-only, invitation-only, private, or restricted?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Yes",
                                              "value": "Yes"
                                        },
                                        {
                                              "label": "Maybe",
                                              "value": "Maybe"
                                        },
                                        {
                                              "label": "No",
                                              "value": "No"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q37",
                                  "source_tally_qid": "Q37",
                                  "label": "Explain any restricted-access context",
                                  "type": "textarea",
                                  "required": false,
                                  "helper": "We cannot bypass rules or membership systems. We can only review legitimate options, proper wording, and feasible routing.",
                                  "show_if": {
                                        "field": "q36",
                                        "operator": "in",
                                        "values": [
                                              "Yes",
                                              "Maybe",
                                              "Not sure"
                                        ]
                                  }
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "movement_arrival_exit",
                      "title": "Movement / Route Sensitivity",
                      "fields": [
                            {
                                  "id": "q38",
                                  "source_tally_qid": "Q38",
                                  "label": "What movement support may be needed?",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Hotel-to-restaurant movement",
                                              "value": "Hotel-to-restaurant movement"
                                        },
                                        {
                                              "label": "Hotel-to-event movement",
                                              "value": "Hotel-to-event movement"
                                        },
                                        {
                                              "label": "Airport arrival / departure coordination",
                                              "value": "Airport arrival / departure coordination"
                                        },
                                        {
                                              "label": "Station / taxi / vehicle route planning",
                                              "value": "Station / taxi / vehicle route planning"
                                        },
                                        {
                                              "label": "Entrance timing",
                                              "value": "Entrance timing"
                                        },
                                        {
                                              "label": "Exit timing",
                                              "value": "Exit timing"
                                        },
                                        {
                                              "label": "Rain / weather backup",
                                              "value": "Rain / weather backup"
                                        },
                                        {
                                              "label": "Crowd avoidance",
                                              "value": "Crowd avoidance"
                                        },
                                        {
                                              "label": "Multi-stop route sequencing",
                                              "value": "Multi-stop route sequencing"
                                        },
                                        {
                                              "label": "Staff handoff points",
                                              "value": "Staff handoff points"
                                        },
                                        {
                                              "label": "Companion or liaison presence",
                                              "value": "Companion or liaison presence"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q39",
                                  "source_tally_qid": "Q39",
                                  "label": "Transportation status",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Already arranged",
                                              "value": "Already arranged"
                                        },
                                        {
                                              "label": "Need private car / driver recommendations",
                                              "value": "Need private car / driver recommendations"
                                        },
                                        {
                                              "label": "Need route logic only",
                                              "value": "Need route logic only"
                                        },
                                        {
                                              "label": "Need companion / liaison to ride or meet",
                                              "value": "Need companion / liaison to ride or meet"
                                        },
                                        {
                                              "label": "Not sure yet",
                                              "value": "Not sure yet"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q40",
                                  "source_tally_qid": "Q40",
                                  "label": "Hotel / accommodation status",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Already booked and can disclose later",
                                              "value": "Already booked and can disclose later"
                                        },
                                        {
                                              "label": "Already booked but should not be disclosed in form",
                                              "value": "Already booked but should not be disclosed in form"
                                        },
                                        {
                                              "label": "Need hotel area strategy",
                                              "value": "Need hotel area strategy"
                                        },
                                        {
                                              "label": "Need privacy-sensitive hotel logic",
                                              "value": "Need privacy-sensitive hotel logic"
                                        },
                                        {
                                              "label": "Not applicable",
                                              "value": "Not applicable"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q41",
                                  "source_tally_qid": "Q41",
                                  "label": "Any specific arrival / exit concerns?",
                                  "type": "textarea",
                                  "required": false,
                                  "placeholder": "Example: Avoid main lobby, do not have client wait outside, need clean exit after dinner, avoid crowded station transfer."
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "private_presence_layer",
                      "title": "Private Presence Layer",
                      "tone": "Some private access files need more than bookings. They need a person who can read the room, soften friction, handle local timing, translate mood, and keep the client from becoming the problem-solver.",
                      "fields": [
                            {
                                  "id": "q42",
                                  "source_tally_qid": "Q42",
                                  "label": "Is a private companion / local liaison layer being considered?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Yes, definitely",
                                              "value": "Yes, definitely"
                                        },
                                        {
                                              "label": "Possibly",
                                              "value": "Possibly"
                                        },
                                        {
                                              "label": "Only for one part of the trip",
                                              "value": "Only for one part of the trip"
                                        },
                                        {
                                              "label": "No, background coordination only",
                                              "value": "No, background coordination only"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q43",
                                  "source_tally_qid": "Q43",
                                  "label": "What kind of presence would help?",
                                  "type": "checkbox_group",
                                  "required": false,
                                  "options": [
                                        {
                                              "label": "Quiet cultural support",
                                              "value": "Quiet cultural support"
                                        },
                                        {
                                              "label": "Restaurant / venue language",
                                              "value": "Restaurant / venue language"
                                        },
                                        {
                                              "label": "Shopping route presence",
                                              "value": "Shopping route presence"
                                        },
                                        {
                                              "label": "Nightlife companion / safety layer",
                                              "value": "Nightlife companion / safety layer"
                                        },
                                        {
                                              "label": "Soft social buffering",
                                              "value": "Soft social buffering"
                                        },
                                        {
                                              "label": "Translation / interpretation support",
                                              "value": "Translation / interpretation support"
                                        },
                                        {
                                              "label": "Local etiquette support",
                                              "value": "Local etiquette support"
                                        },
                                        {
                                              "label": "Route timing and movement support",
                                              "value": "Route timing and movement support"
                                        },
                                        {
                                              "label": "Conversation / warmth / personal ease",
                                              "value": "Conversation / warmth / personal ease"
                                        },
                                        {
                                              "label": "Yamato-led private presence review",
                                              "value": "Yamato-led private presence review"
                                        },
                                        {
                                              "label": "Female companion preferred",
                                              "value": "Female companion preferred"
                                        },
                                        {
                                              "label": "Male companion preferred",
                                              "value": "Male companion preferred"
                                        },
                                        {
                                              "label": "No gender preference",
                                              "value": "No gender preference"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "show_if": {
                                        "field": "q42",
                                        "operator": "not_equals",
                                        "value": "No, background coordination only"
                                  }
                            },
                            {
                                  "id": "q44",
                                  "source_tally_qid": "Q44",
                                  "label": "Yamato-led private presence review",
                                  "type": "radio",
                                  "required": false,
                                  "options": [
                                        {
                                              "label": "Yes, specifically interested in Yamato-led presence",
                                              "value": "Yes, specifically interested in Yamato-led presence"
                                        },
                                        {
                                              "label": "Open to Yamato if appropriate",
                                              "value": "Open to Yamato if appropriate"
                                        },
                                        {
                                              "label": "Mentioned only as a possibility",
                                              "value": "Mentioned only as a possibility"
                                        },
                                        {
                                              "label": "Need to understand fit first",
                                              "value": "Need to understand fit first"
                                        }
                                  ],
                                  "show_if": {
                                        "field": "q43",
                                        "operator": "contains",
                                        "value": "Yamato-led private presence review"
                                  }
                            },
                            {
                                  "id": "q45",
                                  "source_tally_qid": "Q45",
                                  "label": "Companion boundaries and tone",
                                  "type": "textarea",
                                  "required": false,
                                  "helper": "Describe the desired support style: discreet, warm, social, culturally fluent, mostly silent, practical, polished, casual, dinner-friendly, shopping-oriented, nightlife-aware, executive-facing.",
                                  "show_if": {
                                        "field": "q42",
                                        "operator": "not_equals",
                                        "value": "No, background coordination only"
                                  }
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "entourage_decision_chain",
                      "title": "Team / Entourage / Decision Chain",
                      "fields": [
                            {
                                  "id": "q46",
                                  "source_tally_qid": "Q46",
                                  "label": "Number of people in the principal party",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "1 person",
                                              "value": "1 person"
                                        },
                                        {
                                              "label": "2 people",
                                              "value": "2 people"
                                        },
                                        {
                                              "label": "3-4 people",
                                              "value": "3-4 people"
                                        },
                                        {
                                              "label": "5-8 people",
                                              "value": "5-8 people"
                                        },
                                        {
                                              "label": "9-15 people",
                                              "value": "9-15 people"
                                        },
                                        {
                                              "label": "More than 15",
                                              "value": "More than 15"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q47",
                                  "source_tally_qid": "Q47",
                                  "label": "Who will communicate with JapanSolved™?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Principal traveler directly",
                                              "value": "Principal traveler directly"
                                        },
                                        {
                                              "label": "Assistant / manager",
                                              "value": "Assistant / manager"
                                        },
                                        {
                                              "label": "Family office",
                                              "value": "Family office"
                                        },
                                        {
                                              "label": "Travel planner",
                                              "value": "Travel planner"
                                        },
                                        {
                                              "label": "Concierge",
                                              "value": "Concierge"
                                        },
                                        {
                                              "label": "Producer / team coordinator",
                                              "value": "Producer / team coordinator"
                                        },
                                        {
                                              "label": "Security contact",
                                              "value": "Security contact"
                                        },
                                        {
                                              "label": "Mixed contacts",
                                              "value": "Mixed contacts"
                                        },
                                        {
                                              "label": "Not sure yet",
                                              "value": "Not sure yet"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q48",
                                  "source_tally_qid": "Q48",
                                  "label": "Who can approve budget / scope changes?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "I can approve",
                                              "value": "I can approve"
                                        },
                                        {
                                              "label": "Principal approves",
                                              "value": "Principal approves"
                                        },
                                        {
                                              "label": "Assistant / manager approves",
                                              "value": "Assistant / manager approves"
                                        },
                                        {
                                              "label": "Family office approves",
                                              "value": "Family office approves"
                                        },
                                        {
                                              "label": "Company / production team approves",
                                              "value": "Company / production team approves"
                                        },
                                        {
                                              "label": "Approval chain is unclear",
                                              "value": "Approval chain is unclear"
                                        },
                                        {
                                              "label": "Not sure yet",
                                              "value": "Not sure yet"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q49",
                                  "source_tally_qid": "Q49",
                                  "label": "Are there multiple teams involved?",
                                  "type": "checkbox_group",
                                  "required": false,
                                  "options": [
                                        {
                                              "label": "Management",
                                              "value": "Management"
                                        },
                                        {
                                              "label": "Assistant team",
                                              "value": "Assistant team"
                                        },
                                        {
                                              "label": "Security team",
                                              "value": "Security team"
                                        },
                                        {
                                              "label": "Family office",
                                              "value": "Family office"
                                        },
                                        {
                                              "label": "Travel agency",
                                              "value": "Travel agency"
                                        },
                                        {
                                              "label": "Production team",
                                              "value": "Production team"
                                        },
                                        {
                                              "label": "PR / communications",
                                              "value": "PR / communications"
                                        },
                                        {
                                              "label": "Hotel concierge",
                                              "value": "Hotel concierge"
                                        },
                                        {
                                              "label": "Driver / transport provider",
                                              "value": "Driver / transport provider"
                                        },
                                        {
                                              "label": "Personal stylist / shopper",
                                              "value": "Personal stylist / shopper"
                                        },
                                        {
                                              "label": "Interpreter",
                                              "value": "Interpreter"
                                        },
                                        {
                                              "label": "Other",
                                              "value": "Other"
                                        },
                                        {
                                              "label": "No, simple party",
                                              "value": "No, simple party"
                                        }
                                  ]
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "safety_security_specialist_scope",
                      "title": "Safety / Security / Specialist Scope",
                      "fields": [
                            {
                                  "id": "q50",
                                  "source_tally_qid": "Q50",
                                  "label": "Is there an active emergency, threat, medical crisis, or immediate safety issue?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "No",
                                              "value": "No"
                                        },
                                        {
                                              "label": "Yes, active emergency",
                                              "value": "Yes, active emergency"
                                        },
                                        {
                                              "label": "Possible safety issue, not immediate",
                                              "value": "Possible safety issue, not immediate"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "warning": "If there is an immediate threat, active medical emergency, crime, disappearance, violence, or danger to life, contact local emergency services, hotel security, venue security, police, ambulance, or your professional security provider immediately. This intake is not an emergency response channel.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q51",
                                  "source_tally_qid": "Q51",
                                  "label": "Do you need professional security / close protection?",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "No",
                                              "value": "No"
                                        },
                                        {
                                              "label": "Maybe",
                                              "value": "Maybe"
                                        },
                                        {
                                              "label": "Yes, likely",
                                              "value": "Yes, likely"
                                        },
                                        {
                                              "label": "Already arranged",
                                              "value": "Already arranged"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "warning": "Professional security, close protection, medical support, or licensed specialist support must be scoped separately with appropriate providers.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q52",
                                  "source_tally_qid": "Q52",
                                  "label": "Any mobility, dietary, health, or accessibility needs relevant to planning?",
                                  "type": "textarea",
                                  "required": false,
                                  "helper": "Only include planning-relevant details. Do not submit full medical records."
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "budget_execution_readiness",
                      "title": "Budget / Scope / Execution Readiness",
                      "fields": [
                            {
                                  "id": "q53",
                                  "source_tally_qid": "Q53",
                                  "label": "Budget posture",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Review only for now",
                                              "value": "Review only for now"
                                        },
                                        {
                                              "label": "Open to $1,250+ route brief if appropriate",
                                              "value": "Open to $1,250+ route brief if appropriate"
                                        },
                                        {
                                              "label": "Open to $2,950+ coordination file if appropriate",
                                              "value": "Open to $2,950+ coordination file if appropriate"
                                        },
                                        {
                                              "label": "Open to $10,000+ private access / multi-day coordination",
                                              "value": "Open to $10,000+ private access / multi-day coordination"
                                        },
                                        {
                                              "label": "Open to $25,000+ elite retainer if appropriate",
                                              "value": "Open to $25,000+ elite retainer if appropriate"
                                        },
                                        {
                                              "label": "Budget depends on feasibility",
                                              "value": "Budget depends on feasibility"
                                        },
                                        {
                                              "label": "Prefer not to say yet",
                                              "value": "Prefer not to say yet"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q54",
                                  "source_tally_qid": "Q54",
                                  "label": "What should be included in the quote if viable?",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Route brief",
                                              "value": "Route brief"
                                        },
                                        {
                                              "label": "Reservation support",
                                              "value": "Reservation support"
                                        },
                                        {
                                              "label": "Ticket / event access review",
                                              "value": "Ticket / event access review"
                                        },
                                        {
                                              "label": "Venue language / Japanese communication",
                                              "value": "Venue language / Japanese communication"
                                        },
                                        {
                                              "label": "Local liaison calls",
                                              "value": "Local liaison calls"
                                        },
                                        {
                                              "label": "On-site attendance / local representation",
                                              "value": "On-site attendance / local representation"
                                        },
                                        {
                                              "label": "Companion presence",
                                              "value": "Companion presence"
                                        },
                                        {
                                              "label": "Yamato-led presence review",
                                              "value": "Yamato-led presence review"
                                        },
                                        {
                                              "label": "Shopping route",
                                              "value": "Shopping route"
                                        },
                                        {
                                              "label": "Nightlife route",
                                              "value": "Nightlife route"
                                        },
                                        {
                                              "label": "Private dining route",
                                              "value": "Private dining route"
                                        },
                                        {
                                              "label": "Cultural access route",
                                              "value": "Cultural access route"
                                        },
                                        {
                                              "label": "Transport coordination",
                                              "value": "Transport coordination"
                                        },
                                        {
                                              "label": "Multi-day itinerary architecture",
                                              "value": "Multi-day itinerary architecture"
                                        },
                                        {
                                              "label": "Retainer support",
                                              "value": "Retainer support"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ],
                                  "step_blocking": true
                            },
                            {
                                  "id": "q55",
                                  "source_tally_qid": "Q55",
                                  "label": "Are third-party costs expected?",
                                  "type": "checkbox_group",
                                  "required": false,
                                  "options": [
                                        {
                                              "label": "Restaurants / dining",
                                              "value": "Restaurants / dining"
                                        },
                                        {
                                              "label": "Tickets",
                                              "value": "Tickets"
                                        },
                                        {
                                              "label": "Venues",
                                              "value": "Venues"
                                        },
                                        {
                                              "label": "Private rooms",
                                              "value": "Private rooms"
                                        },
                                        {
                                              "label": "Drivers / transport",
                                              "value": "Drivers / transport"
                                        },
                                        {
                                              "label": "Interpreters",
                                              "value": "Interpreters"
                                        },
                                        {
                                              "label": "Local providers",
                                              "value": "Local providers"
                                        },
                                        {
                                              "label": "Companion / attendance fees",
                                              "value": "Companion / attendance fees"
                                        },
                                        {
                                              "label": "Security providers",
                                              "value": "Security providers"
                                        },
                                        {
                                              "label": "Travel / meals / waiting time",
                                              "value": "Travel / meals / waiting time"
                                        },
                                        {
                                              "label": "Not sure",
                                              "value": "Not sure"
                                        }
                                  ]
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "supporting_context",
                      "title": "Supporting Context",
                      "fields": [
                            {
                                  "id": "q56",
                                  "source_tally_qid": "Q56",
                                  "label": "Useful non-sensitive documents or upload notes",
                                  "type": "textarea",
                                  "required": false,
                                  "helper": "Native intake stores controlled text by default. Mention rough itinerary, event links, restaurant list, shopping wishlist, timing chart, assistant brief, or venue email thread. Do not upload passports, medical records, confidential contracts, private addresses, hotel room numbers, or unauthorized third-party information."
                            },
                            {
                                  "id": "q57",
                                  "source_tally_qid": "Q57",
                                  "label": "Links or references",
                                  "type": "textarea",
                                  "required": false,
                                  "helper": "Add public links, venue pages, event pages, restaurant pages, public schedules, or relevant reference links."
                            },
                            {
                                  "id": "q58",
                                  "source_tally_qid": "Q58",
                                  "label": "Anything we must avoid?",
                                  "type": "textarea",
                                  "required": true,
                                  "placeholder": "Examples: No public waiting, no fan interaction, no crowded club, no staff announcing name, no photos, no direct client calls, no luxury theater.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q59",
                                  "source_tally_qid": "Q59",
                                  "label": "Anything the client especially wants?",
                                  "type": "textarea",
                                  "required": true,
                                  "placeholder": "Examples: calm, privacy, beautiful food, meaningful local access, warm companion energy, no chaos, excellent timing, low-profile shopping, private room, good exit path.",
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                },
                {
                      "id": "final_compliance_confirmation",
                      "title": "Final Confirmation",
                      "fields": [
                            {
                                  "id": "q60",
                                  "source_tally_qid": "Q60",
                                  "label": "Confirm the request is legitimate and authorized",
                                  "type": "checkbox_group",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "I confirm this request is legitimate and client-centered.",
                                              "value": "I confirm this request is legitimate and client-centered."
                                        },
                                        {
                                              "label": "I confirm I am authorized to submit this request or I am submitting only a general inquiry without private personal details.",
                                              "value": "I confirm I am authorized to submit this request or I am submitting only a general inquiry without private personal details."
                                        },
                                        {
                                              "label": "I confirm I am not asking JapanSolved™ to stalk, locate, follow, photograph, access, expose, or contact a public figure without authorization.",
                                              "value": "I confirm I am not asking JapanSolved™ to stalk, locate, follow, photograph, access, expose, or contact a public figure without authorization."
                                        },
                                        {
                                              "label": "I confirm I understand private access, reservations, companion presence, Yamato-led support, venue coordination, tickets, transport, security, and execution are subject to review, availability, lawful feasibility, and separate quotation.",
                                              "value": "I confirm I understand private access, reservations, companion presence, Yamato-led support, venue coordination, tickets, transport, security, and execution are subject to review, availability, lawful feasibility, and separate quotation."
                                        },
                                        {
                                              "label": "I confirm urgent requests may require priority-handling premiums or may be declined if proper handling is not possible.",
                                              "value": "I confirm urgent requests may require priority-handling premiums or may be declined if proper handling is not possible."
                                        }
                                  ],
                                  "require_all": true,
                                  "step_blocking": true
                            },
                            {
                                  "id": "q61",
                                  "source_tally_qid": "Q61",
                                  "label": "Final summary",
                                  "type": "textarea",
                                  "required": true,
                                  "helper": "In 5-10 lines, summarize the file: who the client is generally, where in Japan, target date, desired outcome, privacy concern, and what must not happen.",
                                  "step_blocking": true
                            },
                            {
                                  "id": "q62",
                                  "source_tally_qid": "Q62",
                                  "label": "Preferred next step",
                                  "type": "radio",
                                  "required": true,
                                  "options": [
                                        {
                                              "label": "Please review my paid compatibility review file",
                                              "value": "Please review my paid compatibility review file"
                                        },
                                        {
                                              "label": "Please tell me which product / pathway to purchase",
                                              "value": "Please tell me which product / pathway to purchase"
                                        },
                                        {
                                              "label": "Please classify this request first",
                                              "value": "Please classify this request first"
                                        },
                                        {
                                              "label": "Please consider this for elite retainer support",
                                              "value": "Please consider this for elite retainer support"
                                        },
                                        {
                                              "label": "Please route this into another JapanSolved™ desk",
                                              "value": "Please route this into another JapanSolved™ desk"
                                        },
                                        {
                                              "label": "Please treat this as unpaid reference only",
                                              "value": "Please treat this as unpaid reference only"
                                        }
                                  ],
                                  "step_blocking": true
                            }
                      ],
                      "validate_before_next": true
                }
          ],
          "final_confirmations": [
                "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
                "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
                "I understand submission does not guarantee private access, reservations, companion presence, Yamato-led support, venue coordination, tickets, transport, security, third-party cooperation, or execution.",
                "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
                "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
          ],
          "conditional_rules": [
                "If unauthorized celebrity access, stalking, paparazzi, private-address hunting, hotel-floor access, backstage circumvention, private schedule hunting, or fan-route behavior is selected, do not assist and route to the disqualified boundary screen.",
                "If timing is today, within 24 hours, or within 2-3 days, show rush/priority-handling language and tag internally as RUSH_72H_PRIVATE_ACCESS.",
                "If professional security or close protection is needed, show security separation language and tag SECURITY_SCOPE_SEPARATE.",
                "If Yamato-led presence is selected, tag YAMATO_PRIVATE_PRESENCE_REVIEW.",
                "If unpaid/routing-only is selected, treat as routing reference only until payment is matched."
          ],
          "end_screens": {
                "disqualified_unauthorized_access": {
                      "title": "We cannot assist with this request",
                      "message": "JapanSolved™ cannot help with unauthorized celebrity access, stalking, paparazzi activity, private-address searches, hotel-floor access, backstage circumvention, private schedules, staff bypassing, fan-interaction routes, or attempts to contact or follow public figures without authorization."
                },
                "paid_file": {
                      "title": "Private access file received",
                      "message": "Thank you. Your Japan Celebrity Concierge & Private Access Desk™ intake has been received. If your review has already been purchased, we will treat this as an active case file and review the request for privacy needs, feasibility, routing, timing, local representation, companion layer, and appropriate specialist desk involvement."
                },
                "unpaid_reference": {
                      "title": "Routing reference received",
                      "message": "Thank you. Your private access intake has been received as routing reference. Unpaid submissions may not be reviewed as active case files. To begin paid review, purchase Japan Celebrity Concierge Compatibility Review™ from the landing page."
                },
                "urgent_file": {
                      "title": "Urgent private access request received",
                      "message": "Requests within three days may require priority-handling premiums, reduced scope, or refusal if proper handling is not possible. If there is an active emergency, contact local emergency services, hotel security, venue security, police, ambulance, or your professional security provider immediately."
                }
          },
          "email_subject": "[Page 31 Private Access] {client_name} - {q24} - {q25}",
          "email_preview_fields": [
                "client_name",
                "contact_email",
                "q10",
                "q4",
                "q5",
                "q13",
                "q16",
                "q19",
                "q20",
                "q24",
                "q25",
                "q29",
                "q42",
                "q44",
                "q53",
                "q61",
                "q62"
          ],
          "admin_tags": [
                "CELEBRITY_PRIVATE_ACCESS",
                "LOW_PROFILE_PROGRAM",
                "PRIVATE_DINING",
                "TICKET_EVENT_ACCESS",
                "PERSONAL_SHOPPING_STYLING",
                "NIGHTLIFE_SAFETY",
                "VIP_TRAVEL_NAVIGATION",
                "BESPOKE_ITINERARY",
                "LOCAL_REPRESENTATION",
                "CULTURAL_ACCESS",
                "ELITE_RETAINER",
                "RUSH_PRIORITY",
                "UNPAID_REFERENCE_ONLY",
                "DO_NOT_ASSIST_BOUNDARY",
                "YAMATO_PRIVATE_PRESENCE_REVIEW",
                "SECURITY_SCOPE_SEPARATE",
                "PAYMENT_FIRST",
                "REGISTRY_BANK_V3_Q62"
          ],
          "client_microcopy_top": "This intake is designed for discretion-sensitive Japan requests where visibility, privacy, timing, venue language, route design, or companion presence matters. Please do not submit private addresses, hotel room numbers, passport details, private schedules, confidential contracts, medical records, or unauthorized third-party personal information. If you are not the principal traveler or authorized representative, keep the request general.",
          "qa_notes": "Page 31 full Q1-Q62 DOCX question set baked into Native Intake registry. Verify product pricing/URLs and renderer support for conditional displays before publishing.",
          "engine_capability_level": "phase_1_native_structured_payload_mode_q62",
          "phase_2_upgrade_path": "App proxy can verify orders, store submissions, handle files, and create a case ID.",
          "intake_bank_extraction": {
                "source_file": "Missing Tally Intake Intelligence.docx",
                "source_mode": "docx_tally_spec_reconstruction_full_q1_q62",
                "stored_in_registry_bank": true,
                "generated_at": "2026-07-03 10:27:46 UTC",
                "original_tally_question_count": 62,
                "native_field_count": 62,
                "hardened_final_confirmation_field_count": 5,
                "final_bridge_pass": "CELEBRITY_Q7_Q8_CANONICAL_EMAIL_VALIDATION_FINAL01"
          },
          "canonical_fields": {
                "client_name": "client_name",
                "contact_email": "contact_email",
                "phone_or_messenger": "phone_or_messenger",
                "payment_reference": "q5",
                "payment_status": "q4",
                "urgency": "q24",
                "main_request_category": "q25",
                "preferred_next_step": "q62"
          },
          "field_aliases": {
                "client_name": [
                      "q7",
                      "Q7",
                      "your_full_name",
                      "requester_name",
                      "full_name"
                ],
                "contact_email": [
                      "q8",
                      "Q8",
                      "your_email_address",
                      "email",
                      "client_email",
                      "best_contact_email",
                      "checkout_email"
                ],
                "phone_or_messenger": [
                      "q9",
                      "Q9",
                      "phone_whatsapp_signal_contact"
                ],
                "payment_reference": [
                      "q5",
                      "Q5",
                      "payment_order_number_or_checkout_email"
                ],
                "payment_status": [
                      "q4",
                      "Q4"
                ],
                "urgency": [
                      "q24",
                      "Q24"
                ],
                "main_request_category": [
                      "q25",
                      "Q25"
                ]
          },
          "required_identity_fields": [
                "client_name",
                "contact_email"
          ],
          "validation_policy": {
                "validate_required_fields_before_step_advance": true,
                "validate_email_fields_before_step_advance": true,
                "validate_contact_email_before_final_review": true,
                "validate_contact_email_before_submit": true,
                "contact_email_canonical_key": "contact_email",
                "contact_email_format_hint": "Use one @ symbol and a real domain, such as name@example.com.",
                "late_submit_email_error_fix": "The email field is canonicalized to contact_email and carries step_blocking email validation so the error appears on the email step, not only on final send.",
                "tally_reconstructed_record": true
          },
          "option_value_mode": "human_readable_values_with_legacy_value_bridge",
          "legacy_value_policy": "legacy snake_case values removed from live option objects; template bridge can prettify old cached answers if encountered",
          "legacy_display_map": {
                "i_am_requesting_support_for_myself_as_the_principal_traveler": "I am requesting support for myself as the principal traveler",
                "i_am_an_authorized_assistant_manager_agent_producer_family_office_contact_travel": "I am an authorized assistant, manager, agent, producer, family-office contact, travel planner, concierge, or representative",
                "i_am_requesting_on_behalf_of_a_private_family_executive_artist_public_figure_fou": "I am requesting on behalf of a private family, executive, artist, public figure, founder, or VIP guest",
                "i_am_exploring_whether_this_desk_is_appropriate_before_sharing_sensitive_details": "I am exploring whether this desk is appropriate before sharing sensitive details",
                "i_am_trying_to_meet_contact_follow_photograph_locate_or_access_a_public_figure_w": "I am trying to meet, contact, follow, photograph, locate, or access a public figure without authorization",
                "other": "Other",
                "yes_i_am_the_principal_traveler": "Yes, I am the principal traveler",
                "yes_i_am_an_authorized_representative": "Yes, I am an authorized representative",
                "yes_i_am_part_of_the_client_s_team_or_household": "Yes, I am part of the client’s team or household",
                "i_am_exploring_first_and_will_provide_authorization_later": "I am exploring first and will provide authorization later",
                "no_i_am_not_authorized": "No, I am not authorized",
                "not_sure": "Not sure",
                "i_understand_this_desk_does_not_guarantee_access_to_people_venues_events_clubs_p": "I understand this desk does not guarantee access to people, venues, events, clubs, private rooms, restaurants, backstage areas, member spaces, or private residences.",
                "i_understand_this_desk_does_not_assist_with_stalking_paparazzi_work_private_addr": "I understand this desk does not assist with stalking, paparazzi work, private-address hunting, unauthorized celebrity contact, private schedules, hotel-floor access, or bypassing staff.",
                "i_understand_paid_files_are_prioritized_and_unpaid_submissions_may_be_treated_on": "I understand paid files are prioritized and unpaid submissions may be treated only as routing reference.",
                "i_understand_professional_security_medical_support_close_protection_and_licensed": "I understand professional security, medical support, close protection, and licensed specialist services must be scoped separately if needed.",
                "yes_i_purchased_japan_celebrity_concierge_compatibility_review": "Yes, I purchased Japan Celebrity Concierge Compatibility Review™",
                "not_yet_but_i_intend_to_purchase_before_review": "Not yet, but I intend to purchase before review",
                "i_was_instructed_to_submit_this_intake_first": "I was instructed to submit this intake first",
                "i_am_submitting_an_unpaid_routing_reference_only": "I am submitting an unpaid routing reference only",
                "i_am_requesting_elite_retainer_consideration": "I am requesting elite retainer consideration",
                "japan_celebrity_concierge_compatibility_review": "Japan Celebrity Concierge Compatibility Review™",
                "japan_low_profile_access_route_brief": "Japan Low-Profile Access Route Brief™",
                "japan_private_access_coordination_file": "Japan Private Access Coordination File™",
                "japan_discreet_executive_celebrity_companion_retainer": "Japan Discreet Executive / Celebrity Companion Retainer™",
                "not_sure_please_route_the_case": "Not sure, please route the case",
                "i_need_urgent_triage": "I need urgent triage",
                "principal_traveler": "Principal traveler",
                "personal_assistant": "Personal assistant",
                "executive_assistant": "Executive assistant",
                "manager_agent": "Manager / agent",
                "family_office": "Family office",
                "producer_production_coordinator": "Producer / production coordinator",
                "private_travel_planner": "Private travel planner",
                "concierge_lifestyle_manager": "Concierge / lifestyle manager",
                "family_member": "Family member",
                "security_close_protection_contact": "Security / close protection contact",
                "friend_or_invited_guest": "Friend or invited guest",
                "email_first": "Email first",
                "whatsapp_preferred": "WhatsApp preferred",
                "signal_preferred": "Signal preferred",
                "phone_call_only_after_initial_review": "Phone call only after initial review",
                "assistant_team_contact_only": "Assistant/team contact only",
                "not_sure_yet": "Not sure yet",
                "public_figure": "Public figure",
                "artist_performer": "Artist / performer",
                "actor_media_personality": "Actor / media personality",
                "musician_dj_creative_talent": "Musician / DJ / creative talent",
                "athlete": "Athlete",
                "founder_entrepreneur": "Founder / entrepreneur",
                "executive_board_level_client": "Executive / board-level client",
                "family_office_guest": "Family-office guest",
                "private_family": "Private family",
                "collector_patron": "Collector / patron",
                "production_or_appearance_related_team": "Production or appearance-related team",
                "high_discretion_traveler_who_is_not_publicly_known": "High-discretion traveler who is not publicly known",
                "no_general_profile_is_enough_for_now": "No, general profile is enough for now",
                "yes_i_am_authorized_to_disclose_the_name": "Yes, I am authorized to disclose the name",
                "yes_but_i_prefer_to_disclose_after_paid_review_nda_discussion": "Yes, but I prefer to disclose after paid review / NDA discussion",
                "very_high_visibility_likely_to_be_recognized": "Very high visibility, likely to be recognized",
                "moderate_visibility_may_be_recognized_in_certain_areas": "Moderate visibility, may be recognized in certain areas",
                "industry_visibility_not_broadly_public": "Industry visibility, not broadly public",
                "private_high_net_worth_family_office_not_publicly_known": "Private high-net-worth / family office, not publicly known",
                "prefer_not_to_say_yet": "Prefer not to say yet",
                "public_recognition": "Public recognition",
                "social_media_attention": "Social media attention",
                "fan_attention": "Fan attention",
                "press_paparazzi_risk": "Press / paparazzi risk",
                "business_reputation": "Business reputation",
                "family_privacy": "Family privacy",
                "staff_entourage_complexity": "Staff / entourage complexity",
                "prior_incident_or_concern": "Prior incident or concern",
                "sensitive_venue_or_event": "Sensitive venue or event",
                "medical_recovery_wellness_context": "Medical / recovery / wellness context",
                "security_concern": "Security concern",
                "client_simply_wants_a_low_profile_trip": "Client simply wants a low-profile trip",
                "yes_already_in_japan": "Yes, already in Japan",
                "arriving_soon": "Arriving soon",
                "trip_is_planned_but_not_booked": "Trip is planned but not booked",
                "exploring_before_booking": "Exploring before booking",
                "tokyo": "Tokyo",
                "kyoto": "Kyoto",
                "osaka": "Osaka",
                "kobe": "Kobe",
                "nara": "Nara",
                "hakone": "Hakone",
                "fuji_area": "Fuji area",
                "hokkaido": "Hokkaido",
                "okinawa": "Okinawa",
                "nagoya": "Nagoya",
                "fukuoka": "Fukuoka",
                "multiple_cities": "Multiple cities",
                "today_within_24_hours": "Today / within 24 hours",
                "within_2_3_days": "Within 2-3 days",
                "within_4_7_days": "Within 4-7 days",
                "within_2_weeks": "Within 2 weeks",
                "within_1_month": "Within 1 month",
                "more_than_1_month_away": "More than 1 month away",
                "flexible": "Flexible",
                "low_profile_japan_itinerary_private_access_review": "Low-profile Japan itinerary / private access review",
                "private_dining_or_chef_counter_privacy": "Private dining or chef-counter privacy",
                "restaurant_private_room_arrival_route": "Restaurant private room / arrival route",
                "event_concert_sports_exhibition_or_entertainment_access": "Event, concert, sports, exhibition, or entertainment access",
                "appointment_style_shopping_route": "Appointment-style shopping route",
                "luxury_vintage_jewelry_styling_support": "Luxury / vintage / jewelry / styling support",
                "art_antiques_gallery_or_collector_access": "Art, antiques, gallery, or collector access",
                "nightlife_route_with_companion_safe_return_layer": "Nightlife route with companion / safe return layer",
                "hotel_to_venue_movement_planning": "Hotel-to-venue movement planning",
                "local_liaison_japan_side_representation": "Local liaison / Japan-side representation",
                "yamato_led_private_presence_review": "Yamato-led private presence review",
                "cultural_access_host_style_introduction": "Cultural access / host-style introduction",
                "multi_day_executive_or_celebrity_itinerary_architecture": "Multi-day executive or celebrity itinerary architecture",
                "elite_retainer_full_discretion_wrap": "Elite retainer / full discretion wrap",
                "not_sure_please_classify_the_request": "Not sure, please classify the request",
                "avoid_public_queues": "Avoid public queues",
                "avoid_crowded_entrances": "Avoid crowded entrances",
                "avoid_lobby_exposure": "Avoid lobby exposure",
                "avoid_being_photographed": "Avoid being photographed",
                "avoid_public_discussion_of_the_client_s_identity": "Avoid public discussion of the client’s identity",
                "avoid_staff_confusion": "Avoid staff confusion",
                "avoid_fan_interaction": "Avoid fan interaction",
                "avoid_press_paparazzi_attention": "Avoid press / paparazzi attention",
                "avoid_social_media_tagging": "Avoid social media tagging",
                "avoid_over_formal_vip_treatment": "Avoid over-formal VIP treatment",
                "avoid_awkward_restaurant_or_venue_explanations": "Avoid awkward restaurant or venue explanations",
                "avoid_the_client_solving_logistics_directly": "Avoid the client solving logistics directly",
                "keep_the_trip_warm_personal_and_human_not_sterile": "Keep the trip warm, personal, and human, not sterile",
                "very_invisible_background_coordination_only": "Very invisible, background coordination only",
                "low_profile_local_liaison_if_needed": "Low-profile local liaison if needed",
                "discreet_in_room_on_route_companion_presence": "Discreet in-room / on-route companion presence",
                "visible_concierge_support_is_acceptable": "Visible concierge support is acceptable",
                "depends_on_the_situation": "Depends on the situation",
                "no_photography_preferred": "No photography preferred",
                "no_social_posting_tagging": "No social posting / tagging",
                "no_staff_photos": "No staff photos",
                "no_public_mention_of_the_client": "No public mention of the client",
                "normal_discretion_is_enough": "Normal discretion is enough",
                "recent_public_attention": "Recent public attention",
                "press_risk": "Press risk",
                "fan_risk": "Fan risk",
                "family_child_privacy": "Family / child privacy",
                "business_confidentiality": "Business confidentiality",
                "health_recovery_context": "Health / recovery context",
                "relationship_social_sensitivity": "Relationship / social sensitivity",
                "prior_incident": "Prior incident",
                "none_known": "None known",
                "prefer_to_discuss_later": "Prefer to discuss later",
                "yes_we_have_specific_targets": "Yes, we have specific targets",
                "some_ideas_but_flexible": "Some ideas, but flexible",
                "no_we_need_recommendations_and_routing": "No, we need recommendations and routing",
                "we_only_need_discretion_strategy": "We only need discretion strategy",
                "public_booking_handled_discreetly": "Public booking handled discreetly",
                "private_room_private_table_request": "Private room / private table request",
                "appointment_style_shopping": "Appointment-style shopping",
                "timed_entry_timed_arrival": "Timed entry / timed arrival",
                "separate_entrance_or_quieter_arrival_logic": "Separate entrance or quieter arrival logic",
                "local_liaison_call_japanese_language_coordination": "Local liaison call / Japanese-language coordination",
                "private_guide_companion_layer": "Private guide / companion layer",
                "after_hours_or_special_viewing_request": "After-hours or special viewing request",
                "event_ticket_access_path_review": "Event ticket / access path review",
                "staff_communication_wording_support": "Staff communication / wording support",
                "exit_plan_safe_return_route": "Exit plan / safe return route",
                "yes": "Yes",
                "maybe": "Maybe",
                "no": "No",
                "hotel_to_restaurant_movement": "Hotel-to-restaurant movement",
                "hotel_to_event_movement": "Hotel-to-event movement",
                "airport_arrival_departure_coordination": "Airport arrival / departure coordination",
                "station_taxi_vehicle_route_planning": "Station / taxi / vehicle route planning",
                "entrance_timing": "Entrance timing",
                "exit_timing": "Exit timing",
                "rain_weather_backup": "Rain / weather backup",
                "crowd_avoidance": "Crowd avoidance",
                "multi_stop_route_sequencing": "Multi-stop route sequencing",
                "staff_handoff_points": "Staff handoff points",
                "companion_or_liaison_presence": "Companion or liaison presence",
                "already_arranged": "Already arranged",
                "need_private_car_driver_recommendations": "Need private car / driver recommendations",
                "need_route_logic_only": "Need route logic only",
                "need_companion_liaison_to_ride_or_meet": "Need companion / liaison to ride or meet",
                "already_booked_and_can_disclose_later": "Already booked and can disclose later",
                "already_booked_but_should_not_be_disclosed_in_form": "Already booked but should not be disclosed in form",
                "need_hotel_area_strategy": "Need hotel area strategy",
                "need_privacy_sensitive_hotel_logic": "Need privacy-sensitive hotel logic",
                "not_applicable": "Not applicable",
                "yes_definitely": "Yes, definitely",
                "possibly": "Possibly",
                "only_for_one_part_of_the_trip": "Only for one part of the trip",
                "no_background_coordination_only": "No, background coordination only",
                "quiet_cultural_support": "Quiet cultural support",
                "restaurant_venue_language": "Restaurant / venue language",
                "shopping_route_presence": "Shopping route presence",
                "nightlife_companion_safety_layer": "Nightlife companion / safety layer",
                "soft_social_buffering": "Soft social buffering",
                "translation_interpretation_support": "Translation / interpretation support",
                "local_etiquette_support": "Local etiquette support",
                "route_timing_and_movement_support": "Route timing and movement support",
                "conversation_warmth_personal_ease": "Conversation / warmth / personal ease",
                "female_companion_preferred": "Female companion preferred",
                "male_companion_preferred": "Male companion preferred",
                "no_gender_preference": "No gender preference",
                "yes_specifically_interested_in_yamato_led_presence": "Yes, specifically interested in Yamato-led presence",
                "open_to_yamato_if_appropriate": "Open to Yamato if appropriate",
                "mentioned_only_as_a_possibility": "Mentioned only as a possibility",
                "need_to_understand_fit_first": "Need to understand fit first",
                "1_person": "1 person",
                "2_people": "2 people",
                "3_4_people": "3-4 people",
                "5_8_people": "5-8 people",
                "9_15_people": "9-15 people",
                "more_than_15": "More than 15",
                "principal_traveler_directly": "Principal traveler directly",
                "assistant_manager": "Assistant / manager",
                "travel_planner": "Travel planner",
                "concierge": "Concierge",
                "producer_team_coordinator": "Producer / team coordinator",
                "security_contact": "Security contact",
                "mixed_contacts": "Mixed contacts",
                "i_can_approve": "I can approve",
                "principal_approves": "Principal approves",
                "assistant_manager_approves": "Assistant / manager approves",
                "family_office_approves": "Family office approves",
                "company_production_team_approves": "Company / production team approves",
                "approval_chain_is_unclear": "Approval chain is unclear",
                "management": "Management",
                "assistant_team": "Assistant team",
                "security_team": "Security team",
                "travel_agency": "Travel agency",
                "production_team": "Production team",
                "pr_communications": "PR / communications",
                "hotel_concierge": "Hotel concierge",
                "driver_transport_provider": "Driver / transport provider",
                "personal_stylist_shopper": "Personal stylist / shopper",
                "interpreter": "Interpreter",
                "no_simple_party": "No, simple party",
                "yes_active_emergency": "Yes, active emergency",
                "possible_safety_issue_not_immediate": "Possible safety issue, not immediate",
                "yes_likely": "Yes, likely",
                "review_only_for_now": "Review only for now",
                "open_to_1_250_route_brief_if_appropriate": "Open to $1,250+ route brief if appropriate",
                "open_to_2_950_coordination_file_if_appropriate": "Open to $2,950+ coordination file if appropriate",
                "open_to_10_000_private_access_multi_day_coordination": "Open to $10,000+ private access / multi-day coordination",
                "open_to_25_000_elite_retainer_if_appropriate": "Open to $25,000+ elite retainer if appropriate",
                "budget_depends_on_feasibility": "Budget depends on feasibility",
                "route_brief": "Route brief",
                "reservation_support": "Reservation support",
                "ticket_event_access_review": "Ticket / event access review",
                "venue_language_japanese_communication": "Venue language / Japanese communication",
                "local_liaison_calls": "Local liaison calls",
                "on_site_attendance_local_representation": "On-site attendance / local representation",
                "companion_presence": "Companion presence",
                "yamato_led_presence_review": "Yamato-led presence review",
                "shopping_route": "Shopping route",
                "nightlife_route": "Nightlife route",
                "private_dining_route": "Private dining route",
                "cultural_access_route": "Cultural access route",
                "transport_coordination": "Transport coordination",
                "multi_day_itinerary_architecture": "Multi-day itinerary architecture",
                "retainer_support": "Retainer support",
                "restaurants_dining": "Restaurants / dining",
                "tickets": "Tickets",
                "venues": "Venues",
                "private_rooms": "Private rooms",
                "drivers_transport": "Drivers / transport",
                "interpreters": "Interpreters",
                "local_providers": "Local providers",
                "companion_attendance_fees": "Companion / attendance fees",
                "security_providers": "Security providers",
                "travel_meals_waiting_time": "Travel / meals / waiting time",
                "i_confirm_this_request_is_legitimate_and_client_centered": "I confirm this request is legitimate and client-centered.",
                "i_confirm_i_am_authorized_to_submit_this_request_or_i_am_submitting_only_a_gener": "I confirm I am authorized to submit this request or I am submitting only a general inquiry without private personal details.",
                "i_confirm_i_am_not_asking_japansolved_to_stalk_locate_follow_photograph_access_e": "I confirm I am not asking JapanSolved™ to stalk, locate, follow, photograph, access, expose, or contact a public figure without authorization.",
                "i_confirm_i_understand_private_access_reservations_companion_presence_yamato_led": "I confirm I understand private access, reservations, companion presence, Yamato-led support, venue coordination, tickets, transport, security, and execution are subject to review, availability, lawful feasibility, and separate quotation.",
                "i_confirm_urgent_requests_may_require_priority_handling_premiums_or_may_be_decli": "I confirm urgent requests may require priority-handling premiums or may be declined if proper handling is not possible.",
                "please_review_my_paid_compatibility_review_file": "Please review my paid compatibility review file",
                "please_tell_me_which_product_pathway_to_purchase": "Please tell me which product / pathway to purchase",
                "please_classify_this_request_first": "Please classify this request first",
                "please_consider_this_for_elite_retainer_support": "Please consider this for elite retainer support",
                "please_route_this_into_another_japansolved_desk": "Please route this into another JapanSolved™ desk",
                "please_treat_this_as_unpaid_reference_only": "Please treat this as unpaid reference only",
                "I am requesting support for myself as the principal traveler": "I am requesting support for myself as the principal traveler",
                "I am an authorized assistant, manager, agent, producer, family-office contact, travel planner, concierge, or representative": "I am an authorized assistant, manager, agent, producer, family-office contact, travel planner, concierge, or representative",
                "I am requesting on behalf of a private family, executive, artist, public figure, founder, or VIP guest": "I am requesting on behalf of a private family, executive, artist, public figure, founder, or VIP guest",
                "I am exploring whether this desk is appropriate before sharing sensitive details": "I am exploring whether this desk is appropriate before sharing sensitive details",
                "I am trying to meet, contact, follow, photograph, locate, or access a public figure without authorization": "I am trying to meet, contact, follow, photograph, locate, or access a public figure without authorization",
                "Other": "Other",
                "Yes, I am the principal traveler": "Yes, I am the principal traveler",
                "Yes, I am an authorized representative": "Yes, I am an authorized representative",
                "Yes, I am part of the client’s team or household": "Yes, I am part of the client’s team or household",
                "I am exploring first and will provide authorization later": "I am exploring first and will provide authorization later",
                "No, I am not authorized": "No, I am not authorized",
                "Not sure": "Not sure",
                "I understand this desk does not guarantee access to people, venues, events, clubs, private rooms, restaurants, backstage areas, member spaces, or private residences.": "I understand this desk does not guarantee access to people, venues, events, clubs, private rooms, restaurants, backstage areas, member spaces, or private residences.",
                "I understand this desk does not assist with stalking, paparazzi work, private-address hunting, unauthorized celebrity contact, private schedules, hotel-floor access, or bypassing staff.": "I understand this desk does not assist with stalking, paparazzi work, private-address hunting, unauthorized celebrity contact, private schedules, hotel-floor access, or bypassing staff.",
                "I understand paid files are prioritized and unpaid submissions may be treated only as routing reference.": "I understand paid files are prioritized and unpaid submissions may be treated only as routing reference.",
                "I understand professional security, medical support, close protection, and licensed specialist services must be scoped separately if needed.": "I understand professional security, medical support, close protection, and licensed specialist services must be scoped separately if needed.",
                "Yes, I purchased Japan Celebrity Concierge Compatibility Review™": "Yes, I purchased Japan Celebrity Concierge Compatibility Review™",
                "Not yet, but I intend to purchase before review": "Not yet, but I intend to purchase before review",
                "I was instructed to submit this intake first": "I was instructed to submit this intake first",
                "I am submitting an unpaid routing reference only": "I am submitting an unpaid routing reference only",
                "I am requesting elite retainer consideration": "I am requesting elite retainer consideration",
                "Japan Celebrity Concierge Compatibility Review™": "Japan Celebrity Concierge Compatibility Review™",
                "Japan Low-Profile Access Route Brief™": "Japan Low-Profile Access Route Brief™",
                "Japan Private Access Coordination File™": "Japan Private Access Coordination File™",
                "Japan Discreet Executive / Celebrity Companion Retainer™": "Japan Discreet Executive / Celebrity Companion Retainer™",
                "Not sure, please route the case": "Not sure, please route the case",
                "I need urgent triage": "I need urgent triage",
                "Principal traveler": "Principal traveler",
                "Personal assistant": "Personal assistant",
                "Executive assistant": "Executive assistant",
                "Manager / agent": "Manager / agent",
                "Family office": "Family office",
                "Producer / production coordinator": "Producer / production coordinator",
                "Private travel planner": "Private travel planner",
                "Concierge / lifestyle manager": "Concierge / lifestyle manager",
                "Family member": "Family member",
                "Security / close protection contact": "Security / close protection contact",
                "Friend or invited guest": "Friend or invited guest",
                "Email first": "Email first",
                "WhatsApp preferred": "WhatsApp preferred",
                "Signal preferred": "Signal preferred",
                "Phone call only after initial review": "Phone call only after initial review",
                "Assistant/team contact only": "Assistant/team contact only",
                "Not sure yet": "Not sure yet",
                "Public figure": "Public figure",
                "Artist / performer": "Artist / performer",
                "Actor / media personality": "Actor / media personality",
                "Musician / DJ / creative talent": "Musician / DJ / creative talent",
                "Athlete": "Athlete",
                "Founder / entrepreneur": "Founder / entrepreneur",
                "Executive / board-level client": "Executive / board-level client",
                "Family-office guest": "Family-office guest",
                "Private family": "Private family",
                "Collector / patron": "Collector / patron",
                "Production or appearance-related team": "Production or appearance-related team",
                "High-discretion traveler who is not publicly known": "High-discretion traveler who is not publicly known",
                "No, general profile is enough for now": "No, general profile is enough for now",
                "Yes, I am authorized to disclose the name": "Yes, I am authorized to disclose the name",
                "Yes, but I prefer to disclose after paid review / NDA discussion": "Yes, but I prefer to disclose after paid review / NDA discussion",
                "Very high visibility, likely to be recognized": "Very high visibility, likely to be recognized",
                "Moderate visibility, may be recognized in certain areas": "Moderate visibility, may be recognized in certain areas",
                "Industry visibility, not broadly public": "Industry visibility, not broadly public",
                "Private high-net-worth / family office, not publicly known": "Private high-net-worth / family office, not publicly known",
                "Prefer not to say yet": "Prefer not to say yet",
                "Public recognition": "Public recognition",
                "Social media attention": "Social media attention",
                "Fan attention": "Fan attention",
                "Press / paparazzi risk": "Press / paparazzi risk",
                "Business reputation": "Business reputation",
                "Family privacy": "Family privacy",
                "Staff / entourage complexity": "Staff / entourage complexity",
                "Prior incident or concern": "Prior incident or concern",
                "Sensitive venue or event": "Sensitive venue or event",
                "Medical / recovery / wellness context": "Medical / recovery / wellness context",
                "Security concern": "Security concern",
                "Client simply wants a low-profile trip": "Client simply wants a low-profile trip",
                "Yes, already in Japan": "Yes, already in Japan",
                "Arriving soon": "Arriving soon",
                "Trip is planned but not booked": "Trip is planned but not booked",
                "Exploring before booking": "Exploring before booking",
                "Tokyo": "Tokyo",
                "Kyoto": "Kyoto",
                "Osaka": "Osaka",
                "Kobe": "Kobe",
                "Nara": "Nara",
                "Hakone": "Hakone",
                "Fuji area": "Fuji area",
                "Hokkaido": "Hokkaido",
                "Okinawa": "Okinawa",
                "Nagoya": "Nagoya",
                "Fukuoka": "Fukuoka",
                "Multiple cities": "Multiple cities",
                "Today / within 24 hours": "Today / within 24 hours",
                "Within 2-3 days": "Within 2-3 days",
                "Within 4-7 days": "Within 4-7 days",
                "Within 2 weeks": "Within 2 weeks",
                "Within 1 month": "Within 1 month",
                "More than 1 month away": "More than 1 month away",
                "Flexible": "Flexible",
                "Low-profile Japan itinerary / private access review": "Low-profile Japan itinerary / private access review",
                "Private dining or chef-counter privacy": "Private dining or chef-counter privacy",
                "Restaurant private room / arrival route": "Restaurant private room / arrival route",
                "Event, concert, sports, exhibition, or entertainment access": "Event, concert, sports, exhibition, or entertainment access",
                "Appointment-style shopping route": "Appointment-style shopping route",
                "Luxury / vintage / jewelry / styling support": "Luxury / vintage / jewelry / styling support",
                "Art, antiques, gallery, or collector access": "Art, antiques, gallery, or collector access",
                "Nightlife route with companion / safe return layer": "Nightlife route with companion / safe return layer",
                "Hotel-to-venue movement planning": "Hotel-to-venue movement planning",
                "Local liaison / Japan-side representation": "Local liaison / Japan-side representation",
                "Yamato-led private presence review": "Yamato-led private presence review",
                "Cultural access / host-style introduction": "Cultural access / host-style introduction",
                "Multi-day executive or celebrity itinerary architecture": "Multi-day executive or celebrity itinerary architecture",
                "Elite retainer / full discretion wrap": "Elite retainer / full discretion wrap",
                "Not sure, please classify the request": "Not sure, please classify the request",
                "Avoid public queues": "Avoid public queues",
                "Avoid crowded entrances": "Avoid crowded entrances",
                "Avoid lobby exposure": "Avoid lobby exposure",
                "Avoid being photographed": "Avoid being photographed",
                "Avoid public discussion of the client’s identity": "Avoid public discussion of the client’s identity",
                "Avoid staff confusion": "Avoid staff confusion",
                "Avoid fan interaction": "Avoid fan interaction",
                "Avoid press / paparazzi attention": "Avoid press / paparazzi attention",
                "Avoid social media tagging": "Avoid social media tagging",
                "Avoid over-formal VIP treatment": "Avoid over-formal VIP treatment",
                "Avoid awkward restaurant or venue explanations": "Avoid awkward restaurant or venue explanations",
                "Avoid the client solving logistics directly": "Avoid the client solving logistics directly",
                "Keep the trip warm, personal, and human, not sterile": "Keep the trip warm, personal, and human, not sterile",
                "Very invisible, background coordination only": "Very invisible, background coordination only",
                "Low-profile local liaison if needed": "Low-profile local liaison if needed",
                "Discreet in-room / on-route companion presence": "Discreet in-room / on-route companion presence",
                "Visible concierge support is acceptable": "Visible concierge support is acceptable",
                "Depends on the situation": "Depends on the situation",
                "No photography preferred": "No photography preferred",
                "No social posting / tagging": "No social posting / tagging",
                "No staff photos": "No staff photos",
                "No public mention of the client": "No public mention of the client",
                "Normal discretion is enough": "Normal discretion is enough",
                "Recent public attention": "Recent public attention",
                "Press risk": "Press risk",
                "Fan risk": "Fan risk",
                "Family / child privacy": "Family / child privacy",
                "Business confidentiality": "Business confidentiality",
                "Health / recovery context": "Health / recovery context",
                "Relationship / social sensitivity": "Relationship / social sensitivity",
                "Prior incident": "Prior incident",
                "None known": "None known",
                "Prefer to discuss later": "Prefer to discuss later",
                "Yes, we have specific targets": "Yes, we have specific targets",
                "Some ideas, but flexible": "Some ideas, but flexible",
                "No, we need recommendations and routing": "No, we need recommendations and routing",
                "We only need discretion strategy": "We only need discretion strategy",
                "Public booking handled discreetly": "Public booking handled discreetly",
                "Private room / private table request": "Private room / private table request",
                "Appointment-style shopping": "Appointment-style shopping",
                "Timed entry / timed arrival": "Timed entry / timed arrival",
                "Separate entrance or quieter arrival logic": "Separate entrance or quieter arrival logic",
                "Local liaison call / Japanese-language coordination": "Local liaison call / Japanese-language coordination",
                "Private guide / companion layer": "Private guide / companion layer",
                "After-hours or special viewing request": "After-hours or special viewing request",
                "Event ticket / access path review": "Event ticket / access path review",
                "Staff communication / wording support": "Staff communication / wording support",
                "Exit plan / safe return route": "Exit plan / safe return route",
                "Yes": "Yes",
                "Maybe": "Maybe",
                "No": "No",
                "Hotel-to-restaurant movement": "Hotel-to-restaurant movement",
                "Hotel-to-event movement": "Hotel-to-event movement",
                "Airport arrival / departure coordination": "Airport arrival / departure coordination",
                "Station / taxi / vehicle route planning": "Station / taxi / vehicle route planning",
                "Entrance timing": "Entrance timing",
                "Exit timing": "Exit timing",
                "Rain / weather backup": "Rain / weather backup",
                "Crowd avoidance": "Crowd avoidance",
                "Multi-stop route sequencing": "Multi-stop route sequencing",
                "Staff handoff points": "Staff handoff points",
                "Companion or liaison presence": "Companion or liaison presence",
                "Already arranged": "Already arranged",
                "Need private car / driver recommendations": "Need private car / driver recommendations",
                "Need route logic only": "Need route logic only",
                "Need companion / liaison to ride or meet": "Need companion / liaison to ride or meet",
                "Already booked and can disclose later": "Already booked and can disclose later",
                "Already booked but should not be disclosed in form": "Already booked but should not be disclosed in form",
                "Need hotel area strategy": "Need hotel area strategy",
                "Need privacy-sensitive hotel logic": "Need privacy-sensitive hotel logic",
                "Not applicable": "Not applicable",
                "Yes, definitely": "Yes, definitely",
                "Possibly": "Possibly",
                "Only for one part of the trip": "Only for one part of the trip",
                "No, background coordination only": "No, background coordination only",
                "Quiet cultural support": "Quiet cultural support",
                "Restaurant / venue language": "Restaurant / venue language",
                "Shopping route presence": "Shopping route presence",
                "Nightlife companion / safety layer": "Nightlife companion / safety layer",
                "Soft social buffering": "Soft social buffering",
                "Translation / interpretation support": "Translation / interpretation support",
                "Local etiquette support": "Local etiquette support",
                "Route timing and movement support": "Route timing and movement support",
                "Conversation / warmth / personal ease": "Conversation / warmth / personal ease",
                "Female companion preferred": "Female companion preferred",
                "Male companion preferred": "Male companion preferred",
                "No gender preference": "No gender preference",
                "Yes, specifically interested in Yamato-led presence": "Yes, specifically interested in Yamato-led presence",
                "Open to Yamato if appropriate": "Open to Yamato if appropriate",
                "Mentioned only as a possibility": "Mentioned only as a possibility",
                "Need to understand fit first": "Need to understand fit first",
                "1 person": "1 person",
                "2 people": "2 people",
                "3-4 people": "3-4 people",
                "5-8 people": "5-8 people",
                "9-15 people": "9-15 people",
                "More than 15": "More than 15",
                "Principal traveler directly": "Principal traveler directly",
                "Assistant / manager": "Assistant / manager",
                "Travel planner": "Travel planner",
                "Concierge": "Concierge",
                "Producer / team coordinator": "Producer / team coordinator",
                "Security contact": "Security contact",
                "Mixed contacts": "Mixed contacts",
                "I can approve": "I can approve",
                "Principal approves": "Principal approves",
                "Assistant / manager approves": "Assistant / manager approves",
                "Family office approves": "Family office approves",
                "Company / production team approves": "Company / production team approves",
                "Approval chain is unclear": "Approval chain is unclear",
                "Management": "Management",
                "Assistant team": "Assistant team",
                "Security team": "Security team",
                "Travel agency": "Travel agency",
                "Production team": "Production team",
                "PR / communications": "PR / communications",
                "Hotel concierge": "Hotel concierge",
                "Driver / transport provider": "Driver / transport provider",
                "Personal stylist / shopper": "Personal stylist / shopper",
                "Interpreter": "Interpreter",
                "No, simple party": "No, simple party",
                "Yes, active emergency": "Yes, active emergency",
                "Possible safety issue, not immediate": "Possible safety issue, not immediate",
                "Yes, likely": "Yes, likely",
                "Review only for now": "Review only for now",
                "Open to $1,250+ route brief if appropriate": "Open to $1,250+ route brief if appropriate",
                "Open to $2,950+ coordination file if appropriate": "Open to $2,950+ coordination file if appropriate",
                "Open to $10,000+ private access / multi-day coordination": "Open to $10,000+ private access / multi-day coordination",
                "Open to $25,000+ elite retainer if appropriate": "Open to $25,000+ elite retainer if appropriate",
                "Budget depends on feasibility": "Budget depends on feasibility",
                "Route brief": "Route brief",
                "Reservation support": "Reservation support",
                "Ticket / event access review": "Ticket / event access review",
                "Venue language / Japanese communication": "Venue language / Japanese communication",
                "Local liaison calls": "Local liaison calls",
                "On-site attendance / local representation": "On-site attendance / local representation",
                "Companion presence": "Companion presence",
                "Yamato-led presence review": "Yamato-led presence review",
                "Shopping route": "Shopping route",
                "Nightlife route": "Nightlife route",
                "Private dining route": "Private dining route",
                "Cultural access route": "Cultural access route",
                "Transport coordination": "Transport coordination",
                "Multi-day itinerary architecture": "Multi-day itinerary architecture",
                "Retainer support": "Retainer support",
                "Restaurants / dining": "Restaurants / dining",
                "Tickets": "Tickets",
                "Venues": "Venues",
                "Private rooms": "Private rooms",
                "Drivers / transport": "Drivers / transport",
                "Interpreters": "Interpreters",
                "Local providers": "Local providers",
                "Companion / attendance fees": "Companion / attendance fees",
                "Security providers": "Security providers",
                "Travel / meals / waiting time": "Travel / meals / waiting time",
                "I confirm this request is legitimate and client-centered.": "I confirm this request is legitimate and client-centered.",
                "I confirm I am authorized to submit this request or I am submitting only a general inquiry without private personal details.": "I confirm I am authorized to submit this request or I am submitting only a general inquiry without private personal details.",
                "I confirm I am not asking JapanSolved™ to stalk, locate, follow, photograph, access, expose, or contact a public figure without authorization.": "I confirm I am not asking JapanSolved™ to stalk, locate, follow, photograph, access, expose, or contact a public figure without authorization.",
                "I confirm I understand private access, reservations, companion presence, Yamato-led support, venue coordination, tickets, transport, security, and execution are subject to review, availability, lawful feasibility, and separate quotation.": "I confirm I understand private access, reservations, companion presence, Yamato-led support, venue coordination, tickets, transport, security, and execution are subject to review, availability, lawful feasibility, and separate quotation.",
                "I confirm urgent requests may require priority-handling premiums or may be declined if proper handling is not possible.": "I confirm urgent requests may require priority-handling premiums or may be declined if proper handling is not possible.",
                "Please review my paid compatibility review file": "Please review my paid compatibility review file",
                "Please tell me which product / pathway to purchase": "Please tell me which product / pathway to purchase",
                "Please classify this request first": "Please classify this request first",
                "Please consider this for elite retainer support": "Please consider this for elite retainer support",
                "Please route this into another JapanSolved™ desk": "Please route this into another JapanSolved™ desk",
                "Please treat this as unpaid reference only": "Please treat this as unpaid reference only"
          },
          "native_bridge_status": "TALLY_RECONSTRUCTED_TO_CANONICAL_NATIVE_INTAKE_FINAL01",
          "review_display_policy": {
                "display_option_labels_not_machine_values": true,
                "use_legacy_display_map_for_cached_slug_answers": true,
                "never_show_snake_case_or_raw_tally_qid_as_client_answer": true
          },
          "descriptor_paragraphs": [
                "Payment first. Case file second.",
                "This intake is for legitimate private-client, celebrity, executive, founder, family-office, talent-team, or high-discretion Japan support. It is not a fan-access, paparazzi, stalking, private-address, unauthorized backstage, hotel-floor, or venue-rule bypass channel.",
                "Use this native intake after checkout or after JapanSolved™ approves a private payment path. Keep sensitive third-party information minimum-necessary until requested."
          ]
    },
    {
      "page_title": "Japan Travel & Cultural Experience Access Hub",
      "page_handle": "japan-travel-cultural-experience-access-hub",
      "page_url": "https://japansolved.com/pages/japan-travel-cultural-experience-access-hub",
      "subject_label": "Travel Cultural Experience Hub Intake",
      "intake_title": "Travel & Cultural Experience Access™ Case File Intake",
      "descriptor_line1": "Payment first. Case file second. Route, dates, access needs, privacy, and support layers stay attached to the paid review.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the payment path that matches the travel/access request. If the file belongs to a child desk, use that review path. If JapanSolved™ approved a private route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Japan Bespoke Experience Design Review™ — /products/japan-bespoke-experience-design-review",
          "value": "/products/japan-bespoke-experience-design-review"
        },
        {
          "label": "Ticket & Event Access Review™ — /products/japan-ticket-event-access-review",
          "value": "/products/japan-ticket-event-access-review"
        },
        {
          "label": "Reservation Route Review™ — /products/japan-reservation-route-review",
          "value": "/products/japan-reservation-route-review"
        },
        {
          "label": "Travel Companion Compatibility Review™ — /products/japan-private-travel-companion-compatibility-review",
          "value": "/products/japan-private-travel-companion-compatibility-review"
        },
        {
          "label": "VIP Travel Navigation Review™ — /products/japan-vip-travel-navigation-review",
          "value": "/products/japan-vip-travel-navigation-review"
        },
        {
          "label": "Private Local Experience Review™ — /products/japan-private-local-experience-review",
          "value": "/products/japan-private-local-experience-review"
        },
        {
          "label": "Nightlife Safety Route Review™ — /products/japan-nightlife-safety-route-review",
          "value": "/products/japan-nightlife-safety-route-review"
        },
        {
          "label": "Personal Styling Shopping Route Review™ — /products/japan-personal-styling-shopping-route-review",
          "value": "/products/japan-personal-styling-shopping-route-review"
        },
        {
          "label": "Celebrity Concierge Compatibility Review™ — /products/japan-celebrity-concierge-compatibility-review",
          "value": "/products/japan-celebrity-concierge-compatibility-review"
        },
        {
          "label": "Concierge Shopping Routing Review™ — /products/japan-concierge-shopping-routing-review",
          "value": "/products/japan-concierge-shopping-routing-review"
        },
        {
          "label": "Approved invoice / access deposit / custom quote / retainer",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the case file for a paid review, approved invoice, access deposit, custom quote, retainer, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_public_review_paid"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_private_approved_path_paid"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Bespoke Experience Design Review™ — /products/japan-bespoke-experience-design-review",
                  "value": "/products/japan-bespoke-experience-design-review"
                },
                {
                  "label": "Ticket & Event Access Review™ — /products/japan-ticket-event-access-review",
                  "value": "/products/japan-ticket-event-access-review"
                },
                {
                  "label": "Reservation Route Review™ — /products/japan-reservation-route-review",
                  "value": "/products/japan-reservation-route-review"
                },
                {
                  "label": "Travel Companion Compatibility Review™ — /products/japan-private-travel-companion-compatibility-review",
                  "value": "/products/japan-private-travel-companion-compatibility-review"
                },
                {
                  "label": "VIP Travel Navigation Review™ — /products/japan-vip-travel-navigation-review",
                  "value": "/products/japan-vip-travel-navigation-review"
                },
                {
                  "label": "Private Local Experience Review™ — /products/japan-private-local-experience-review",
                  "value": "/products/japan-private-local-experience-review"
                },
                {
                  "label": "Nightlife Safety Route Review™ — /products/japan-nightlife-safety-route-review",
                  "value": "/products/japan-nightlife-safety-route-review"
                },
                {
                  "label": "Personal Styling Shopping Route Review™ — /products/japan-personal-styling-shopping-route-review",
                  "value": "/products/japan-personal-styling-shopping-route-review"
                },
                {
                  "label": "Celebrity Concierge Compatibility Review™ — /products/japan-celebrity-concierge-compatibility-review",
                  "value": "/products/japan-celebrity-concierge-compatibility-review"
                },
                {
                  "label": "Concierge Shopping Routing Review™ — /products/japan-concierge-shopping-routing-review",
                  "value": "/products/japan-concierge-shopping-routing-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "helper": "If JapanSolved™ told you to submit before a public checkout exists, enter the approved instruction or invoice reference."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client and trip identity",
          "tone": "Tell us who the file belongs to and how to reach the correct person for paid review routing.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "country_timezone",
              "label": "Country / timezone",
              "type": "text",
              "required": true
            },
            {
              "id": "preferred_contact",
              "label": "Preferred contact method",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Email",
                  "value": "email"
                },
                {
                  "label": "WhatsApp / mobile message",
                  "value": "whatsapp_mobile"
                },
                {
                  "label": "Shopify order email only",
                  "value": "shopify_order_email"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "trip_shape",
          "title": "Trip shape and route type",
          "tone": "Use this step to classify whether the request is a single access need, a travel-support day, or a multi-desk Japan program.",
          "fields": [
            {
              "id": "target_cities",
              "label": "Target city or cities",
              "type": "text",
              "required": true,
              "placeholder": "Tokyo, Kyoto, Osaka, Sapporo, Fukuoka, etc."
            },
            {
              "id": "target_dates",
              "label": "Priority date window, backup dates, and trip timing",
              "type": "textarea",
              "required": true,
              "helper": "Include priority, secondary, and tertiary dates when possible."
            },
            {
              "id": "group_size",
              "label": "Group size and traveler profile",
              "type": "text",
              "required": true,
              "placeholder": "Solo traveler, couple, family, executive team, public figure, etc."
            },
            {
              "id": "lead_service_route",
              "label": "Which route seems closest?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Parent / Bespoke experience design review",
                  "value": "parent_bespoke_design_review"
                },
                {
                  "label": "Ticket, event, or entertainment access",
                  "value": "ticket_event_access"
                },
                {
                  "label": "Restaurant, activity, or reservation concierge",
                  "value": "reservation_activity_concierge"
                },
                {
                  "label": "Private companion, reset, or presence support",
                  "value": "private_companion_reset_presence"
                },
                {
                  "label": "VIP travel navigation or cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Private local experience or cultural access",
                  "value": "private_local_cultural_access"
                },
                {
                  "label": "Nightlife companion or safety route",
                  "value": "nightlife_safety_route"
                },
                {
                  "label": "Personal shopping, styling, or companion support",
                  "value": "personal_shopping_styling"
                },
                {
                  "label": "Celebrity concierge or high-discretion private access",
                  "value": "celebrity_concierge_discretion"
                },
                {
                  "label": "Not sure yet. I need JapanSolved™ to classify the route.",
                  "value": "not_sure_route_classification"
                }
              ]
            }
          ]
        },
        {
          "id": "support_needs",
          "title": "Support layers and desired experience",
          "tone": "Choose the support layers that may matter. This helps keep the hub from becoming one swollen request.",
          "fields": [
            {
              "id": "support_layers",
              "label": "Which support layers may be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Tickets, entry, or event access",
                  "value": "tickets_access"
                },
                {
                  "label": "Dining, activity, or reservation route",
                  "value": "reservations"
                },
                {
                  "label": "Private human presence or companion support",
                  "value": "presence_companion"
                },
                {
                  "label": "VIP navigation, station logic, or travel-day support",
                  "value": "navigation"
                },
                {
                  "label": "Local cultural host / artisan / neighborhood access",
                  "value": "local_culture"
                },
                {
                  "label": "Nightlife, safe return, or after-dark support",
                  "value": "nightlife"
                },
                {
                  "label": "Shopping, styling, or route-based buying support",
                  "value": "shopping_style"
                },
                {
                  "label": "Privacy, discretion, or public-profile control",
                  "value": "discretion"
                },
                {
                  "label": "Sourcing, purchase, pickup, shipping, or local representation may be needed",
                  "value": "sideways_operations"
                }
              ]
            },
            {
              "id": "desired_mood",
              "label": "Desired mood or outcome",
              "type": "textarea",
              "required": true,
              "placeholder": "Elegant, calm, stylish, playful, family-safe, discreet, restorative, strange, social, food-driven, shopping-driven, etc."
            },
            {
              "id": "avoid_list",
              "label": "What should be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "Crowds, nightlife, long walking, alcohol, tourist traps, public exposure, romance framing, etc."
            },
            {
              "id": "budget_range",
              "label": "Approximate budget range in USD",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "$500–$1,000 review / routing only",
                  "value": "500_1000"
                },
                {
                  "label": "$1,000–$3,000 small specialist support",
                  "value": "1000_3000"
                },
                {
                  "label": "$3,000–$7,500 private day or multi-desk route",
                  "value": "3000_7500"
                },
                {
                  "label": "$7,500–$20,000+ larger private program",
                  "value": "7500_20000_plus"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_budget"
                }
              ]
            }
          ]
        },
        {
          "id": "risk_boundaries",
          "title": "Privacy, safety, and urgency boundaries",
          "tone": "Travel access requests can involve timing, privacy, human support, alcohol/nightlife, public visibility, or third-party access. Flag anything that changes the handling.",
          "fields": [
            {
              "id": "privacy_sensitivity",
              "label": "Privacy or discretion needs",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Normal private client handling",
                  "value": "normal_private"
                },
                {
                  "label": "High discretion / public profile / family privacy",
                  "value": "high_discretion"
                },
                {
                  "label": "Very sensitive. Explain below.",
                  "value": "very_sensitive"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "safety_medical_mobility",
              "label": "Safety, mobility, medical-adjacent, alcohol/nightlife, or accessibility notes",
              "type": "textarea",
              "required": false
            },
            {
              "id": "urgency",
              "label": "Timing urgency",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "One month or more before target date",
                  "value": "one_month_plus"
                },
                {
                  "label": "About one to three weeks before target date",
                  "value": "one_to_three_weeks"
                },
                {
                  "label": "About one week before target date",
                  "value": "one_week"
                },
                {
                  "label": "Within 72 hours / rush review may be needed",
                  "value": "within_72"
                },
                {
                  "label": "Already in Japan / same-day or next-day concern",
                  "value": "same_day_next_day"
                }
              ]
            },
            {
              "id": "case_details",
              "label": "Anything else JapanSolved™ should know before routing this file?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "label": "Paid intake boundary",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_route",
              "label": "Unpaid user routing",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid users may be routed to the correct product, payment path, or review before the case file is processed."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "No guarantee of outcome",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, access, reservation success, provider cooperation, availability, timing, or outcome."
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "Accuracy and authorization",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information is accurate, authorized, and safe for JapanSolved™ to review for this paid request."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "HUB-TRAVEL",
      "record_id": "JSII_BANK_JAPAN_TRAVEL_CULTURAL_EXPERIENCE_ACCESS_HUB",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Travel & Cultural Experience Access Hub.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "JapanSolved™ Concierge Shopping & Entourage Support",
      "page_handle": "japansolved-concierge-shopping-entourage-support",
      "page_url": "https://japansolved.com/pages/japansolved-concierge-shopping-entourage-support",
      "intake_title": "JapanSolved™ Concierge Shopping & Entourage Support Intake",
      "product_routes": [
        {
          "label": "Purchase the concierge routing review",
          "value": "/products/japan-concierge-shopping-routing-review"
        },
        {
          "label": "Secure the concierge case deposit",
          "value": "/products/japan-concierge-shopping-case-deposit"
        },
        {
          "label": "Open the concierge retainer path",
          "value": "/products/japan-private-concierge-shopping-retainer"
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, deposit, retainer, invoice, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                "Yes, I completed checkout for the concierge routing review",
                "Yes, I secured the concierge case deposit",
                "Yes, I am on an approved retainer / private payment path",
                "JapanSolved™ instructed me to submit this intake",
                "Not yet, I need the correct payment route first"
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options_from": "product_routes",
              "helper": "Choose the closest path. If you have not paid yet, use one of the payment routes below before submitting the full support file."
            },
            {
              "id": "checkout_email",
              "label": "Checkout email address",
              "type": "email",
              "required": true,
              "helper": "Use the same email used at checkout whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required_logic": "required_if_paid",
              "placeholder": "Example: #JS1234 or invoice reference"
            }
          ]
        },
        {
          "id": "identity",
          "title": "Client identity and authority",
          "tone": "Tell us who the support file belongs to and who may authorize coordination.",
          "fields": [
            {
              "id": "client_name",
              "label": "Full name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for this case",
              "type": "email",
              "required": true
            },
            {
              "id": "country_region",
              "label": "Country / region",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_method",
              "label": "Phone / WhatsApp / LINE / preferred contact method",
              "type": "text",
              "required": false
            },
            {
              "id": "client_role",
              "label": "Your role in this request",
              "type": "select",
              "required": true,
              "options": [
                "I am the client / traveler",
                "I am submitting for a family member",
                "I am submitting for my company or executive",
                "I am an assistant / authorized representative",
                "Other / needs explanation"
              ]
            },
            {
              "id": "authority_note",
              "label": "If submitting for someone else, explain your authority",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "route_profile",
          "title": "Japan-side route profile",
          "tone": "Give us the shape of the day, route, or support window before we classify the right desk.",
          "fields": [
            {
              "id": "plain_language_goal",
              "label": "What do you want JapanSolved™ to help coordinate?",
              "type": "textarea",
              "required": true,
              "placeholder": "Example: guided shopping route, boutique support, interpretation, vendor conversation, purchase handoff, hotel-to-store movement, family support, or private entourage planning."
            },
            {
              "id": "support_context",
              "label": "What kind of support does this feel closest to?",
              "type": "select",
              "required": true,
              "options": [
                "Concierge shopping route",
                "Luxury / boutique support",
                "Jewelry / high-value purchase support",
                "Preloved luxury / vintage / flea-market route",
                "Art, antiques, gallery, or dealer route",
                "Medical tourism entourage logistics",
                "VIP navigation / private access / high-touch support",
                "Mixed route / not sure yet"
              ]
            },
            {
              "id": "client_location_status",
              "label": "Where is the client now?",
              "type": "select",
              "required": true,
              "options": [
                "Already in Japan",
                "Arriving within 72 hours",
                "Arriving within 1 week",
                "Arriving within 1 month",
                "Planning future travel",
                "Client may not travel, but local representation is needed",
                "Not sure yet"
              ]
            }
          ]
        },
        {
          "id": "timing_location",
          "title": "Timing, city, and route constraints",
          "tone": "Dates and locations control feasibility, staffing, transport, route design, and whether rush handling is realistic.",
          "fields": [
            {
              "id": "city_area",
              "label": "City, district, hotel area, appointment area, or likely route",
              "type": "text",
              "required": true,
              "placeholder": "Tokyo, Osaka, Kyoto, Ginza, Shibuya, clinic area, hotel base, or unknown"
            },
            {
              "id": "target_dates",
              "label": "Support dates, travel dates, or date windows",
              "type": "textarea",
              "required": true,
              "placeholder": "Include Japan time where relevant."
            },
            {
              "id": "urgency",
              "label": "How time-sensitive is this?",
              "type": "select",
              "required": true,
              "options": [
                "No fixed deadline",
                "Within 1 month",
                "Within 2 weeks",
                "Within 1 week",
                "Within 72 hours",
                "Within 24 hours",
                "Already in motion / support date already committed"
              ]
            },
            {
              "id": "group_profile",
              "label": "Who is involved in the route?",
              "type": "textarea",
              "required": false,
              "placeholder": "Client alone, spouse, family, assistant, executive team, friends, minors, elderly family member, etc."
            }
          ]
        },
        {
          "id": "support_needs",
          "title": "Support needs and boundaries",
          "tone": "Tell us what kind of human operating layer the day needs, and what must stay protected.",
          "fields": [
            {
              "id": "support_requested",
              "label": "Which support lanes may be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Route design / shopping day plan",
                "In-person guidance or attendance",
                "Interpreter or bilingual coordination",
                "Vendor / boutique / dealer communication",
                "Purchase comparison or decision support",
                "Transport / timing / waiting logistics",
                "Hotel handoff / pickup / storage / shipping coordination",
                "Privacy-sensitive movement",
                "Family, assistant, executive, or entourage support",
                "Desk routing only / not sure yet"
              ]
            },
            {
              "id": "privacy_sensitivity",
              "label": "Privacy, discretion, or special handling concerns",
              "type": "textarea",
              "required": false,
              "placeholder": "High-profile client, family privacy, sensitive purchase, clinic visit, private route, no photos, discreet entrances, etc."
            },
            {
              "id": "language_needs",
              "label": "Language and communication needs",
              "type": "textarea",
              "required": false,
              "placeholder": "Japanese calls, in-store conversation, interpreter coordination, written notes, family updates, etc."
            }
          ]
        },
        {
          "id": "purchase_budget_logistics",
          "title": "Purchase, budget, and logistics",
          "tone": "Clear purchase and cost boundaries prevent the support file from turning into fog.",
          "fields": [
            {
              "id": "budget_range",
              "label": "Budget range to keep in mind",
              "type": "select",
              "required": true,
              "options": [
                "Review only for now",
                "Under $500 additional",
                "$500 to $1,500",
                "$1,500 to $3,500",
                "$3,500 to $7,500",
                "$7,500+",
                "Retainer-level support may be appropriate",
                "Not sure yet"
              ]
            },
            {
              "id": "cost_authorization",
              "label": "Cost authorization preference",
              "type": "select",
              "required": true,
              "options": [
                "Quote everything before proceeding",
                "Minor costs may be approved case by case",
                "I may approve a working budget after review",
                "Do not incur any cost without written approval",
                "Not sure yet"
              ]
            },
            {
              "id": "purchase_or_handoff",
              "label": "Will the route involve purchases, pickup, storage, packing, shipping, or handoff?",
              "type": "textarea",
              "required": false,
              "placeholder": "Describe item categories, purchase intent, likely stores or sellers, shipping needs, hotel handoff, courier needs, or no purchase involved."
            },
            {
              "id": "scope_boundary",
              "label": "What should JapanSolved™ avoid doing without written approval?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "documents_context",
          "title": "Links, references, and context",
          "tone": "Share the context that helps us classify the route without turning the intake into a scattered message thread.",
          "fields": [
            {
              "id": "primary_url",
              "label": "Store, venue, map, product, hotel, clinic, or reference URL",
              "type": "url",
              "required": false
            },
            {
              "id": "upload_links",
              "label": "Secure folder links / document links / images",
              "type": "textarea",
              "required": false,
              "helper": "Use Google Drive, Dropbox, iCloud, or similar if images, product links, maps, or PDFs are needed. Keep permissions viewable."
            },
            {
              "id": "messages_or_text",
              "label": "Paste important Japanese text, seller messages, route notes, or instructions",
              "type": "textarea",
              "required": false
            },
            {
              "id": "routing_concerns",
              "label": "What are you most worried could go wrong?",
              "type": "textarea",
              "required": false,
              "placeholder": "Timing, language, route overload, seller cooperation, privacy, mobility, costs, purchase risk, shipping, appointment rules, etc."
            }
          ]
        },
        {
          "id": "final_confirm",
          "title": "Final confirmation before submission",
          "tone": "Final gate: paid path, authority, route scope, and support-boundary confirmations.",
          "fields": [
            {
              "id": "final_notes",
              "label": "Anything else we should know before reviewing this intake?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "final_confirmations",
              "label": "Required intake confirmations",
              "type": "checkbox_group",
              "required": true,
              "require_all": true,
              "options": [
                "I confirm this intake is connected to the appropriate paid review, deposit, retainer, invoice, or JapanSolved™-approved payment path.",
                "If I have not completed payment yet, I understand JapanSolved™ may route me to the correct product/payment path before reviewing or acting on this intake.",
                "I understand submission does not guarantee acceptance, staff availability, appointment approval, seller cooperation, access, item availability, pricing, purchase success, logistics feasibility, or final third-party decisions.",
                "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to share it.",
                "I understand JapanSolved™ does not guarantee discounts, allocations, medical outcomes, legal outcomes, provider decisions, customs clearance, delivery timing, or any third-party decision."
              ]
            },
            {
              "id": "digital_signature",
              "label": "Digital signature",
              "type": "text",
              "required": true,
              "helper": "Type your full name to confirm this submission."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "NEW-CONCIERGE",
      "record_id": "JSII_BANK_JAPANSOLVED_CONCIERGE_SHOPPING_ENTOURAGE_SUPPORT",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "JapanSolved Concierge Shopping & Entourage Support.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 3,
        "hardened_final_confirmation_field_count": 4
      }
    },
    {
      "page_title": "Tokyo Personal Assistant & Private Concierge Support Desk™",
      "page_handle": "tokyo-personal-assistant-private-concierge-support",
      "page_url": "https://japansolved.com/pages/tokyo-personal-assistant-private-concierge-support",
      "subject_label": "Tokyo Personal Assistant & Private Concierge Intake",
      "intake_title": "Tokyo Personal Assistant & Private Concierge™ Case File Intake",
      "service_label": "Tokyo-side private assistant support, concierge task triage, Japanese communication, pickups, deliveries, handoffs, schedule protection, and quiet coordination routing",
      "descriptor_line1": "Payment first. Case file second. Tasks, deadlines, Tokyo area, private context, names that may be used, provider details, budget authority, and boundaries stay attached to the paid review, deposit, day support, or retainer path.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Tokyo assistant payment first",
      "payment_block_copy": "Choose the paid assistant review, coordination deposit, day-support path, retainer, or approved private invoice before submitting private task details.",
      "payment_block_fineprint": "Use the same payment email at intake so the Tokyo assistant file can be matched to the paid path.",
      "not_paid_error": "This Tokyo personal assistant and private concierge intake requires a matched paid or JapanSolved™-approved payment path before submission.",
      "product_routes": [
        {
          "label": "Tokyo Personal Assistant & Private Concierge Review™",
          "value": "/products/tokyo-personal-assistant-private-concierge-review"
        },
        {
          "label": "Tokyo Small Systems Rescue Case Deposit™",
          "value": "/products/tokyo-small-systems-rescue-case-deposit"
        },
        {
          "label": "Tokyo Quiet Day Concierge Support™",
          "value": "/products/tokyo-quiet-day-concierge-support"
        },
        {
          "label": "Tokyo Invisible Hand Concierge Retainer™",
          "value": "/products/tokyo-invisible-hand-concierge-retainer"
        },
        {
          "label": "Approved invoice / custom quote / retainer / private payment path",
          "value": "approved_private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_match",
          "title": "Payment and task-path match",
          "tone": "Payment-first, case-file-second. Match the assistant request to the correct paid path before the file is sent.",
          "fields": [
            {
              "id": "payment_status",
              "type": "radio",
              "label": "Have you already secured the correct paid path for this Tokyo assistant request?",
              "required": true,
              "options": [
                "Yes — I purchased the Tokyo Personal Assistant & Private Concierge Review",
                "Yes — I secured the Small Systems Rescue Case Deposit",
                "Yes — I purchased or was approved for day support, retainer, quote, invoice, or private payment path",
                "Not yet — I need to purchase or confirm the correct payment path first"
              ]
            },
            {
              "id": "selected_product_path",
              "type": "select",
              "label": "Which product or payment path applies?",
              "required": true,
              "options": [
                "Tokyo Personal Assistant & Private Concierge Review™",
                "Tokyo Small Systems Rescue Case Deposit™",
                "Tokyo Quiet Day Concierge Support™",
                "Tokyo Invisible Hand Concierge Retainer™",
                "Approved private payment path / invoice / custom quote"
              ]
            },
            {
              "id": "checkout_email",
              "type": "email",
              "label": "Payment email address",
              "required": true,
              "placeholder": "Use the same email used at checkout or invoice payment."
            },
            {
              "id": "order_reference",
              "type": "text",
              "label": "Order number, invoice number, or payment reference",
              "required": true,
              "placeholder": "Example: JS-1001, order number, invoice number, or approved payment note"
            }
          ]
        },
        {
          "id": "client_profile",
          "title": "Client, submitter, and privacy profile",
          "tone": "Give the private assistant file enough identity and discretion context to handle Tokyo-side tasks correctly.",
          "fields": [
            {
              "id": "client_name",
              "type": "text",
              "label": "Client name",
              "required": true
            },
            {
              "id": "contact_email",
              "type": "email",
              "label": "Best contact email",
              "required": true
            },
            {
              "id": "country_timezone",
              "type": "text",
              "label": "Country / timezone",
              "required": true
            },
            {
              "id": "submitter_role",
              "type": "select",
              "label": "Who is submitting this file?",
              "required": true,
              "options": [
                "Client directly",
                "Assistant / family office / staff member submitting for the client",
                "Family member or travel companion submitting for the client",
                "Travel advisor, concierge, or agency submitting for the client",
                "Other authorized representative"
              ]
            },
            {
              "id": "client_context",
              "type": "checkbox_group",
              "label": "Client context that affects handling",
              "required": true,
              "options": [
                "Executive / business traveler",
                "Family or private traveler",
                "VIP or privacy-sensitive client",
                "Long-stay Tokyo visitor",
                "Founder / creative / public-facing guest",
                "Client needs discreet or low-visibility coordination",
                "Client needs practical help only"
              ]
            },
            {
              "id": "privacy_constraints",
              "type": "textarea",
              "label": "Privacy, discretion, name-use, or disclosure boundaries",
              "required": false,
              "placeholder": "What should not be shared unnecessarily? Are there names, schedule details, purchase details, family details, or addresses that require special care?"
            }
          ]
        },
        {
          "id": "task_profile",
          "title": "Tokyo task profile",
          "tone": "Describe the practical request clearly enough to decide whether this is review, active coordination, day support, or retainer work.",
          "fields": [
            {
              "id": "task_type",
              "type": "checkbox_group",
              "label": "What kind of support is needed?",
              "required": true,
              "options": [
                "Japanese calls, messages, wording, or provider follow-up",
                "Restaurant, hotel, shop, salon, appointment, or vendor confirmation",
                "Pickup, delivery, handoff, document drop-off, gift, or package timing",
                "Shopping assistance, purchase pickup, or store communication",
                "Family, executive, meeting, or travel-day schedule protection",
                "Same-day or urgent Tokyo-side issue",
                "Private day support or in-person presence",
                "Ongoing weekly/monthly assistant support"
              ]
            },
            {
              "id": "task_summary",
              "type": "textarea",
              "label": "Describe the task or task cluster",
              "required": true,
              "placeholder": "What needs to happen, who is involved, what result is desired, and what would count as success?"
            },
            {
              "id": "tokyo_area",
              "type": "text",
              "label": "Tokyo area, hotel area, venue/store/provider location, or delivery/handoff zone",
              "required": true
            },
            {
              "id": "deadline_timing",
              "type": "textarea",
              "label": "Deadline, appointment time, date window, urgency, and backup timing",
              "required": true
            },
            {
              "id": "urgency",
              "type": "select",
              "label": "Urgency level",
              "required": true,
              "options": [
                "Flexible — review can proceed normally",
                "Soon — needed within one week",
                "Urgent — needed within 72 hours",
                "Same-day / within 24 hours",
                "Ongoing or repeated support window"
              ]
            }
          ]
        },
        {
          "id": "coordination_details",
          "title": "Contacts, authority, and coordination details",
          "tone": "Tokyo-side support often turns on the right names, authority, provider details, and cost boundaries.",
          "fields": [
            {
              "id": "provider_contacts",
              "type": "textarea",
              "label": "Provider, hotel, restaurant, shop, vendor, courier, or contact details",
              "required": false,
              "placeholder": "Names, phone numbers, emails, addresses, URLs, reservation numbers, or screenshots summarized in text."
            },
            {
              "id": "names_authority",
              "type": "textarea",
              "label": "Names that may be used and authority to act",
              "required": true,
              "placeholder": "Whose name can be used? May JapanSolved™ contact the provider on your behalf? Are there limits on what can be said?"
            },
            {
              "id": "language_wording_need",
              "type": "textarea",
              "label": "Japanese wording, tone, or communication problem",
              "required": false,
              "placeholder": "What needs to be explained politely, confirmed, softened, refused, clarified, or translated?"
            },
            {
              "id": "physical_handling",
              "type": "select",
              "label": "Does the request require physical attendance, pickup, delivery, waiting, or handoff?",
              "required": true,
              "options": [
                "No — communication or review only",
                "Possibly — please review whether physical support is needed",
                "Yes — pickup / delivery / handoff / waiting may be needed",
                "Yes — in-person day support or local attendance is requested",
                "Not sure yet"
              ]
            },
            {
              "id": "budget_authority",
              "type": "textarea",
              "label": "Out-of-pocket costs, purchase budget, vendor fees, transport, and approval limits",
              "required": false,
              "placeholder": "What may be paid, purchased, reimbursed, or quoted separately? What needs approval before action?"
            }
          ]
        },
        {
          "id": "boundaries_escalation",
          "title": "Boundaries and escalation routing",
          "tone": "A good assistant file knows when to stay small and when to move into the right specialist desk.",
          "fields": [
            {
              "id": "support_style",
              "type": "select",
              "label": "Preferred support style",
              "required": true,
              "options": [
                "Quiet background coordination only",
                "Clear practical instruction and written route support",
                "Japanese communication and provider follow-up",
                "Active coordination with possible field support",
                "Private day support or human presence consideration",
                "Ongoing retainer support"
              ]
            },
            {
              "id": "what_must_not_happen",
              "type": "textarea",
              "label": "What must not happen?",
              "required": true,
              "placeholder": "Example: do not reveal purchase reason, do not call before a certain time, do not use client name unnecessarily, do not commit to costs without approval."
            },
            {
              "id": "likely_escalation",
              "type": "checkbox_group",
              "label": "Possible specialist escalation if this desk is not the right final home",
              "required": false,
              "options": [
                "Restaurant / activity reservation concierge",
                "VIP travel navigation and cultural support",
                "Lost item recovery and return coordination",
                "Personal shopping / styling / companion support",
                "Logistics and local representation",
                "Celebrity concierge / private access",
                "Bespoke experience design",
                "Yamato private companion profile consideration"
              ]
            },
            {
              "id": "excluded_scope_acknowledgment",
              "type": "checkbox",
              "label": "Boundary acknowledgment",
              "text": "I understand this desk does not replace licensed professionals, bypass rules, misrepresent authority, handle unsafe/invasive requests, or guarantee third-party responses.",
              "required": true
            }
          ]
        },
        {
          "id": "links_context",
          "title": "Links, references, and final context",
          "tone": "Add the useful receipts, links, screenshots summarized in text, and context that prevents the task from being misunderstood.",
          "fields": [
            {
              "id": "relevant_links",
              "type": "textarea",
              "label": "Relevant links, screenshots described in text, booking references, order details, or provider pages",
              "required": false,
              "placeholder": "Paste URLs or summarize screenshots. Do not include passwords or highly sensitive login details."
            },
            {
              "id": "desired_outcome",
              "type": "textarea",
              "label": "Desired outcome and acceptable backup outcome",
              "required": true,
              "placeholder": "What result do you want? What backup result is acceptable if the first option fails?"
            },
            {
              "id": "follow_up_preference",
              "type": "select",
              "label": "Follow-up preference",
              "required": true,
              "options": [
                "Email first",
                "Email plus urgent note if needed",
                "Coordinate through assistant / representative",
                "Discuss after review before any provider contact",
                "Other — I will explain in final notes"
              ]
            },
            {
              "id": "final_notes",
              "type": "textarea",
              "label": "Anything else JapanSolved™ should know before reading this file?",
              "required": false
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the paid intake rules before sending the private assistant case file.",
          "fields": [
            {
              "id": "confirm_paid_path",
              "type": "checkbox",
              "label": "Paid-path confirmation",
              "text": "I confirm this intake is tied to the correct paid Tokyo assistant review, coordination deposit, day-support product, retainer, invoice, or JapanSolved™-approved payment path.",
              "required": true
            },
            {
              "id": "confirm_unpaid_route",
              "type": "checkbox",
              "label": "Unpaid-routing confirmation",
              "text": "I understand unpaid users must purchase or confirm the correct payment path before active review, routing, outreach, calls, purchases, fieldwork, or coordination begins.",
              "required": true
            },
            {
              "id": "confirm_no_guarantee",
              "type": "checkbox",
              "label": "No-guarantee confirmation",
              "text": "I understand submission does not guarantee acceptance, availability, staffing, provider response, reservation success, delivery outcome, purchase result, timing, or final result.",
              "required": true
            },
            {
              "id": "confirm_accuracy_authority",
              "type": "checkbox",
              "label": "Accuracy and authority confirmation",
              "text": "I confirm the information is accurate and that I am authorized to submit this private assistant and concierge task file for the client or party involved.",
              "required": true
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "NEW-TOKYO-PA",
      "record_id": "JSII_BANK_TOKYO_PERSONAL_ASSISTANT_PRIVATE_CONCIERGE_SUPPORT",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Tokyo Personal Assistant & Private Concierge Support.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Yamato Private Companion Profile",
      "page_handle": "yamato-companion-profile",
      "page_url": "https://japansolved.com/pages/yamato-companion-profile",
      "intake_title": "Yamato Private Companion Profile Request™ Intake",
      "service_label": "Yamato private companion fit, profile-led day presence, cultural ease, low-pressure support, and availability review",
      "subject_label": "Yamato Private Companion Profile",
      "descriptor_line1": "A guided, paginated case-file intake for Yamato Private Companion Profile.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, privacy, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Yamato Private Companion Request Review™",
          "value": "/products/yamato-private-companion-request-review",
          "render_as_link": true
        },
        {
          "label": "Japan Private Travel Companion Compatibility Review™",
          "value": "/products/japan-private-travel-companion-compatibility-review",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Yamato Private Companion Request Review™ — /products/yamato-private-companion-request-review",
                  "value": "/products/yamato-private-companion-request-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Yamato private companion request profile",
          "fields": [
            {
              "id": "profile_interest",
              "label": "What kind of Yamato-led private companion presence are you imagining?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "day_shape",
              "label": "Day shape: dining, shopping, nightlife, quiet reset, local experience, event support, errands, handoffs, or mixed route",
              "type": "textarea",
              "required": false
            },
            {
              "id": "client_style",
              "label": "Client style: conversation level, privacy needs, mobility, social comfort, language preference, age/context, and desired pace",
              "type": "textarea",
              "required": false
            },
            {
              "id": "route_boundaries",
              "label": "Boundaries, sensitivities, public visibility concerns, relationship expectations, no-go contexts, or safety concerns",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, spending ceiling, retainer context, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, city, route, handoff, appointment, movement, support location, or service context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, safety concerns, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, image references, messages, route notes, product pages, public posts, documents, or prior correspondence",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, booked, checked, reported, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, access, assignment, availability, coordination, purchase, meeting, location result, family outcome, recovery, approval, export/import clearance, or any specific outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "HIDDEN-YAMATO-PROFILE",
      "record_id": "JSII_BANK_YAMATO_COMPANION_PROFILE",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "hidden_support",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Yamato Private Companion Profile.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Yamato Companion Advisory Background",
      "page_handle": "yamato-companion-background",
      "page_url": "https://japansolved.com/pages/yamato-companion-background",
      "intake_title": "Yamato Private Companion Advisory™ Request Intake",
      "service_label": "Yamato-led private companion advisory, mood fit, discreet day-presence, reset rhythm, and route suitability review",
      "subject_label": "Yamato Companion Advisory Background",
      "descriptor_line1": "A guided, paginated case-file intake for Yamato Companion Advisory Background.",
      "descriptor_line2": "Payment first. Case file second. Product route, scope, timing, privacy, and approved payment boundaries are protected.",
      "payment_block_title": "Complete payment before continuing",
      "payment_block_copy": "Choose the public review payment path that matches this request. If JapanSolved™ gave you a private invoice, access deposit, case quote, or retainer route, select the approved private payment path after payment.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched.",
      "not_paid_error": "This intake requires a matched paid or payment path approved by JapanSolved™ before the full file opens. Use the payment route above, then return with your payment email and reference.",
      "product_routes": [
        {
          "label": "Purchase the Yamato Private Companion Request Review™",
          "value": "/products/yamato-private-companion-request-review",
          "render_as_link": true
        },
        {
          "label": "Japan Private Travel Companion Compatibility Review™",
          "value": "/products/japan-private-travel-companion-compatibility-review",
          "render_as_link": true
        },
        {
          "label": "JapanSolved™ instructed me to use a custom quote, access deposit, approved invoice, or private payment path",
          "value": "private_payment_path",
          "render_as_link": false
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the support file for a paid review, approved invoice, access deposit, custom quote, or service path approved by JapanSolved™.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, I completed payment for the public review route",
                  "value": "yes_i_completed_payment_for_the_public_review_route"
                },
                {
                  "label": "Yes, I am on an approved access deposit, invoice, retainer, or private payment path",
                  "value": "yes_i_am_on_an_approved_access_deposit_invoice_retainer_or_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake",
                  "value": "japansolved_instructed_me_to_submit_this_intake"
                },
                {
                  "label": "Not yet",
                  "value": "not_yet"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Yamato Private Companion Request Review™ — /products/yamato-private-companion-request-review",
                  "value": "/products/yamato-private-companion-request-review"
                },
                {
                  "label": "Approved invoice / access deposit / custom quote / retainer",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "Not sure yet",
                  "value": "not_sure_yet"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true,
              "helper": "Use the email connected to the paid review, access deposit, invoice, retainer, or approved private route."
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": false,
              "helper": "Include the order number, invoice number, receipt ID, access deposit reference, retainer note, or private payment reference if available."
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Client identity and contact channel",
          "fields": [
            {
              "id": "client_name",
              "label": "Client name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for follow-up",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messenger",
              "label": "Phone / WhatsApp / LINE / preferred messenger",
              "type": "text",
              "required": false
            },
            {
              "id": "requester_role",
              "label": "Who is submitting this intake?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "I am the client",
                  "value": "i_am_the_client"
                },
                {
                  "label": "Assistant / EA / family office",
                  "value": "assistant_ea_family_office"
                },
                {
                  "label": "Travel advisor / concierge partner",
                  "value": "travel_advisor_concierge_partner"
                },
                {
                  "label": "Business / organization representative",
                  "value": "business_organization_representative"
                },
                {
                  "label": "Family member or authorized helper",
                  "value": "family_member_or_authorized_helper"
                },
                {
                  "label": "Other authorized requester",
                  "value": "other_authorized_requester"
                }
              ]
            },
            {
              "id": "client_location",
              "label": "Where is the client now?",
              "type": "text",
              "required": false
            }
          ]
        },
        {
          "id": "request_profile",
          "title": "Yamato advisory request profile",
          "fields": [
            {
              "id": "yamato_interest",
              "label": "What draws you to Yamato-led presence for this Japan day or private route?",
              "type": "textarea",
              "required": true
            },
            {
              "id": "desired_mood",
              "label": "Desired mood, pace, conversation style, privacy level, social setting, dining route, movement, or reset rhythm",
              "type": "textarea",
              "required": false
            },
            {
              "id": "dates_city_route",
              "label": "Target dates, city, hotel/area, route idea, availability window, and how flexible the client can be",
              "type": "textarea",
              "required": false
            },
            {
              "id": "fit_boundaries",
              "label": "Boundaries, sensitivities, no-go contexts, language preference, public visibility concerns, or companion-style expectations",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and route constraints",
          "fields": [
            {
              "id": "target_timing",
              "label": "Target timing / deadline",
              "type": "text",
              "required": false
            },
            {
              "id": "budget_range",
              "label": "Budget range, spending ceiling, retainer context, or support limit",
              "type": "text",
              "required": false
            },
            {
              "id": "destination_or_handoff",
              "label": "Destination, city, route, handoff, appointment, movement, support location, or service context",
              "type": "textarea",
              "required": false
            },
            {
              "id": "constraints",
              "label": "Non-negotiables, red lines, privacy needs, safety concerns, custody concerns, language issues, or people involved",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "attachments_context",
          "title": "Links, references, and supporting context",
          "fields": [
            {
              "id": "links_references",
              "label": "Relevant links, screenshots, image references, messages, route notes, product pages, public posts, documents, or prior correspondence",
              "type": "textarea",
              "required": false
            },
            {
              "id": "prior_attempts",
              "label": "What has already been attempted, contacted, booked, checked, reported, or ruled out?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "sensitive_notes",
              "label": "Anything sensitive JapanSolved™ should know before replying?",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "confirmations",
          "title": "Final confirmation",
          "fields": [
            {
              "id": "confirm_paid_route",
              "label": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or approved private payment route.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid users must use the correct payment route before full intake review or execution can begin.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, access, assignment, availability, coordination, purchase, meeting, location result, family outcome, recovery, approval, export/import clearance, or any specific outcome.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_accuracy_authority",
              "label": "I confirm the information is accurate and I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "options": [
                {
                  "label": "Confirmed",
                  "value": "confirmed"
                }
              ]
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by availability, official-route rules, timing windows, identity checks, pickup or transferability conditions, privacy boundaries, lawful handling requirements, and the need for additional clarification, documents, authorization, payment, or quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "page_sequence": "HIDDEN-YAMATO-BACKGROUND",
      "record_id": "JSII_BANK_YAMATO_COMPANION_BACKGROUND",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "hidden_support",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Yamato Companion Advisory Background.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 4,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "page_title": "Japan Disaster Preparedness Sourcing & Setup Desk™",
      "page_handle": "japan-disaster-preparedness-sourcing-setup",
      "page_url": "https://japansolved.com/pages/japan-disaster-preparedness-sourcing-setup",
      "intake_title": "Japan Disaster Preparedness Sourcing & Setup™ Intake",
      "product_routes": [
        {
          "label": "Purchase the preparedness sourcing review",
          "value": "/products/japan-disaster-preparedness-sourcing-setup-review"
        },
        {
          "label": "Secure the preparedness setup case deposit",
          "value": "/products/japan-disaster-preparedness-setup-case-deposit"
        },
        {
          "label": "Open the preparedness support retainer path",
          "value": "/products/japan-preparedness-support-retainer"
        }
      ],
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "This intake creates the readiness file for a paid review, deposit, retainer, invoice, or JapanSolved™-approved service path.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Have you already secured the correct paid path for this preparedness request?",
              "type": "radio",
              "required": true,
              "options": [
                "Yes, I completed checkout for the preparedness sourcing review",
                "Yes, I secured the preparedness setup case deposit",
                "Yes, I am on an approved retainer / private payment path",
                "JapanSolved™ instructed me to submit this intake",
                "Not yet, I need the correct payment route first"
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options_from": "product_routes",
              "helper": "Choose the closest path. If you have not paid yet, use one of the payment routes below before submitting the full readiness file."
            },
            {
              "id": "checkout_email",
              "label": "Checkout email address",
              "type": "email",
              "required": true,
              "helper": "Use the same email used at checkout whenever possible.",
              "placeholder": "name@example.com"
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required_logic": "required_if_paid",
              "placeholder": "Example: #JS1234 or invoice reference"
            }
          ]
        },
        {
          "id": "identity",
          "title": "Client identity and authority",
          "tone": "Tell us who the preparedness file belongs to and who may authorize purchases, property access, or local setup coordination.",
          "fields": [
            {
              "id": "client_name",
              "label": "Full name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best email for this case",
              "type": "email",
              "required": true
            },
            {
              "id": "country_region",
              "label": "Country / region",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_method",
              "label": "Phone / WhatsApp / LINE / preferred contact method",
              "type": "text",
              "required": false
            },
            {
              "id": "client_role",
              "label": "Your role in this request",
              "type": "select",
              "required": true,
              "options": [
                "I am the resident / client",
                "I am submitting for my family",
                "I am submitting for my company or office",
                "I am submitting for a property owner",
                "I am an assistant / authorized representative",
                "Other / needs explanation"
              ]
            },
            {
              "id": "authority_note",
              "label": "If submitting for someone else or requesting property access, explain your authority",
              "type": "textarea",
              "required": false
            }
          ]
        },
        {
          "id": "site_profile",
          "title": "Household, office, or property profile",
          "tone": "The right preparedness setup depends on the people, place, building, storage, and access reality.",
          "fields": [
            {
              "id": "readiness_context",
              "label": "What kind of site is this preparedness file for?",
              "type": "select",
              "required": true,
              "options": [
                "Private home / apartment",
                "Family household",
                "Serviced apartment / long-stay residence",
                "Second home / remote owner property",
                "Office / small business",
                "Executive residence",
                "Mixed home and office",
                "Not sure yet"
              ]
            },
            {
              "id": "city_area",
              "label": "City, ward, prefecture, district, station area, or property location",
              "type": "text",
              "required": true,
              "placeholder": "Tokyo, Yokohama, Osaka, Kyoto, Saitama, building area, or unknown"
            },
            {
              "id": "building_profile",
              "label": "Building type, floor level, access, storage, and elevator/stair concerns",
              "type": "textarea",
              "required": true,
              "placeholder": "Example: high-rise apartment, older house, office floor, narrow storage, no elevator, coastal area, remote property, building rules, or unknown."
            },
            {
              "id": "people_profile",
              "label": "Who needs to be considered?",
              "type": "textarea",
              "required": true,
              "placeholder": "Adults, children, elderly relatives, pets, visitors, staff, mobility limits, dietary restrictions, language comfort, etc."
            }
          ]
        },
        {
          "id": "readiness_needs",
          "title": "Preparedness needs and boundaries",
          "tone": "Tell us what should be planned, purchased, organized, labeled, or refreshed without turning preparedness into clutter.",
          "fields": [
            {
              "id": "plain_language_goal",
              "label": "What do you want JapanSolved™ to help coordinate?",
              "type": "textarea",
              "required": true,
              "placeholder": "Example: build a practical home kit, source water and toilets, prepare an office shelf, label supplies, restock a remote property, or design a realistic shopping/setup path."
            },
            {
              "id": "scenario_concerns",
              "label": "Which scenarios or concerns should be considered?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Earthquake",
                "Typhoon / heavy rain",
                "Blackout / power disruption",
                "Water disruption",
                "Transport stoppage",
                "Heat / cold / seasonal needs",
                "Pets",
                "Children / elderly relatives",
                "Mobility limitations",
                "Medical-device power needs",
                "Office / visitor supplies",
                "Remote property readiness",
                "Not sure yet"
              ]
            },
            {
              "id": "current_supplies",
              "label": "What supplies or setup already exist?",
              "type": "textarea",
              "required": false,
              "placeholder": "Mention water, food, toilets, lights, batteries, radios, chargers, bags, first-aid basics, documents, labels, storage, or no supplies yet."
            },
            {
              "id": "known_boundaries",
              "label": "What should JapanSolved™ avoid doing without written approval?",
              "type": "textarea",
              "required": false,
              "placeholder": "Examples: do not enter property, do not order supplies, do not contact building management, do not exceed budget, do not disclose owner identity."
            }
          ]
        },
        {
          "id": "setup_sourcing",
          "title": "Sourcing, setup, and local coordination",
          "tone": "Separate planning from physical work so purchasing, delivery, storage, and repeat checks stay controlled.",
          "fields": [
            {
              "id": "support_requested",
              "label": "Which support lanes may be needed?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                "Preparedness sourcing review only",
                "Recommended supply categories",
                "Local product sourcing / comparison",
                "Shopping or online ordering coordination",
                "Delivery or receiving coordination",
                "Home / office / property setup visit",
                "Translated labels or simple household notes",
                "Storage and access placement logic",
                "Expiry / restock / seasonal refresh plan",
                "Vendor, building, or property access coordination",
                "Desk routing only / not sure yet"
              ]
            },
            {
              "id": "access_authority",
              "label": "If setup, delivery, or property access may be needed, explain access rules and authorization",
              "type": "textarea",
              "required": false,
              "placeholder": "Keys, building rules, concierge/front desk, landlord, office manager, owner authorization, photos allowed/not allowed, etc."
            },
            {
              "id": "language_label_needs",
              "label": "Language, labeling, or instruction-support needs",
              "type": "textarea",
              "required": false,
              "placeholder": "Japanese labels, English household notes, family-facing reminders, building notices, product instructions, expiry markings."
            }
          ]
        },
        {
          "id": "timing_budget",
          "title": "Timing, budget, and cost control",
          "tone": "Preparedness should be reachable and maintainable. Tell us the timeline and spending boundary before anything is quoted.",
          "fields": [
            {
              "id": "urgency",
              "label": "How time-sensitive is this?",
              "type": "select",
              "required": true,
              "options": [
                "No fixed deadline",
                "Within 1 month",
                "Within 2 weeks",
                "Within 1 week",
                "Within 72 hours",
                "Within 24 hours",
                "Already in motion / setup date already committed"
              ]
            },
            {
              "id": "target_dates",
              "label": "Target dates, delivery windows, setup windows, or travel/property access windows",
              "type": "textarea",
              "required": false,
              "placeholder": "Include Japan time where relevant."
            },
            {
              "id": "budget_range",
              "label": "Budget range to keep in mind before supply costs",
              "type": "select",
              "required": true,
              "options": [
                "Review only for now",
                "Under $500 additional",
                "$500 to $1,500",
                "$1,500 to $3,500",
                "$3,500 to $7,500",
                "$7,500+",
                "Retainer-level support may be appropriate",
                "Not sure yet"
              ]
            },
            {
              "id": "cost_authorization",
              "label": "Cost authorization preference",
              "type": "select",
              "required": true,
              "options": [
                "Quote everything before proceeding",
                "Minor costs may be approved case by case",
                "I may approve a working budget after review",
                "Do not incur any cost without written approval",
                "Not sure yet"
              ]
            }
          ]
        },
        {
          "id": "documents_context",
          "title": "Links, references, and context",
          "tone": "Share practical context that helps us classify the setup without scattering the file across messages.",
          "fields": [
            {
              "id": "primary_url",
              "label": "Product, store, property, building, map, or reference URL",
              "type": "url",
              "required": false
            },
            {
              "id": "upload_links",
              "label": "Secure folder links / document links / images",
              "type": "textarea",
              "required": false,
              "helper": "Use Google Drive, Dropbox, iCloud, or similar if images, current supply photos, floor plans, shelves, labels, or PDFs are needed. Keep permissions viewable."
            },
            {
              "id": "messages_or_text",
              "label": "Paste important Japanese text, building notices, delivery rules, or product notes",
              "type": "textarea",
              "required": false
            },
            {
              "id": "routing_concerns",
              "label": "What are you most worried could go wrong?",
              "type": "textarea",
              "required": false,
              "placeholder": "Too many supplies, wrong products, storage, weight, pets, expired goods, access, building rules, language, delivery timing, office responsibility, etc."
            }
          ]
        },
        {
          "id": "final_confirm",
          "title": "Final confirmation before submission",
          "tone": "Final gate: paid path, authorization, practical boundaries, and emergency-outcome acknowledgements.",
          "fields": [
            {
              "id": "final_notes",
              "label": "Anything else we should know before reviewing this intake?",
              "type": "textarea",
              "required": false
            },
            {
              "id": "final_confirmations",
              "label": "Required intake confirmations",
              "type": "checkbox_group",
              "required": true,
              "require_all": true,
              "options": [
                "I confirm this intake is connected to the appropriate paid review, deposit, retainer, invoice, or JapanSolved™-approved payment path.",
                "If I have not completed payment yet, I understand JapanSolved™ may route me to the correct product/payment path before reviewing or acting on this intake.",
                "I understand submission does not guarantee acceptance, product availability, vendor cooperation, setup availability, delivery timing, supply suitability, utility restoration, building performance, government response, safety, rescue, or emergency outcomes.",
                "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to share it.",
                "I understand JapanSolved™ does not provide emergency response, rescue, medical advice, legal advice, hazardous material procurement, illegal-goods procurement, or disaster-outcome guarantees."
              ]
            },
            {
              "id": "digital_signature",
              "label": "Digital signature",
              "type": "text",
              "required": true,
              "helper": "Type your full name to confirm this submission."
            },
            {
              "id": "confirm_page_specific_boundaries",
              "label": "Page-specific boundaries and lawful handling",
              "type": "checkbox",
              "required": true,
              "text": "I understand this request may be limited by lawful-handling requirements, feasibility limits, availability limits, third-party cooperation, documentation needs, timing windows, and the need for additional clarification, authorization, payment, route correction, or separate quote before JapanSolved™ can proceed."
            }
          ]
        }
      ],
      "record_id": "JSII_BANK_JAPAN_DISASTER_PREPAREDNESS_SOURCING_SETUP",
      "native_anchor": "#jslp-intake",
      "intake_version": "native-intake-registry-bank-v1",
      "page_type": "specialist",
      "desk_sensitivity": "standard",
      "payment_policy": "payment-first-case-file-second",
      "intake_bank_extraction": {
        "source_file": "Japan Disaster Preparedness Sourcing & Setup Desk.txt",
        "source_mode": "embedded_record",
        "scraped_from_page_body_embedded_nif": true,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 3,
        "hardened_final_confirmation_field_count": 4
      }
    },
    {
      "record_id": "JSII-GENERIC-FALLBACK",
      "page_sequence": "GENERIC",
      "page_title": "JapanSolved™ General Paid Request Routing Intake™",
      "page_handle": "generic-fallback-intake",
      "page_url": "https://japansolved.com/pages/intake-routing",
      "page_type": "generic_fallback",
      "service_family": "routing_fallback",
      "archetype": "generic_case_router",
      "desk_sensitivity": "mixed",
      "payment_policy": "payment_first_case_file_second_with_routing_only_option",
      "native_anchor": "#jslp-intake",
      "intake_title": "JapanSolved™ General Paid Request Routing Intake™",
      "intake_version": "generic_fallback_v3",
      "product_routes": [
        "/collections/japansolved-service-reviews",
        "/pages/japansolved-sourcing-procurement-export-hub",
        "/pages/japansolved-logistics-local-representation-hub"
      ],
      "product_route_objects": [
        {
          "route": "/collections/japansolved-service-reviews",
          "slug_or_note": "service-reviews-collection",
          "status": "ready_path",
          "render_as_link": true
        },
        {
          "route": "/pages/japansolved-sourcing-procurement-export-hub",
          "slug_or_note": "sourcing-hub",
          "status": "ready_path",
          "render_as_link": true
        },
        {
          "route": "/pages/japansolved-logistics-local-representation-hub",
          "slug_or_note": "logistics-hub",
          "status": "ready_path",
          "render_as_link": true
        }
      ],
      "unpaid_behavior": "allow_routing_only_with_strong_payment_notice",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Start with the correct payment route",
          "tone": "This quick gate keeps serious case files separate from casual notes. If you have not paid yet, we will route you to the correct product before any formal review begins.",
          "fields": [
            {
              "id": "payment_status",
              "type": "radio",
              "label": "Have you already secured the appropriate JapanSolved™ review, deposit, retainer, invoice, or approved payment route?",
              "required": true,
              "options": [
                "Yes, I have already paid or secured the route",
                "No, I need the correct payment path first",
                "I am not sure which service product applies",
                "JapanSolved™ specifically directed me to submit this fallback intake"
              ]
            },
            {
              "id": "selected_product_path",
              "type": "select",
              "label": "Which product or service path best matches this request?",
              "required": false,
              "options_from": "product_routes",
              "helper": "Choose the closest route. If unsure, select I am not sure and explain the request in the next step."
            },
            {
              "id": "checkout_email",
              "type": "email",
              "label": "Payment email address",
              "required": false,
              "required_logic": "required_if_paid",
              "placeholder": "client@email.com",
              "helper": "Use the same email used at checkout whenever possible."
            },
            {
              "id": "order_reference",
              "type": "text",
              "label": "Order number, invoice number, or payment reference, if already paid",
              "required": false,
              "required_logic": "required_if_paid",
              "placeholder": "Example: #JS1234, invoice number, or payment confirmation"
            }
          ]
        },
        {
          "id": "client_identity",
          "title": "Tell us who is opening the file",
          "tone": "A few details here help us match the request to the correct desk without making you repeat yourself later.",
          "fields": [
            {
              "id": "client_name",
              "type": "text",
              "label": "Full name",
              "required": true
            },
            {
              "id": "contact_email",
              "type": "email",
              "label": "Best email for case communication",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "type": "text",
              "label": "Phone, WhatsApp, LINE, or preferred secondary contact",
              "required": false
            },
            {
              "id": "country_region",
              "type": "text",
              "label": "Country or region",
              "required": true
            },
            {
              "id": "client_type",
              "type": "select",
              "label": "Which best describes you?",
              "required": true,
              "options": [
                "Private individual",
                "Collector or buyer",
                "Company or organization",
                "Advisor / representative / family office",
                "Dealer / gallery / shop / importer",
                "Traveler or concierge client",
                "Not sure / other"
              ]
            }
          ]
        },
        {
          "id": "request_map",
          "title": "Map the request corridor",
          "tone": "Plain wording is fine. We are looking for the practical result: what needs to be checked, sourced, arranged, recovered, reviewed, or coordinated.",
          "fields": [
            {
              "id": "request_category",
              "type": "checkbox_group",
              "label": "Which category best fits this request?",
              "required": true,
              "options": [
                "Sourcing / procurement / item finding",
                "Proxy buyer / seller communication / purchase execution",
                "Shopping / styling / concierge support",
                "Art / antiques / cultural object review",
                "Logistics / cargo / local representation",
                "Travel / reservation / experience access",
                "Compliance-sensitive item or export/import question",
                "Lost item / missing person / welfare / urgent support",
                "Beauty / medical / wellness-related sourcing or support",
                "JDM / vehicle / parts / inspection",
                "Other / not sure"
              ]
            },
            {
              "id": "request_summary",
              "type": "textarea",
              "label": "What do you want JapanSolved™ to help you do or decide?",
              "required": true,
              "placeholder": "Example: I found an item in Japan and need to know whether to buy it, ask the seller questions, route it to export review, or use proxy purchase support."
            },
            {
              "id": "current_stage",
              "type": "select",
              "label": "What stage is the request in now?",
              "required": true,
              "options": [
                "Research only",
                "I found something but have not acted",
                "I contacted the seller / venue / third party",
                "I have a deadline or appointment",
                "I already paid or committed",
                "The item/person/service is already in Japan-side custody or progress",
                "I need urgent route correction",
                "Not sure"
              ]
            },
            {
              "id": "links_references",
              "type": "url_list",
              "label": "Links, references, screenshots, or source notes",
              "required": false,
              "helper": "Paste URLs, listing links, venue links, Google Drive links, screenshots links, or short source notes. For file uploads, send links for now or wait for JapanSolved™ to request them after review."
            }
          ]
        },
        {
          "id": "timing_budget_risk",
          "title": "Timing, budget, and risk shape",
          "tone": "This is the part that helps us prevent wrong-route work. Deadlines, budgets, and risk signals decide whether a baseline review is enough or a deposit/retainer is needed.",
          "fields": [
            {
              "id": "urgency",
              "type": "select",
              "label": "How urgent is this?",
              "required": true,
              "options": [
                "No urgent deadline",
                "Within 2 to 4 weeks",
                "Within 1 week",
                "Within 72 hours",
                "Within 24 hours",
                "Already overdue / already committed",
                "Travel / event / pickup / seller deadline exists",
                "Not sure"
              ]
            },
            {
              "id": "deadline_details",
              "type": "textarea",
              "label": "Deadline details, if any",
              "required": false,
              "required_logic": "required_if_urgent",
              "placeholder": "Auction close, travel date, pickup deadline, reservation window, seller hold, event date, import/export timing, etc."
            },
            {
              "id": "estimated_budget",
              "type": "text",
              "label": "Estimated budget or amount at stake",
              "required": false,
              "placeholder": "Example: ¥180,000 item budget, $2,500 review/shipping range, or not sure yet"
            },
            {
              "id": "risk_flags",
              "type": "checkbox_group",
              "label": "Which risk flags may apply?",
              "required": true,
              "options": [
                "High-value item or sensitive client",
                "Already paid or committed",
                "Seller / venue / third party may not cooperate",
                "Export/import/customs/carrier issue",
                "Authenticity / provenance / documentation concern",
                "Large / fragile / living / regulated / hard-to-move item",
                "Privacy / reputation / discretion concern",
                "Health / safety / welfare concern",
                "Tight deadline",
                "I am not sure yet",
                "No obvious risk yet"
              ]
            }
          ]
        },
        {
          "id": "routing_consent",
          "title": "Final checkpoint before submission",
          "tone": "This turns your answers into a routeable intake file. If payment is not complete, we may use this only to point you toward the right product path before review begins.",
          "fields": [
            {
              "id": "final_paid_ack",
              "type": "checkbox",
              "label": "Paid intake handling",
              "required": true,
              "text": "I understand this intake is tied to the appropriate paid review, deposit, retainer, invoice, or service route, and JapanSolved™ may redirect me to the correct product before reviewing details."
            },
            {
              "id": "final_no_guarantee_ack",
              "type": "checkbox",
              "label": "No outcome guarantee",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, approval, sourcing success, reservation success, export/import clearance, recovery success, seller cooperation, or final execution."
            },
            {
              "id": "final_truth_authority_ack",
              "type": "checkbox",
              "label": "Accuracy and authority",
              "required": true,
              "text": "I confirm the information provided is accurate to the best of my knowledge and that I am authorized to submit this request."
            },
            {
              "id": "final_extra_scope_ack",
              "type": "checkbox",
              "label": "Additional scope may be required",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, links, payment, route correction, case deposit, retainer, or a separate quote before action begins."
            },
            {
              "id": "final_notes",
              "type": "textarea",
              "label": "Anything else we should know before routing this?",
              "required": false
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm that this intake is connected to the appropriate paid review, deposit, retainer, invoice, or JapanSolved™-approved payment path for the service I am requesting.",
        "If I have not completed payment yet, I understand JapanSolved™ may route me to the correct product/payment path before reviewing or acting on this intake.",
        "I understand this intake does not guarantee acceptance, approval, availability, seller cooperation, access, sourcing success, reservation success, export/import clearance, customs clearance, carrier acceptance, repair outcome, recovery outcome, safety outcome, or final third-party pricing.",
        "I confirm the information I submitted is accurate to the best of my knowledge and that I am authorized to share it.",
        "I understand JapanSolved™ may request additional clarification, documents, photos, links, payment, authorization, route correction, or a separate quote before the case can proceed."
      ],
      "conditional_rules": [
        "If no paid route is declared, treat as routing-only until product/payment path is complete.",
        "If sensitive risk flags appear, route to the closest specialist intake before action.",
        "If no specialist record exists yet, fallback record preserves the inquiry and payment-route logic."
      ],
      "email_subject": "[JS Native Intake] Generic Routing / {client_name} / {payment_status}",
      "hidden_fields": {
        "fallback_intake": "true",
        "engine_version": "v3",
        "submission_target": "private_intake_delivery_channel"
      },
      "admin_tags": [
        "GENERIC-FALLBACK",
        "ROUTING-ONLY-POSSIBLE",
        "PAYMENT-FIRST",
        "SPECIALIST-ROUTE-NEEDED"
      ],
      "qa_notes": "Use only when a landing page does not yet have a completed specialist record or as emergency fallback during final-pass rollout.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "engagement_programming": [
        "Keep the user oriented.",
        "Ask broad routing questions first.",
        "Never punish uncertainty.",
        "End with paid-route clarity."
      ],
      "intake_bank_extraction": {
        "source_file": "v1.4 baseline registry",
        "source_mode": "v1_4_generic_fallback",
        "scraped_from_page_body_embedded_nif": false,
        "extracted_at": "2026-07-03 05:43:01",
        "stored_in_registry_bank": true,
        "original_final_confirmation_field_count": 5,
        "hardened_final_confirmation_field_count": 5
      }
    },
    {
      "record_id": "japan-health-longevity-discreet-care-access",
      "page_sequence": "ANNEX-J-00",
      "page_title": "Japan Health, Longevity & Discreet Care Access Wing™",
      "page_handle": "japan-health-longevity-discreet-care-access",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-health-longevity-discreet-care-access",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Health, Longevity & Discreet Care Access Wing™ Intake",
      "intake_title": "Japan Health, Longevity & Discreet Care Access Wing™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Parent wing / care corridor router for medical tourism, longevity, discreet care, suitability, wellness stay, records, clinic-claim sorting, and sensitive health-adjacent routing.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Health, Longevity & Discreet Care Route Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-health-longevity-discreet-care-route-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Health, Longevity & Discreet Care Route Review™",
          "url": "/products/japan-health-longevity-discreet-care-route-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Health, Longevity & Discreet Care Route Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Health, Longevity & Discreet Care Route Review™",
                  "value": "/products/japan-health-longevity-discreet-care-route-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Parent wing / care corridor router for medical tourism, longevity, discreet care, suitability, wellness stay, records, clinic-claim sorting, and sensitive health-adjacent routing.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Stem cell / regenerative longevity",
                  "value": "stem_cell_regenerative_longevity"
                },
                {
                  "label": "Second opinion / records coordination",
                  "value": "second_opinion_records_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay",
                  "value": "private_recovery_stay"
                },
                {
                  "label": "Travel suitability / cultural access",
                  "value": "travel_suitability_cultural_access"
                },
                {
                  "label": "Discreet care or sensitive handling",
                  "value": "discreet_care_or_sensitive_handling"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "medical_adjacency_level",
              "label": "How medically sensitive is this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Not medical, wellness/travel only",
                  "value": "not_medical_wellness_travel_only"
                },
                {
                  "label": "Medical-adjacent but not urgent",
                  "value": "medical_adjacent_but_not_urgent"
                },
                {
                  "label": "Medical records or provider review involved",
                  "value": "medical_records_or_provider_review_involved"
                },
                {
                  "label": "Treatment/procedure route involved",
                  "value": "treatment_procedure_route_involved"
                },
                {
                  "label": "Sensitive/discreet care context",
                  "value": "sensitive_discreet_care_context"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "care_priorities",
              "label": "What matters most?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Safety screening",
                  "value": "safety_screening"
                },
                {
                  "label": "Claim sorting",
                  "value": "claim_sorting"
                },
                {
                  "label": "Privacy",
                  "value": "privacy"
                },
                {
                  "label": "Translation readiness",
                  "value": "translation_readiness"
                },
                {
                  "label": "Provider comparison",
                  "value": "provider_comparison"
                },
                {
                  "label": "Recovery logistics",
                  "value": "recovery_logistics"
                },
                {
                  "label": "Travel rhythm",
                  "value": "travel_rhythm"
                },
                {
                  "label": "Family/assistant coordination",
                  "value": "family_assistant_coordination"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "health_boundary_notes",
              "label": "Any boundaries, diagnoses, treatments, or private matters JapanSolved™ should avoid storing in this first intake?",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee medical suitability, provider acceptance, clinical result, treatment recommendation, travel feasibility, privacy outcome, or final coordination approval.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee medical suitability, provider acceptance, clinical result, treatment recommendation, travel feasibility, privacy outcome, or final coordination approval."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee medical suitability, provider acceptance, clinical result, treatment recommendation, travel feasibility, privacy outcome, or final coordination approval.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Health, Longevity & Discreet Care Access Wing™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-health-longevity-discreet-care-access",
        "desk_name": "Japan Health, Longevity & Discreet Care Access Wing™",
        "intake_type": "japan_health_longevity_discreet_care_access",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_HEALTH_LONGEVITY_DISCREET_CARE_ACCESS",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-J-00",
        "role": "Parent wing / care corridor router for medical tourism, longevity, discreet care, suitability, wellness stay, records, clinic-claim sorting, and sensitive health-adjacent routing.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-stem-cell-regenerative-longevity-access",
      "page_sequence": "ANNEX-J-01",
      "page_title": "Japan Stem Cell & Regenerative Longevity Access Desk™",
      "page_handle": "japan-stem-cell-regenerative-longevity-access",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-stem-cell-regenerative-longevity-access",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Stem Cell & Regenerative Longevity Access Desk™ Intake",
      "intake_title": "Japan Stem Cell & Regenerative Longevity Access Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Stem cell, regenerative, exosome, anti-aging, and clinic-claim sorting desk focused on classification, risk language, and route discipline before fantasy.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Stem Cell & Regenerative Longevity Access Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-stem-cell-regenerative-longevity-access-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Stem Cell & Regenerative Longevity Access Review™",
          "url": "/products/japan-stem-cell-regenerative-longevity-access-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Stem Cell & Regenerative Longevity Access Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Stem Cell & Regenerative Longevity Access Review™",
                  "value": "/products/japan-stem-cell-regenerative-longevity-access-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Stem cell, regenerative, exosome, anti-aging, and clinic-claim sorting desk focused on classification, risk language, and route discipline before fantasy.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Stem cell therapy",
                  "value": "stem_cell_therapy"
                },
                {
                  "label": "Exosome / regenerative clinic",
                  "value": "exosome_regenerative_clinic"
                },
                {
                  "label": "Anti-aging / longevity program",
                  "value": "anti_aging_longevity_program"
                },
                {
                  "label": "Clinic claim verification",
                  "value": "clinic_claim_verification"
                },
                {
                  "label": "Travel and recovery logistics",
                  "value": "travel_and_recovery_logistics"
                },
                {
                  "label": "Second opinion / records needed first",
                  "value": "second_opinion_records_needed_first"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "therapy_claim_types",
              "label": "Which claim areas are involved?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Stem cells",
                  "value": "stem_cells"
                },
                {
                  "label": "Exosomes",
                  "value": "exosomes"
                },
                {
                  "label": "Regenerative medicine",
                  "value": "regenerative_medicine"
                },
                {
                  "label": "Anti-aging",
                  "value": "anti_aging"
                },
                {
                  "label": "Pain / orthopedic",
                  "value": "pain_orthopedic"
                },
                {
                  "label": "Neurological claim",
                  "value": "neurological_claim"
                },
                {
                  "label": "Immune / wellness claim",
                  "value": "immune_wellness_claim"
                },
                {
                  "label": "Beauty / skin claim",
                  "value": "beauty_skin_claim"
                },
                {
                  "label": "Unclear marketing claim",
                  "value": "unclear_marketing_claim"
                }
              ]
            },
            {
              "id": "prior_medical_review",
              "label": "Has a licensed medical professional already reviewed your suitability?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes",
                  "value": "yes"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Partially",
                  "value": "partially"
                },
                {
                  "label": "Clinic claims yes but I am unsure",
                  "value": "clinic_claims_yes_but_i_am_unsure"
                },
                {
                  "label": "Prefer not to say",
                  "value": "prefer_not_to_say"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "clinic_claim_links",
              "label": "Clinic links, brochures, screenshots, or claims to review",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee clinic acceptance, medical suitability, treatment availability, regenerative result, anti-aging outcome, diagnosis, provider response, or program approval.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee clinic acceptance, medical suitability, treatment availability, regenerative result, anti-aging outcome, diagnosis, provider response, or program approval."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee clinic acceptance, medical suitability, treatment availability, regenerative result, anti-aging outcome, diagnosis, provider response, or program approval.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Stem Cell & Regenerative Longevity Access Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-stem-cell-regenerative-longevity-access",
        "desk_name": "Japan Stem Cell & Regenerative Longevity Access Desk™",
        "intake_type": "japan_stem_cell_regenerative_longevity_access",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_STEM_CELL_REGENERATIVE_LONGEVITY_ACCESS",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-J-01",
        "role": "Stem cell, regenerative, exosome, anti-aging, and clinic-claim sorting desk focused on classification, risk language, and route discipline before fantasy.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-travel-suitability-cultural-access-review",
      "page_sequence": "ANNEX-K-01",
      "page_title": "Japan Travel Suitability & Cultural Access Review Desk™",
      "page_handle": "japan-travel-suitability-cultural-access-review",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-travel-suitability-cultural-access-review",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Travel Suitability & Cultural Access Review Desk™ Intake",
      "intake_title": "Japan Travel Suitability & Cultural Access Review Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Route suitability, cultural-access triage, and sharper Japan planning for travelers who need fit, feasibility, comfort, and route intelligence before building bigger.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Travel Suitability & Cultural Access Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-travel-suitability-cultural-access-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Travel Suitability & Cultural Access Review™",
          "url": "/products/japan-travel-suitability-cultural-access-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Travel Suitability & Cultural Access Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Travel Suitability & Cultural Access Review™",
                  "value": "/products/japan-travel-suitability-cultural-access-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Route suitability, cultural-access triage, and sharper Japan planning for travelers who need fit, feasibility, comfort, and route intelligence before building bigger.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Route suitability",
                  "value": "route_suitability"
                },
                {
                  "label": "Cultural access review",
                  "value": "cultural_access_review"
                },
                {
                  "label": "Travel comfort / constraints",
                  "value": "travel_comfort_constraints"
                },
                {
                  "label": "Family or elder travel",
                  "value": "family_or_elder_travel"
                },
                {
                  "label": "Privacy-sensitive travel",
                  "value": "privacy_sensitive_travel"
                },
                {
                  "label": "Special-interest Japan route",
                  "value": "special_interest_japan_route"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "traveler_constraints",
              "label": "Which traveler constraints matter?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Mobility/walking load",
                  "value": "mobility_walking_load"
                },
                {
                  "label": "Dietary needs",
                  "value": "dietary_needs"
                },
                {
                  "label": "Children/family pacing",
                  "value": "children_family_pacing"
                },
                {
                  "label": "Elder support",
                  "value": "elder_support"
                },
                {
                  "label": "Sensory/crowd limits",
                  "value": "sensory_crowd_limits"
                },
                {
                  "label": "Privacy",
                  "value": "privacy"
                },
                {
                  "label": "Language barrier",
                  "value": "language_barrier"
                },
                {
                  "label": "Cultural etiquette",
                  "value": "cultural_etiquette"
                },
                {
                  "label": "Weather/seasonal constraints",
                  "value": "weather_seasonal_constraints"
                }
              ]
            },
            {
              "id": "planning_stage",
              "label": "Planning stage",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Not booked",
                  "value": "not_booked"
                },
                {
                  "label": "Flights booked",
                  "value": "flights_booked"
                },
                {
                  "label": "Hotels booked",
                  "value": "hotels_booked"
                },
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Post-trip follow-up",
                  "value": "post_trip_follow_up"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "route_dream_vs_risk",
              "label": "What is the dream route, and what might make it fail?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee itinerary feasibility, cultural-access approval, provider acceptance, reservation availability, companion availability, route suitability, or final coordination approval.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee itinerary feasibility, cultural-access approval, provider acceptance, reservation availability, companion availability, route suitability, or final coordination approval."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee itinerary feasibility, cultural-access approval, provider acceptance, reservation availability, companion availability, route suitability, or final coordination approval.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Travel Suitability & Cultural Access Review Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-travel-suitability-cultural-access-review",
        "desk_name": "Japan Travel Suitability & Cultural Access Review Desk™",
        "intake_type": "japan_travel_suitability_cultural_access_review",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_TRAVEL_SUITABILITY_CULTURAL_ACCESS_REVIEW",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-K-01",
        "role": "Route suitability, cultural-access triage, and sharper Japan planning for travelers who need fit, feasibility, comfort, and route intelligence before building bigger.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-second-opinion-medical-records-coordination",
      "page_sequence": "ANNEX-J-02",
      "page_title": "Japan Second Opinion & Medical Records Coordination Desk™",
      "page_handle": "japan-second-opinion-medical-records-coordination",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-second-opinion-medical-records-coordination",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Second Opinion & Medical Records Coordination Desk™ Intake",
      "intake_title": "Japan Second Opinion & Medical Records Coordination Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Documentation brain of ANNEX-J: translation, records organization, doctor-summary preparation, appointment-readiness, provider-routing clarity, and second-opinion coordination support.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Second Opinion & Medical Records Coordination Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-second-opinion-medical-records-coordination-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Second Opinion & Medical Records Coordination Review™",
          "url": "/products/japan-second-opinion-medical-records-coordination-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Second Opinion & Medical Records Coordination Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Second Opinion & Medical Records Coordination Review™",
                  "value": "/products/japan-second-opinion-medical-records-coordination-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Documentation brain of ANNEX-J: translation, records organization, doctor-summary preparation, appointment-readiness, provider-routing clarity, and second-opinion coordination support.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Second opinion preparation",
                  "value": "second_opinion_preparation"
                },
                {
                  "label": "Medical records organization",
                  "value": "medical_records_organization"
                },
                {
                  "label": "Translation / summary preparation",
                  "value": "translation_summary_preparation"
                },
                {
                  "label": "Doctor appointment readiness",
                  "value": "doctor_appointment_readiness"
                },
                {
                  "label": "Clinic/provider routing",
                  "value": "clinic_provider_routing"
                },
                {
                  "label": "Diagnosis/treatment question clarification",
                  "value": "diagnosis_treatment_question_clarification"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "records_available",
              "label": "Which records exist?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Doctor letter",
                  "value": "doctor_letter"
                },
                {
                  "label": "Diagnosis summary",
                  "value": "diagnosis_summary"
                },
                {
                  "label": "Lab results",
                  "value": "lab_results"
                },
                {
                  "label": "Imaging report",
                  "value": "imaging_report"
                },
                {
                  "label": "Medication list",
                  "value": "medication_list"
                },
                {
                  "label": "Treatment plan",
                  "value": "treatment_plan"
                },
                {
                  "label": "Insurance documents",
                  "value": "insurance_documents"
                },
                {
                  "label": "Japanese records",
                  "value": "japanese_records"
                },
                {
                  "label": "English records",
                  "value": "english_records"
                },
                {
                  "label": "No records yet",
                  "value": "no_records_yet"
                }
              ]
            },
            {
              "id": "records_language",
              "label": "Primary records language",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "English",
                  "value": "english"
                },
                {
                  "label": "Japanese",
                  "value": "japanese"
                },
                {
                  "label": "Chinese",
                  "value": "chinese"
                },
                {
                  "label": "Korean",
                  "value": "korean"
                },
                {
                  "label": "Other",
                  "value": "other"
                },
                {
                  "label": "Mixed",
                  "value": "mixed"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "medical_question_to_answer",
              "label": "What exact question should a second-opinion route help clarify?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee a medical opinion, doctor acceptance, diagnosis, treatment recommendation, appointment availability, translation outcome, or provider response.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee a medical opinion, doctor acceptance, diagnosis, treatment recommendation, appointment availability, translation outcome, or provider response."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee a medical opinion, doctor acceptance, diagnosis, treatment recommendation, appointment availability, translation outcome, or provider response.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Second Opinion & Medical Records Coordination Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-second-opinion-medical-records-coordination",
        "desk_name": "Japan Second Opinion & Medical Records Coordination Desk™",
        "intake_type": "japan_second_opinion_medical_records_coordination",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_SECOND_OPINION_MEDICAL_RECORDS_COORDINATION",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-J-02",
        "role": "Documentation brain of ANNEX-J: translation, records organization, doctor-summary preparation, appointment-readiness, provider-routing clarity, and second-opinion coordination support.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-longevity-clinic-rejuvenation-route",
      "page_sequence": "ANNEX-J-03",
      "page_title": "Japan Longevity Clinic & Rejuvenation Route Desk™",
      "page_handle": "japan-longevity-clinic-rejuvenation-route",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-longevity-clinic-rejuvenation-route",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Longevity Clinic & Rejuvenation Route Desk™ Intake",
      "intake_title": "Japan Longevity Clinic & Rejuvenation Route Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Longevity clinics, anti-aging programs, preventive diagnostics, IV/wellness-adjacent routes, recovery stays, and high-discretion rejuvenation planning.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Longevity Clinic Route Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-longevity-clinic-route-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Longevity Clinic Route Review™",
          "url": "/products/japan-longevity-clinic-route-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Longevity Clinic Route Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Longevity Clinic Route Review™",
                  "value": "/products/japan-longevity-clinic-route-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Longevity clinics, anti-aging programs, preventive diagnostics, IV/wellness-adjacent routes, recovery stays, and high-discretion rejuvenation planning.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Longevity clinic route",
                  "value": "longevity_clinic_route"
                },
                {
                  "label": "Anti-aging program",
                  "value": "anti_aging_program"
                },
                {
                  "label": "Health screening",
                  "value": "health_screening"
                },
                {
                  "label": "Preventive diagnostics",
                  "value": "preventive_diagnostics"
                },
                {
                  "label": "IV/wellness-adjacent route",
                  "value": "iv_wellness_adjacent_route"
                },
                {
                  "label": "High-discretion rejuvenation stay",
                  "value": "high_discretion_rejuvenation_stay"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "longevity_interests",
              "label": "Which route elements interest you?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Executive health screening",
                  "value": "executive_health_screening"
                },
                {
                  "label": "Biomarker review",
                  "value": "biomarker_review"
                },
                {
                  "label": "Preventive diagnostics",
                  "value": "preventive_diagnostics"
                },
                {
                  "label": "Recovery / sleep / stress",
                  "value": "recovery_sleep_stress"
                },
                {
                  "label": "IV/wellness",
                  "value": "iv_wellness"
                },
                {
                  "label": "Skin / beauty-adjacent rejuvenation",
                  "value": "skin_beauty_adjacent_rejuvenation"
                },
                {
                  "label": "Hotel/stay planning",
                  "value": "hotel_stay_planning"
                },
                {
                  "label": "Interpreter support",
                  "value": "interpreter_support"
                }
              ]
            },
            {
              "id": "risk_posture",
              "label": "Risk posture",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Conservative / evidence-first",
                  "value": "conservative_evidence_first"
                },
                {
                  "label": "Open but cautious",
                  "value": "open_but_cautious"
                },
                {
                  "label": "Exploratory",
                  "value": "exploratory"
                },
                {
                  "label": "High-discretion / privacy-first",
                  "value": "high_discretion_privacy_first"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "longevity_claims_or_programs",
              "label": "Clinics, programs, claims, or packages you want classified",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee clinic acceptance, medical suitability, diagnostic result, treatment recommendation, wellness outcome, appointment availability, or program approval.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee clinic acceptance, medical suitability, diagnostic result, treatment recommendation, wellness outcome, appointment availability, or program approval."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee clinic acceptance, medical suitability, diagnostic result, treatment recommendation, wellness outcome, appointment availability, or program approval.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Longevity Clinic & Rejuvenation Route Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-longevity-clinic-rejuvenation-route",
        "desk_name": "Japan Longevity Clinic & Rejuvenation Route Desk™",
        "intake_type": "japan_longevity_clinic_rejuvenation_route",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_LONGEVITY_CLINIC_REJUVENATION_ROUTE",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-J-03",
        "role": "Longevity clinics, anti-aging programs, preventive diagnostics, IV/wellness-adjacent routes, recovery stays, and high-discretion rejuvenation planning.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-cosmetic-surgery-route-image-coordination",
      "page_sequence": "ANNEX-J-04",
      "page_title": "Japan Cosmetic Surgery Route & Image Coordination Desk™",
      "page_handle": "japan-cosmetic-surgery-route-image-coordination",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-cosmetic-surgery-route-image-coordination",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Cosmetic Surgery Route & Image Coordination Desk™ Intake",
      "intake_title": "Japan Cosmetic Surgery Route & Image Coordination Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Cosmetic surgery route sorting, clinic comparison, image/aesthetic planning support, translation prep, privacy handling, recovery logistics, and post-procedure stay planning.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Cosmetic Surgery Route Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-cosmetic-surgery-route-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Cosmetic Surgery Route Review™",
          "url": "/products/japan-cosmetic-surgery-route-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Cosmetic Surgery Route Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Cosmetic Surgery Route Review™",
                  "value": "/products/japan-cosmetic-surgery-route-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Cosmetic surgery route sorting, clinic comparison, image/aesthetic planning support, translation prep, privacy handling, recovery logistics, and post-procedure stay planning.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Cosmetic surgery clinic route",
                  "value": "cosmetic_surgery_clinic_route"
                },
                {
                  "label": "Procedure comparison",
                  "value": "procedure_comparison"
                },
                {
                  "label": "Aesthetic/image planning support",
                  "value": "aesthetic_image_planning_support"
                },
                {
                  "label": "Translation prep",
                  "value": "translation_prep"
                },
                {
                  "label": "Privacy handling",
                  "value": "privacy_handling"
                },
                {
                  "label": "Recovery logistics",
                  "value": "recovery_logistics"
                },
                {
                  "label": "Post-procedure stay planning",
                  "value": "post_procedure_stay_planning"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "procedure_areas",
              "label": "Which procedure areas are involved?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Face",
                  "value": "face"
                },
                {
                  "label": "Eyes",
                  "value": "eyes"
                },
                {
                  "label": "Nose",
                  "value": "nose"
                },
                {
                  "label": "Jaw/contour",
                  "value": "jaw_contour"
                },
                {
                  "label": "Skin/laser",
                  "value": "skin_laser"
                },
                {
                  "label": "Body",
                  "value": "body"
                },
                {
                  "label": "Hair",
                  "value": "hair"
                },
                {
                  "label": "Dental/cosmetic",
                  "value": "dental_cosmetic"
                },
                {
                  "label": "Revision/second opinion",
                  "value": "revision_second_opinion"
                },
                {
                  "label": "Prefer not to say yet",
                  "value": "prefer_not_to_say_yet"
                }
              ]
            },
            {
              "id": "surgery_timing",
              "label": "Procedure timing",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already scheduled",
                  "value": "already_scheduled"
                },
                {
                  "label": "Seeking clinic options",
                  "value": "seeking_clinic_options"
                },
                {
                  "label": "Comparing quotes",
                  "value": "comparing_quotes"
                },
                {
                  "label": "Travel dates fixed",
                  "value": "travel_dates_fixed"
                },
                {
                  "label": "Exploratory only",
                  "value": "exploratory_only"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "aesthetic_goal_boundaries",
              "label": "Describe the aesthetic goal and any hard boundaries",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee surgical suitability, clinic acceptance, procedure result, aesthetic outcome, medical recommendation, appointment availability, or recovery outcome.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee surgical suitability, clinic acceptance, procedure result, aesthetic outcome, medical recommendation, appointment availability, or recovery outcome."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee surgical suitability, clinic acceptance, procedure result, aesthetic outcome, medical recommendation, appointment availability, or recovery outcome.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Cosmetic Surgery Route & Image Coordination Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-cosmetic-surgery-route-image-coordination",
        "desk_name": "Japan Cosmetic Surgery Route & Image Coordination Desk™",
        "intake_type": "japan_cosmetic_surgery_route_image_coordination",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_COSMETIC_SURGERY_ROUTE_IMAGE_COORDINATION",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-J-04",
        "role": "Cosmetic surgery route sorting, clinic comparison, image/aesthetic planning support, translation prep, privacy handling, recovery logistics, and post-procedure stay planning.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-private-wellness-stay-recovery-planning",
      "page_sequence": "ANNEX-J-05",
      "page_title": "Japan Private Wellness Stay & Recovery Planning Desk™",
      "page_handle": "japan-private-wellness-stay-recovery-planning",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-private-wellness-stay-recovery-planning",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Private Wellness Stay & Recovery Planning Desk™ Intake",
      "intake_title": "Japan Private Wellness Stay & Recovery Planning Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Soft bridge between medical, travel, privacy, sabbatical, and companion/reset: quiet stay design, recovery rhythm, private lodging, low-stress movement, meals, interpreter support, and discretion.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Private Recovery Stay Planning Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-private-recovery-stay-planning-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Private Recovery Stay Planning Review™",
          "url": "/products/japan-private-recovery-stay-planning-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Private Recovery Stay Planning Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Private Recovery Stay Planning Review™",
                  "value": "/products/japan-private-recovery-stay-planning-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Soft bridge between medical, travel, privacy, sabbatical, and companion/reset: quiet stay design, recovery rhythm, private lodging, low-stress movement, meals, interpreter support, and discretion.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Private recovery stay",
                  "value": "private_recovery_stay"
                },
                {
                  "label": "Wellness stay",
                  "value": "wellness_stay"
                },
                {
                  "label": "Post-procedure rhythm",
                  "value": "post_procedure_rhythm"
                },
                {
                  "label": "Low-stress movement",
                  "value": "low_stress_movement"
                },
                {
                  "label": "Meal/support planning",
                  "value": "meal_support_planning"
                },
                {
                  "label": "Interpreter/local liaison",
                  "value": "interpreter_local_liaison"
                },
                {
                  "label": "Discreet lodging / movement",
                  "value": "discreet_lodging_movement"
                },
                {
                  "label": "Sabbatical/reset bridge",
                  "value": "sabbatical_reset_bridge"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "stay_needs",
              "label": "What stay layers may be needed?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Quiet hotel/ryokan logic",
                  "value": "quiet_hotel_ryokan_logic"
                },
                {
                  "label": "Apartment/private stay",
                  "value": "apartment_private_stay"
                },
                {
                  "label": "Meal rhythm",
                  "value": "meal_rhythm"
                },
                {
                  "label": "Low-walking route",
                  "value": "low_walking_route"
                },
                {
                  "label": "Transport support",
                  "value": "transport_support"
                },
                {
                  "label": "Interpreter",
                  "value": "interpreter"
                },
                {
                  "label": "Companion/local presence",
                  "value": "companion_local_presence"
                },
                {
                  "label": "Family/assistant coordination",
                  "value": "family_assistant_coordination"
                },
                {
                  "label": "Privacy",
                  "value": "privacy"
                }
              ]
            },
            {
              "id": "care_level",
              "label": "Care level expected",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Self-directed wellness stay",
                  "value": "self_directed_wellness_stay"
                },
                {
                  "label": "Light local support",
                  "value": "light_local_support"
                },
                {
                  "label": "Post-procedure logistics",
                  "value": "post_procedure_logistics"
                },
                {
                  "label": "Family/assistant-supported",
                  "value": "family_assistant_supported"
                },
                {
                  "label": "Medical provider involved separately",
                  "value": "medical_provider_involved_separately"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "daily_rhythm",
              "label": "Describe the ideal daily rhythm and recovery constraints",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee accommodation availability, medical recovery outcome, provider acceptance, itinerary feasibility, companion availability, or final coordination approval.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee accommodation availability, medical recovery outcome, provider acceptance, itinerary feasibility, companion availability, or final coordination approval."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee accommodation availability, medical recovery outcome, provider acceptance, itinerary feasibility, companion availability, or final coordination approval.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Private Wellness Stay & Recovery Planning Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-private-wellness-stay-recovery-planning",
        "desk_name": "Japan Private Wellness Stay & Recovery Planning Desk™",
        "intake_type": "japan_private_wellness_stay_recovery_planning",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_PRIVATE_WELLNESS_STAY_RECOVERY_PLANNING",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-J-05",
        "role": "Soft bridge between medical, travel, privacy, sabbatical, and companion/reset: quiet stay design, recovery rhythm, private lodging, low-stress movement, meals, interpreter support, and discretion.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-private-sensitive-discreet-matters-hub",
      "page_sequence": "ANNEX-L-00",
      "page_title": "Japan Private, Sensitive & Discreet Matters Hub™",
      "page_handle": "japan-private-sensitive-discreet-matters-hub",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-private-sensitive-discreet-matters-hub",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Private, Sensitive & Discreet Matters Hub™ Intake",
      "intake_title": "Japan Private, Sensitive & Discreet Matters Hub™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Parent corridor for delicate, reputation-aware, family-sensitive, public-visibility-sensitive, or unusual requests that need lawful, calm, boundaried route triage.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Sensitive Matter Route Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-sensitive-matter-route-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Sensitive Matter Route Review™",
          "url": "/products/japan-sensitive-matter-route-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Sensitive Matter Route Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Sensitive Matter Route Review™",
                  "value": "/products/japan-sensitive-matter-route-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Parent corridor for delicate, reputation-aware, family-sensitive, public-visibility-sensitive, or unusual requests that need lawful, calm, boundaried route triage.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Sensitive family matter",
                  "value": "sensitive_family_matter"
                },
                {
                  "label": "Reputation-sensitive request",
                  "value": "reputation_sensitive_request"
                },
                {
                  "label": "Discreet movement / stay",
                  "value": "discreet_movement_stay"
                },
                {
                  "label": "Private visit coordination",
                  "value": "private_visit_coordination"
                },
                {
                  "label": "Welfare-adjacent non-emergency matter",
                  "value": "welfare_adjacent_non_emergency_matter"
                },
                {
                  "label": "Public-visibility concern",
                  "value": "public_visibility_concern"
                },
                {
                  "label": "Unusual request / not sure",
                  "value": "unusual_request_not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "sensitivity_level",
              "label": "Sensitivity level",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Mild discretion",
                  "value": "mild_discretion"
                },
                {
                  "label": "High privacy",
                  "value": "high_privacy"
                },
                {
                  "label": "Family-sensitive",
                  "value": "family_sensitive"
                },
                {
                  "label": "Reputation-sensitive",
                  "value": "reputation_sensitive"
                },
                {
                  "label": "Public-visibility-sensitive",
                  "value": "public_visibility_sensitive"
                },
                {
                  "label": "Legal/lawful-feasibility concern",
                  "value": "legal_lawful_feasibility_concern"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "boundaries",
              "label": "Which boundaries matter?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "No public exposure",
                  "value": "no_public_exposure"
                },
                {
                  "label": "No third-party contact without approval",
                  "value": "no_third_party_contact_without_approval"
                },
                {
                  "label": "No illegal or coercive action",
                  "value": "no_illegal_or_coercive_action"
                },
                {
                  "label": "No medical emergency channel",
                  "value": "no_medical_emergency_channel"
                },
                {
                  "label": "No surveillance/stalking",
                  "value": "no_surveillance_stalking"
                },
                {
                  "label": "No private-address hunting",
                  "value": "no_private_address_hunting"
                },
                {
                  "label": "Need careful wording",
                  "value": "need_careful_wording"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "sensitive_summary",
              "label": "Describe the matter in careful, minimum-necessary language",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee acceptance, lawful feasibility, third-party cooperation, privacy outcome, access approval, investigation result, or final coordination action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee acceptance, lawful feasibility, third-party cooperation, privacy outcome, access approval, investigation result, or final coordination action."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee acceptance, lawful feasibility, third-party cooperation, privacy outcome, access approval, investigation result, or final coordination action.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Private, Sensitive & Discreet Matters Hub™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-private-sensitive-discreet-matters-hub",
        "desk_name": "Japan Private, Sensitive & Discreet Matters Hub™",
        "intake_type": "japan_private_sensitive_discreet_matters_hub",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_PRIVATE_SENSITIVE_DISCREET_MATTERS_HUB",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-L-00",
        "role": "Parent corridor for delicate, reputation-aware, family-sensitive, public-visibility-sensitive, or unusual requests that need lawful, calm, boundaried route triage.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-sensitive-life-matter-coordination",
      "page_sequence": "ANNEX-L-01",
      "page_title": "Japan Sensitive Life Matter Coordination Desk™",
      "page_handle": "japan-sensitive-life-matter-coordination",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-sensitive-life-matter-coordination",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Sensitive Life Matter Coordination Desk™ Intake",
      "intake_title": "Japan Sensitive Life Matter Coordination Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Family matters, personal situations, delicate welfare-adjacent coordination, non-emergency sensitive requests, discreet local help, and route triage.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Sensitive Life Matter Coordination Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-sensitive-life-matter-coordination-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Sensitive Life Matter Coordination Review™",
          "url": "/products/japan-sensitive-life-matter-coordination-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Sensitive Life Matter Coordination Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Sensitive Life Matter Coordination Review™",
                  "value": "/products/japan-sensitive-life-matter-coordination-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Family matters, personal situations, delicate welfare-adjacent coordination, non-emergency sensitive requests, discreet local help, and route triage.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Family-sensitive matter",
                  "value": "family_sensitive_matter"
                },
                {
                  "label": "Non-emergency welfare-adjacent support",
                  "value": "non_emergency_welfare_adjacent_support"
                },
                {
                  "label": "Delicate personal coordination",
                  "value": "delicate_personal_coordination"
                },
                {
                  "label": "Local discreet help",
                  "value": "local_discreet_help"
                },
                {
                  "label": "Communication/translation support",
                  "value": "communication_translation_support"
                },
                {
                  "label": "Route triage",
                  "value": "route_triage"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "emergency_status",
              "label": "Is this an active emergency or immediate danger?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Possible but not immediate",
                  "value": "possible_but_not_immediate"
                },
                {
                  "label": "Yes, active emergency",
                  "value": "yes_active_emergency"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "coordination_needed",
              "label": "What support might be needed?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Local information gathering",
                  "value": "local_information_gathering"
                },
                {
                  "label": "Translation/wording support",
                  "value": "translation_wording_support"
                },
                {
                  "label": "Appointment/support route",
                  "value": "appointment_support_route"
                },
                {
                  "label": "Family coordination",
                  "value": "family_coordination"
                },
                {
                  "label": "Privacy-aware logistics",
                  "value": "privacy_aware_logistics"
                },
                {
                  "label": "Non-emergency check-in route",
                  "value": "non_emergency_check_in_route"
                },
                {
                  "label": "Referral to proper authority",
                  "value": "referral_to_proper_authority"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "who_is_involved_minimum",
              "label": "Who is involved, in minimum necessary terms?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee welfare outcome, third-party cooperation, legal feasibility, family resolution, contact success, safety outcome, privacy outcome, or coordination action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee welfare outcome, third-party cooperation, legal feasibility, family resolution, contact success, safety outcome, privacy outcome, or coordination action."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee welfare outcome, third-party cooperation, legal feasibility, family resolution, contact success, safety outcome, privacy outcome, or coordination action.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Sensitive Life Matter Coordination Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-sensitive-life-matter-coordination",
        "desk_name": "Japan Sensitive Life Matter Coordination Desk™",
        "intake_type": "japan_sensitive_life_matter_coordination",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_SENSITIVE_LIFE_MATTER_COORDINATION",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-L-01",
        "role": "Family matters, personal situations, delicate welfare-adjacent coordination, non-emergency sensitive requests, discreet local help, and route triage.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-private-stay-discreet-movement-coordination",
      "page_sequence": "ANNEX-L-02",
      "page_title": "Japan Private Stay & Discreet Movement Coordination Desk™",
      "page_handle": "japan-private-stay-discreet-movement-coordination",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-private-stay-discreet-movement-coordination",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Private Stay & Discreet Movement Coordination Desk™ Intake",
      "intake_title": "Japan Private Stay & Discreet Movement Coordination Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Public-visibility avoidance, privacy-first movement, quiet hotels, low-profile transfers, VIP discretion, and delicate route design.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Private Stay & Discreet Movement Coordination Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-private-stay-discreet-movement-coordination-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Private Stay & Discreet Movement Coordination Review™",
          "url": "/products/japan-private-stay-discreet-movement-coordination-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Private Stay & Discreet Movement Coordination Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Private Stay & Discreet Movement Coordination Review™",
                  "value": "/products/japan-private-stay-discreet-movement-coordination-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Public-visibility avoidance, privacy-first movement, quiet hotels, low-profile transfers, VIP discretion, and delicate route design.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Private stay planning",
                  "value": "private_stay_planning"
                },
                {
                  "label": "Discreet movement",
                  "value": "discreet_movement"
                },
                {
                  "label": "Quiet hotel / ryokan logic",
                  "value": "quiet_hotel_ryokan_logic"
                },
                {
                  "label": "Low-profile transfers",
                  "value": "low_profile_transfers"
                },
                {
                  "label": "Public-visibility avoidance",
                  "value": "public_visibility_avoidance"
                },
                {
                  "label": "VIP discretion",
                  "value": "vip_discretion"
                },
                {
                  "label": "Delicate route design",
                  "value": "delicate_route_design"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "movement_privacy_goals",
              "label": "Which privacy outcomes matter?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Avoid lobbies",
                  "value": "avoid_lobbies"
                },
                {
                  "label": "Avoid public queues",
                  "value": "avoid_public_queues"
                },
                {
                  "label": "Avoid crowded stations",
                  "value": "avoid_crowded_stations"
                },
                {
                  "label": "Avoid photos/social posting",
                  "value": "avoid_photos_social_posting"
                },
                {
                  "label": "Quiet entrances/exits",
                  "value": "quiet_entrances_exits"
                },
                {
                  "label": "Private vehicle logic",
                  "value": "private_vehicle_logic"
                },
                {
                  "label": "Low-profile companion/support",
                  "value": "low_profile_companion_support"
                },
                {
                  "label": "Minimal staff explanation",
                  "value": "minimal_staff_explanation"
                }
              ]
            },
            {
              "id": "party_profile",
              "label": "Party profile",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Solo principal",
                  "value": "solo_principal"
                },
                {
                  "label": "Couple/family",
                  "value": "couple_family"
                },
                {
                  "label": "Executive/VIP",
                  "value": "executive_vip"
                },
                {
                  "label": "Public-facing person",
                  "value": "public_facing_person"
                },
                {
                  "label": "Medical/recovery context",
                  "value": "medical_recovery_context"
                },
                {
                  "label": "Sensitive personal matter",
                  "value": "sensitive_personal_matter"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "movement_route_context",
              "label": "Describe the stay and movement context",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee accommodation availability, route privacy, transport availability, venue cooperation, public-visibility avoidance, companion availability, or final coordination approval.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee accommodation availability, route privacy, transport availability, venue cooperation, public-visibility avoidance, companion availability, or final coordination approval."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee accommodation availability, route privacy, transport availability, venue cooperation, public-visibility avoidance, companion availability, or final coordination approval.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Private Stay & Discreet Movement Coordination Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-private-stay-discreet-movement-coordination",
        "desk_name": "Japan Private Stay & Discreet Movement Coordination Desk™",
        "intake_type": "japan_private_stay_discreet_movement_coordination",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_PRIVATE_STAY_DISCREET_MOVEMENT_COORDINATION",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-L-02",
        "role": "Public-visibility avoidance, privacy-first movement, quiet hotels, low-profile transfers, VIP discretion, and delicate route design.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    },
    {
      "record_id": "japan-reputation-sensitive-access-visit-coordination",
      "page_sequence": "ANNEX-L-03",
      "page_title": "Japan Reputation-Sensitive Access & Visit Coordination Desk™",
      "page_handle": "japan-reputation-sensitive-access-visit-coordination",
      "alternate_page_handles": [],
      "page_url": "https://japansolved.com/pages/japan-reputation-sensitive-access-visit-coordination",
      "page_type": "native_intake_registry_record",
      "service_family": "Compact NIF Annex / Projected Wing",
      "template_system": "compact_nif_annex_registry_reference",
      "question_intelligence_status": "projected_compact_nif_annex_record",
      "payment_policy": "payment_first_case_file_second",
      "native_anchor": "#jslp-intake",
      "subject_label": "Japan Reputation-Sensitive Access & Visit Coordination Desk™ Intake",
      "intake_title": "Japan Reputation-Sensitive Access & Visit Coordination Desk™ Native Intake™",
      "intake_version": "registry-bank-v2",
      "service_label": "Executives, creators, public-facing individuals, family-office clients, and high-profile travelers needing careful access without public noise.",
      "descriptor_line1": "Payment first. Case file second. This intake preserves page-specific routing, boundary, timing, and support intelligence.",
      "descriptor_line2": "Use this native intake after checkout or after JapanSolved™ approves a private payment path.",
      "payment_block_title": "Complete the Japan Reputation-Sensitive Access & Visit Coordination Review™ path first",
      "payment_block_copy": "Choose the paid review, approved invoice, deposit, retainer, or private payment path that matches this request.",
      "payment_block_fineprint": "Use the same payment email at intake so the file can be matched to the paid path.",
      "not_paid_error": "This intake requires a matched paid or JapanSolved™-approved payment path before the full file opens. Unpaid submissions may be treated only as routing reference.",
      "product_routes": [
        "/products/japan-reputation-sensitive-access-visit-coordination-review",
        "approved_private_payment_path",
        "not_paid_routing_reference_only"
      ],
      "product_route_objects": [
        {
          "label": "Japan Reputation-Sensitive Access & Visit Coordination Review™",
          "url": "/products/japan-reputation-sensitive-access-visit-coordination-review",
          "kind": "primary_review"
        },
        {
          "label": "Approved invoice / deposit / retainer / private quote",
          "url": "approved_private_payment_path",
          "kind": "private_payment"
        },
        {
          "label": "Not paid / routing reference only",
          "url": "not_paid_routing_reference_only",
          "kind": "unpaid_reference"
        }
      ],
      "unpaid_behavior": "routing_reference_only_until_payment_is_matched",
      "steps": [
        {
          "id": "payment_gate",
          "title": "Payment and route match",
          "tone": "Payment first. Case file second. Match the request to the correct paid path before sensitive details are sent.",
          "fields": [
            {
              "id": "payment_status",
              "label": "Which payment path applies to this request?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "I purchased / completed payment for Japan Reputation-Sensitive Access & Visit Coordination Review™",
                  "value": "paid_primary_review"
                },
                {
                  "label": "I am on an approved invoice, case deposit, retainer, or private payment path",
                  "value": "approved_private_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit this intake before payment",
                  "value": "japansolved_instructed"
                },
                {
                  "label": "I have not paid yet",
                  "value": "not_paid"
                }
              ]
            },
            {
              "id": "selected_product_path",
              "label": "Which product or payment path applies?",
              "type": "select",
              "required": true,
              "options": [
                {
                  "label": "Japan Reputation-Sensitive Access & Visit Coordination Review™",
                  "value": "/products/japan-reputation-sensitive-access-visit-coordination-review"
                },
                {
                  "label": "Approved invoice / case deposit / retainer / private quote",
                  "value": "approved_private_payment_path"
                },
                {
                  "label": "JapanSolved™ instructed me to submit before payment",
                  "value": "japansolved_instructed_prepayment_exception"
                },
                {
                  "label": "Not paid yet / routing reference only",
                  "value": "not_paid_routing_reference_only"
                }
              ]
            },
            {
              "id": "checkout_email",
              "label": "Payment email address",
              "type": "email",
              "required": true
            },
            {
              "id": "order_reference",
              "label": "Order number, invoice number, or payment reference",
              "type": "text",
              "required": true,
              "placeholder": "Example: #JS1234, invoice number, or approved private-payment note"
            }
          ]
        },
        {
          "id": "client_contact",
          "title": "Client and contact details",
          "tone": "Keep the client identity and communication route clear enough for safe follow-up.",
          "fields": [
            {
              "id": "client_name",
              "label": "Client or lead contact name",
              "type": "text",
              "required": true
            },
            {
              "id": "contact_email",
              "label": "Best contact email",
              "type": "email",
              "required": true
            },
            {
              "id": "phone_or_messaging",
              "label": "WhatsApp, LINE, Signal, or phone number, if relevant",
              "type": "text",
              "required": false
            },
            {
              "id": "submitter_role",
              "label": "Who is submitting this intake?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Myself / principal client",
                  "value": "myself_principal_client"
                },
                {
                  "label": "Partner or family member",
                  "value": "partner_or_family_member"
                },
                {
                  "label": "Assistant / manager / representative",
                  "value": "assistant_manager_representative"
                },
                {
                  "label": "Travel planner / concierge",
                  "value": "travel_planner_concierge"
                },
                {
                  "label": "Family office / executive team",
                  "value": "family_office_executive_team"
                },
                {
                  "label": "Other",
                  "value": "other"
                }
              ]
            }
          ]
        },
        {
          "id": "request_classification",
          "title": "Request classification",
          "tone": "Executives, creators, public-facing individuals, family-office clients, and high-profile travelers needing careful access without public noise.",
          "fields": [
            {
              "id": "request_categories",
              "label": "Which topics best describe this request?",
              "type": "checkbox_group",
              "required": true,
              "options": [
                {
                  "label": "Executive visit",
                  "value": "executive_visit"
                },
                {
                  "label": "Creator/public-facing travel",
                  "value": "creator_public_facing_travel"
                },
                {
                  "label": "Family-office access",
                  "value": "family_office_access"
                },
                {
                  "label": "Private meeting / visit coordination",
                  "value": "private_meeting_visit_coordination"
                },
                {
                  "label": "Low-profile dining/venue access",
                  "value": "low_profile_dining_venue_access"
                },
                {
                  "label": "Reputation-sensitive route",
                  "value": "reputation_sensitive_route"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "plain_language_goal",
              "label": "Describe the request in plain language",
              "type": "textarea",
              "required": true,
              "placeholder": "What are you trying to clarify, avoid, arrange, or decide?",
              "rows": 5
            },
            {
              "id": "must_avoid",
              "label": "What must be avoided?",
              "type": "textarea",
              "required": false,
              "placeholder": "List medical, privacy, timing, cultural, reputational, access, or logistics boundaries.",
              "rows": 5
            },
            {
              "id": "reputation_risks",
              "label": "Which reputation risks matter?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Being photographed",
                  "value": "being_photographed"
                },
                {
                  "label": "Public association with venue/person",
                  "value": "public_association_with_venue_person"
                },
                {
                  "label": "Staff gossip/social posting",
                  "value": "staff_gossip_social_posting"
                },
                {
                  "label": "Press/paparazzi",
                  "value": "press_paparazzi"
                },
                {
                  "label": "Business confidentiality",
                  "value": "business_confidentiality"
                },
                {
                  "label": "Family privacy",
                  "value": "family_privacy"
                },
                {
                  "label": "Misunderstood request",
                  "value": "misunderstood_request"
                },
                {
                  "label": "Over-formal VIP treatment",
                  "value": "over_formal_vip_treatment"
                }
              ]
            },
            {
              "id": "access_legitimacy",
              "label": "Is the target access legitimate and authorized?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes",
                  "value": "yes"
                },
                {
                  "label": "Mostly, but needs careful wording",
                  "value": "mostly_but_needs_careful_wording"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                },
                {
                  "label": "No / speculative only",
                  "value": "no_speculative_only"
                }
              ]
            }
          ]
        },
        {
          "id": "timing_context",
          "title": "Timing, location, and readiness",
          "fields": [
            {
              "id": "japan_status",
              "label": "Japan status",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Already in Japan",
                  "value": "already_in_japan"
                },
                {
                  "label": "Arriving soon",
                  "value": "arriving_soon"
                },
                {
                  "label": "Planning future Japan visit",
                  "value": "planning_future_japan_visit"
                },
                {
                  "label": "Remote review before travel",
                  "value": "remote_review_before_travel"
                },
                {
                  "label": "Submitting for someone else",
                  "value": "submitting_for_someone_else"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "target_start_date",
              "label": "Target start date or preferred review date",
              "type": "date",
              "required": false
            },
            {
              "id": "target_city_area",
              "label": "Target city / area / clinic region / route base",
              "type": "text",
              "required": false
            },
            {
              "id": "urgency",
              "label": "How urgent is this?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Within 24 hours",
                  "value": "within_24_hours"
                },
                {
                  "label": "Within 2-3 days",
                  "value": "within_2_3_days"
                },
                {
                  "label": "Within 4-7 days",
                  "value": "within_4_7_days"
                },
                {
                  "label": "Within 2 weeks",
                  "value": "within_2_weeks"
                },
                {
                  "label": "Within 1 month",
                  "value": "within_1_month"
                },
                {
                  "label": "More than 1 month",
                  "value": "more_than_1_month"
                },
                {
                  "label": "Flexible",
                  "value": "flexible"
                }
              ]
            },
            {
              "id": "timing_constraints",
              "label": "Timing constraints or deadline pressure",
              "type": "textarea",
              "required": false,
              "rows": 5
            }
          ]
        },
        {
          "id": "records_context",
          "title": "Records, links, and existing context",
          "fields": [
            {
              "id": "existing_links_records",
              "label": "Relevant links, clinic pages, provider names, itineraries, records summaries, screenshots, or notes",
              "type": "textarea",
              "required": false,
              "placeholder": "Paste links or describe records. Do not upload private medical records or sensitive documents unless JapanSolved™ requests them through a safer follow-up route.",
              "rows": 5
            },
            {
              "id": "existing_provider_status",
              "label": "Have you already contacted a provider, clinic, hotel, venue, or route source?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Yes, confirmed response",
                  "value": "yes_confirmed_response"
                },
                {
                  "label": "Yes, unclear response",
                  "value": "yes_unclear_response"
                },
                {
                  "label": "No",
                  "value": "no"
                },
                {
                  "label": "Someone else contacted them",
                  "value": "someone_else_contacted_them"
                },
                {
                  "label": "Not sure",
                  "value": "not_sure"
                }
              ]
            },
            {
              "id": "existing_provider_discussion",
              "label": "What has already been discussed or promised?",
              "type": "textarea",
              "required": false,
              "rows": 5
            },
            {
              "id": "access_visit_goal",
              "label": "What access or visit needs careful coordination?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "support_level_routing",
          "title": "Support level and related routing",
          "fields": [
            {
              "id": "support_level_requested",
              "label": "Which support level do you believe you need?",
              "type": "radio",
              "required": true,
              "options": [
                {
                  "label": "Baseline route review only",
                  "value": "baseline_route_review_only"
                },
                {
                  "label": "Records / link organization and summary",
                  "value": "records_link_organization_and_summary"
                },
                {
                  "label": "Provider or route feasibility pre-check",
                  "value": "provider_or_route_feasibility_pre_check"
                },
                {
                  "label": "Appointment-readiness or communication support",
                  "value": "appointment_readiness_or_communication_support"
                },
                {
                  "label": "Travel / privacy / logistics routing",
                  "value": "travel_privacy_logistics_routing"
                },
                {
                  "label": "Escalation to related JapanSolved™ desk",
                  "value": "escalation_to_related_japansolved_desk"
                },
                {
                  "label": "Not sure, please classify",
                  "value": "not_sure_please_classify"
                }
              ]
            },
            {
              "id": "related_routes",
              "label": "Which related routes may apply?",
              "type": "checkbox_group",
              "required": false,
              "options": [
                {
                  "label": "Medical records / second opinion coordination",
                  "value": "medical_records_second_opinion_coordination"
                },
                {
                  "label": "Longevity clinic / rejuvenation route",
                  "value": "longevity_clinic_rejuvenation_route"
                },
                {
                  "label": "Stem cell / regenerative claims review",
                  "value": "stem_cell_regenerative_claims_review"
                },
                {
                  "label": "Cosmetic surgery route",
                  "value": "cosmetic_surgery_route"
                },
                {
                  "label": "Private recovery stay planning",
                  "value": "private_recovery_stay_planning"
                },
                {
                  "label": "Travel suitability review",
                  "value": "travel_suitability_review"
                },
                {
                  "label": "VIP navigation / cultural support",
                  "value": "vip_navigation_cultural_support"
                },
                {
                  "label": "Discreet movement / sensitive matters",
                  "value": "discreet_movement_sensitive_matters"
                },
                {
                  "label": "Interpreter / local representation",
                  "value": "interpreter_local_representation"
                },
                {
                  "label": "None / not sure",
                  "value": "none_not_sure"
                }
              ]
            },
            {
              "id": "success_definition",
              "label": "What would make this review successful?",
              "type": "textarea",
              "required": true,
              "rows": 5
            }
          ]
        },
        {
          "id": "final_confirmations",
          "title": "Final paid-intake confirmations",
          "tone": "Confirm the case-file boundaries before preparing the native submission.",
          "fields": [
            {
              "id": "confirm_paid_boundary",
              "label": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path."
            },
            {
              "id": "confirm_unpaid_routing",
              "label": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action."
            },
            {
              "id": "confirm_no_guarantee",
              "label": "I understand submission does not guarantee access approval, reputation outcome, privacy outcome, venue cooperation, third-party discretion, appointment availability, public visibility control, or final coordination action.",
              "type": "checkbox",
              "required": true,
              "text": "I understand submission does not guarantee access approval, reputation outcome, privacy outcome, venue cooperation, third-party discretion, appointment availability, public visibility control, or final coordination action."
            },
            {
              "id": "confirm_accuracy_authorization",
              "label": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
              "type": "checkbox",
              "required": true,
              "text": "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it."
            },
            {
              "id": "confirm_clarification_quote",
              "label": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding.",
              "type": "checkbox",
              "required": true,
              "text": "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
            }
          ]
        }
      ],
      "final_confirmations": [
        "I confirm this intake is tied to the appropriate paid review, deposit, invoice, retainer, or JapanSolved™-approved payment path.",
        "I understand unpaid or unclear submissions may be routed to the correct product/payment path before formal review or action.",
        "I understand submission does not guarantee access approval, reputation outcome, privacy outcome, venue cooperation, third-party discretion, appointment availability, public visibility control, or final coordination action.",
        "I confirm the information submitted is accurate to the best of my knowledge and that I am authorized to submit it.",
        "I understand JapanSolved™ may request clarification, documents, payment, authorization, lawful-handling review, feasibility review, or a separate quote before proceeding."
      ],
      "conditional_rules": [
        "Projected record generated from compact-NIF annex planning. Treat as prebuilt question intelligence, not scraped live form output.",
        "Use with Compact NIF architecture only unless deliberately mapped into the Original NIF slot system.",
        "Review legal/medical/privacy wording before publishing."
      ],
      "email_subject": "[JS Native Intake] Japan Reputation-Sensitive Access & Visit Coordination Desk™ Intake / {client_name} / {payment_status}",
      "hidden_fields": {
        "page_handle": "japan-reputation-sensitive-access-visit-coordination",
        "desk_name": "Japan Reputation-Sensitive Access & Visit Coordination Desk™",
        "intake_type": "japan_reputation_sensitive_access_visit_coordination",
        "payment_first_policy": "payment_first_case_file_second",
        "registry_version": "native-intake-registry-bank-v2"
      },
      "admin_tags": [
        "JAPAN_REPUTATION_SENSITIVE_ACCESS_VISIT_COORDINATION",
        "COMPACT_NIF_ANNEX___PROJECTED_WING",
        "PAYMENT_FIRST",
        "REGISTRY_BANK_V2"
      ],
      "qa_notes": "Generated for Native Intake Registry Bank v2. Review final product URLs, prices, and page-handle parity before publishing as a live form.",
      "engine_capability_level": "phase_1_native_structured_payload_mode",
      "phase_2_upgrade_path": "App proxy can verify orders, store submission, handle files, and create a case ID.",
      "intake_bank_extraction": {
        "source_mode": "projected_compact_nif_annex_record",
        "stored_in_registry_bank": true,
        "generated_at": "2026-07-03 06:05:52 UTC",
        "hardened_final_confirmation_field_count": 5
      },
      "compact_nif_annex": {
        "annex_code": "ANNEX-L-03",
        "role": "Executives, creators, public-facing individuals, family-office clients, and high-profile travelers needing careful access without public noise.",
        "source": "Compact NIF wing planning document plus projected intake intelligence"
      }
    }
  ]
};
